// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.heading-primary {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}

.heading-secondary {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
  margin-bottom: 0.2rem;
}

.field-labels {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.2;
  margin-bottom: 0.3rem;
}

body {
  font-family: "Open Sans", sans-serif;
  background-color: #fafafa;
  color: #1a1a1a;
}

.mainheading {
  margin-top: 2rem;
  text-align: left;
  margin-left: 0.1rem;
  /* Using rem for better responsiveness */
  color: #1a1a1a;
  font-weight: 700;
  font-size: 20px;
}

.mainheading3 {
  /* Using rem for scalability */
  text-align: left;
  margin-left: 2rem;
  /* Using rem for better responsiveness */
  color: #1a1a1a;
  font-weight: 700;
  font-size: 20px;
  /* Using rem instead of px */
}

@media screen and (max-width: 480px) {
  .mainheading {
    margin-top: 1rem;
    margin-left: 1.5rem;
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  .h2design {
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  label {
    display: block;
    font-size: 10px;
    font-weight: 600;
    margin-bottom: 5px;
  }
}
.error-heading {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
  text-align: center;
}

.overview-heading {
  margin-bottom: 10px;
}

.list-section h2 {
  margin-bottom: 12px;
  color: #1a1a1a;
}

h2,
h3 {
  color: #1a1a1a;
  font-size: 16px;
  margin-bottom: 15px;
  margin-top: 5px;
}

.subtxt {
  color: #9ca3af;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
}

.textOne {
  display: flex;
  align-items: center;
}

.textOne img {
  width: 60px;
  /* Adjust image size */
  margin-right: 20px;
}

.textOne span {
  font-size: 20px;
  font-weight: 700;
}

.error-text-data-fetching {
  font-size: 20px;
  font-weight: 400;
  color: #1a1a1a;
  text-align: left;
}

.error-text-signIn {
  color: #e53935;
  font-size: 12px;
}

.zero-notification-text {
  color: #9ca3af;
  font-size: 12px;
  margin-top: 5px;
}

.upload-text {
  font-weight: 700;
  font-size: 16px;
}

.upload-subtext {
  font-size: 14px;
  color: #6b7280;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 30px;
}

.ant-menu-title-content {
  color: inherit !important;
}

.centered-modal .ant-modal-title {
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 1rem;
}

.stat-box {
  background: #ffffff;
  border: 1px solid #3079bb;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 51, 102, 0.1);
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.stat-box .label {
  font-size: 16px;
  color: #2c68ad;
  margin-bottom: 8px;
}
.stat-box .value {
  font-size: 28px;
  font-weight: bold;
  color: #03045e;
  unicode-bidi: plaintext;
}
.stat-box .description {
  font-size: 14px;
  color: #ff6d00;
  margin-top: 4px;
}
.stat-box.success {
  border-color: #3079bb;
}
.stat-box.success .value {
  color: #023e8a;
}
.stat-box.error {
  border-color: #ff9100;
}
.stat-box.error .value {
  color: #ff6d00;
}

.panel-row {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media (min-width: 992px) {
  .panel-row {
    flex-direction: row;
  }
}

.panel-card {
  flex: 1 1;
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}
.panel-card .panel-header {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1e3a8a;
}

.panel-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.panel-header-row h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e3a8a;
}

.button {
  padding: 0.6rem 1.3rem;
  margin-top: -0.3px;
  border-radius: 12px;
  font-weight: 400;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s ease, color 0.2s ease;
  height: auto;
  min-height: 44px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.button--primary {
  width: auto;
  min-width: fit-content;
  min-height: 40px;
  background-color: #2c68ad !important;
  color: #ffffff !important;
  font-weight: 400;
  border-radius: 12px;
  transition: all 0.2s ease;
  padding: 0.6rem 1.4rem;
}
.button--primary:hover {
  background-color: #2a73c2 !important;
}
.button--outline {
  background-color: #ffffff !important;
  color: #2c68ad !important;
  border: 2px solid #2c68ad !important;
}
.button--outline:hover {
  background-color: rgba(44, 104, 173, 0.15) !important;
  color: #2a73c2 !important;
  border-color: #2a73c2 !important;
}
.button--danger {
  background-color: #e53935 !important;
  color: #ffffff !important;
}
.button--danger:hover {
  background-color: #bf3936 !important;
}
.button--connection {
  background-color: #28a745 !important;
  color: #ffffff !important;
  box-shadow: 0 2px 4px rgba(182, 178, 178, 0.6) !important;
}
.button--connection:hover {
  background-color: #0cc036 !important;
  box-shadow: 0 2px 4px rgba(182, 178, 178, 0.6) !important;
}

.button--disabled,
.button:disabled {
  background-color: #c2c2c2 !important;
  color: #ffffff !important;
  border-color: transparent !important;
  box-shadow: none !important;
  opacity: 0.8;
  cursor: not-allowed;
  pointer-events: none;
}

.ant-modal .ant-modal-footer > .ant-btn + .ant-btn {
  background-color: #2a73c2 !important;
  color: #ffffff !important;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s ease, color 0.2s ease;
  box-shadow: 0 2px 4px rgba(182, 178, 178, 0.6) !important;
}

.ant-modal .ant-modal-footer > .ant-btn + .ant-btn:hover {
  background-color: #2a73c2 !important;
  box-shadow: 0 2px 4px rgba(182, 178, 178, 0.6) !important;
}

.competitive-back-button {
  background-color: #2c68ad;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  font-weight: 500;
  height: 32px;
}

.competitive-back-button:hover {
  background-color: #2a73c2 !important;
  color: #ffffff !important;
}

.custom-table {
  border: 1px solid #2c68ad;
  margin-top: 10px;
  height: fit-content;
  /* CSS override (global or module-specific) */
}
.custom-table .ant-table-thead > tr > th {
  background-color: #2c68ad;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  padding: 12px;
  text-transform: uppercase;
  border-bottom: 2px solid #03045e;
  text-align: center !important;
  vertical-align: middle;
  overflow: visible;
}
.custom-table .ant-table-tbody > tr > td {
  padding: 12px;
  font-size: 13px;
  color: #03045e;
  background-color: #ffffff;
  border-bottom: 1px solid #9ca3af;
  text-align: center !important;
  vertical-align: middle;
  overflow: visible;
}
.custom-table .ant-table-cell {
  overflow: visible !important;
  position: relative;
}
.custom-table .even-row {
  background-color: #e5e7eb;
}
.custom-table .odd-row {
  background-color: #ffffff;
}

.status-healthy {
  background-color: #d3f9d8;
  color: #2e7d32;
}

.status-degraded {
  background-color: #ff9100;
  color: #ff9100;
}

.status-failing,
.status-down {
  background-color: #ff9100;
  color: #ff9100;
}

.status-default {
  background-color: #9ca3af;
  color: #1a1a1a;
}

.status-badge {
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: capitalize;
  text-align: center;
  display: inline-block;
  min-width: 60px;
  color: #ffffff !important;
}
.status-badge--positive {
  background-color: #d3f9d8;
  color: #2e7d32 !important;
}
.status-badge--negative {
  background-color: #ff9100;
  color: #000000;
}
.status-badge--neutral {
  background-color: #eeeeee;
  color: #1a1a1a !important;
}
.status-badge--healthy {
  background-color: #d3f9d8;
  color: #2e7d32 !important;
}
.status-badge--degraded, .status-badge--failing, .status-badge--down {
  background-color: #ff9100;
  color: #ff9100;
}
.status-badge--success {
  background-color: #d3f9d8;
  color: #2e7d32 !important;
}
.status-badge--failed {
  background-color: #ff9100;
  color: #ffffff;
}
.status-badge--active {
  background-color: #d3f9d8;
  color: #2e7d32 !important;
}
.status-badge--inactive {
  background-color: #ff9100;
  color: #ffffff;
}
.status-badge--suspended {
  background-color: #03045e;
  color: #ffffff;
}
.status-badge--error {
  background-color: #e53935;
  color: #ff6d00;
}
.status-badge--warning, .status-badge--pending {
  background-color: #f9ee24;
  color: #ffffff;
}
.status-badge--paid {
  background-color: #d3f9d8;
  color: #2e7d32 !important;
}
.status-badge--overdue {
  background-color: #ff9100;
  color: #ffffff;
}
.status-badge--default {
  background-color: #9ca3af;
  color: #1a1a1a;
}

.custom-table .ant-table {
  background-color: #ffffff;
}
.custom-table .even-row {
  background-color: #e5e7eb;
}
.custom-table .odd-row {
  background-color: #ffffff;
}
.custom-table th {
  background-color: #2c68ad;
  color: #ffffff;
}

.access-level-select {
  width: 150px;
}

.status-cell {
  display: flex;
  align-items: center;
}

.status-text {
  margin-left: 8px;
}

.user-management-icon.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.user-management-icons {
  display: flex;
  align-items: center;
}

.delete-icon {
  margin-left: 4px;
  margin-top: 2px;
}

.custom-pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pipeline-table .ant-pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.pipeline-table .ant-pagination .ant-pagination-item,
.pipeline-table .ant-pagination .ant-pagination-prev,
.pipeline-table .ant-pagination .ant-pagination-next {
  border-radius: 6px;
  background-color: #d3f9d8;
  border: none;
  margin: 0 4px;
  font-weight: 500;
}
.pipeline-table .ant-pagination .ant-pagination-item a,
.pipeline-table .ant-pagination .ant-pagination-prev a,
.pipeline-table .ant-pagination .ant-pagination-next a {
  color: #1a1a1a;
}
.pipeline-table .ant-pagination .ant-pagination-item-active {
  background-color: #2c68ad;
}
.pipeline-table .ant-pagination .ant-pagination-item-active a {
  color: #ffffff;
}
.pipeline-table .ant-pagination .ant-pagination-disabled {
  opacity: 0.5;
}
.pipeline-table .ant-pagination .ant-pagination-prev,
.pipeline-table .ant-pagination .ant-pagination-next {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 768px) {
  /* Apply different styles for screens with a max-width of 768px */
  .tablediv table {
    margin-left: 50px;
  }
  .payment-confirmation {
    padding-left: 5px;
    display: grid;
  }
}
.tablediv {
  align-items: center;
  justify-content: center;
  overflow-x: auto;
  max-width: 100%;
  margin-left: -30px;
}

@media screen and (max-width: 768px) {
  .tablediv table {
    margin-left: 50px;
  }
  .payment-confirmation {
    padding-left: 50px;
    display: grid;
  }
}
tbody {
  align-items: center;
  justify-content: center;
}

tr {
  width: 90%;
}

table,
tr,
td {
  border: none;
  padding: 15px;
}

tbody tr:nth-child(odd) {
  border-radius: 5px;
}

.tableBody {
  overflow-y: auto;
  gap: 5px;
  color: #6b7280;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
}

@media (max-width: 480px) {
  .tableBody {
    max-height: 700px;
    overflow-y: auto;
    gap: 5px;
    color: #6b7280;
    font-size: 8px;
    font-family: "Open Sans", sans-serif;
    overflow-x: auto;
  }
}
/* \`.notification-table-wrapper\` is styled by
   layouts/MyAccount/Notifications/Notifications.scss, the only place that markup
   lives. The duplicate block that used to sit here fought it — its
   \`margin-top: -30px\` pulled the table up under the section header (hiding the
   first activity row) and its \`overflow-x: auto\` turned the wrapper into a
   scroll container. */
.notification-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  table-layout: fixed;
  align-self: center;
}

.notification-table th,
.notification-table td {
  padding: 10px;
  border-bottom: 1px solid #ffffff;
  text-align: left;
  background-color: #ffffff;
}

.table-main-row {
  color: #6b7280;
  font-size: 10px;
}

.campaign-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 1rem;
}
.campaign-table th,
.campaign-table td {
  padding: 5px;
  text-align: left;
  border-bottom: 1px solid #9ca3af;
}
.campaign-table th {
  background-color: #e5e7eb;
  font-weight: 500;
}
.campaign-table tbody tr:hover {
  background-color: #d3f9d8;
}

.chart-container {
  margin: 20px 0;
}

.data-table {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 10px rgba(0, 82, 204, 0.1);
}

.data-table-header,
.data-table-row {
  display: grid;
  grid-template-columns: 60px 1fr 1fr 1fr 100px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #d3f9d8;
}
.data-table-header span,
.data-table-row span {
  font-weight: 500;
}

.data-table-header {
  color: #023e8a;
  font-size: 14px;
}

.data-table-row input,
.data-table-row .dropdown {
  width: 90%;
}
.data-table-row .sample-data {
  color: #595959;
  font-size: 13px;
}
.data-table-row .data-type {
  font-size: 13px;
  color: #1890ff;
}

.styled-data-table .ant-table-thead > tr > th {
  background-color: #d3f9d8;
  color: #1e3a8a;
  font-weight: 600;
}

.styled-data-table .ant-table-tbody > tr:hover {
  background-color: #d3f9d8;
  transition: background-color 0.2s ease;
}

.styled-data-table .ant-table-cell {
  padding: 12px 16px;
  font-size: 14px;
}

.styled-data-table .ant-input {
  border-radius: 6px;
  border-color: #9ca3af;
  transition: border-color 0.2s ease;
}

.styled-data-table .ant-input:focus {
  border-color: #1890ff !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.column-status span {
  display: inline-block;
  width: 60px;
  margin-left: 1rem;
  text-align: left;
  color: #000000;
}

.column-name {
  width: 250px;
}

.column-email {
  width: 250px;
}

.column-access-level {
  width: 250px;
}

.column-status {
  width: 250px;
}

.column-actions {
  width: 250px;
}

.greyrow {
  background-color: #f8f9fa;
}

.highlighted-row {
  background-color: #d3f9d8;
  transition: background-color 0.3s;
}

.container {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr 1.2fr;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 24px;
  font-family: Arial, sans-serif;
  background-color: #ffffff;
}

.header-cell {
  padding: 12px 16px;
  background: #ffffff;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
}

.data-cell {
  padding: 12px 16px;
  border-bottom: 1px solid #9ca3af;
  border-right: 1px solid #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.select-cell {
  padding: 8px 16px;
  border-bottom: 1px solid #9ca3af;
  border-right: 1px solid #9ca3af;
}

.sample-cell {
  padding: 12px 16px;
  border-bottom: 1px solid #9ca3af;
  white-space: nowrap;
}

.connected-sources-container {
  display: flex;
  flex-direction: column;
  min-height: 86vh;
  padding-inline-start: 50px;
  padding-inline-end: 40px;
  background: #fff;
  box-sizing: border-box;
  position: relative;
}

.connected-sources-content {
  flex: 1 1;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 24px;
  margin-top: 50px;
  max-width: 1480px;
}

.connector-img-shopify {
  width: 110px;
  height: 40px;
}

.connector-img-google-ads {
  width: 220px;
  height: 100px;
}

.connector-img-google-analytics {
  width: 220px;
  height: 100px;
}

.connector-img-facebook {
  width: 220px;
  height: 100px;
}

.connector-img-instagram {
  width: 200px;
  height: 100px;
}

.connector-img-odoo {
  width: 220px;
  height: 100px;
}

.connector-img-zid,
.connector-img-salla,
.connector-img-tiktok,
.connector-img-snapchat,
.connector-img-whatsapp,
.connector-img-blinkco {
  width: 150px;
  height: 56px;
  object-fit: contain;
}

.card span {
  white-space: nowrap;
}

.shopify {
  background-color: #eef7ee;
}

.google-ads,
.facebook {
  background-color: #f7f8fc;
}

.google-analytics {
  background-color: #fef4e8;
}

.instagram {
  background-color: #fce4ec !important;
}

.odoo {
  background-color: #f6edf3;
}

.zid {
  background-color: #f4eef8;
}

.salla {
  background-color: #eaf7f5;
}

.tiktok {
  background-color: #f4f4f6;
}

.snapchat {
  background-color: #fffde7;
}

.whatsapp {
  background-color: #e9f8ef;
}

.blinkco {
  background-color: #fff7e6;
}

.connected-footer {
  position: absolute;
  inset-inline-end: 40px;
  bottom: 40px;
}

.highlight {
  font-weight: 600;
  color: #ff6c00;
}

.highlight-orange {
  font-weight: 300;
  color: #000;
}

.connect-header {
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  font-size: 35px;
  text-align: start;
}

.sub-heading {
  text-align: start;
}

.button-footer {
  width: 250px;
  height: 50px;
  padding: 5px;
  gap: 10px;
  background-color: #1c60c6;
  justify-content: center;
  align-items: center;
  color: white;
}

.connected-card {
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 20px;
  width: 180px;
  max-width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f8f8;
  transition: border 0.3s ease;
  box-shadow: 0 30px 20px rgba(4, 11, 5, 0.15);
  cursor: default;
  justify-self: center;
}

.connected-card img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.connected-card.highlight-border {
  border: 3px solid #ff6c00;
}

.disconnected-message {
  font-size: 10px;
  text-align: start;
  padding: 10px;
  color: #000;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
}

.shopify {
  background-color: #eef7ee;
}

.google-ads {
  background-color: #f0f4f8;
}

.google-analytics {
  background-color: #fff3e0;
}

.facebook {
  background-color: #f1f4fb;
}

/* ========== RESPONSIVE BREAKPOINTS ========== */
/* Mobile: ≤480px → 1 card per row */
@media (max-width: 480px) {
  .cards-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 20px;
    justify-items: center;
  }
  .connected-card {
    width: 100%;
    max-width: 300px;
    height: auto;
  }
  .connect-header {
    font-size: 22px;
  }
  .button-footer {
    width: 100%;
    max-width: 280px;
  }
  .connected-footer {
    position: static; /* no overlap */
    margin-top: 20px;
    text-align: center;
  }
}
/* Tablet: 481px – 768px → 2 cards per row */
@media (min-width: 481px) and (max-width: 768px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: 25px;
    justify-items: center;
  }
  .connected-card {
    width: 100%;
    max-width: 250px;
  }
  .connect-header {
    font-size: 28px;
  }
  .button-footer {
    width: 100%;
    max-width: 280px;
  }
  .connected-footer {
    position: static;
    margin-top: 30px;
    text-align: center;
  }
}
/* Small laptop: 769px – 1240px → still 3 cards but flexible */
@media (min-width: 769px) and (max-width: 1240px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    justify-items: center;
  }
  .connected-card {
    width: 100%;
    max-width: 200px;
  }
}
.error-message, .ant-form-item-explain-error {
  color: var(--error-red, #d21c1c);
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

input:invalid[focused=true] {
  border: 1px solid #e53935;
}

/* Resetpassword.css */
.error-message, .ant-form-item-explain-error {
  color: #e53935;
}

.input-error {
  border: 1px solid #e53935;
}

.error-message-source-connector {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #fde2e2;
  border: 0.1rem solid #e53935;
  border-radius: 0.25rem;
  color: #000000;
  font-size: 1rem;
}
.error-message-source-connector .error-icon-source-connector {
  margin-right: 0.5rem;
  font-size: 1.125rem;
}

@media (max-width: 480px) {
  .error-message, .ant-form-item-explain-error {
    color: #e53935;
    font-size: 8px;
  }
}
.alert {
  color: #d21c1c;
  font-weight: bold;
}

.red-icon {
  font-size: 1rem;
  color: #d21c1c;
  margin-bottom: 10px;
}

.alerts-health-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 10px;
}
@media (min-width: 992px) {
  .alerts-health-container {
    flex-direction: row;
  }
}

.alert-panel,
.api-health-panel {
  flex: 1 1;
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  margin-top: 2.5rem;
}

.alert-actions {
  display: flex;
  gap: 0.5rem;
}

.alert-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0.75rem;
  margin-bottom: 1rem;
  background-color: #e5e7eb;
  border-left: 4px solid;
}
.alert-card .alert-icon {
  font-size: 1.4rem;
}
.alert-card .alert-content {
  flex-grow: 1;
}
.alert-card .alert-content strong {
  display: block;
  font-size: 1rem;
  margin-bottom: 0.25rem;
}
.alert-card .alert-content p {
  margin: 0;
  font-size: 0.85rem;
  color: #475569;
}
.alert-card .alert-content .alert-meta {
  font-size: 0.75rem;
  color: #9ca3af;
}
.alert-card .alert-tag {
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}
.alert-card.high {
  border-color: #f87171;
  background-color: #fde2e2;
}
.alert-card.high .alert-tag {
  background-color: #f87171;
  color: #e53935;
}
.alert-card.medium {
  border-color: #f9ee24;
  background-color: #fef9c3;
}
.alert-card.medium .alert-tag {
  background-color: #fef08a;
  color: #92400e;
}
.alert-card.low {
  border-color: #34d399;
  background-color: #ecfdf5;
}
.alert-card.low .alert-tag {
  background-color: #bbf7d0;
  color: #065f46;
}
.alert-card.info {
  border-color: #91d5ff;
  background-color: #bbf7d0;
}
.alert-card.info .alert-tag {
  background-color: #bbf7d0;
  color: #1d4ed8;
}

.error-container-data-fetching {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 30px;
  width: 750px;
  height: 250px;
  box-shadow: 0px 20px 12px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
  opacity: 0;
  transition: opacity 5.5s ease-in-out;
}

.error-container-data-fetching.fade-in {
  opacity: 2;
}

.error-content {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

/* More compact chat message styling */
.message {
  max-width: 75%;
  margin: 8px 12px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.3;
}

.message.user {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  color: #3079bb;
  margin-left: auto;
}

.timestamp {
  font-size: 9px;
  color: #595959;
  margin-top: 3px;
  text-align: right;
}

.custom-ribbon:where(.css-dev-only-do-not-override-vryruh).ant-ribbon {
  background-color: #ffffff !important;
  border: 2px solid #2c68ad !important;
  width: 50% !important;
  white-space: normal !important;
  height: auto !important;
  margin-bottom: 20px;
}

.custom-ribbon :where(.ant-ribbon .ant-ribbon-text) {
  color: #000000 !important;
  font-size: 12px;
}

/* Branded toast for API \`detail\` (e.g. template generation limits) — use with showApiDetailToast() */
.datatram-api-detail-toast.ant-message-notice,
.datatram-api-detail-toast .ant-message-notice {
  padding: 0 !important;
}

.datatram-api-detail-toast .ant-message-notice-content {
  background: #edf3fb !important;
  border: 1px solid rgba(44, 104, 173, 0.45) !important;
  color: #2c68ad !important;
  border-radius: 10px !important;
  padding: 12px 16px !important;
  font-size: 13px !important;
  line-height: 1.45 !important;
  font-weight: 500 !important;
  box-shadow: 0 4px 14px rgba(44, 104, 173, 0.12) !important;
  max-width: min(520px, 100vw - 32px) !important;
}

.datatram-api-detail-toast .anticon {
  color: #2c68ad !important;
}

.admin-portal-layout.ant-layout-has-sider {
  overflow-y: auto;
}

.admin-portal-layout .ant-layout-content {
  overflow-y: auto;
}

.headline {
  color: var(--dark-purple, #140054);
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  margin-inline-start: 30px;
  gap: 5px;
}

.header-dashboard {
  padding: 0;
  background-color: colorBgContainer;
  color: black;
  width: 100%;
  z-index: 1000;
  position: relative;
  overflow: visible;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboards-heading {
  color: var(--text, #718096);
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: lighter;
  line-height: normal;
  margin-bottom: -5%;
  margin-top: -15px;
  margin-inline-start: 5px;
}

.dashboards-headings {
  color: var(--text, #718096);
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: lighter;
  line-height: normal;
  margin-bottom: -5%;
  margin-top: -18px;
  margin-inline-start: 5px;
}

.filters-settings-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.dashboard-image {
  margin-inline-end: 5px;
  width: 25px;
  height: 25px;
}

.chart-image {
  margin-inline-start: 15px;
  margin-inline-end: 3px;
  height: 25px !important;
  width: 25px;
  color: #2c68ad;
}

.dashboard-image-2 {
  margin-inline-start: 7px;
}

.header-search-dashboard {
  border-radius: 0px;
  width: 300px;
  height: 30px;
  margin-top: 18px;
  margin-right: 140px;
  font-size: 14px;
  padding: 5px;
}

.bell-icon-dashboard {
  background: white;
  cursor: pointer;
  color: grey;
  width: 30px;
  margin-top: 4px;
  margin-right: 15px !important;
}

.avatar-icon-dashboard {
  background: #2eb67d !important;
  cursor: pointer;
  margin-top: 8px;
  margin-right: 10px;
}

.p-0 {
  margin-left: 3px !important;
}

@media screen and (max-width: 768px) {
  .dashboards-heading {
    font-size: 12px;
  }
  .header-search-dashboard {
    border-radius: 0px;
    width: 200px;
  }
  .p-0 {
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .headline {
    font-size: 6px;
  }
  .dashboards-heading {
    font-size: 4px;
    margin-left: -10px;
  }
  .dashboard-image {
    width: 10px;
  }
  .chart-image {
    margin-right: 3px;
    width: 15px;
    margin-left: 10px;
  }
  .anticon {
    margin-left: 5px !important;
  }
  .dashboard-image-2 {
    margin-left: 5px;
    width: 30px;
  }
  .bell-icon-dashboard {
    margin-top: 22px;
    height: 20px !important;
    width: 20px !important;
  }
  .avatar-icon-dashboard {
    margin-top: 22px;
    height: 20px !important;
    width: 20px !important;
  }
  .p-0 {
    font-size: 2px;
    margin-left: 2px !important;
  }
}
.ant-layout-sider {
  width: 50px;
  max-width: 50px;
  min-width: 50px;
}

@media (max-width: 768px) {
  .ant-layout-sider {
    width: 60px;
    max-width: 60px;
    min-width: 60px;
  }
}
@media (max-width: 480px) {
  .ant-layout-sider {
    width: 50px;
    max-width: 50px !important;
    min-width: 50px !important;
  }
}
.ant-layout-content-css-dev-only-do-not-override-vryruh {
  margin-left: 80px !important;
}

@media (max-width: 768px) {
  .ant-layout-content-css-dev-only-do-not-override-vryruh {
    margin-left: 40px;
  }
}
@media (max-width: 480px) {
  .ant-layout-css-dev-only-do-not-override-vryruh {
    margin-left: 60px !important;
  }
}
.responsive-margin {
  margin-left: 80px !important;
}
@media (max-width: 768px) {
  .responsive-margin {
    margin-left: 80px !important;
  }
}
@media (max-width: 480px) {
  .responsive-margin {
    margin-left: 50px !important;
  }
}

.header-style {
  margin-left: 210px !important;
}
@media (max-width: 480px) {
  .header-style {
    margin-left: 50px !important;
  }
}

.responsive-margin-right {
  margin-right: 110px;
}
@media (min-width: 769px) {
  .responsive-margin-right {
    margin-right: 230px;
  }
}

/* PipelineDashboard.scss */
.admin-portal-page .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding: 5px;
  margin-bottom: 1.5rem;
}
.admin-portal-page .header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #003366;
}
.admin-portal-page .header h1 {
  font-size: 1.8rem;
  color: #03045e;
}
.admin-portal-page .header button {
  background-color: #ff9100;
  border: none;
}
.admin-portal-page .header button:hover {
  background-color: #ff6d00;
}
.admin-portal-page .last-refreshed {
  font-size: 12px;
  color: #ff6d00;
  font-weight: 700;
}
.admin-portal-page .filters {
  display: flex;
  gap: 16px;
  margin-bottom: -40px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.admin-portal-page .filters .status-select,
.admin-portal-page .filters .date-picker {
  width: 300px;
}

.ant-tooltip {
  z-index: 9999 !important;
}

.announcement-card {
  background: #ffffff;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border-left: 5px solid #007acc;
}
.announcement-card.published {
  border-color: #2db584;
}
.announcement-card.scheduled {
  border-color: #f0ad4e;
}
.announcement-card.draft {
  border-color: #6c757d;
}
.announcement-card .announcement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.announcement-card .status-badge {
  background: #e0ecf8;
  padding: 0.25rem 0.75rem;
  border-radius: 15px;
  font-size: 0.8rem;
  color: #007acc;
}
.announcement-card .meta {
  font-size: 0.85rem;
  color: #6b778c;
  margin: 0.3rem 0 1rem;
}
.announcement-card .tags {
  margin-top: 0.75rem;
}
.announcement-card .tags .tag {
  background: #e3ecf6;
  color: #274c6c;
  padding: 0.3rem 0.7rem;
  border-radius: 14px;
  font-size: 0.75rem;
  margin-right: 0.5rem;
  display: inline-block;
}

.blue-outline-card {
  border-color: #00b4d8;
  border-style: solid;
  border-width: 1px;
}

:where(.ant-table-wrapper) table {
  border: none !important;
  box-shadow: none !important;
}

:where(.ant-table-wrapper) .ant-table-container {
  border: none !important;
  box-shadow: none !important;
}

:where(.ant-table-wrapper) .ant-table {
  border: none !important;
}

.sidebar-admin-portal {
  position: "fixed";
  height: "100%";
  zindex: 1000;
  background: #03045e !important;
}

.user-management-container {
  min-height: 80vh;
}

.user-management-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  align-items: center;
}

.add-user-button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -130px;
  margin-right: 20px;
}

.user-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.filter-input {
  width: 240px;
}

.filter-select {
  height: 32px;
  padding: 0 8px;
}

.refresh-btn {
  height: 32px;
}

.admin-search {
  width: 300px !important;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.admin-search .ant-input {
  border-radius: 8px;
  padding-left: 36px;
}

.announcement-search {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.announcement-search .ant-input {
  border-radius: 8px;
  padding-left: 36px;
}

.DataSourceSearch {
  width: 380px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.DataSourceSearch .ant-input {
  border-radius: 8px;
  padding-left: 36px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 480px;
  margin-inline-start: 122px;
  padding: 0;
}

.body {
  position: relative;
  min-height: 100vh;
  width: 100%;
}

.body::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background-image: var(--auth-bg-image);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

[dir=rtl] .body::before {
  transform: scaleX(-1);
}

.app {
  display: flex;
  padding-inline-start: 10px;
  min-height: 100vh;
}

.formdesign {
  background-color: #ffffff;
  padding: 30px 75px;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  max-height: 80vh;
  margin-inline-start: 92px;
  max-width: 480px;
  margin-top: -17px;
  text-align: start;
}

.or {
  color: #bac7d5 !important;
  font-size: 12px !important;
  margin-bottom: -10px !important;
  margin-top: -3px !important;
}

.logo-design {
  display: block;
  padding-left: 0;
}

.logo-wrapper .language-switcher {
  order: 1;
}

.formInput {
  display: flex;
  flex-direction: column;
  width: auto;
  margin-left: 30px;
}

label {
  font-size: 12px;
  color: #5d3f85;
  font-weight: bold;
  display: block;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0;
}

.span {
  font-size: 12px;
  color: grey;
  display: none;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

input:invalid[focused=true] {
  border: 1px solid red;
}

.password-toggle-icon {
  display: none;
  position: absolute;
  right: -38px;
  top: 40%;
  transform: translateY(-50%);
  cursor: pointer;
}

/* Form styling */
.form-selection,
.form-input {
  margin-bottom: 20px;
}

.form-selection {
  width: 50%;
}

.access-tkn-fb {
  width: 70%;
}

input {
  width: 100%;
  padding: 10px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.button-group {
  display: flex;
  gap: 15px;
  justify-content: flex-start;
  margin-top: 28px;
}

.create-connection,
.cancel {
  padding: 10px 15px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 50px;
}

.remove-connection {
  padding: 5px 5px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #28a745;
  color: white;
}

.create-connection {
  background-color: #28a745;
  color: white;
}

.cancel {
  background-color: #f5f5f5;
  color: #333;
}

@media screen and (max-width: 768px) {
  .formdesign {
    padding: 30px 4%;
    max-height: 568px;
    width: 611px;
    height: 820px;
  }
  .logo-design {
    height: 70px;
    padding-left: 0;
    padding-top: 25px;
    margin-bottom: 5vw;
    margin-top: 2vh;
  }
  .logo-wrapper {
    max-width: 611px;
    margin-left: 0;
    padding: 0 4%;
  }
}
@media screen and (max-width: 480px) {
  .formdesign {
    padding: 30px 3%;
    height: 600px;
    margin-left: 20px;
    width: 280px;
  }
  .logo-design {
    width: 105px;
    padding-left: 20px;
    padding-bottom: 30px;
  }
  .logo-wrapper {
    max-width: 280px;
    margin-left: 20px;
    padding: 0;
  }
}
.add-user-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-row {
  display: flex;
  gap: 8px;
}

.form-item {
  flex: 1 1;
  margin-bottom: 2dvh;
}

.form-item-invitation {
  font-size: 5px !important;
  color: red;
  font-weight: bold;
  margin-bottom: 0px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 0;
}
.form-actions .cancel-button {
  background-color: #f5f5f5;
  color: #595959;
  border: 1px solid #d9d9d9;
}
.form-actions .cancel-button:hover {
  background-color: #e6e6e6;
}
.form-actions .add-user-button {
  background-color: #1890ff;
  color: #fff;
  border: none;
}
.form-actions .add-user-button:hover {
  background-color: #1677e6;
}

.ant-form-item-control-input-content {
  font-size: 12px;
  min-height: 0px;
}

.ant-form-item-explain-error {
  color: #ff4d4f;
  font-size: 10px;
  margin-top: 1px;
  font-weight: bold;
}

.segment-form {
  background: #ffffff;
  border: 1px solid #d9e2f3;
  border-radius: 8px;
  padding: 24px;
}

.segment-name-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #a6c1f3;
  border-radius: 4px;
  font-size: 14px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
}

.segment-conditions .condition-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
.segment-conditions .condition-btn {
  padding: 0 16px;
  height: 42px;
  background: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.segment-conditions .condition-btn:hover {
  background: #ffffff !important;
}
.segment-conditions .condition-btn.active {
  background: #2c5bbd !important;
  color: #fff !important;
  font-weight: 500;
}
.segment-conditions .ant-select-selector {
  background: #ffffff !important;
}
.segment-conditions .trash-icon {
  font-size: 18px;
  margin-left: auto;
  align-self: center;
  cursor: pointer;
}

.logic-buttons {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}
.logic-buttons .logic-btn {
  padding: 8px 20px;
  background: #f0f4ff;
  border: 1px solid #a6c1f3;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.logic-buttons .logic-btn:hover {
  background: #dbe9ff;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  gap: 12px;
}
.action-buttons .cancel-btn {
  background: #fff;
  border: 1px solid #b3c5e6;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.action-buttons .submit-btn {
  background: #2c5bbd;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.action-buttons .submit-btn:hover {
  background: #1e429f;
}

.form-container {
  display: grid;
  gap: 1rem;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  padding-top: 0;
}

.login-form .ant-form-item-label > label {
  color: #003366;
  font-weight: 500;
}

.login-form .ant-input,
.login-form .ant-input-password {
  border-radius: 6px;
}

.login-btn {
  background-color: #0052cc;
  border-color: #0052cc;
  border-radius: 6px;
  font-weight: 500;
}
.login-btn:hover, .login-btn:focus {
  background-color: #003d99 !important;
  border-color: #003d99 !important;
}

.add-admin-modal .modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a3f75;
}
.add-admin-modal .modal-subtitle {
  margin-bottom: 16px;
  color: #5a6d8c;
  font-size: 14px;
}
.add-admin-modal .ant-form-item-label > label {
  color: #1a3f75;
  font-weight: 500;
}
.add-admin-modal .ant-input,
.add-admin-modal .ant-input-password,
.add-admin-modal .ant-select-selector {
  border-radius: 6px;
  border-color: #c4d3ec;
}
.add-admin-modal .ant-input:hover, .add-admin-modal .ant-input:focus,
.add-admin-modal .ant-input-password:hover,
.add-admin-modal .ant-input-password:focus,
.add-admin-modal .ant-select-selector:hover,
.add-admin-modal .ant-select-selector:focus {
  border-color: #2d64bc;
  box-shadow: 0 0 0 2px rgba(45, 100, 188, 0.2);
}
.add-admin-modal .modal-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.add-admin-modal .modal-buttons .ant-btn {
  margin-left: 12px;
  border-radius: 6px;
}
.add-admin-modal .modal-buttons .ant-btn-primary {
  background-color: #2d64bc;
  border-color: #2d64bc;
}
.add-admin-modal .modal-buttons .ant-btn-primary:hover {
  background-color: #1e4fa3;
  border-color: #1e4fa3;
}

.login-container {
  background-size: cover;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  /* 3D effect */
  perspective: 1000px; /* set perspective */
  transform-style: preserve-3d;
  transition: transform 0.5s ease;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 2rem 2.5rem;
  box-shadow: 0 10px 25px rgba(0, 102, 204, 0.15);
  border-radius: 12px;
  background-color: #ffffff;
}

.login-title {
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #003366;
  font-weight: 600;
}

.signup-heading {
  color: #130054;
  font-family: sans-serif;
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
}

/***************************************************SignUp Page***************************************/
.signup-heading {
  color: #130054;
  font-family: sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

@media (max-width: 480px) {
  .signup-heading {
    color: #130054;
    font-family: sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}
@media (max-width: 480px) {
  .custom-google-button {
    width: 100%;
    border-color: #2596be !important;
    color: #2596be !important;
    width: 200px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: white;
    font-size: 10px;
    cursor: pointer;
    color: black;
    margin-left: 30px;
  }
}
@media (max-width: 480px) {
  .button-style {
    width: 200px;
    height: 25px;
    border: none;
    background-color: #2596be;
    color: white;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 12px;
    display: flex;
    padding: 5px 5px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    font-size: 10px;
    justify-content: center;
    margin-left: 30px;
  }
  .alreadyRegistered_text {
    font-size: 8px;
    margin-top: 5%;
  }
  .viewTerms_text {
    font-size: 13px;
    margin-top: 5% !important;
    align-items: center;
  }
}
.user-lock {
  color: #38abd2;
  font-family: Font Awesome 6 Pro;
  font-size: 65px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  padding-top: 3rem;
  padding-bottom: 25px;
}

.reset-pass-bg {
  background-size: auto;
  background-repeat: no-repeat;
  background-position: right;
}

.Reset-password {
  color: #140054;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  padding-top: 10px;
  padding-bottom: 15px;
}

.Reset-detail {
  color: #718096;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  /* 150% */
  padding-top: 5px;
  text-align: left;
}

.email-sent-detail {
  color: #718096;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  /* 150% */
  padding-top: 10px;
  text-align: left;
}

.password-msgs span {
  margin-left: 2%;
  font-size: 0.75rem;
  vertical-align: middle;
}

.password-msgs {
  max-height: 110px;
}

.condition-row {
  margin-top: 1%;
}

.open-lock {
  padding-bottom: 1rem;
  padding-top: 1rem;
}

.password-field {
  position: relative;
}

.password-input-container {
  position: relative;
}

.password-input-container input {
  width: 100%;
  padding-right: 40px;
}

.new-email {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-top: 15%;
}

.entercode {
  color: rgb(107, 42, 119);
  font-size: 25px;
  padding-top: 20px;
  padding-bottom: 5px;
  font-family: Open Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  /* 133.333% */
}

.bg {
  background-size: cover;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  overflow-x: hidden;
  overflow-y: hidden;
}

* {
  margin: 0;
  padding: 0;
}

.header-language-switcher {
  margin-bottom: 10px;
  margin-right: -20px;
  margin-left: -15px;
}

.logo-design {
  height: 70px;
  padding-top: 25px;
  margin-bottom: 10px;
  margin-top: 2vh;
  margin-left: -20px;
}

.signup-internal-container {
  margin-top: 20px;
}

.Otp-Detail {
  text-align: justify;
  color: grey;
  font-weight: 10px;
  font-size: medium;
  padding-bottom: 25px;
  padding-top: 10px;
}

.otp-boxes {
  width: 42px !important;
  border-radius: 5px;
  border-color: 1px solid #c3e6f2;
  text-align: center;
  margin-right: 5px;
  margin-left: 5px;
}

.resend-email {
  margin-top: 15%;
  color: grey;
  font-size: 12px;
  text-align: center;
}

@media screen and (max-width: 480px) {
  .app {
    padding-left: 0px;
  }
  .logo-design {
    width: 208px;
    height: 41px;
    padding-left: 20px;
    padding-bottom: 10px;
    padding-top: 35px;
  }
}
h1 {
  color: rgb(77, 1, 77);
  text-align: center;
}

a {
  color: #2596be;
}

.policy-blue-bg {
  background-color: #023e8a !important;
  padding: 20px;
  border-radius: 5px;
}

.date-prop {
  color: #ffffff;
  text-align: center;
  /* Center the text horizontally */
  font-size: 14px;
  margin-top: -5px;
}

.privacy-logo {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 220px;
  height: 90px;
}

.privacy-policy-body {
  margin-left: 100px;
  margin-right: 100px;
}

.private-policy-title {
  color: #ffffff;
  margin-top: 10px;
  font-size: 40px;
}

.policy-heading {
  font-size: 26px;
  color: #1e3a8a;
}

.policy-description {
  color: #03045e;
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: bold;
}

.policy-card-design {
  background-color: #9ca3af;
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 20px;
  border-radius: 5px;
  height: 100%;
  align-items: center;
  text-align: center;
}

.policy-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.policy-subheading {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 5px;
}

.policy-details {
  margin: 5px 0 0 0;
  color: #4f5e71;
  font-size: 14px;
}

/* src/components/reusable/NoDataDisplay.scss */
.no-data-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #2c68ad;
  text-align: center;
  width: 100%;
  overflow: hidden;
}

.no-data-message {
  font-size: 14px;
  font-weight: bold;
  margin-top: -80px;
}

.no-data-image {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

/* Help section styling */
.help-section {
  margin-top: 30px;
  text-align: center;
}

.help-section p {
  font-size: 16px;
}

.help-section a {
  font-size: 16px;
  color: #1890ff;
  text-decoration: none;
}

.help-section a:hover {
  text-decoration: underline;
}

.shopify-signin {
  display: flex;
  flex-direction: row;
}

.shopify-signin-btn {
  width: 50%;
  margin-left: 20px;
  height: fit-content;
  margin-top: 28px;
}

#shopify-logo {
  width: 35%;
  margin-bottom: 25px;
}

.menu-icon {
  font-size: 40px;
  color: #ffffff;
}

.top-sub-icons {
  width: 25px;
  height: 19px;
  font-family: sans-serif;
}

.plan-over-icon {
  width: 70px;
  height: 75.32px;
  top: 0px;
  margin-bottom: 1vh;
}

.green-icon {
  color: #28a745;
}

.policy-icon {
  font-size: 40px;
  color: #3079bb;
  /* Adjust the color of the icons */
  margin-bottom: 10px;
}

.facebook-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.step-icon {
  width: 30px;
  height: 30px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.step-icon.completed {
  background-size: cover;
  border: none;
}

.heading-icon-container {
  display: flex;
  align-items: center;
}

:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon + span,
:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon + span,
:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,
:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,
:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-item .anticon + span,
:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span,
:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,
:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {
  color: #ffffff !important;
}

.custom-progress .ant-progress-status-success .anticon-check-circle {
  color: #1890ff !important;
}

.anticon-check-circle {
  font-size: 2vw !important;
}

.plan-icon {
  width: 20px;
  /* Adjust the width as per your requirement */
}

/* Optionally, you can add different sizes for specific plans */
.plan-icon-large {
  width: 30px;
  /* Larger size for images, e.g., Premium Plan */
}

.plan-icon-small {
  width: 15px;
  /* Smaller size for other cases */
}

/* If you want to make images responsive for smaller screens */
@media screen and (max-width: 768px) {
  .plan-icon {
    width: 18px;
    /* Smaller size for tablets */
  }
  .plan-icon-large {
    width: 25px;
  }
  .plan-icon-small {
    width: 12px;
  }
}
@media (max-width: 480px) {
  .plan-icon {
    width: 10px;
    /* Smaller size for tablets */
  }
}
.icon-grid {
  padding-top: 20px;
  margin-left: 20px;
}

/* Onboarding: Connect Sources zigzag layout */
.zigzag-icons-container {
  margin-top: 24px;
}

.zigzag-icon {
  margin-bottom: 24px;
}

.zigzag-left {
  margin-left: 40px;
}

.zigzag-right {
  margin-left: 120px;
}

.social-media-image {
  display: block;
}

.connector-highlight {
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  background-color: #bbf7d0;
}

.source-connector-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.source-connector-header .language-switcher__trigger {
  margin-top: 0;
}

.money-check-icon {
  width: 30px;
  height: 25px;
}

.upgrade-icon {
  color: #1890ff;
  margin-top: 2px;
}

.mastercard-icon {
  width: 35px;
  height: 35px;
  margin-top: -20px;
}

.user-management-icon {
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-left: 18px;
  padding-bottom: 0px !important;
  transition: opacity 0.2s ease-in-out;
}

.user-management-icons {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.disabled-icon {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.audience_icon {
  margin-bottom: 10px;
}

.upload-icon {
  font-size: 2rem;
  color: #3079bb;
}

.p-icon.p-multiselect-token-icon {
  margin-left: 5px;
  width: 12px;
  height: 12px;
}

.chatbot-icon {
  justify-content: end;
}

.openclose-Icons {
  width: 18px;
  height: 18px;
  margin-left: auto;
}

.confirmation-Icon {
  width: 75px;
  height: 75px;
}

.icon-heading {
  display: flex;
  flex-direction: row;
  gap: 1%;
  margin-bottom: 2%;
}

.icon-heading label {
  font-size: 1.2rem;
  color: rgba(44, 104, 173, 0.15);
}

.cross-filled-icon,
.invalid-msg {
  color: #d21c1c;
}

.tick-filled-icon,
.valid-msg {
  color: #28a745;
}

.cross-filled-icon,
.tick-filled-icon {
  margin-left: 1%;
  vertical-align: middle;
}

.tick-filled-icon {
  width: 12px;
  height: 12px;
  vertical-align: middle;
}

.password-msgs {
  margin-top: 2%;
  margin-bottom: 1%;
}

div.PhoneInputCountryIcon.PhoneInputCountryIcon--border,
img.PhoneInputCountryIconImg {
  border: none !important;
}

.PhoneInputInput::placeholder {
  color: #9ca3af !important;
  font-style: italic;
}

.eye-icon {
  position: absolute !important;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  vertical-align: middle !important;
}

svg.p-icon.p-multiselect-trigger-icon.p-c {
  color: #cbd5e1;
  height: 15px;
  width: 14px;
}

.error-icon-data-fetching {
  width: 40px;
  height: 40px;
  margin-right: 20px;
}

.shopify-login {
  max-width: 700px;
  margin: 0 auto;
  padding: 50px;
  background-color: #ffffff;
  border-radius: 8px;
  font-family: Arial, sans-serif;
  top: 50%;
  left: 50%;
}

/***********************Ask Datatram*********************/
.chatbot-container {
  position: fixed;
  bottom: 42px;
  right: 20px;
  background: #2c68ad;
  z-index: 9999;
  border-radius: 20px;
  margin-right: 10px;
  margin-bottom: -10px;
}

div.chatbot-header {
  cursor: pointer;
  padding: 10px;
}

.campaign-search-input {
  height: 45px !important;
  color: rgba(0, 0, 0, 0.88);
}

.campaign-search-input {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  transition: border-color 0.2s ease;
  margin-bottom: 2px !important;
}

.campaign-search-input:hover {
  border-color: #3b82f6; /* Tailwind blue-500 */
}

.campaign-search-input:focus {
  border-color: #3b82f6; /* Blue border on focus */
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

.header-shadow {
  color: grey;
}

.bot-description {
  color: #a0aec0;
  font-size: small;
  padding: 14px;
  text-align: center;
}

img.enterBTN-chat {
  cursor: pointer;
}

.convo-background {
  width: 40%; /* Adjust size as needed */
  height: auto;
  display: block; /* Ensures margin auto works */
  margin: 0 auto; /* Centers horizontally */
  margin-top: 15px;
}

.chatbox {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  width: 370px;
  height: 500px;
  display: flex;
  flex-direction: column;
}

.menuHeading {
  color: #140054;
  font-size: 14px;
  font-weight: bolder;
}

.askDT-logo {
  width: 100px;
  height: 80px;
}

.askDT-logo-inside {
  width: 70px;
  height: 50px;
  margin-right: -20px;
  margin-left: -10px;
}

.menuOption span {
  color: #718096;
  font-size: 12px;
}

.menuHeader {
  display: flex;
  justify-content: space-between; /* Pushes items to opposite ends */
  align-items: center; /* Aligns them vertically */
  width: 100%; /* Ensures it takes full width */
  padding: 10px; /* Optional: Add spacing */
}

div.chatbot-container.closed {
  outline: #007bff;
  z-index: 9999;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  position: absolute;
  bottom: 120%; /* Position above the circle */
  background-color: #555; /* Grey background */
  color: #fff; /* White text */
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
  z-index: 1000;
}

/* The launcher is draggable anywhere on screen, so a fixed centered tooltip can run off
   whichever edge it's dragged near — grow away from that edge instead of straddling it. */
.tooltip-text--left {
  left: 0;
}

.tooltip-text--right {
  left: auto;
  right: 0;
}

.tooltip-container:hover .tooltip-text {
  opacity: 1;
  visibility: visible;
}

.chatbot-border {
  width: 60px; /* circle size */
  height: 60px;
  border-radius: 50%; /* makes it a perfect circle */
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2C68AD; /* inner fill */
  border: 10px solid #2C68AD; /* thick blue border */
  cursor: pointer;
  position: fixed; /* floating button */
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

.chatbot-border:active {
  cursor: grabbing;
}

.chatbot-logo {
  width: 40px;
  height: 40px;
}

.chatbot-border:focus {
  outline: 3px solid #007bff; /* blue outline when focused */
  outline-offset: 2px; /* small spacing from border */
}

.blue-border {
  border-color: #0172cb !important;
  border-width: 2px;
}

.chatbox-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #2c68ad;
  padding: 0 8px;
  border-bottom: 1px solid #007bff;
}

.chatbox-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chatbot-heading {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}

.chatbox-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chatbot {
  display: flex;
  align-items: center;
  background: white;
  padding: 10px;
  border-radius: 25px;
  border: #007bff;
  cursor: pointer;
  color: white;
}

.chatbot-button .logo {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.chatbot-title {
  color: white;
  font-weight: bolder;
  margin-right: 10px;
}

.chatbox-header .logo {
  width: 25px;
  height: 25px;
}

.close-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
}

.conversation-area {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
  background: white;
}

.input-area {
  display: flex;
  padding: 8px;
  background: #fff;
  border-top: 1px solid #ddd;
}

.input-area input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 12px;
  margin-right: 15px;
}

.enterBTN-chat {
  padding: 5px;
}

.options-chatbot {
  margin-right: 5px;
  margin-bottom: 5px;
}

.menuOption img {
  margin-left: 12px;
  margin-right: 12px;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 1px;
  overflow-y: auto;
}

.message {
  padding: 8px 12px;
  max-width: 80%;
  position: relative;
  min-width: 80px;
  min-height: 50px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */
  margin-bottom: 2px;
}

.message.user {
  align-self: flex-end;
  background-color: #2C68AD;
  color: white;
  font-size: 12px;
  border-radius: 10px;
  font-weight: 400;
  font-family: "opensans", sans-serif;
  width: 200px;
}

.message.bot {
  align-self: flex-start;
  background-color: rgba(44, 104, 173, 0.1607843137); /* light gray/blue */
  border-radius: 8px;
  font-size: 12px;
  color: #000000;
  text-align: left;
  max-width: 80%;
  font-weight: 500;
  font-family: "opensans", sans-serif;
  margin-left: 35px;
}

.timestamp {
  font-size: 10px;
  position: absolute;
  bottom: 4px;
  right: 8px;
  font-style: italic;
  margin-top: 5px;
  color: #fff;
}

.message-text {
  margin-bottom: 5px;
  text-align: justify;
  font-size: 14px;
  color: #000000;
  font-family: "opensans", sans-serif;
  font-weight: 400;
  font-size: 14px;
}

.suggested-question {
  border-radius: 25px;
  border: 2px solid skyblue;
  background-color: #e0f7ff;
  padding: 5px 8px;
  font-size: 12px;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  margin: 5px 10px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #FFFFFF;
  font-weight: 400;
  font-family: "opensans", sans-serif;
}

.suggested-question:hover {
  background-color: #cceeff;
}

.chatbot-header {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* ✅ left alignment */
  text-align: left;
}

.expand-icon {
  opacity: 1 !important;
  filter: none !important;
}

.suggested-questions-heading {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  margin: 10px 0;
  position: relative;
  text-transform: uppercase;
}

.suggested-questions-heading::before,
.suggested-questions-heading::after {
  content: "";
  flex: 1 1;
  height: 2px;
  background-color: #cceeff;
  margin: 0 10px;
}

.submenu-question {
  font-size: 10px;
  color: #718096;
  padding-left: 45px;
  padding-top: 5px;
  padding-right: 10px;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
}

.menuOption img:last-child {
  width: 10px;
  height: 10px;
}

.question-icon {
  width: 20px;
  height: 10px;
  padding-right: 10px;
}

.chatbot-welcome-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
}

.chatbot-avatar {
  flex-shrink: 0;
  margin-right: 8px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-radius: 50%;
  background-color: #2C68AD !important;
  overflow: hidden;
  width: 32px;
  height: 32px;
  margin-top: 0;
  align-self: flex-start;
}

.chatbot-welcome-message {
  background-color: rgba(44, 104, 173, 0.1607843137);
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 12px;
  color: #000000;
  text-align: left;
  max-width: 80%;
  font-weight: 400;
  font-family: "opensans", sans-serif;
}

.quick-action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 18px;
  margin: 0 0 8px;
}

.chatbot-action-button {
  background-color: #fff;
  border: 1px solid #b8d2f1;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1f63ad;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.chatbot-action-button .arrow {
  width: 12px;
  height: 12px;
  margin-top: 10px;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.chatbot-action-button .arrow img {
  width: 12px;
  height: 12px;
}

[dir=rtl] .chatbot-action-button .arrow img {
  transform: scaleX(-1);
}

.chatbot-action-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chatbot-action-icon {
  color: #1f63ad;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.chatbot-action-icon svg {
  width: 22px;
  height: 22px;
}

.chatbot-action-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.chatbot-action-title {
  color: #1f63ad;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
}

.chatbot-action-subtitle {
  color: #6b7280;
  font-size: 10px;
  line-height: 1.2;
  font-weight: 400;
}

.chatbot-action-button:hover {
  background-color: #edf3fb;
  border-color: #8db6e5;
}

.chatbot-send-button {
  background-color: transparent !important;
  border: none;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 18px;
  padding: 0;
}

.send-icon {
  transform: rotate(45deg);
  transition: transform 0.2s ease;
  margin-right: 15px;
}

.clip-icon {
  transform: rotate(-90deg);
  transition: transform 0.2s ease;
  margin-right: 15px;
}

.category-bubble-container {
  display: flex;
  margin: 8px 0;
  max-width: 100%;
  align-items: flex-start;
  padding: 0 16px 0 0;
  width: 100%;
  box-sizing: border-box;
}

.category-selection-container {
  background: rgba(44, 104, 173, 0.1607843137);
  border-radius: 18px;
  padding: 12px 16px;
  margin-left: 5px;
  max-width: calc(100% - 64px);
  position: relative;
  word-wrap: break-word;
  margin-right: 16px;
  box-sizing: border-box;
  flex: 1 1;
  align-self: flex-start;
}

.category-prompt {
  font-size: 14px;
  margin-bottom: 12px;
  color: #333;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.category-search-empty {
  font-size: 13px;
  color: #555;
  margin: 0 0 10px;
  line-height: 1.4;
}

.category-grid .category-search-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #000000;
  border-radius: 8px;
  background-color: #fff;
  align-self: start;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  grid-column: 1/-1;
}

.category-grid .category-search-cell:focus-within {
  border-color: #2c68ad;
  box-shadow: 0 0 0 2px rgba(44, 104, 173, 0.12);
}

.category-grid .category-search-icon {
  flex-shrink: 0;
  color: #64748b;
  width: 12px;
  height: 12px;
}

.category-grid .category-search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-family: "opensans", sans-serif;
  font-weight: 400;
  color: #333;
  padding: 0;
  text-align: start;
}

.category-grid .category-search-input::placeholder {
  color: #888;
}

[dir=rtl] .category-search-cell {
  flex-direction: row-reverse;
}

.category-item {
  padding: 8px 0px;
  border: 1px solid #000000;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
}

.category-item:hover {
  border-color: #000000;
  background: #fafafa;
}

.category-item.selected {
  background-color: rgba(44, 104, 173, 0.18);
  border-color: #2c68ad;
}

.category-name {
  font-size: 12px;
  font-family: "opensans", sans-serif;
  font-weight: 400;
}

.category-actions {
  display: flex;
  justify-content: flex-end;
}

.proceed-button {
  background: #2C68AD;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-right: 5px;
}
.proceed-button:hover:not(:disabled) {
  background-color: #23538A;
}
.proceed-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.7;
}

.proceed-button:hover {
  background: #3a7bb0;
}

.campaign-options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 per row */
  gap: 12px; /* spacing between buttons */
  margin: 12px 12px;
}

.campaign-option-button {
  background-color: #ffffff;
  border: 2px solid #9E9B9B;
  padding: 5px 8px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
  color: #000000;
  cursor: pointer;
  text-align: left; /* so text + arrow align properly */
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.campaign-option-button:hover {
  border-color: #ff6c00;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.campaign-option-button .arrow img {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

[dir=rtl] .campaign-option-button .arrow img {
  transform: scaleX(-1);
}

.promptbox-container {
  background: rgba(44, 104, 173, 0.1607843137);
  border-radius: 12px;
  padding: 16px;
  margin: 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  width: 80% !important;
  margin-left: 35px;
}

.promptbox-subtitle {
  margin-bottom: 5px;
  text-align: justify;
  font-size: 14px;
  color: #000000;
  font-family: "opensans", sans-serif;
  font-weight: 400;
}

.promptbox-textarea {
  width: 100%;
  min-height: 80px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #ddd;
  margin-bottom: 16px;
}

.promptbox-tone-section {
  margin-bottom: 16px;
}

.promptbox-tone-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.promptbox-tone-btn {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 6px 12px;
  background: #f7f7f7;
  cursor: pointer;
}

.promptbox-tone-btn.active {
  background: #2C68AD;
  color: #fff;
  border-color: #2C68AD;
}

.promptbox-form-section {
  margin-bottom: 12px;
}

.promptbox-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 12px;
}

.promptbox-loading {
  margin-left: 8px;
}

.menu-questions-container {
  margin: 12px 0;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 12px;
  width: 80%;
}

.menu-questions-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.menu-question-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: background 0.2s;
}

.menu-question-btn:hover {
  background: #f0f0f0;
}

.menu-question-icon {
  width: 20px;
  height: 20px;
}

/* Common row */
.message-row {
  display: flex;
  align-items: flex-start;
  margin: 8px 0;
  direction: ltr;
}

/* Bubbles */
.message-bubble {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 10px;
  word-break: break-word;
  unicode-bidi: plaintext;
}

.message-bubble ul,
.message-bubble ol,
.message-bubble li {
  color: currentColor;
}

.message-bubble ul,
.message-bubble ol {
  margin: 0.5rem 0;
  padding-left: 1.25rem;
}

.message-bubble li {
  margin: 0.25rem 0;
  padding-left: 0;
}

.message-bubble p {
  margin: 0.5rem 0;
}

.message-bubble > *:first-child {
  margin-top: 0;
}

.message-bubble > *:last-child {
  margin-bottom: 0;
}

/* Bot bubble (blue background) */
.bot-bubble {
  background: rgba(44, 104, 173, 0.1607843137);
  color: #000000;
  font-family: "opensans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  margin-left: 5px;
}

/* User bubble (keep your existing style) */
.user-bubble {
  background: #2C68AD;
  color: #fff;
  margin-left: auto; /* push to right */
  border-radius: 10px 10px 0 10px;
  font-family: "opensans", sans-serif;
  font-weight: 400;
  font-size: 14px;
}

.show-more-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  gap: 4px;
  margin-bottom: 20px;
  font-family: "opensans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  align-items: center !important;
  justify-content: center;
  display: block;
  margin: 0 auto;
  padding: 10px;
}

.typing-message {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
}

.typing-wrapper {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.message.bot {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.typing-bubble {
  background: rgba(44, 104, 173, 0.1607843137);
  color: #000000;
  padding: 10px 14px;
  border-radius: 10px;
  max-width: 70%;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: -6px;
}

.typing-container {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
  margin-top: 7px;
}

.typing-text {
  font-size: 14px;
  color: #555;
  font-style: italic;
  font-family: "opensans", sans-serif;
  animation: blinkText 1.6s infinite;
}

@keyframes blinkText {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
.typing-indicator {
  display: flex;
  gap: 3px;
}

.typing-indicator span {
  width: 6px;
  height: 6px;
  background-color: #777;
  border-radius: 50%;
  display: inline-block;
  animation: typingBlink 1.4s infinite both;
}

.typing-indicator span:nth-child(1) {
  animation-delay: 0s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typingBlink {
  0% {
    opacity: 0.3;
    transform: translateY(0);
  }
  20% {
    opacity: 1;
    transform: translateY(-3px);
  }
  40% {
    opacity: 0.3;
    transform: translateY(0);
  }
}
.template-action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.template-btn {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: background 0.2s ease;
}

.template-btn.primary {
  background-color: #2c68ad;
  color: #fff;
}

.template-btn.primary:hover {
  background-color: #1e4c7d;
}

.template-btn.secondary {
  background-color: #f2f2f2;
  color: #333;
}

.template-btn.secondary:hover {
  background-color: #e0e0e0;
}

.ant-picker-dropdown {
  z-index: 9999 !important;
}

.audience-selection-container {
  margin-bottom: 24px;
}

.audience-list-heading,
.custom-list-heading {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
  margin-top: 24px;
  font-family: "opensans", sans-serif;
  margin-left: 35px;
}

.audience-list-heading {
  margin-top: 0;
}

/* Search cell sits in first grid slot; matches .campaign-option-button frame */
.campaign-screen-grid .audience-list-search-cell,
.campaign-options-grid .audience-list-search-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  border: 2px solid #9e9b9b;
  border-radius: 8px;
  padding: 5px 8px;
  align-self: start;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  grid-column: 1/-1;
}

.campaign-screen-grid .audience-list-search-cell:hover,
.campaign-options-grid .audience-list-search-cell:hover {
  border-color: #2c68ad;
  box-shadow: 0 1px 4px rgba(44, 104, 173, 0.1);
}

.campaign-screen-grid .audience-list-search-cell:focus-within,
.campaign-options-grid .audience-list-search-cell:focus-within {
  border-color: #2c68ad;
  box-shadow: 0 1px 4px rgba(44, 104, 173, 0.18);
}

.campaign-screen-grid .audience-list-search-icon,
.campaign-options-grid .audience-list-search-icon {
  flex-shrink: 0;
  color: #5b6570;
  width: 12px;
  height: 12px;
}

.campaign-screen-grid .audience-list-search-input,
.campaign-options-grid .audience-list-search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #000000;
  font-size: 10px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.35;
  padding: 0;
}

.campaign-screen-grid .audience-list-search-input::placeholder,
.campaign-options-grid .audience-list-search-input::placeholder {
  color: #6b7280;
  font-weight: 400;
}

.audience-list-empty-filter {
  margin: 0 12px 8px 35px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

[dir=rtl] .audience-list-search-cell {
  flex-direction: row-reverse;
}

.campaign-options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 16px;
  margin-bottom: 8px;
  margin-left: 35px;
}

.chatbot-menu-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.chatbot-menu-dots {
  font-size: 26px;
  color: #fff;
  padding: 0 8px;
  -webkit-user-select: none;
          user-select: none;
  margin-bottom: 2px;
}

.chatbox-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
}
.chatbox-header-actions .expand-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
  opacity: 0.8;
}
.chatbox-header-actions .expand-icon:hover {
  transform: scale(1.1);
  opacity: 1;
}

.chatbot-menu-dropdown {
  position: absolute;
  top: 32px;
  right: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 10;
  min-width: 120px;
  padding: 4px 0;
}

.chatbot-menu-dropdown button {
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  padding: 10px 18px;
  font-size: 13px;
  font-family: "opensans", sans-serif;
  color: #d32f2f;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s;
  font-weight: 600;
}

.chatbot-menu-dropdown button:hover {
  background: #f5f5f5;
}

.confirm-buttons {
  display: flex;
  gap: 12px;
  margin-top: 10px;
  margin-left: 40px;
}

.schedule-picker-box {
  margin-top: 1rem;
  padding: 1.5rem;
  background-color: rgba(44, 104, 173, 0.1607843137);
  border-radius: 1rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  width: 100%;
  margin-left: 35px;
  max-width: 270px;
  animation: fadeIn 0.3s ease-in-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.schedule-picker-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #222;
  font-family: "opensans", sans-serif;
}

.schedule-picker-paragraph {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #222;
  font-family: "opensans", sans-serif;
}

.schedule-picker-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  color: #222;
  font-family: "opensans", sans-serif;
}

.schedule-picker-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #444;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: "opensans", sans-serif;
}

.schedule-picker-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  color: #333;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  font-family: "opensans", sans-serif;
}
.schedule-picker-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  outline: none;
}

.schedule-label {
  display: block;
  margin-bottom: 5px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  font-family: "opensans", sans-serif;
}

.schedule-picker-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.preset-button {
  background-color: #ffffff;
  border: 1px solid #000000;
  border-radius: 0.5rem;
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  color: #374151;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: all 0.2s ease;
}
.preset-button:hover {
  background: #fafafa;
}
.preset-button:active {
  background-color: rgba(44, 104, 173, 0.18);
  border-color: #2c68ad;
}

.schedule-actions {
  margin-top: 10px;
}

.confirmation-buttons {
  display: flex;
  gap: 10px;
  margin-top: 8px;
  margin-left: 35px;
  margin-right: 35px;
}

.yes-button {
  background-color: #2C68AD;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
}

.no-button {
  background-color: #e4e4e4;
  color: #333;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
}

.required-star {
  color: red;
  margin-left: 4px;
}

.compact-input-area {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 60px;
  margin: 0 5px 7px;
  padding: 8px 12px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  width: calc(100% - 10px);
  min-width: 0;
}

/* ✅ Inner row for input and buttons */
.input-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* ✅ Make input take available width */
.input-row input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
}

.compact-input-area {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: calc(100% - 10px);
  margin-left: 5px;
  margin-right: 5px;
  box-sizing: border-box;
  padding: 4px 12px;
  border-radius: 34px;
  min-width: 0;
}

/* Host wraps ChatComposerPanel (unified border + notice); strip inner pill chrome */
.compact-input-area--composer-panel-host {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  width: 100% !important;
  gap: 10px;
}

.file-preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  min-width: 0;
  padding: 0;
  margin: 0 0 4px;
  box-sizing: border-box;
}

.file-thumbnail {
  position: relative;
  box-sizing: border-box;
}

/* Image preview: fixed tile, remove control inside corner (no overlap with outer pill) */
.file-thumbnail--image {
  width: 102px;
  height: 72px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f1f5f9;
}

.file-thumbnail--image .remove-file-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
}

/* Documents / CSV / PDF: full-width row, chip truncates long names */
.file-thumbnail--document {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  height: auto;
  padding: 2px 0 4px;
}

.file-thumbnail--document .file-chip {
  flex: 1 1;
  min-width: 0;
}

.file-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 8px 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  max-width: 100%;
  box-sizing: border-box;
}

.file-icon {
  flex-shrink: 0;
  display: inline-flex;
  color: #2c68ad;
}

.file-name {
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  line-height: 1.35;
  color: #334155;
  text-align: start;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 4px solid #6b7280;
}

.remove-file-btn {
  background: #2c68ad;
  color: #ffffff;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  min-width: 22px;
  min-height: 22px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  flex-shrink: 0;
}

.remove-file-btn--inline {
  position: static;
}

.remove-file-btn:hover {
  background: #1f63ad;
}

.remove-file-btn:focus-visible {
  outline: 2px solid rgba(44, 104, 173, 0.45);
  outline-offset: 2px;
}

.input-row {
  display: flex;
  align-items: center;
  border-radius: 20px;
  padding: 0 2px;
}

.input-row input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  padding: 0 8px;
  min-height: 28px;
}

.chatbot-send-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
}

.clip-icon, .send-icon {
  width: 18px;
  height: 18px;
}

.chat-input-attach-trigger {
  display: inline-flex;
}

.input-row .chat-input-icon {
  transform: none !important;
  margin: 0 !important;
}

.chat-input-icon-button.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.chat-input-icon-button.disabled .chat-input-icon {
  color: #8ca3c0;
}

/* ✅ Ensure buttons stay centered */
.chatbot-send-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  /* Earlier .chatbot-send-button rule locks width/height to 10px, clipping
     the 18px icon down to an invisible sliver — reclaim real size here. */
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  margin-left: 0;
  overflow: visible;
}

.chat-file {
  margin-top: 6px;
  display: flex;
}

.chat-file.user {
  justify-content: flex-end;
}

.chat-file.bot {
  justify-content: flex-start;
}

.chat-image-preview {
  max-width: 220px;
  max-height: 160px;
  border-radius: 8px;
  margin-top: 4px;
  cursor: pointer;
  margin-left: 0;
}

.chat-file-link {
  display: inline-block;
  padding: 6px 10px;
  background: #f5f5f5;
  border-radius: 6px;
  text-decoration: none;
  color: #333;
  font-size: 14px;
  margin-left: 0;
}

.schedule-picker-box.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.template-btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.clear-chat-btn {
  margin-top: -5px;
}

@media (max-width: 480px) {
  .chatbot-container.open {
    inset: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    border-radius: 0;
    width: 100%;
    height: 100dvh;
  }
  .chatbot-container.open .chatbox {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  .chatbot-container.open .conversation-area {
    min-height: 0;
  }
  .chatbot-container.open .campaign-options-grid,
  .chatbot-container.open .category-grid {
    grid-template-columns: 1fr;
  }
  .message-bubble {
    max-width: calc(100% - 44px);
  }
}
html,
body,
#root {
  height: 100%;
  margin: 0;
}

.sidebar + .ant-layout {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

.ant-layout-has-sider {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  overflow: hidden;
}

.sidebar + .ant-layout .ant-layout-content {
  flex: 1 1;
  min-width: 0;
  overflow-y: auto;
}

.ant-layout {
  min-height: 86vh;
  min-height: 0;
}

.ant-layout-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
}

.ant-layout-content::-webkit-scrollbar {
  width: 8px;
}

.ant-layout-content::-webkit-scrollbar-track {
  background: transparent;
}

.ant-layout-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 10px;
}

.ant-layout-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.sidebar.ant-layout-sider {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

.sidebar .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.sidebar + .ant-layout {
  margin-inline-start: 0 !important;
  padding-inline-start: 0 !important;
}

.sidebar {
  background-color: #2c68ad;
  transition: width 0.25s ease;
  overflow-x: hidden;
  padding: 0;
  flex-shrink: 0;
  position: relative;
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}

.sidebar-hamburger {
  position: fixed;
  top: 12px;
  inset-inline-start: 12px;
  z-index: 1100;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  background: #2c68ad;
  color: #ffffff;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.sidebar-hamburger svg {
  display: block;
}

.sidebar--drawer {
  height: 100%;
}

.sidebar-inner {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.45) rgba(255, 255, 255, 0.12);
}

.sidebar-sections {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

.sidebar-sections::-webkit-scrollbar {
  width: 8px;
}

.sidebar-sections::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 10px;
}

.sidebar-sections::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.45);
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.12);
}

.sidebar-sections::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.6);
}

.sidebar-inner.collapsed {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 25px !important;
}

.section-header .collapsed {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px !important;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  margin: 4px 8px;
  transition: background 0.15s ease;
}

.section-header.open {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 8px !important;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin: 4px 8px;
  transition: background 0.15s ease;
}

.section-header.open:hover {
  background: rgba(255, 255, 255, 0.08);
}

.section-header.open .icon {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
}

.section-header.open .label {
  flex: 1 1;
}

.sidebar-icon-img {
  width: 20px;
  height: 20px;
}

.sub-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 8px 10px;
  padding-inline-start: 35px;
  margin: 2px 8px;
  font-size: 12px;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s ease;
}

.sub-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.item-label {
  font-weight: 500;
}

.item-icon {
  min-width: 20px;
  display: flex;
  justify-content: flex-start;
}

.sub-active {
  background: #2a5f99;
}

.sub-sub-item {
  padding: 6px 16px;
  padding-inline-start: 68px;
  margin: 2px 8px;
  border-radius: 6px;
  font-size: 12.5px;
  color: #eaf1fb;
  cursor: pointer;
  transition: background 0.15s ease;
}

.sub-sub-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.sub-sub-active {
  background: #3a78b8;
  color: #ffffff;
}

.sidebar.collapsed .section-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.sidebar.collapsed .label,
.sidebar.collapsed .sub-item,
.sidebar.collapsed .sub-sub-item {
  display: none;
}

.section-arrow {
  margin-inline-end: 15px;
  font-size: 12px;
  color: #ffffff;
  flex-shrink: 0;
}

.section-header.section-active {
  background: #23538a;
  color: white;
}

.sub-item.sub-active,
.sub-sub-item.sub-sub-active {
  background-color: #23538a;
  color: white;
}

.sub-item.sub-active .item-label,
.sub-sub-item.sub-sub-active .label {
  color: white;
}

.sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  padding: 16px 18px;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.sidebar-footer:hover {
  background: rgba(255, 255, 255, 0.08);
}

.sidebar-footer.collapsed {
  justify-content: center;
  padding: 16px;
}

.sidebar-footer__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.home-layout-shell .home-layout-main.responsive-margin,
.home-layout-shell .home-layout-main.header-style {
  margin-left: 0 !important;
}

@media (max-width: 768px) {
  .home-layout-shell .home-layout-main,
  .home-layout-shell .home-layout-main.responsive-margin,
  .home-layout-shell .home-layout-main.header-style {
    margin-left: 0 !important;
    width: 100% !important;
  }
  .home-layout-shell .ant-layout-content {
    margin-inline-start: 0 !important;
    padding-inline-start: 0 !important;
  }
}
/*********Loading Screen**********/
.loading-screen-container {
  margin: 0;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;
  box-sizing: border-box;
}

.loading-screen-heading {
  margin-top: -20px;
  font-size: 3vw;
  font-weight: bolder;
  color: #ffffff;
}

.loading-screen {
  background-image: url("D:ÚtatramÚtatram-fepublicimagesLoading-Background.jpg") !important;
  background-size: cover;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  overflow-x: hidden;
  overflow-y: hidden;
}

.loading-content {
  text-align: center;
}

.loading-gif {
  margin-top: 20px;
  width: 30%;
}

.dt-logo-loading-scr {
  position: absolute;
  top: 4%;
  left: 2%;
  z-index: 10;
}

.dt-logo-loading-scr img {
  height: auto;
  width: 100%;
}

.page-enter {
  opacity: 0;
}

.page-enter-active {
  opacity: 1;
  transition: opacity 800ms ease-in-out;
}

.page-exit {
  opacity: 1;
}

.page-exit-active {
  opacity: 0;
  transition: opacity 3000ms ease-in-out;
}

.custom-progress .ant-progress-text {
  color: #ffffff !important;
}

.ant-progress-text {
  font-size: 1.5vw;
}

.custom-progress .ant-progress-status-success .ant-progress-text-success {
  color: #ffffff !important;
  font-size: 1.5vw;
}

.custom-progress .ant-progress-text-success {
  color: #ffffff !important;
}

.fade-out {
  opacity: 0;
  transition: opacity 1.5s ease-out;
}

.loading-screen-heading.now-see-the-magic {
  opacity: 1;
  animation: fadeIn 2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.connected {
  border: 2px solid #28a745;
  background-color: rgba(40, 167, 69, 0.2);
  border-radius: 55px;
  width: 55px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tableau-container {
  border: 1px solid #9ca3af;
  border-radius: 4px;
  overflow: hidden;
}

.tableau-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.tableau-scroll-inner {
  display: inline-block;
  width: 100%;
}

.over-flow-y {
  overflow-y: hidden;
  max-height: 100vh;
}

.payment-card {
  width: 95px;
  height: 90px;
  padding: 10px;
  margin-bottom: 10px;
}

.card {
  width: 320px;
  height: 190px;
  padding: 10px;
  border: none;
}

.zoomable-div:hover {
  transform: scale(1.02);
  border-color: #1890ff;
  border-radius: 5px;
}

.zoomable-div-two {
  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;
  border: 1px solid;
  border-color: transparent;
  padding: 10px;
  border-radius: 2px;
  width: 300px;
  margin-top: 5%;
}

.zoomable-div-two:hover {
  transform: scale(1.02);
  border-color: #1890ff;
  border-radius: 5px;
}

.zoomable-div {
  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;
  border: 1px solid;
  border-color: transparent;
  padding: 10px;
  border-radius: 2px;
  width: 300px;
  max-width: 300px;
  margin-top: 15%;
}

/**************************************PAYMENT CONTAINER AND PAYMENTCONFIRMATION******************************/
@media (max-width: 480px) {
  .payment-image {
    margin-bottom: 20px;
    width: 200px;
    height: 155px;
    padding-top: 40px;
  }
}
@media (max-width: 480px) {
  .group-image {
    margin-bottom: 10px;
    width: 200px;
    height: 150px;
    padding-top: 40px;
  }
  /**********************************************Payment Confirmation****************************************/
}
@media (max-width: 480px) and (max-width: 480px) {
  .pc {
    color: var(--text, #718096);
    font-family: Open Sans;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    padding-top: 15px;
  }
}
@media (max-width: 480px) {
  .group-image-container {
    display: flex;
    padding-left: 40px;
  }
  .group-image {
    margin-bottom: 10px;
    width: 400px;
    height: 255px;
    padding-top: 40px;
  }
  .plan-payment-header {
    display: flex;
    padding-left: 40px;
    margin-top: 40px;
  }
}
@media (max-width: 480px) and (max-width: 480px) {
  .payment-confirm-2 {
    margin-bottom: 10px;
    width: 200px;
    height: 150px;
    padding-top: 20px;
    margin-left: 35px;
  }
}
@media (max-width: 480px) {
  .payment-container-3 {
    display: flex;
    padding-left: 40px;
    margin-top: 40px;
  }
  .money-check-2 {
    width: 30px;
    height: 25px;
  }
  .plan-pay-2 {
    color: #150054;
    font-size: 13px;
    font-weight: bold;
    padding-top: 4px;
  }
  .paragraph-2 {
    display: grid;
    padding-left: 40px;
  }
  .plan-payment-title {
    color: #150054;
    font-size: 13px;
    font-weight: bold;
    padding-top: 4px;
    margin-left: 10px;
  }
  .payment-details {
    display: flex;
  }
  .payment-labels,
  .payment-values {
    display: grid;
    padding-left: 40px;
  }
  .subscription-info {
    margin-top: 21px;
  }
  .upgrade-container {
    display: flex;
  }
  .upgrade-text {
    color: #38abd2;
    text-align: left;
    padding-left: 4px;
  }
  .payment-method {
    margin-top: 20px;
  }
  .billing-info {
    margin-top: 25px;
  }
  .plan-payment-title {
    color: #150054;
    font-size: 10px;
    font-weight: bold;
    padding-top: 4px;
    margin-left: 65px;
  }
  .subscription-info {
    margin-top: 21px;
    font-size: 8px;
  }
  .pcr {
    color: var(--placeholder, #a0aec0);
    font-family: Open Sans;
    font-size: 8px;
    font-style: normal;
    font-weight: 400;
    margin-top: 21px;
  }
}
.payment-confirmation {
  display: grid;
  padding-left: 50px;
}

.payment-confirm-2 {
  margin-bottom: 40px;
  width: 450px;
  height: 300px;
  padding-top: 30px;
}

.payment-confirmation-heading {
  padding-top: 20px;
  padding-left: 20px;
  text-align: left;
  margin-left: 20px;
}

/*********** PaymentConfrimation**********/
.payment_method {
  display: flex;
  flex-direction: row;
}

@media (max-width: 480px) {
  .card {
    width: 150px;
    height: 100px;
    padding: 10px;
  }
}
@media (max-width: 480px) and (max-width: 480px) {
  .paynow {
    max-width: 100px;
    color: var(--white, #fff);
    text-align: center;
    font-family: "Open Sans";
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 8px;
    padding: 5px;
  }
}
.paynow {
  width: 250px;
  color: var(--white, #fff);
  text-align: center;
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  /* 150% */
}

/*.invoice-page-wrapper {
  width: 794px;
  height: 1123px; // A4 height at 96 DPI
  box-sizing: border-box;
  padding: 24px;
  background-color: white;
  font-family: 'Arial', sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto; // center horizontally
}*/
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.invoice-page-wrapper {
  width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  background: white;
  display: flex;
  flex-direction: column;
  border: 6px solid \\\$brand-primary;
  box-sizing: border-box;
}

.invoice-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}

.invoice-bold {
  font-weight: 700;
  padding-right: 15px;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px 0 30px;
  align-items: flex-start;
}

.invoice-logo-section {
  display: flex;
  align-items: flex-start;
  padding: 0%;
  margin-top: 10%;
  padding-left: 10px;
}

.invoice-title-wrap {
  margin-left: 5px;
}

.invoice-title {
  text-transform: uppercase;
  font-size: 18px;
  color: \\\$brand-primary;
}

.invoice-sub-title {
  font-size: 12px;
}

.invoice-info-section {
  text-align: right;
  margin-top: 120px;
  padding: 0 0px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.invoice-heading {
  font-size: 28px;
  color: \\\$brand-primary;
}

.invoice-detail-row {
  display: flex;
  width: 100%;
}

.invoice-detail-row span:first-child {
  width: 90px;
  text-align: left;
}

.invoice-detail-row span:last-child {
  width: calc(100% - 90px);
}

.invoice-bill-wrap {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  align-items: flex-start;
  margin-top: -60px;
}

.invoice-bill-to {
  font-size: 20px;
  padding-left: 20px;
}

.invoice-name,
.invoice-final .invoice-price {
  color: \\\$brand-primary;
  font-size: 20px;
}

.invoice-main-table {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  margin-top: 10%;
}

.invoice-table-header {
  background: \\\$brand-primary;
  color: white;
  font-size: 12px;
  display: flex;
  padding: 10px;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.invoice-table-row {
  display: flex;
  border-bottom: 1px solid #03045e;
}

.invoice-table-col {
  padding: 10px;
}

.invoice-col-description {
  width: 45%;
}

.invoice-col-qty {
  width: 10%;
  text-align: center;
}

.invoice-col-unit-price {
  width: 20%;
  text-align: center;
}

.invoice-col-amount {
  width: 25%;
  text-align: right;
}

.invoice-summary-section {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 5px 20px 20px 20px;
  margin-top: 20px;
}

.invoice-payment-method {
  padding-left: 30px;
}

.invoice-totals {
  width: 30%;
  font-size: 14px;
  margin-bottom: 130px;
  padding-left: -20px;
}

.invoice-totals p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  margin: 0;
}

.invoice-totals p span {
  padding: 0 10px;
}

.invoice-totals p span:first-child {
  width: 60%;
  text-align: left;
}

.invoice-totals p span:last-child {
  width: 40%;
  text-align: right;
}

.invoice-totals p:last-child {
  font-weight: bold;
}
.invoice-totals p:last-child span {
  padding: 12px 15px;
}
.invoice-totals p:last-child span:first-child {
  background: \\\$brand-primary;
  color: white;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.invoice-totals p:last-child span:last-child {
  background: \\\$brand-primary;
  color: white;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.invoice-notes-section {
  font-weight: 700;
  margin-top: -90px;
  padding-left: 20px;
  align-items: center;
  justify-content: center;
}

.invoice-notes-heading {
  font-size: 16px;
  text-decoration: underline;
}

.invoice-notes {
  font-size: 14px;
  color: \\\$brand-primary;
  margin-top: -10px;
}

.invoice-logo {
  max-width: 200px;
  height: auto;
}

.bill-to-heading {
  font-size: 16px;
  text-decoration: underline;
}

.address-description {
  font-weight: 700;
}

/* Tablets */
@media (max-width: 1024px) {
  .invoice-page-wrapper {
    width: 100%;
    height: auto;
    padding: 15px;
    border-width: 4px;
  }
  .invoice-heading {
    font-size: 24px;
  }
  .invoice-title {
    font-size: 16px;
  }
  .invoice-totals {
    width: 100%;
  }
}
/* Mobile phones */
@media (max-width: 768px) {
  .invoice-page-wrapper {
    width: 100%;
    padding: 10px;
    border-width: 3px;
  }
  .invoice-heading {
    font-size: 20px;
  }
  .invoice-title {
    font-size: 14px;
  }
  .invoice-bill-to,
  .invoice-name,
  .invoice-final .invoice-price {
    font-size: 16px;
  }
  .invoice-main-table {
    padding: 0 10px;
    margin-top: 20px;
  }
  .invoice-table-header,
  .invoice-table-row {
    flex-direction: column;
    font-size: 12px;
  }
  .invoice-summary-section {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
  }
  .invoice-totals {
    font-size: 12px;
    width: 100%;
    margin-bottom: 40px;
  }
  .invoice-notes-section {
    margin-top: 0;
  }
}
/**********************************************PLAN OVERVIEW PAGE**********************************************/
@media screen and (max-width: 768px) {
  .mainheading {
    margin-top: 40px;
    margin-left: 15px;
    font-size: 25px;
    /* Smaller font size for smaller screens */
  }
}
@media (max-width: 480px) and (max-width: 480px) {
  .mainheading {
    margin-top: 40px;
    margin-left: 5px;
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .planpage_switch_link {
    margin-bottom: 5vw;
    color: #38abd2;
    cursor: pointer;
    text-decoration: underline;
    margin-left: 3.5%;
    font-size: 10px;
  }
}
@media (max-width: 480px) {
  .zoomable-div {
    /* transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s; */
    border: 1px solid;
    border-color: transparent;
    /* padding: 10px; */
    border-radius: 2px;
    max-width: 10px;
    margin-top: 5%;
  }
  .h3,
  h3 {
    font-size: 10px;
  }
  .prices {
    font-weight: 900;
    color: #130054;
    font-size: 10px;
  }
  li {
    padding: 5px;
    /* text-align: left; */
    font-size: 8px;
  }
  .subscribecmp {
    max-width: 100px;
    padding: 5px 5px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background-color: none;
    border-radius: 3px;
    border: 1px solid #38abd2;
    background: #fff;
    color: #38abd2;
    text-align: center;
    font-family: "Open Sans";
    font-size: 5px;
    font-style: normal;
    font-weight: 700;
    line-height: 10px;
    height: 20px;
  }
  .custom-divider {
    margin: 1px;
  }
}
.chooseplan {
  padding: 50px 0;
  color: var(--dark-purple, #140054);
  font-family: "Open Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  /* 100% */
}

.comparePlan-cell {
  display: block !important;
  align-items: center !important;
  text-align: center !important;
  border-color: #333 !important;
  border: 2px !important;
}

.subscribedplan {
  color: var(--dark-purple, #140054);
  font-family: "Open Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  justify-content: center;
  text-align: left;
}

.planpage_switch_link {
  color: #38abd2;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 3.5%;
}

.plan-name {
  color: #130054;
  font-family: "Open Sans";
  font-weight: lighter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/************************ Compare Plan ***********************/
.colHeadings {
  background-color: white !important;
  position: sticky;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 10px;
}

.heading-price-container {
  display: flex;
  flex-direction: column;
  justify-content: left;
}

.rowHeadings {
  text-align: left !important;
  font-weight: bolder;
  color: #000;
}

.container {
  margin-left: 3%;
}

.prices {
  font-weight: 900;
  color: #130054;
  font-size: 28px;
  margin-top: -5%;
  margin-left: -2%;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.invoice-page-wrapper {
  width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  background: white;
  display: flex;
  flex-direction: column;
  border: 6px solid #2c68ad;
  box-sizing: border-box;
}

.invoice-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}

.invoice-bold {
  font-weight: 700;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px 0 30px;
  align-items: flex-start;
}

.invoice-logo-section {
  display: flex;
  align-items: flex-start;
  padding: 0%;
  margin-top: 10%;
  padding-left: 10px;
}

.invoice-title-wrap {
  margin-left: 5px;
}

.invoice-title {
  text-transform: uppercase;
  font-size: 18px;
  color: \\\$brand-primary;
}

.invoice-sub-title {
  font-size: 12px;
}

.invoice-info-section {
  text-align: right;
  margin-top: 120px;
  padding: 0 0px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.invoice-heading {
  font-size: 28px;
  color: \\\$brand-primary;
}

.invoice-detail-row {
  display: flex;
  width: 100%;
}

.invoice-detail-row span:first-child {
  width: 90px;
  text-align: left;
}

.invoice-detail-row span:last-child {
  width: calc(100% - 90px);
}

.invoice-bill-wrap {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

/* Left side: allow to shrink but not overflow the container */
.invoice-bill-to {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: break-word;
  padding-left: 0;
}

.total-due-section {
  flex: 0 0 180px;
  text-align: right;
  white-space: nowrap;
  text-align: right !important;
}

.invoice-name,
.invoice-final .invoice-price {
  color: \\\$brand-primary;
  font-size: 20px;
  padding-left: -30px;
}

.invoice-main-table {
  width: 100%;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  margin-top: 10%;
}

.invoice-table-header {
  background: \\\$brand-primary;
  color: white;
  font-size: 12px;
  display: flex;
  padding: 10px;
}

.invoice-table-row {
  display: flex;
  border-bottom: 1px solid #03045e;
}

.invoice-table-col {
  padding: 10px;
}

.invoice-col-description {
  width: 45%;
}

.invoice-col-qty {
  width: 10%;
  text-align: center;
}

.invoice-col-unit-price {
  width: 20%;
  text-align: center;
}

.invoice-col-amount {
  width: 25%;
  text-align: right;
}

.invoice-summary-section {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 5px 30px 30px 30px;
  margin-top: 20px;
}

.invoice-payment-method {
  padding-left: 30px;
}

.invoice-totals {
  width: 30%;
  font-size: 14px;
  margin-bottom: 130px;
  padding-left: -20px;
}

.invoice-totals p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  margin: 0;
}

.invoice-totals p span {
  padding: 0 10px;
}

.invoice-totals p span:first-child {
  width: 60%;
  text-align: left;
}

.invoice-totals p span:last-child {
  width: 40%;
  text-align: right;
}

.invoice-totals p:last-child {
  font-weight: bold;
}
.invoice-totals p:last-child span {
  padding: 12px 15px;
}
.invoice-totals p:last-child span:first-child {
  background: \\\$brand-primary;
  color: white;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.invoice-totals p:last-child span:last-child {
  background: \\\$brand-primary;
  color: white;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.invoice-notes-section {
  font-weight: 700;
  margin-top: -90px;
  margin-left: 40px;
}

.invoice-notes-heading {
  font-size: 16px;
  text-decoration: underline;
}

.invoice-notes {
  font-size: 14px;
  color: \\\$brand-primary;
  margin-top: -10px;
}

.finance-email {
  font-size: 14px;
  color: white;
  font-weight: 700 !important;
  width: fit-content;
  margin: 0 auto;
  font-weight: lighter;
}

.invoice-logo {
  max-width: 200px;
  height: auto;
}

.bill-to-heading {
  font-size: 16px;
  text-decoration: underline;
}

.address-description {
  font-weight: 700;
}

.invoice-amount-due {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px 10px 30px;
  font-weight: 700;
  font-size: 18px;
  color: \\\$brand-primary;
}
.invoice-amount-due .label {
  margin-right: 10px;
}
.invoice-amount-due .amount {
  color: \\\$brand-primary;
}

/* Tablets */
@media (max-width: 1024px) {
  .invoice-page-wrapper {
    width: 100%;
    height: auto;
    padding: 15px;
    border-width: 4px;
  }
  .invoice-heading {
    font-size: 24px;
  }
  .invoice-title {
    font-size: 16px;
  }
  .invoice-totals {
    width: 100%;
  }
}
/* Mobile phones */
@media (max-width: 768px) {
  .invoice-page-wrapper {
    width: 100%;
    padding: 10px;
    border-width: 3px;
  }
  .invoice-heading {
    font-size: 20px;
  }
  .invoice-title {
    font-size: 14px;
  }
  .invoice-bill-to,
  .invoice-name,
  .invoice-final .invoice-price {
    font-size: 16px;
  }
  .invoice-main-table {
    padding: 0 10px;
    margin-top: 20px;
  }
  .invoice-table-header,
  .invoice-table-row {
    flex-direction: column;
    font-size: 12px;
  }
  .invoice-summary-section {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
  }
  .invoice-totals {
    font-size: 12px;
    width: 100%;
    margin-bottom: 40px;
  }
  .invoice-notes-section {
    margin-top: 0;
  }
}
.Create-invoice-box {
  padding-left: 5;
  padding-top: 0;
}

.invoice-back-button {
  margin-bottom: 10px;
}

.customer-row {
  margin-top: 10px;
  display: flex;
  align-items: stretch;
}

.customer-card {
  border: 1px solid #00b4d8;
}

.customer-space {
  width: 100%;
}

.customer-paragraph {
  margin-top: 10px;
}

.invoice-datepicker {
  width: 100%;
}

.custom-multiselect-dashboards-list {
  width: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  height: 2rem;
}

div#dashboardAccess_selectall.p-checkbox.p-component {
  display: flex;
  align-items: center;
  position: relative;
  width: auto;
}

div#dashboardAccess_selectall.p-checkbox.p-component::after {
  content: "All" !important;
  font-size: 12px;
  margin-left: 10px;
  color: #9ca3af;
  display: inline-block;
  white-space: nowrap;
  pointer-events: none;
}

div#dashboardAccess_selectall.p-checkbox.p-component input[type=checkbox] {
  margin-right: 8px;
  pointer-events: auto;
}

.campaign-dashboard {
  font-family: "Segoe UI", sans-serif;
  color: #1a1a1a;
}
.campaign-dashboard .dashboard-header {
  display: flex;
  justify-content: space-between;
  margin-top: 0px;
}
.campaign-dashboard .dashboard-header h2 {
  font-size: 1.8rem;
  color: #114b8a;
}

.compare-container {
  padding: 2rem;
  background-color: #f7f9fc;
  font-family: "Segoe UI", sans-serif;
  color: #1a202c;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 2rem;
}

.dropdown-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.compare-label {
  font-weight: 500;
}

.add-more {
  background-color: transparent;
  color: #4a90e2;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.chart-section {
  background-color: #ffffff;
  padding: 1.5rem;
  margin-top: 0.5rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.chart-bar-group {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 300px;
  margin-bottom: 1rem;
}

.bar-set {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bar {
  width: 20px;
  margin: 0.15rem 0;
  border-radius: 3px;
}

.bar.delivered {
  height: 150px;
  background-color: #0d47a1;
}

.bar.open-rate {
  height: 100px;
  background-color: #1565c0;
}

.bar.ctr {
  height: 80px;
  background-color: #1e88e5;
}

.bar.bounce-rate {
  height: 20px;
  background-color: #64b5f6;
}

.bar.conversion-rate {
  height: 50px;
  background-color: #90caf9;
}

.bar.unsubscribe-rate {
  height: 40px;
  background-color: #bbdefb;
}

.bar.share-rate {
  height: 30px;
  background-color: #e3f2fd;
}

.bar-label {
  margin-top: 0.5rem;
  font-weight: 500;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.9rem;
  color: #1a202c;
}

.legend-item {
  padding: 0.3rem 0.6rem;
  border-radius: 3px;
}

.chart-card {
  background: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}

.form-title-list {
  font-size: 14px;
  font-weight: 600;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin-bottom: 0px;
}

.form-title-segment {
  font-size: 14px;
  font-weight: 600;
  font-family: "opensans", sans-serif;
  color: #000000;
  margin-bottom: 5px;
}

.chart-title {
  color: #0d3b66;
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.condition-btn:active {
  background: #3b5998; /* darker blue */
  border-color: #2d4373;
}

.definition-section:not(:last-child) {
  border-bottom: 2px dashed #3b5998; /* dashed blue line */
  margin-bottom: 20px; /* space after the line */
  padding-bottom: 20px; /* space before the line */
}

.metric-selection {
  min-width: 350px;
}

.chart-container {
  margin: 20px 0;
}

.dashboard-prefix {
  margin: 0;
  margin-bottom: 8px;
  margin-top: 8px;
}

@media (max-width: 1024px) {
  .header-dashboard .dashboard-prefix,
  .header-dashboard .dashboard-image {
    display: none;
  }
}
.create-campaign-container {
  padding: 2rem;
  background: white;
  color: #2c3e50;
  min-height: 70vh;
}
.create-campaign-container h2 {
  font-size: 1.6rem;
  margin: 1rem 0;
}
.create-campaign-container .back-button {
  background: none;
  border: none;
  color: #4a90e2;
  font-size: 0.95rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.create-campaign-container .input-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}
.create-campaign-container h3 {
  font-size: 1.2rem;
  color: #2a4d77;
  margin-bottom: 1rem;
}
.create-campaign-container .recipient-box {
  background: #ffffff;
  border: 1px solid #e0ecf9;
  border-radius: 0.75rem;
  padding: 1.5rem;
  width: 100%;
}
.create-campaign-container .recipient-box .recipient-selects {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
}
.create-campaign-container .recipient-box .recipient-selects label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.create-campaign-container .recipient-box .recipient-selects .select-list {
  border: 1px solid #bdd6f4;
  border-radius: 0.5rem;
  min-width: 350px;
  max-width: 350px;
}
.create-campaign-container .recipient-box .campaign-search-input {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 6px 10px;
  transition: border-color 0.2s ease;
}
.create-campaign-container .recipient-box .campaign-search-input:hover {
  border-color: #1E63A6; /* blue on hover */
}
.create-campaign-container .recipient-box .draggable {
  transition: none; /* ensures no lag while dragging */
}
.create-campaign-container .recipient-box .action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.create-campaign-container .recipient-box .action-buttons .reset-button {
  padding: 0.6rem 1.2rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  font-weight: 600;
}
.create-campaign-container .recipient-box .action-buttons .reset-button {
  background: #f0f4f9;
  color: #2c3e50;
}

.campaign-performance {
  padding: 0.5rem;
  color: #1e3a8a;
  /* Image 3 popup layout: donut + users on top, rates full-width below. */
}
.campaign-performance__back-btn {
  margin-bottom: 20px;
}
.campaign-performance__page-title {
  margin-left: -1px;
}
.campaign-performance__modal-heading {
  margin-bottom: 16px;
}
.campaign-performance__modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}
.campaign-performance__modal-subtitle {
  margin: 4px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #667085;
}
.campaign-performance .card-section-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
}
.campaign-performance .card-section-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  text-align: left;
}
.campaign-performance__donut {
  flex: 1 1 auto;
  width: 100%;
  min-height: 180px;
  height: 180px;
  max-width: none;
}
.campaign-performance__bar-chart {
  width: 100%;
  height: 180px;
}
.campaign-performance .performance-cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
}
.campaign-performance .performance-cards .card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 20px rgba(30, 58, 138, 0.1);
  transition: transform 0.2s ease;
  min-width: 360px;
  height: 500px;
}
.campaign-performance .performance-cards .card:hover {
  transform: translateY(-4px);
}
.campaign-performance .performance-cards .bar-card .bar-chart {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 500px;
}
.campaign-performance .performance-cards--popup {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 0;
  width: 100%;
}
.campaign-performance .performance-cards--popup .performance-cards__top-row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
  gap: 16px;
  width: 100%;
}
.campaign-performance .performance-cards--popup .card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  height: auto;
  padding: 18px 20px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
  border: 1px solid #e5e7eb;
}
.campaign-performance .performance-cards--popup .card:hover {
  transform: none;
}
.campaign-performance .performance-cards--popup .donut-card {
  text-align: left;
  justify-content: flex-start;
}
.campaign-performance .performance-cards--popup .donut-card .engagement-overview-donut__legend {
  margin-top: 10px;
  padding: 0;
}
.campaign-performance .performance-cards--popup .donut-card .engagement-overview-donut__legend--centered {
  align-items: stretch;
  gap: 8px;
}
.campaign-performance .performance-cards--popup .donut-card .engagement-overview-donut__legend--centered .engagement-overview-donut__legend-item {
  max-width: none;
}
.campaign-performance .performance-cards--popup .bar-card .bar-chart,
.campaign-performance .performance-cards--popup .bar-card .campaign-performance__bar-chart {
  height: 180px;
  width: 100%;
  flex: 1 1 auto;
}
.campaign-performance .performance-cards--popup .bar-card,
.campaign-performance .performance-cards--popup .donut-card {
  min-height: 0;
}
.campaign-performance .performance-cards--popup .metrics-card--grid {
  width: 100%;
}
.campaign-performance .performance-cards--popup .metrics-card--grid .metrics-card__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 40px;
  row-gap: 0;
}
.campaign-performance .performance-cards--popup .metrics-card--grid .metrics-card__column {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  column-gap: 12px;
  row-gap: 12px;
  align-items: center;
  min-width: 0;
}
.campaign-performance .performance-cards--popup .metrics-card--grid .metric-row {
  display: contents;
  margin-bottom: 0;
}
.campaign-performance .performance-cards--popup .metrics-card--grid .metric-label {
  margin-bottom: 0;
  font-size: 13px;
  font-weight: 500;
  color: #667085;
  line-height: 1.3;
  white-space: nowrap;
}
.campaign-performance .performance-cards--popup .metrics-card--grid .metric-row__body {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.campaign-performance .performance-cards--popup .metrics-card--grid .metric-value {
  flex: 0 0 auto;
  min-width: 40px;
  font-size: 14px;
  font-weight: 700;
  color: #101828;
  text-align: right;
  line-height: 1;
}
.campaign-performance .metric-progress {
  display: block;
  flex: 1 1 auto;
  width: 100%;
  height: 8px;
  border: 0;
  border-radius: 999px;
  overflow: hidden;
  background: #e8edf4;
  appearance: none;
}
.campaign-performance .metric-progress::-webkit-progress-bar {
  background: #e8edf4;
  border-radius: 999px;
}
.campaign-performance .metric-progress::-webkit-progress-value {
  border-radius: 999px;
  background: #2b74e4;
}
.campaign-performance .metric-progress::-moz-progress-bar {
  border-radius: 999px;
  background: #2b74e4;
}
.campaign-performance .metric-progress--open::-webkit-progress-value {
  background: #2b74e4;
}
.campaign-performance .metric-progress--open::-moz-progress-bar {
  background: #2b74e4;
}
.campaign-performance .metric-progress--click::-webkit-progress-value {
  background: #36cdb0;
}
.campaign-performance .metric-progress--click::-moz-progress-bar {
  background: #36cdb0;
}
.campaign-performance .metric-progress--conversion::-webkit-progress-value {
  background: #8d4fd3;
}
.campaign-performance .metric-progress--conversion::-moz-progress-bar {
  background: #8d4fd3;
}
.campaign-performance .metric-progress--unsubscribe::-webkit-progress-value {
  background: #8eb8f0;
}
.campaign-performance .metric-progress--unsubscribe::-moz-progress-bar {
  background: #8eb8f0;
}
.campaign-performance .metric-progress--share::-webkit-progress-value {
  background: #3d8b6e;
}
.campaign-performance .metric-progress--share::-moz-progress-bar {
  background: #3d8b6e;
}
.campaign-performance--modal {
  padding: 0;
  color: #17325c;
}
.campaign-performance--modal .action-buttons {
  margin-top: 16px;
  justify-content: flex-end;
}

.campaign-performance-modal {
  max-width: calc(100vw - 48px);
}
.campaign-performance-modal .ant-modal-content {
  border-radius: 16px;
  padding: 20px 24px 16px;
  max-height: calc(110vh - 100px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.campaign-performance-modal .ant-modal-body {
  padding: 0;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.engagement-overview-donut__swatch--delivered {
  background-color: #2b74e4;
}

.engagement-overview-donut__swatch--bounced {
  background-color: #94d0b5;
}

.campaign-performance .engagement-overview-donut__center-label {
  text-transform: uppercase;
}

@media (max-width: 768px) {
  .campaign-performance .performance-cards--popup .performance-cards__top-row {
    grid-template-columns: 1fr;
  }
  .campaign-performance .performance-cards--popup .metrics-card--grid .metrics-card__grid {
    grid-template-columns: 1fr;
  }
}
.campaign-name {
  color: #2c68ad;
  cursor: pointer;
  transition: color 0.2s ease;
  font-weight: 700;
  font-size: 12px;
  font-family: "opensans", sans-serif;
  letter-spacing: 0 !important;
  text-transform: none;
}

.list-name {
  color: #0088cc;
  cursor: pointer;
  transition: color 0.2s ease; /* Smooth transition for hover effect */
}

.campaign-name:hover {
  color: #1b4d99;
  text-decoration: underline;
}

.campaign-row:hover {
  background-color: #f5f8fc;
  transition: background-color 0.2s ease;
}

.campaign-headers {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 10px;
}

.campaign-header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.remove-campaign-btn {
  background: none;
  border: none;
  color: #ff4d4f;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 0;
}

.remove-campaign-btn:hover {
  color: #d9363e;
}

.campaign-row:hover {
  background-color: #f5f8fc;
  transition: background-color 0.2s ease;
}

campaign-selector {
  margin-bottom: -15px;
}

.compare-container .col-3 {
  border-color: #dee2e6 !important;
  border-width: 2px !important;
  padding: 12px !important;
  height: 100% !important;
}

.compare-container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-left: 50px;
}

.compare-btn {
  background-color: #145da0;
  color: white;
}

.compare-with-text {
  font-weight: 500;
  color: #145da0;
}

.comparison-container {
  padding: 2rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.comparison-title {
  color: #0d3b66;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

.comparison-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.campaign-comparison {
  padding: 20px;
}

.comparison-controls {
  display: flex;
  gap: 20px;
  margin: 20px 0;
  align-items: flex-end;
  flex-wrap: wrap;
}

.campaign-selector {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.campaign-selector select {
  padding: 8px;
  min-width: 200px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.campaign-selector select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.button-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.add-more-btn {
  padding: 8px 16px;
  background-color: white;
  color: #1890ff;
  border: 1px solid #1890ff;
  border-radius: 4px;
  cursor: pointer;
  height: 35px;
}

.add-more-btn:disabled {
  border-color: #d9d9d9;
  color: #d9d9d9;
  cursor: not-allowed;
}

.compare-btn {
  padding: 8px 16px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 35px;
}

.compare-btn:disabled {
  background-color: #d9d9d9;
  cursor: not-allowed;
}

.chart-container {
  margin-top: 30px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-container h3 {
  text-align: center;
  margin-bottom: 20px;
}

.campaign-headers {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.campaign-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.remove-campaign-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #ff4d4f;
}

/************Mobile screen responsiveness**************/
@media (max-width: 768px) {
  .comparison-controls {
    flex-direction: column;
    align-items: stretch;
  }
  .button-group {
    flex-direction: column;
    width: 100%;
  }
  .button-group button {
    width: 100%;
  }
  .headline {
    font-size: 13px;
    margin-bottom: 10px;
  }
}
@media (max-width: 480px) {
  .comparison-controls {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
  }
  .comparison-controls h4,
  .comparison-controls h5 {
    font-size: 18px;
    margin-bottom: 6px; /* space between heading and dropdown */
    line-height: 1.3;
  }
  .campaign-selector {
    display: flex;
    flex-direction: column;
    margin-top: 120px;
    margin-bottom: -100px;
  }
  .go-back-button {
    width: 100%;
    margin-bottom: 16px;
  }
  .button-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .button-group button,
  .compare-button {
    width: 100%;
  }
  .headline {
    font-size: 13px;
    margin-bottom: 10px;
  }
}
.custom-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 16px;
}

.custom-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.header-actions-buttons {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: nowrap;
  margin-bottom: 0px;
}

.audience-btn {
  margin-bottom: 0;
}

.bulk-actions {
  display: flex;
  gap: 10px;
  margin-bottom: -12px;
}

.list-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-left: 0;
}

/* Fix for double scrollbar */
.custom-select-dropdown .rc-virtual-list-holder {
  max-height: 250px !important;
  overflow-y: auto !important;
}

.custom-select-dropdown .rc-virtual-list-holder::-webkit-scrollbar {
  width: 6px;
}

.custom-select-dropdown .rc-virtual-list-holder::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.custom-select-dropdown .rc-virtual-list-holder::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Remove the outer scroll container */
.custom-select-dropdown {
  overflow: hidden !important;
  padding-right: 0 !important;
}

/* Adjust the dropdown menu padding if needed */
.custom-select-dropdown .ant-select-item {
  padding: 8px 12px;
}

/*******revamped css******/
.ant-layout-content {
  padding: 10px !important;
}

.dashboard-header {
  display: flex;
  flex-direction: column; /* stacks title & subtext */
  align-items: flex-start;
}

.Campaign-dashboard-header {
  font-size: 32px;
  font-weight: 600;
  font-family: "opensans", sans-serif;
  color: #2A2929;
  margin: 0;
  margin-top: 10px;
}

.audience-summary {
  color: #6E6A6A;
  font-weight: 400;
  font-size: 16px;
  font-family: "opensans", sans-serif;
  margin-top: 2px;
  padding-left: 2px;
}

.overview-summary {
  color: #6E6A6A;
  font-weight: 400;
  font-size: 16px;
  font-family: "opensans", sans-serif;
  margin-top: 2px;
  padding-left: 2px;
  margin-bottom: 20px;
}

.audience-summary span {
  display: block;
  line-height: 1.4;
  margin-bottom: 10px;
}

.campaign-header-actions {
  display: flex;
  gap: 10px; /* buttons spaced like first screenshot */
  justify-content: flex-end;
  margin-top: -65px;
}

.overview-header-actions {
  display: flex;
  gap: 10px; /* buttons spaced like first screenshot */
  justify-content: flex-end;
  margin-top: -65px;
}

.header-actions {
  display: flex;
  gap: 10px; /* buttons spaced like first screenshot */
  justify-content: flex-end;
  margin-top: -30px;
}

.chart-dropdown:hover {
  border-color: #aaa;
}

/* Remove AntD default borders */
.chart-dropdown .ant-select-selector {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  min-height: 36px !important;
  padding: 0 !important;
}

.campaign-dropdown {
  width: 100%;
  padding: 6px 14px;
  padding-right: 36px;
  border-radius: 20px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #000000 !important;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  appearance: none;
  cursor: pointer;
  box-shadow: 0.3px 0.3px 1px rgba(182, 178, 178, 0.6), 1px 1px 4px rgba(182, 178, 178, 0.8);
  transition: all 0.2s ease;
  justify-content: right !important;
}

.campaign-dropdown-arrow {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #666;
}

.filters-container {
  display: flex;
  justify-content: space-between; /* Left vs Right */
  align-items: center;
  margin-bottom: 32px !important;
  margin-top: 35px !important;
  flex-wrap: wrap;
  border: 1px solid #d9d9d9;
  padding: 15px 20px;
  border-radius: 10px;
  padding-top: 10px;
}

.filters-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 1;
  max-width: 100%;
}

.filters-right .button {
  padding: 6px 14px;
  height: 44px;
  line-height: 1.5;
  white-space: nowrap;
  flex: 0 0 auto;
  margin-bottom: -3px;
  box-shadow: 0.3px 0.3px 1px rgba(182, 178, 178, 0.6), 1px 1px 4px rgba(182, 178, 178, 0.8);
}

.filters-right .campaign-dropdown {
  flex: 0 1 auto;
  min-width: 250px;
}

.metric-dropdown {
  width: 100%;
  border-radius: 20px; /* pill-like style */
}

/* Remove border/line inside multiple select dropdown */
.ant-select-multiple .ant-select-selection-item {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important; /* optional */
  padding: 0 4px !important;
  margin-bottom: 15px !important;
}

.campaign-dropdown.ant-select-multiple .ant-select-selector {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.info-banner-campaign {
  flex: 1 1;
  background: #f9f9f9;
  border-radius: 6px;
  padding: 3px 40px 3px 16px;
  font-size: 14px;
  font-family: "opensans", sans-serif;
  color: #000000;
  font-weight: 400;
  line-height: 1.4;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  text-align: center;
  position: relative;
}

.info-banner-campaign .info-banner-close {
  border: none;
  background: #f9f9f9;
  color: #616161;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.info-banner-campaign .info-banner-close:hover {
  background-color: #cbd5e1;
  color: #000000;
}

.info-banner-campaign strong {
  font-weight: 600;
}

.Banner-highlight {
  font-weight: 600;
  color: #000000;
  font-size: 14px;
}

.campaign-dropdown {
  width: 100%;
  border-radius: 30px !important;
  height: 42px;
  background-color: #fff;
  border: none !important;
  box-shadow: 0.5px 0.5px 2px rgba(182, 178, 178, 0.6), 2px 2px 6px rgba(182, 178, 178, 0.8);
  /* Remove icon inside tag */
}
.campaign-dropdown .ant-select-selector {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 30px !important;
  height: 42px !important;
  display: flex;
  align-items: center;
  padding: 0 8px !important;
  gap: 6px;
  color: #000 !important;
}
.campaign-dropdown .ant-select-selection-placeholder {
  color: #777 !important;
  font-weight: 500;
}
.campaign-dropdown .ant-select-selection-item-remove {
  color: #555 !important;
  margin-left: 4px;
}

/* Open state */
.campaign-dropdown.ant-select-open {
  background-color: #e0e0e0 !important;
  color: #000 !important;
}

/* Dropdown menu */
.custom-dropdown-menu {
  border-radius: 12px !important;
  background-color: #fff !important;
  padding: 6px 0;
  color: #000 !important;
}
.custom-dropdown-menu .ant-select-item {
  padding: 10px 16px;
  border-radius: 8px;
  transition: background 0.2s ease;
}
.custom-dropdown-menu .ant-select-item-option-active {
  background-color: #f2f2f2 !important;
}
.custom-dropdown-menu .ant-select-item-option-selected {
  background-color: #1c60c6 !important;
  color: #fff !important;
}

/* Selected tags */
.campaign-dropdown .ant-select-selection-item {
  background: #e0e0e0 !important;
  color: #000 !important;
  border-radius: 10px !important;
  padding: 0 10px !important;
  font-size: 13px !important;
  height: 26px !important;
  display: flex !important;
  align-items: center !important; /* vertical centering */
  justify-content: center !important;
  line-height: normal !important; /* reset */
  margin-bottom: 10px;
}

.campaign-dropdown .ant-select-selection-item-content {
  display: flex !important;
  align-items: center !important;
}

.campaign-performance-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 16px;
  overflow: hidden;
}

.campaign-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 22px;
}

.campaign-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  font-family: "Open Sans", sans-serif;
}

.campaign-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.campaign-card-actions .button--primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
}

/* ── Campaign Performance page revamp ──────────────────────────────────────
   Scoped under \`.campaign-dashboard\` because \`Campaign.scss\` is global and
   shared with the Audience / Overview pages. */
.campaign-dashboard {
  /* Labelled bulk actions (replaces the icon-only toolbar buttons). */
  /* Active / Archive segmented tabs (replaces the square toggle pill). */
  /* The toolbar now carries search + filters, so let it wrap rather than
     overflow on narrower viewports. */
  /* The chart is now a sibling card, not nested inside the table card. */
  /* Channel badge in the table's Source column. */
  /* Campaign Comparison header controls. */
}
.campaign-dashboard .dashboard-header {
  width: 100%;
  align-self: stretch;
  overflow: visible;
}
.campaign-dashboard .campaign-dashboard__title-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas: "title create" "select dates";
  column-gap: 16px;
  row-gap: 24px;
  align-items: start;
  width: 100%;
  margin-bottom: 20px;
  overflow: visible;
}
.campaign-dashboard .campaign-dashboard__title-copy {
  grid-area: title;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}
.campaign-dashboard .campaign-dashboard__title-copy .audience-summary span {
  margin-bottom: 0;
}
.campaign-dashboard .campaign-dashboard__achievements {
  margin-top: 20px;
  margin-bottom: 20px;
}
.campaign-dashboard .campaign-dashboard__create-btn {
  grid-area: create;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  margin-top: 45px;
  flex-shrink: 0;
  justify-self: end;
  align-self: start;
}
.campaign-dashboard .campaign-dashboard__filter-select {
  grid-area: select;
  width: 34%;
  min-width: 220px;
  max-width: 420px;
  align-self: center;
  overflow: visible;
  position: relative;
  z-index: 6;
}
.campaign-dashboard .campaign-dashboard__select {
  width: 100%;
  position: relative;
}
.campaign-dashboard .campaign-dashboard__select .sales-product-analytics-dashboard__select-trigger {
  width: 100%;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px 0 18px;
  border: 1px solid #ccd6e3;
  border-radius: 8px;
  background: #ffffff;
  color: #17325c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
}
.campaign-dashboard .campaign-dashboard__select .sales-product-analytics-dashboard__select-trigger span {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.campaign-dashboard .campaign-dashboard__select .sales-product-analytics-dashboard__select-trigger--open {
  border-color: #cfd8e3;
  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);
}
.campaign-dashboard .campaign-dashboard__select .sales-product-analytics-dashboard__select-trigger-icon {
  width: 16px;
  height: 16px;
  color: #6b7280;
  flex-shrink: 0;
}
.campaign-dashboard .campaign-dashboard__select--toolbar {
  min-width: 160px;
  width: 180px;
}
.campaign-dashboard .campaign-dashboard__select--compare {
  min-width: 260px;
  width: 280px;
}
.campaign-dashboard .campaign-dashboard__filters {
  grid-area: dates;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 0;
  width: auto;
  justify-self: end;
  align-self: center;
}
@media (max-width: 768px) {
  .campaign-dashboard .campaign-dashboard__title-row {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas: "title create" "select dates";
    column-gap: 12px;
    row-gap: 16px;
  }
  .campaign-dashboard .campaign-dashboard__create-btn {
    justify-self: end;
    width: auto;
    max-width: none;
    min-width: 0;
  }
  .campaign-dashboard .campaign-dashboard__filter-select {
    justify-self: start;
    width: 100%;
    min-width: 0;
    max-width: min(280px, 100% - 8px);
  }
  .campaign-dashboard .campaign-dashboard__filters {
    justify-self: end;
    width: auto;
    min-width: 0;
    max-width: 100%;
  }
  .campaign-dashboard .campaign-dashboard__filters .date-range-picker-container {
    flex-wrap: nowrap;
    gap: 8px;
  }
  .campaign-dashboard .campaign-dashboard__filters .dashboard-date-picker {
    width: min(160px, 28vw) !important;
    min-width: 0;
  }
}
.campaign-dashboard .campaign-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  color: #000000;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.campaign-dashboard .campaign-action-btn:hover {
  background: #f2f2f2;
  border-color: #d9d9d9;
}
.campaign-dashboard .campaign-action-btn--danger {
  background: #dc3545;
  border-color: #dc3545;
  color: #ffffff;
}
.campaign-dashboard .campaign-action-btn--danger:hover {
  background: #c22a39;
  border-color: #c22a39;
}
.campaign-dashboard .campaign-scope-tabs {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  gap: 2px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f2f2f2;
}
.campaign-dashboard .campaign-scope-tab {
  border: none;
  background: transparent;
  border-radius: 6px;
  padding: 6px 16px;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #6a6a6a;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.campaign-dashboard .campaign-scope-tab.is-active {
  background: #ffffff;
  color: #000000;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.campaign-dashboard .campaign-card-toolbar {
  flex-wrap: wrap;
}
.campaign-dashboard .campaign-toolbar-right {
  gap: 8px;
  align-items: center;
  justify-content: end;
}
.campaign-dashboard .campaign-toolbar-right .campaign-dashboard__select--toolbar {
  width: 150px;
  min-width: 150px;
}
.campaign-dashboard .campaign-table .ant-table-footer {
  background: #faf9f6;
  padding: 0;
  border-top: 1px solid #e5e7eb;
}
.campaign-dashboard .campaign-table .ant-table-container,
.campaign-dashboard .campaign-table .ant-table-content,
.campaign-dashboard .campaign-table .ant-table-body {
  overflow-x: hidden !important;
}
.campaign-dashboard .campaign-dashboard__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 16px;
  background: #ffffff;
}
.campaign-dashboard .campaign-dashboard__pagination-label {
  color: #9aa0a6;
  font-size: 14px;
  font-weight: 400;
}
.campaign-dashboard .campaign-dashboard__pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.campaign-dashboard .campaign-dashboard__pagination-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.campaign-dashboard .campaign-dashboard__pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.campaign-dashboard .campaign-chart-card {
  margin-bottom: 16px;
  border-radius: 12px;
  border: 1px solid #eaeaea;
}
.campaign-dashboard .campaign-source-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 6px;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;
}
.campaign-dashboard .campaign-source-badge--whatsapp {
  background: #e7f7ee;
  color: #1c8a52;
}
.campaign-dashboard .campaign-source-badge--email {
  background: #fdf1e3;
  color: #b96a10;
}
.campaign-dashboard .campaign-source-badge--neutral {
  background: #f2f2f2;
  color: #4a4a4a;
}
.campaign-dashboard .campaign-chart-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.campaign-dashboard .campaign-chart-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
}
.campaign-dashboard .campaign-chart-header-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  min-width: 0;
}
.campaign-dashboard .campaign-chart-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}
.campaign-dashboard .campaign-compare-select {
  width: 280px;
  min-width: 220px;
  max-width: 360px;
}
.campaign-dashboard .campaign-compare-select .ant-select-selector {
  width: 100% !important;
  min-width: 0 !important;
}
.campaign-dashboard .campaign-compare-source,
.campaign-dashboard .campaign-compare-status {
  min-width: 180px;
  max-width: 240px;
}
.campaign-dashboard .campaign-compare-source .ant-select-selector,
.campaign-dashboard .campaign-compare-status .ant-select-selector {
  width: 100% !important;
  min-width: 0 !important;
}
.campaign-dashboard .campaign-chart-card .chart-legend {
  justify-content: flex-end;
}
@media (max-width: 996px) {
  .campaign-dashboard .campaign-chart-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas: "title controls" "legend legend";
    align-items: center;
    column-gap: 12px;
    row-gap: 12px;
  }
  .campaign-dashboard .campaign-chart-title {
    grid-area: title;
    flex: 0 1 auto;
    flex-wrap: nowrap;
    align-items: center;
    min-width: 0;
    white-space: nowrap;
  }
  .campaign-dashboard .campaign-chart-title > span {
    white-space: nowrap;
  }
  .campaign-dashboard .campaign-chart-header-side {
    display: contents;
  }
  .campaign-dashboard .campaign-chart-controls {
    grid-area: controls;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    justify-self: end;
    min-width: 0;
  }
  .campaign-dashboard .campaign-chart-card .chart-legend {
    grid-area: legend;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
  }
  .campaign-dashboard .campaign-compare-select {
    width: min(200px, 46vw);
    min-width: 160px;
    max-width: 280px;
  }
}

/* SelectMenu popup is portalled to document.body, so option styles cannot
   live under \`.campaign-dashboard\`. */
.campaign-dashboard__select-dropdown {
  min-width: 160px;
  max-height: 240px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 6px;
  border: 1px solid #e6edf7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-dropdown-scroll {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar {
  width: 6px;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-option {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-option span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-option:hover {
  background: #f2f2f2;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-option--active {
  background: #e4e4e4;
  color: #1f1f1f;
  font-weight: 600;
}
.campaign-dashboard__select-dropdown .sales-product-analytics-dashboard__select-option-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #111827;
}

.campaign-dashboard__compare-menu {
  z-index: 1300;
  max-height: 280px;
  overflow: hidden;
}
.campaign-dashboard__compare-menu .rc-virtual-list-holder {
  max-height: 256px !important;
  overflow-y: auto !important;
}
.campaign-dashboard__compare-menu .ant-select-item {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 8px 12px;
}

.campaign-card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 0;
  flex-wrap: nowrap;
  padding-left: 16px;
  padding-right: 16px;
}

.campaign-toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.campaign-toolbar-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
}

.icon-button {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #2c68ad;
}

.campaign-toolbar-left .date-range-picker-container {
  gap: 8px;
}

.campaign-toolbar-left .date-range-picker-container,
.campaign-toolbar-left .custom-date-picker {
  flex-shrink: 0;
}

.campaign-search-input {
  max-width: 260px;
}

.campaign-card-toolbar .custom-date-picker {
  width: 150px !important;
}

.icon-button:hover {
  background: #f2f2f2;
}

.icon-button--primary {
  background: #2c68ad;
  color: #ffffff;
}

.icon-button--primary:hover {
  background: #2a73c2;
}

.toggle-pill {
  width: 72px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  background: #e9effa;
  padding: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.toggle-pill__icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #2c68ad;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  margin-left: -2px;
}

.toggle-pill__img {
  width: 16px;
  height: 16px;
  display: block;
}

.toggle-pill.is-on {
  justify-content: flex-end;
  background: #e3f2fd;
}

.campaign-search-input {
  width: 180px;
}

.campaign-card-toolbar .custom-date-picker {
  width: 150px !important;
  height: 44px;
  border-radius: 8px;
  border-color: #d9d9d9;
}

.campaign-card-toolbar .custom-date-picker .ant-picker-input > input {
  font-size: 12px;
}

.campaign-toolbar-right .campaign-dashboard__select {
  min-width: 160px;
}

.modify-file-container {
  padding: 12px 2px;
}

.modify-file-back-button {
  min-width: 72px;
  height: 34px;
  padding: 0 14px;
  margin-bottom: 14px;
}

.modify-file-title {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: #000000;
  text-align: left;
}

.modify-file-subtitle {
  margin: 2px 0 14px;
  color: #6b7280;
  font-size: 16px;
}

.modify-file-card {
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
}

.modify-file-card-header {
  padding: 14px 18px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}

.modify-file-table {
  margin-top: 0;
}

.modify-file-table .ant-table-thead > tr > th {
  background: #fff;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.modify-file-table .ant-table-tbody > tr > td {
  font-size: 16px;
  color: #111827;
  height: 58px;
}

.modify-file-cell-text {
  color: #111827;
}

.modify-file-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.campaign-table-wrapper {
  background: transparent;
  border-radius: 0;
  padding: 0;
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}

.campaign-table .ant-table {
  background: transparent;
}

/* Without this the inner <table> sizes to its columns' content rather than
   the card, leaving a blank strip (no cell, so no border) to the right of
   narrower rows — this is what made each row's border-bottom look like it
   stopped short of the card's edge instead of spanning the full width. */
.campaign-table .ant-table table {
  width: 100% !important;
  table-layout: auto;
}

.campaign-table .ant-table-container,
.campaign-table .ant-table-content {
  padding: 0 !important;
  margin: 0 !important;
}

.campaign-table .ant-table-container::before,
.campaign-table .ant-table-container::after {
  display: none !important;
  content: none !important;
}

.campaign-table {
  margin-top: 0px;
  margin-bottom: 0px;
}

.campaign-table .ant-table-thead > tr > th {
  background: #ffffff;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
}

.campaign-table .ant-table-thead > tr > th::before {
  display: none !important;
  content: none !important;
}

.campaign-table .ant-table-thead > tr > th:last-child {
  border-right: 0;
}

.campaign-table .ant-table-tbody > tr > td {
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 400;
  color: #1a1a1a;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff !important;
}

.campaign-table .ant-table-tbody > tr {
  background: #ffffff !important;
}

.campaign-table .ant-table-tbody > tr > td:last-child {
  border-right: 0;
}

.campaign-table .ant-table-tbody > tr:hover > td {
  background: #ffffff;
}

.campaign-table .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ffffff;
}

.campaign-table .ant-table-tbody > tr.ant-table-row-selected:hover > td {
  background: #ffffff;
}

.campaign-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}

.campaign-table .ant-table-row-expand-icon-cell {
  width: 24px;
  padding: 10px 0 10px 8px !important;
}

.campaign-table .ant-table-row-expand-icon-cell + td {
  padding-left: 4px !important;
}

.campaign-table__expand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: transform 0.15s ease;
}
.campaign-table__expand-icon svg {
  transition: transform 0.15s ease;
}

.campaign-table__expand-icon--open svg {
  transform: rotate(90deg);
}

.campaign-table .ant-table-expanded-row > td {
  padding: 0 !important;
  background: #f7f8fa !important;
}

.campaign-table .ant-table-expanded-row:hover > td {
  background: #f7f8fa !important;
}

.campaign-metrics-panel {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px 20px;
  padding: 16px 20px;
  background-color: #f3f4f6 !important;
}

.campaign-metrics-panel__cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.campaign-metrics-panel__cell--empty {
  visibility: hidden;
}

.campaign-metrics-panel__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #8a8f98;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.campaign-metrics-panel__value {
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
}

@media (max-width: 1100px) {
  .campaign-metrics-panel {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .campaign-metrics-panel {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.campaign-chart-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px;
}

.campaign-chart-card .chart-section-overview {
  background: transparent;
  box-shadow: none;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0;
}

.campaign-chart-card .chart-header {
  padding: 0;
  margin-bottom: 8px;
}

.campaign-chart-card .chart-legend {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #475569;
}

.campaign-chart-card .chart-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.campaign-chart-card .chart-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
  flex-shrink: 0;
}

.campaign-chart-card .chart-legend-dot--delivered {
  background: #8d4fd3;
}

.campaign-chart-card .chart-legend-dot--openRate {
  background: #94d0b5;
}

.campaign-chart-card .chart-legend-dot--clickRate {
  background: #d946ef;
}

.campaign-chart-card .chart-legend-dot--bounceRate {
  background: #8eb8f0;
}

.campaign-chart-card .chart-legend-dot--conversionRate {
  background: #5abf8b;
}

.campaign-chart-card .chart-legend-dot--unsubscribeRate {
  background: #f0a84a;
}

.campaign-chart-card .chart-legend-dot--shareRate {
  background: #2b4a9e;
}

.campaign-chart-card .chart-pagination-wrapper {
  display: flex;
  justify-content: flex-end;
}

.campaign-chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #555;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.campaign-chart-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  padding: 16px;
}

.campaign-chart-header .campaign-chart-title {
  margin-bottom: 0;
}

.pagination-controls .pagination-btn {
  background-color: #eeeeee;
}

@media (max-width: 768px) {
  .header-actions {
    justify-content: center;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin-bottom: 1rem;
  }
  .header-actions .button {
    width: 100%; /* full width buttons */
    text-align: center;
  }
}
@media (max-width: 768px) {
  .filters-container {
    flex-direction: column;
    align-items: stretch;
  }
  .filters-left,
  .filters-right {
    width: 100%;
    min-width: unset;
  }
  .campaign-dropdown {
    width: 100% !important;
    margin-bottom: 20px;
    height: 5%;
    margin-top: 20px;
  }
}
.audience-search-input {
  border-radius: 6px;
  height: 38px;
  width: 250px !important;
}

.list-section {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.audience-list-header {
  border: 0;
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
  margin-bottom: 0;
  padding: 12px 16px;
}

.audience-toolbar-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
  padding: 10px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.audience-archive-toggle {
  min-width: 150px;
}

.audience-list-header .toggle-pill {
  margin-bottom: 0;
}

.audience-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.audience-sort-dropdown {
  min-width: 210px;
  margin-bottom: 0 !important;
}

.audience-actionbuttons.is-disabled {
  opacity: 0.4;
  cursor: not-allowed !important;
  pointer-events: none;
}

.table-row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-row-actions .audience-actionbuttons {
  margin-right: 0;
}

.audience-list-table .ant-table-footer {
  border-top: 0;
  padding-right: 16px;
}

/* --- Campaign Dashboard Responsive --- */
@media (max-width: 1024px) {
  .campaign-card-header {
    align-items: flex-start;
  }
  .campaign-card-actions {
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .campaign-card-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .campaign-toolbar-left,
  .campaign-toolbar-right {
    width: 100%;
    flex-wrap: wrap;
  }
  .campaign-toolbar-left .custom-date-picker,
  .campaign-toolbar-left .date-range-picker-container,
  .campaign-search-input {
    width: auto !important;
    max-width: 100% !important;
  }
  .campaign-toolbar-right .campaign-dashboard__select {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 768px) {
  .campaign-card-header {
    padding-left: 12px;
    padding-right: 12px;
  }
  .campaign-card-toolbar {
    padding-left: 12px;
    padding-right: 12px;
  }
  .campaign-toolbar-right {
    gap: 8px;
  }
  .campaign-toolbar-right .icon-button {
    width: 32px;
    height: 32px;
  }
  .campaign-dashboard .campaign-table .ant-table-container,
  .campaign-dashboard .campaign-table .ant-table-content,
  .campaign-dashboard .campaign-table .ant-table-body {
    overflow-x: hidden !important;
  }
  .campaign-chart-header {
    flex-direction: column;
    align-items: stretch;
  }
  .campaign-chart-header-side,
  .campaign-chart-controls,
  .campaign-chart-card .chart-legend {
    align-items: stretch;
    justify-content: flex-start;
  }
  .audience-toolbar-row {
    flex-direction: column;
    align-items: stretch;
  }
  .audience-actions {
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .audience-sort-dropdown,
  .audience-search-input {
    width: 100%;
  }
}
@media (max-width: 968px) {
  .audience-toolbar-row > .custom-input-audience {
    width: 100% !important;
    border-radius: 6px;
    height: 38px;
  }
}
@media (max-width: 480px) {
  .Campaign-dashboard-header {
    font-size: 24px;
  }
  .audience-summary,
  .overview-summary {
    font-size: 14px;
  }
  .campaign-card-actions .button--primary {
    width: 100%;
    justify-content: center;
  }
  .campaign-toolbar-right {
    justify-content: flex-start;
  }
}
/* Audience + Modify File responsive safeguards */
@media (max-width: 1024px) {
  .audience-list-table .ant-table-content {
    overflow-x: auto !important;
  }
  .audience-list-table .ant-table-content table {
    min-width: 900px;
  }
  .modify-file-table .ant-table-content {
    overflow-x: auto !important;
  }
  .modify-file-table .ant-table-content table {
    min-width: 760px;
  }
}
@media (max-width: 768px) {
  .campaign-dashboard {
    overflow-x: hidden;
  }
  .audience-list-header {
    gap: 10px;
  }
  .campaign-dashboard .header-actions-buttons {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: end;
    gap: 10px;
  }
  .campaign-dashboard .header-actions-buttons .audience-btn,
  .campaign-dashboard .header-actions-buttons .audience-archive-toggle,
  .campaign-dashboard .header-actions-buttons .toggle-pill,
  .campaign-dashboard .header-actions-buttons .button {
    width: auto !important;
    flex: 0 0 auto;
    margin-top: 0 !important;
  }
  .campaign-dashboard .audience-toolbar-row {
    gap: 10px;
  }
  .campaign-dashboard .audience-actions {
    width: 100%;
    justify-content: flex-start;
    gap: 21px;
    flex-direction: row !important;
    align-items: center;
  }
  .campaign-dashboard .audience-sort-dropdown {
    min-width: 0;
    flex: 1 1 220px;
  }
  .modify-file-container {
    padding: 10px 0 20px;
  }
  .modify-file-title {
    font-size: 28px;
  }
  .modify-file-card-header {
    font-size: 24px;
    padding: 12px;
  }
  .modify-file-actions {
    gap: 6px;
  }
}
@media (max-width: 480px) {
  .campaign-dashboard .list-section {
    overflow: hidden;
  }
  .campaign-dashboard .audience-list-header .list-header-title {
    font-size: 16px;
  }
  .campaign-dashboard .header-actions-buttons {
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .campaign-dashboard .header-actions-buttons .audience-btn {
    width: calc(100% - 88px) !important;
    min-width: 0;
    margin-top: 0 !important;
  }
  .campaign-dashboard .header-actions-buttons .toggle-pill {
    flex: 0 0 auto;
    margin-top: 0 !important;
  }
  .campaign-dashboard .audience-toolbar-row {
    padding: 10px 12px;
  }
  .campaign-dashboard .audience-actions {
    flex-wrap: wrap;
  }
  .campaign-dashboard .audience-actions .audience-actionbuttons {
    margin-right: 0;
  }
  .campaign-dashboard .audience-sort-dropdown {
    width: 100% !important;
    flex: 1 1 100%;
  }
  .modify-file-title {
    font-size: 24px;
  }
  .modify-file-subtitle {
    font-size: 14px;
  }
  .modify-file-back-button {
    margin-bottom: 10px;
  }
  .modify-file-card-header {
    font-size: 20px;
  }
}
/***************** UserIntro ****************/
.user-intro-container {
  display: flex;
  gap: 1rem;
  align-items: start;
  height: 100%;
  padding: 1rem;
}

.image-section {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

.girl {
  max-width: 75%;
  height: auto;
}

.noScroll {
  overflow: hidden;
}

/********************************UserIntro Media Queries*********************************/
@media (max-width: 480px) {
  .input-style {
    max-width: 150px;
    height: 30px;
    padding: 5px 5px;
    font-size: 10px;
  }
  .input-style-2 {
    width: 200px;
    height: 30px;
    padding: 5px 5px;
    font-size: 10px;
  }
}
.container-wrap {
  margin-left: 30px;
  overflow-y: auto;
  padding: 0;
}

@media (max-width: 480px) {
  .container-wrap {
    margin-left: 3px;
    overflow-y: auto !important;
  }
}
.user-management-description-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-management-title {
  font-size: 24px;
}

.user-management-description {
  color: #6E6A6A;
  font-weight: 400;
  font-size: 16px;
  font-family: "opensans", sans-serif;
  margin-top: 2px;
  padding-left: 2px;
}

.user-manage-divider {
  margin-top: 5px !important;
}

.user-management-actions .ant-input,
.user-management-actions .ant-select {
  margin-right: 16px;
  width: auto;
}

.user-input {
  width: 250px !important;
}

@media (max-width: 768px) {
  .user-management-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .user-management-search-bar,
  .user-management-actions select {
    width: 100%;
    margin-bottom: 10px;
  }
}
.actions-user {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.actions-user .ant-input,
.actions-user .ant-select,
.actions-user {
  margin-right: 0;
  margin-bottom: 10px;
}

.user-management-product-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: left !important;
}

.User-dashboard-header {
  font-size: 32px;
  font-weight: 600;
  font-family: "opensans", sans-serif;
  color: #2A2929;
  margin: 0;
}

@media (max-width: 768px) {
  .actions-user {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .actions-user .ant-input,
  .actions-user .ant-select,
  .actions-user {
    width: 100%;
  }
}
@media (max-width: 1024px) {
  /* Adjust font size and table cell width for laptops */
  .user-management-title {
    font-size: 20px; /* Decrease title font size */
  }
  .user-management-description {
    font-size: 14px; /* Decrease description font size */
  }
  .ant-select-selector {
    width: fit-content;
  }
  .user-management-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .user-management-search-bar,
  .user-management-actions select {
    width: fit-content;
    margin-bottom: 10px;
  }
}
.add-user-modal .ant-modal-content {
  border-radius: 8px;
}

.add-user-modal .ant-modal-title {
  color: black;
  text-align: center;
}

.user-initials {
  background-color: #f58512 !important;
  width: 150px;
  height: 150px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 4rem;
}

@media (max-width: 768px) {
  .user-initials {
    width: 120px;
    height: 120px;
    font-size: 3rem;
  }
}
@media (max-width: 480px) {
  .user-initials {
    width: 100px;
    height: 100px;
    font-size: 2.5rem;
  }
}
/*********** Update Profile **********/
.update-Profile-btn {
  width: 125px;
  height: 44px;
  border-radius: 3px;
  padding: 14px 12px;
  font-size: 16px;
  background-color: #2596be;
  margin-top: 10px;
  margin-bottom: 15px;
  cursor: pointer;
}

.update-Profile-btn:disabled,
.update-Profile-btn[disabled] {
  background-color: #cccccc !important; /* Gray it out */
  color: #666 !important;
  cursor: not-allowed !important;
}

.update-Profile-btn label {
  color: white;
  cursor: pointer;
}

.update-Profile-btn:hover label {
  color: #2596be !important;
}

.update-Profile-btn:hover {
  border-color: #2596be !important;
  cursor: pointer;
  border-width: 2px !important;
}

/* For Account settings */
@media (max-width: 768px) {
  .row.mt-4.ml-3 {
    flex-direction: column;
    margin-left: 0;
    margin-top: 1rem;
  }
  .col-2,
  .col-5,
  .col-10 {
    width: 100% !important;
    padding: 0 1rem;
  }
  .user-initials {
    margin-bottom: 1rem;
    margin-left: auto;
    margin-right: auto;
    display: flex !important;
    justify-content: center;
    align-items: center;
    width: 100px !important;
    height: 100px !important;
    border-radius: 50% !important;
    background: #2B68AD;
    color: white;
    font-weight: bold;
  }
}
/* Small devices (phones) */
@media (max-width: 480px) {
  .input-fields-acc-setting {
    font-size: 0.95rem;
    padding: 8px;
  }
  .icon-heading {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 1rem 0;
  }
  .icon-heading img {
    width: 24px;
    height: 24px;
  }
  .icon-heading label {
    font-size: 1rem;
    font-weight: 500;
  }
  .button--primary {
    width: 100%;
    margin-top: 1rem;
  }
}
.access-level-select {
  width: 150px;
  justify-content: center;
}

.access-level-select .ant-select-selector {
  min-height: 30px !important;
}

.access-level-select--disabled {
  opacity: 0.8;
}

.status-cell {
  display: flex;
  align-items: center;
}

.status-text {
  margin-left: 8px;
}

.user-management-icon.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.user-management-icons {
  display: flex;
  align-items: center;
  justify-content: left;
}

.user-management-switch.ant-switch-checked,
.user-management-switch.ant-switch-checked:hover {
  background: #03045e !important;
}

.delete-icon {
  margin-left: 4px;
  margin-top: 2px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .user-management-actions {
    flex-direction: column;
    align-items: flex-start;
  }
  .actions-user {
    flex-direction: column;
    align-items: center;
    width: 50%;
    margin-top: 10px;
  }
  .actions-user .ant-input,
  .actions-user .ant-select,
  .actions-user .button {
    width: 100% !important;
    max-width: 100%;
  }
  .user-management-description-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .user-management-description {
    font-size: 0.95rem;
    margin-top: 0.5rem;
  }
  .user-management-header {
    padding: 0.5rem;
  }
  .user-management-table {
    max-width: 100%;
  }
  .custom-dropdown {
    max-width: 70%;
  }
}
/* Responsive adjustments */
@media (max-width: 480px) {
  .user-management-actions {
    flex-direction: column;
    align-items: flex-start;
  }
  .actions-user {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .actions-user .ant-input,
  .actions-user .ant-select,
  .actions-user .button {
    max-width: 100%;
    align-items: center;
  }
  .user-management-description-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .user-management-description {
    font-size: 0.95rem;
    margin-top: 0.5rem;
  }
  .user-management-header {
    padding: 0.5rem;
  }
  .user-management-table {
    overflow-x: auto;
  }
}
.user-management-box {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  padding: 15px 20px;
  border-radius: 10px;
  margin-bottom: 24px;
  overflow: visible;
  position: relative;
}

/* Toolbar container */
.user-management-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
}

.user-toolbar-left {
  display: flex;
  align-items: center;
}

.user-toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.user-input {
  width: 250px;
  height: 40px;
  flex-shrink: 0;
}

.usermanagement-dropdown {
  width: 160px;
  height: 40px;
  flex-shrink: 0;
}

.usermanagement-dropdown[mode=multiple] {
  width: 200px;
}

.user-management-button {
  margin-top: 8px;
}

/* ===== User Management Revamp ===== */
.user-management-container {
  padding: 8px 14px 20px;
  min-height: 100%;
}

.user-management-container .user-management-product-header {
  margin-bottom: 14px;
}

.user-management-container .User-dashboard-header {
  font-size: 32px;
  line-height: 1.1;
  font-weight: 700;
  margin: 0;
}

.user-management-container .user-management-description {
  font-size: 13px;
  color: #000000;
  margin: 3px 0 0;
  padding-left: 0;
}

.user-management-container .user-management-box {
  background: #fff;
  border: 1px solid #d9e2ee;
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
}

.user-management-container .user-management-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #e6edf7;
}

.user-management-container .user-management-card-title {
  font-size: 26px;
  font-weight: 600;
  color: #1f1f1f;
}

.user-management-container .user-management-card-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-management-container .user-management-delete-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  background: #fff;
  color: #2c68ad;
}

.user-management-container .user-management-delete-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.user-management-container .user-management-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  padding: 6px 16px 10px;
}

.user-management-container .user-management-filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-management-container .user-input {
  width: 280px !important;
  margin: 0;
}

.user-management-container .usermanagement-dropdown {
  width: 170px;
  margin: 0;
}

.user-management-container .usermanagement-dropdown.ant-select-multiple:not(.ant-select-show-search) .ant-select-selection-search {
  display: none;
}

.user-management-container .user-management-button {
  margin-top: 0;
  margin-bottom: 0;
  min-width: 102px;
}

.user-management-container .campaign-table-wrapper {
  border-top: 1px solid #edf2fb;
}

.user-management-container .user-management-table .ant-table {
  border-radius: 0;
}

.user-management-container .user-management-table .ant-table-thead > tr > th {
  color: #161616;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 1px solid #e6edf7 !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr > td {
  border-bottom: 1px solid #edf2fb !important;
  color: #2a2a2a;
  font-size: 13px;
  vertical-align: middle;
}

.user-management-container .user-management-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr:hover > td {
  background: #eeeeee !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled > td {
  background: #eeeeee !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled:hover > td {
  background: #eeeeee !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled > td,
.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled > td .campaign-name,
.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled > td a {
  color: #666666 !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled .user-management-icons {
  color: #666666 !important;
  opacity: 0.7;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled .user-management-icons svg {
  stroke: #666666 !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled .access-level-select.ant-select-disabled .ant-select-selection-item,
.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled .access-level-select.ant-select-disabled .ant-select-selection-placeholder {
  color: #666666 !important;
  opacity: 1 !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled .access-level-select.ant-select-disabled .styled-dropdown-caret {
  border-top-color: #666666 !important;
}

.user-management-container .user-management-table .ant-table-tbody > tr.user-row-disabled .user-management-switch.ant-switch-disabled.ant-switch-checked {
  background: #8f8f8f !important;
}

.user-management-container .user-management-table .ant-table-container {
  overflow: visible;
}

.user-management-container .user-management-table .ant-table-tbody .access-level-select .ant-select-selector {
  height: 32px !important;
  min-height: 32px !important;
  /* The wide end-side pad reserves room for the arrow, so it tracks direction
     and no separate RTL rule is needed. */
  padding-block: 0 !important;
  padding-inline-start: 12px !important;
  padding-inline-end: 34px !important;
}

.user-management-container .user-management-table .ant-table-tbody .access-level-select .ant-select-selection-item,
.user-management-container .user-management-table .ant-table-tbody .access-level-select .ant-select-selection-placeholder {
  font-size: 12px !important;
  line-height: 1 !important;
  display: flex;
  align-items: center;
}

.user-management-container .user-management-table .ant-table-tbody .access-level-select .ant-select-arrow {
  top: 68% !important;
  transform: translateY(-50%) !important;
  height: 20px;
  width: 20px;
  /* Logical inset, so the arrow follows the writing direction on its own.
     The shared \`.custom-dropdown .ant-select-arrow\` rule (DropDownStyle.scss)
     is logical too, so the filter dropdowns and the portalled Add/Edit User
     modals no longer need per-direction overrides here. */
  inset-inline-end: 10px;
}

.user-management-container .user-management-table .ant-table-tbody .access-level-cell-inner {
  display: flex;
  align-items: center;
  min-height: 100%;
}

@media (max-width: 1024px) {
  .user-management-container .user-management-filters {
    flex-direction: column;
    align-items: stretch;
  }
  .user-management-container .user-management-filter-group {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .user-management-container .user-input {
    width: 100% !important;
  }
  .ant-select-selector {
    width: 100% !important;
  }
}
@media (max-width: 768px) {
  .user-management-container .User-dashboard-header {
    font-size: 30px;
  }
  .user-management-container .user-management-card-header {
    align-items: flex-start;
    gap: 10px;
  }
  .ant-select-selector {
    width: 100% !important;
  }
}
.filter-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  font-weight: bold;
  align-self: center;
}
.filter-buttons div {
  color: #2c68ad;
  background-color: #ffffff;
  border: 2px solid #2c68ad;
  padding: 10px 15px;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
  width: fit-content;
}
.filter-buttons div:hover {
  background: #2c68ad;
  color: #ffffff;
}

.filter-btn {
  border: 2px solid #38abd2;
}

.button-container {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  padding-top: 30px;
  margin-left: 25px;
}

@media (max-width: 480px) {
  .annualbtn {
    max-width: 50px;
    font-size: 7px;
    font-weight: 700;
    font-size: 8px;
    line-height: 5px;
    border-radius: 5px;
    height: 20px;
  }
}
@media (max-width: 480px) {
  .monthlybtn {
    max-width: 50px;
    font-size: 7px;
    font-weight: 700;
    font-size: 8px;
    line-height: 5px;
    border-radius: 5px;
    height: 20px;
  }
}
@media (max-width: 480px) {
  .facebook-signin-btn {
    display: flex;
    background-color: #1977f3;
    color: #ffffff;
    border-radius: 5px;
    cursor: pointer;
    font-size: 9px;
    width: 200px;
    height: 30px;
    border: #ffffff;
    margin-left: 10px;
    margin-top: 14px;
    text-align: center;
    padding-left: 10px;
  }
}
@media screen and (max-width: 768px) {
  .button-container {
    padding-left: 50px;
  }
  .frequency-heading {
    padding-left: 50px;
  }
}
.error-ok-button {
  background-color: #3ec3f0;
  color: #ffffff;
  font-weight: bold;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
  width: 100px;
}

.error-ok-button:hover {
  background-color: #2a99b4;
}

.error-ok-button:focus {
  outline: none;
}

button.p-multiselect-close.p-link {
  width: fit-content !important;
  height: fit-content !important;
}

.action-btn {
  padding: 4px 8px;
  margin: 0 4px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.2s ease;
}

.archive-btn {
  background-color: #9ca3af;
  color: #666;
}

.archive-btn:hover {
  background-color: #9ca3af;
}

.delete-btn {
  background-color: #ffebee;
  color: #d32f2f;
}

.delete-btn:hover {
  background-color: #ffcdd2;
}

.unarchive-btn {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.unarchive-btn:hover {
  background-color: #c8e6c9;
}

.red-btn {
  background-color: #ff4d4f;
  color: #ffffff;
  border: none;
}

.red-btn:hover {
  background-color: #ff7875 !important;
  color: #ffffff !important;
}

.grey-btn {
  background-color: #9ca3af;
  border: 2px solid #000000;
}

.grey-btn:hover {
  background-color: #d9d9d9;
}

.cancel-btn {
  background: #e53935;
  color: #ffffff;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #ffffff;
}

.confirm-btn {
  background: #2c68ad;
  border: 1px solid #ffffff;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  color: #ffffff;
  gap: 10px;
}

.compare-button,
.send-again-button {
  margin-right: 1rem;
  padding: 0.5rem 1.2rem;
  background-color: #2c68ad;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.back-button {
  background: none;
  border: none;
  color: #2c5bbd;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 16px;
}

.action-buttons {
  margin-top: 1rem;
  display: flex;
  justify-content: right;
  gap: 1.25rem;
}
.action-buttons .compare-btn {
  padding: 0.6rem 1.8rem;
  font-weight: 500;
  font-size: 1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.action-buttons .compare-btn {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  color: #2c68ad;
}
.action-buttons .compare-btn:hover {
  background-color: #f1f5f9;
}

.center-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.compact-send-button:hover {
  background-color: #0088cc;
}

.compact-send-button img {
  width: 18px;
  height: 18px;
}

/* More compact send button */
.compact-send-button {
  background-color: #00a2cc;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 8px;
  padding: 0;
}

.compact-pill-button:hover {
  background-color: #bae7ff;
}

/* More compact pill buttons */
.compact-pill-button {
  flex: 0 0 auto;
  background-color: rgba(44, 104, 173, 0.1607843137);
  border: 1px solid #91d5ff;
  border-radius: 20px;
  padding: 6px 12px;
  margin-right: 8px;
  white-space: nowrap;
  cursor: pointer;
  color: #000000;
  font-size: 10px;
  transition: background-color 0.2s ease;
  box-shadow: none;
  height: 30px;
  line-height: 1.2;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 400px;
  font-weight: 600;
  font-family: "open sans", sans-serif;
}

.resend-button {
  background: none;
  border: none;
  color: #38abd2;
  cursor: pointer;
  text-decoration: underline;
  font-size: inherit;
}

.hamburger-btn {
  position: fixed;
  top: 20px; /* adjust as needed */
  left: 0;
  z-index: 1100;
  background-color: #2b68ad;
  color: #ffffff;
  border: none;
  padding: 12px;
  cursor: pointer;
  font-size: 25px;
  border-radius: 0 6px 6px 0;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
}

.resend-button:hover {
  text-decoration: none;
  background: none;
  border: none;
}

.annualbtn {
  background-color: #ffffff !important;
  max-width: 166px;
  border-color: #000000;
  color: var(--dark-purple, #140054);
  text-align: center;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 142.857% */
  border-radius: 5px;
  border: 2px solid var(--blue-normal, #0172cb);
}

.monthlybtn {
  background-color: #ffffff !important;
  width: 166px;
  border-color: #000000;
  color: var(--dark-purple, #140054);
  text-align: center;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 142.857% */
  border-radius: 5px;
  border: 2px solid var(--blue-normal, #0172cb);
}

.annualbtn:hover {
  background-color: #ffffff !important;
  border-color: #000000;
  color: var(--dark-purple, #140054);
  text-align: center;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 142.857% */
  border-radius: 5px;
  border: 2px solid var(--blue-normal, #0172cb);
}

.monthlybtn:hover {
  background-color: #ffffff !important;
  border-color: #000000;
  color: var(--dark-purple, #140054);
  text-align: center;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 142.857% */
  border-radius: 5px;
  border: 2px solid var(--blue-normal, #0172cb);
}

.annualbtn:hover {
  background-color: none;
  color: var(--dark-purple, #140054);
}

.subscribebtn {
  width: 200px;
  background-color: none !important;
  border-radius: 0px;
  border-color: #38abd2;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.close-btn {
  margin-left: auto;
}

.facebook-signin-btn {
  display: flex;
  background-color: #1977f3;
  color: #ffffff;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 300px;
  height: 40px;
  border: #ffffff;
  margin-left: 70px;
  margin-top: 28px;
  text-align: center;
  padding-left: 10px;
}

.facebook-signin-btn:hover {
  background-color: #165ec9;
}

.add-more-btn,
.compare-btn {
  padding: 0.5rem 1.25rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
}

.add-more-btn {
  background-color: #dbeeff;
  color: #145da0;
}

.red-btn {
  background-color: #e53935;
  color: #ffffff;
  border-color: #e53935;
}

.grey-btn {
  background-color: #ffffff;
  color: #9ca3af;
  border-color: #9ca3af;
}

.grey-btn,
.red-btn {
  border-radius: 3px;
  width: 146px;
  height: 45px;
  font-size: 16px;
}

.cancel-btnMagicScreen {
  position: fixed;
  bottom: 100px;
  /* Adjust the distance from the bottom */
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.cancel-btnMagicScreen:hover {
  background: transparent !important;
  text-decoration: underline;
}

.send-email-btn {
  background-color: \\\\ #2c68ad;
  font-size: 10px;
  width: 100px;
  height: 40px;
  color: #ffffff;
  border-color: \\\\ #2c68ad;
  border: 1px;
  border-radius: 5px;
  font-size: 12px;
  margin-bottom: 20px;
}

.page-btn {
  padding: 6px 12px;
  border: 1px solid #c1d6f5;
  background-color: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  /* Remove browser focus ring */
  outline: none !important;
  /* Prevent tap highlight on mobile */
  -webkit-tap-highlight-color: transparent !important;
  /* Remove inner border in Firefox */
}
.page-btn -moz-focus-inner {
  border: 0;
}

.page-btn:focus {
  outline: none;
  box-shadow: none;
}

.page-btn.active,
.page-btn:hover {
  background-color: #2979ff;
  color: #ffffff;
  border-color: #2979ff;
}

.back-btn {
  background: none;
  border: none;
  color: #0050b3;
  font-size: 16px;
  padding: 0;
  margin-bottom: 20px;
  cursor: pointer;
}

.next-btn {
  display: block;
  margin: 30px auto 0 auto;
  background-color: #1890ff;
  border-color: #1890ff;
  font-weight: 500;
  height: 40px;
  padding: 0 24px;
  border-radius: 6px;
  text-align: center;
}

.btn-outline {
  border: 1px solid #cbd5e1;
  background: transparent;
  padding: 0.35rem 0.75rem;
  font-size: 0.85rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.btn-outline:hover {
  background-color: #f1f5f9;
}
.btn-outline.danger:hover {
  background-color: #fee2e2;
}

.btn-refresh {
  background: transparent;
  color: #1e3a8a;
  font-size: 0.9rem;
  border: none;
  cursor: pointer;
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
}
.btn-refresh:hover {
  background-color: #eff6ff;
}

.right-aligned-btns {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.filter-btn.selected {
  background-color: \\\\ #2c68ad;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.button-container {
  display: flex;
  padding-top: 30px;
  margin-left: 25px;
}

@media screen and (max-width: 768px) {
  .button-container {
    padding-left: 50px;
  }
  .frequency-heading {
    padding-left: 50px;
  }
}
.frequency-heading {
  padding-top: 20px;
  padding-left: 20px;
  text-align: left;
  margin-left: 25px;
}

.buttonstyle {
  height: 45px;
  width: 140px;
}

.selectable-button {
  border-radius: 3px;
  border: 1px solid #38abd2;
  background-color: #ffffff;
  margin: 10px;
  color: #38abd2;
  /* Text color */
  cursor: pointer;
  transition: background-color 0.3s;
  /* Smooth transition */
  text-align: center;
  font-family: Open, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  /* 150% */
  text-transform: uppercase;
}

.selectable-button:hover {
  background-color: #38abd2;
  color: #ffffff;
}

.selectable-button.selected {
  background-color: #38abd2;
  color: #ffffff;
}

.button-style {
  width: 330px;
  height: 45px;
  border: none;
  background-color: #2596be;
  color: #ffffff;
  font-weight: bold;
  max-width: 350px;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 30px;
  display: flex;
  padding: 14px 5px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  font-size: 16px;
  justify-content: center;
}

.button-otp {
  padding: 10px;
  border: none;
  background-color: #2596be;
  color: #ffffff;
  border-radius: 5px;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
}

/* *************************************Steps.css************************************ */
.steps-list {
  list-style-type: none;
  padding: 0;
}

.step-item {
  display: flex;
  align-items: center;
  margin: 30px 0;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 180px;
}

.nextbutton {
  flex: 1 1;
  max-width: 200px;
  height: 40px;
  font-weight: 300;
  color: rgb(15, 15, 15) !important;
  background-color: #75ceeb;
  border-radius: 1px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 25px;
}

.prebutton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border-radius: 1px;
  width: 40px;
  height: 40px;
  padding: 0;
  margin-left: 5px;
}

.prebutton.sidebar-back {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.prebutton .button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  width: 40px;
}

.button-icon:hover {
  color: #000000;
}

.input-style {
  border: 1px solid #bac7d5;
  max-width: 350px;
  height: 35px;
  border-radius: 3px;
  display: flex;
  padding: 14px 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  font-size: 16px;
  margin-bottom: 10px;
}

.input-style-2 {
  border: 1px solid #bac7d5;
  max-width: 350px;
  height: 45px;
  border-radius: 3px;
  display: flex;
  padding: 14px 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  font-size: 16px;
  margin-bottom: 10px;
}

.h2design {
  color: #000000;
  font-family: "opensans", sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-top: 30px;
}

.submit {
  height: 38px;
  width: 78px;
  color: #ffffff !important;
  background-color: #38abd2;
  border: none;
  text-align: center;
  /* font-family: 'sans-serif'; */
  font-weight: normal;
}

/* Notification List */
.notifications-list {
  overflow-y: auto;
}

.create-list-segment-container {
  padding: 18px 10px 30px;
  color: #1a1a1a;
}
.create-list-segment-container .list-segment-back-button {
  min-width: 70px;
  height: 34px;
  padding: 0 14px;
  margin-bottom: 14px;
  font-size: 14px;
}
.create-list-segment-container .list-segment-page-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #000000;
  justify-content: left;
  text-align: left;
}
.create-list-segment-container .list-segment-page-subtitle {
  margin: 4px 0 24px;
  color: #6b7280;
  font-size: 16px;
}
.create-list-segment-container .selection-box {
  background: transparent;
  border: 0;
  border-radius: 0;
  padding: 0;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.create-list-segment-container .selection-box .selection-options {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 24px;
  margin-top: 80px;
}
.create-list-segment-container .selection-box .selection-options .selection-card {
  width: 266px;
  min-height: 210px;
  padding: 20px 18px 16px;
  background: #ffffff;
  border: 1px solid rgb(117, 117, 117);
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans", sans-serif;
  color: #1a1a1a;
  gap: 6px;
}
.create-list-segment-container .selection-box .selection-options .selection-card:hover {
  background-color: rgb(217, 228, 240);
  border-color: #2c68ad;
  box-shadow: 0 3px 10px rgba(44, 104, 173, 0.12);
}
.create-list-segment-container .selection-box .selection-options .selection-card .audience_icon {
  margin-bottom: 8px;
  color: #000000;
}
.create-list-segment-container .selection-box .selection-options .selection-card .card-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px;
  color: #000000;
}
.create-list-segment-container .selection-box .selection-options .selection-card .card-description {
  margin: 0;
  font-size: 12px;
  line-height: 1.35;
  color: rgb(117, 117, 117);
  max-width: 190px;
}

.create-list-container {
  padding: 16px 10px 24px;
  color: #1a1a1a;
}
.create-list-container .create-list-back-button {
  min-width: 70px;
  height: 34px;
  padding: 0 14px;
  margin-bottom: 14px;
  font-size: 14px;
  margin-left: 30px;
}
.create-list-container .create-list-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #000000;
  text-align: left;
  padding-left: 30px;
}
.create-list-container .create-list-subtitle {
  margin: 4px 0 14px;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.4;
  padding-left: 30px;
}
.create-list-container .create-list-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.create-list-container .form-label {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin-top: 2px;
}
.create-list-container .create-list-input {
  width: 100%;
  height: 38px;
  border-radius: 6px;
}
.create-list-container .create-list-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border: 1px solid #2c68ad;
  color: #1f3b65;
  background: #edf4ff;
  border-radius: 8px;
  font-size: 11px;
}
.create-list-container .tag-remove-btn {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  font-size: 12px;
}
.create-list-container .create-list-upload-area {
  margin-top: 8px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  background: #ffffff;
  padding: 62px 12px;
}
.create-list-container .create-list-upload-box {
  gap: 4px;
}
.create-list-container .create-list-upload-box .upload-icon {
  color: #2c68ad;
  margin-bottom: 6px;
}
.create-list-container .create-list-upload-box .upload-text {
  color: #000000;
  font-size: 18px;
  font-weight: 600;
}
.create-list-container .create-list-upload-box .upload-subtext {
  color: rgb(117, 117, 117);
  font-size: 13px;
  font-weight: 400;
}
.create-list-container .create-list-upload-note {
  margin: 2px 0 4px;
  font-size: 11px;
  color: #8b8b8b;
}
.create-list-container .uploaded-file-row {
  margin-top: 8px;
  width: 260px;
  max-width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #ffffff;
}
.create-list-container .uploaded-file-name {
  font-size: 12px;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.create-list-container .uploaded-file-paperclip {
  color: #000000;
  transform: rotate(320deg);
  flex-shrink: 0;
}
.create-list-container .uploaded-file-remove {
  border: 0;
  background: transparent;
  color: #2c68ad;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
}
.create-list-container .create-list-actions {
  margin-top: 0px;
  justify-content: flex-end;
  gap: 10px;
}

.create-segment-page {
  padding: 18px 10px 30px;
  color: #1a1a1a;
}
.create-segment-page .create-segment-back-button {
  min-width: 70px;
  height: 34px;
  padding: 0 14px;
  margin-bottom: 14px;
  font-size: 14px;
}
.create-segment-page .create-segment-title {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.1;
  color: #000000;
  text-align: left;
}
.create-segment-page .create-segment-subtitle {
  margin: 4px 0 16px;
  color: rgb(117, 117, 117);
  font-size: 13px;
  line-height: 1.4;
}
.create-segment-page .create-segment-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.create-segment-page .create-segment-label {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.create-segment-page .create-segment-conditions-title {
  margin-top: 2px;
}
.create-segment-page .create-segment-input {
  height: 38px;
  border-radius: 6px;
}
.create-segment-page .create-segment-condition-wrap {
  position: relative;
}
.create-segment-page .create-segment-condition-card {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px 16px 16px;
  overflow: visible;
}
.create-segment-page .create-segment-condition-dropdown {
  width: 100%;
  min-width: 0;
}
.create-segment-page .create-segment-list-title {
  margin: 20px 0 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.create-segment-page .create-segment-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}
.create-segment-page .condition-btn {
  height: 38px;
  min-width: 130px;
  padding: 0 14px;
  border: 1px solid #9ea8b3;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.create-segment-page .condition-btn:hover {
  border-color: #2c68ad !important;
}
.create-segment-page .condition-btn.active {
  background: rgba(44, 104, 173, 0.18) !important;
  border-color: #2c68ad !important;
  color: #000000 !important;
}
.create-segment-page .condition-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.create-segment-page .create-segment-card-bottom {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-top: 1px solid #edf0f4;
  padding-top: 12px;
}
.create-segment-page .create-segment-logic-buttons {
  display: inline-flex;
  gap: 8px;
  margin-top: 20px;
}
.create-segment-page .create-segment-logic-btn {
  min-width: 44px;
  height: 32px;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  border-color: #2c68ad;
  color: #2c68ad;
}
.create-segment-page .create-segment-logic-btn.is-active,
.create-segment-page .create-segment-logic-btn:hover {
  background: #2c68ad !important;
  color: #ffffff !important;
  border-color: #2c68ad !important;
}
.create-segment-page .create-segment-delete-btn {
  border: 0;
  background: transparent;
  color: #2c68ad;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-right: 8px;
  line-height: 1;
}
.create-segment-page .create-segment-delete-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;
  margin-bottom: 8px;
  padding-right: 2px;
  position: relative;
  z-index: 2;
}
.create-segment-page .create-segment-connector {
  position: relative;
  margin: 0 0 0 34px;
  min-height: 54px;
  display: flex;
  align-items: center;
}
.create-segment-page .create-segment-connector-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 20px;
  padding: 0 10px;
  border-radius: 6px;
  background: #2c68ad;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  transform: translateY(0);
}
.create-segment-page .create-segment-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .create-segment-page .create-segment-title {
    font-size: 32px;
  }
  .create-segment-page .create-segment-condition-card {
    padding: 12px;
  }
  .create-segment-page .condition-btn {
    min-width: 120px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
  }
  .create-segment-page .create-segment-actions .button--primary {
    width: 100%;
    max-width: 220px;
  }
}
@media (max-width: 480px) {
  .create-segment-page .create-segment-title {
    font-size: 28px;
  }
  .create-segment-page .create-segment-back-button {
    margin-left: 0;
  }
  .create-segment-page .create-segment-chip-row {
    gap: 8px;
  }
  .create-segment-page .condition-btn {
    min-width: 100%;
    flex: 1 1 100%;
  }
  .create-segment-page .create-segment-connector::before {
    left: -16px;
    width: 16px;
  }
}
.import-columns-page {
  padding: 16px 10px 24px;
  color: #1a1a1a;
}
.import-columns-page .import-columns-back-button {
  min-width: 70px;
  height: 34px;
  padding: 0 14px;
  margin-bottom: 14px;
  font-size: 14px;
}
.import-columns-page .import-columns-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: left;
}
.import-columns-page .import-columns-subtitle {
  margin: 4px 0 16px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.4;
}
.import-columns-page .import-columns-subtitle strong {
  font-weight: 700;
}
.import-columns-page .import-columns-card {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
}
.import-columns-page .import-columns-table {
  margin-top: 0;
}
.import-columns-page .import-columns-table .ant-table-thead > tr > th {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}
.import-columns-page .import-columns-table .ant-table-tbody > tr > td {
  font-size: 16px;
  color: #1a1a1a;
  height: 56px;
}
.import-columns-page .mapping-text {
  color: #1a1a1a;
}
.import-columns-page .import-mapping-dropdown {
  min-width: 240px;
}
.import-columns-page .import-columns-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
  max-width: 1240px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.import-columns-page .import-mapping-dropdown .ant-select-selector {
  height: 40px !important;
  min-height: 40px !important;
}

.import-columns-page .import-mapping-dropdown .ant-select-selection-item,
.import-columns-page .import-mapping-dropdown .ant-select-selection-placeholder {
  font-size: 14px !important;
}

.tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

@media (max-width: 480px) {
  .create-list-segment-container .selection-box {
    min-height: 0;
  }
  .create-list-segment-container .selection-box .selection-options {
    flex-direction: column;
    align-items: center;
  }
  .create-list-segment-container .selection-box .selection-options .selection-card {
    width: 220px;
    min-height: 210px;
    font-size: 12px;
  }
}
@media (max-width: 1024px) {
  .create-list-segment-container .selection-box .selection-options {
    margin-top: 30px;
  }
  .create-list-segment-container .list-segment-back-button,
  .create-list-container .create-list-back-button,
  .import-columns-page .import-columns-back-button {
    width: auto !important;
  }
  .import-columns-page .import-columns-table .ant-table-content {
    overflow-x: auto !important;
  }
  .import-columns-page .import-columns-table .ant-table-content table {
    min-width: 820px;
  }
}
@media (max-width: 768px) {
  .create-list-segment-container {
    padding: 12px 6px 20px;
  }
  .create-list-segment-container .list-segment-page-subtitle {
    font-size: 14px;
    margin-bottom: 14px;
  }
  .create-list-segment-container .selection-box .selection-options {
    margin-top: 0;
    gap: 14px;
  }
  .create-list-container {
    padding: 12px 6px 18px;
  }
  .create-list-container .create-list-back-button,
  .create-list-container .create-list-title,
  .create-list-container .create-list-subtitle {
    margin-left: 0;
    padding-left: 0;
  }
  .create-list-container .create-list-upload-area {
    padding: 36px 10px;
  }
  .create-list-container .uploaded-file-row {
    width: 100%;
  }
  .create-list-container .create-list-actions {
    margin-top: 10px;
    justify-content: flex-end;
    width: 100%;
  }
  .create-list-container .create-list-actions .button {
    width: auto !important;
    min-width: 110px;
    margin-top: 0 !important;
  }
  .create-list-container .create-list-back-button,
  .import-columns-page .import-columns-back-button,
  .create-list-segment-container .list-segment-back-button {
    width: auto !important;
    min-width: 70px;
  }
  .import-columns-page {
    padding: 12px 6px 18px;
  }
  .import-columns-page .import-columns-title {
    font-size: 28px;
  }
  .import-columns-page .import-columns-subtitle {
    font-size: 14px;
  }
  .import-columns-page .import-columns-card {
    border-radius: 8px;
  }
  .import-columns-page .import-columns-actions {
    margin-top: 10px;
  }
  .import-columns-page .import-columns-actions .button {
    width: auto !important;
    min-width: 110px;
  }
}
@media (max-width: 480px) {
  .create-list-segment-container .list-segment-page-title {
    font-size: 28px;
  }
  .create-list-segment-container .selection-box .selection-options .selection-card {
    width: 100%;
    max-width: 260px;
  }
  .create-list-container .create-list-title {
    font-size: 28px;
  }
  .create-list-container .create-list-subtitle {
    font-size: 13px;
  }
  .create-list-container .create-list-actions {
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .create-list-container .create-list-actions .button {
    min-width: 104px;
  }
  .import-columns-page .import-columns-title {
    font-size: 24px;
  }
  .import-columns-page .import-columns-back-button {
    margin-bottom: 10px;
  }
  .import-columns-page .import-columns-table .ant-table-content table {
    min-width: 760px;
  }
}
.notification-preferences-container {
  padding: 20px;
  margin-bottom: 10px;
  max-width: 100%;
  /* \`height: 84vh\` reserved a full-viewport-tall box no matter how little was
     expanded, so a single open section left dead space below its rows and the
     card scrolled internally. \`max-height\` keeps the same scroll ceiling but
     lets the card shrink to its content. */
  max-height: 84vh;
  overflow-y: auto;
}

div.p-multiselect-label.p-placeholder,
div.p-multiselect-label {
  color: black;
}

/* legacy class kept for any non-preference notification UI */
.notification-category {
  margin-bottom: 10px;
  margin-top: 10px;
}

/* Notifications Modal */
.notifications-modal {
  position: fixed;
  top: 9%;
  right: 50px;
  width: 480px;
  height: 580px;
  background: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 8px;
  border: 1px solid #e5e7eb; /* Gray-200 */
  z-index: 100000;
  display: flex;
  flex-direction: column;
}

/* Header */
.notifications-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 5px;
  padding-left: 5px;
  max-height: 28px;
  border-bottom: 1px solid #f3f4f6;
}

.notifications-modal-title {
  font-size: 14px; /* text-lg */
  color: #1d1d4f;
  font-weight: bold;
  line-height: 1.4;
}

.notifications-mark-all-read {
  border: none;
  background: transparent;
  color: #2c68ad;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  padding: 0;
}
.notifications-mark-all-read:disabled {
  color: #999;
  cursor: not-allowed;
  text-decoration: none;
}

.notifications-modal-content {
  flex: 1 1;
  overflow-y: auto;
}

.notifications-popup-group:not(:last-child) {
  margin-bottom: 4px;
}

.notifications-popup-group__label {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  padding: 10px 4px 4px;
}

.notifications-popup-row__toggle {
  color: #0077b6;
  font-weight: 500;
  cursor: pointer;
  margin-left: 4px;
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  display: inline;
}
.notifications-popup-row__toggle:focus-visible {
  outline: 2px solid #2c68ad;
  outline-offset: 2px;
}

.notifications-view-more-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  border: none;
  border-top: 1px solid #e5e7eb;
  background: transparent;
  color: #2c68ad;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  padding: 10px 4px 4px;
}
.notifications-view-more-btn:hover {
  color: #2a73c2;
}

/* No notifications UI */
.notifications-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
}

.notifications-no-data-image {
  width: 70%; /* w-48 */
}

/* ========== Notification empty / error state (page + bell popup) ========== */
.notification-state-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  padding: 64px 24px;
}

.notification-state-display__icon {
  width: 160px;
  height: 160px;
  margin-bottom: 8px;
}

.notification-state-display__title {
  font-size: 20px;
  font-weight: 700;
  color: #2c68ad;
  font-family: "Open Sans", sans-serif;
}

.notification-state-display__message {
  max-width: 420px;
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
}

.notification-state-display--compact {
  padding: 32px 16px;
  gap: 8px;
}

.notification-state-display--compact .notification-state-display__icon {
  width: 90px;
  height: 90px;
  margin-bottom: 4px;
}

.notification-state-display--compact .notification-state-display__title {
  font-size: 16px;
}

.notification-state-display--compact .notification-state-display__message {
  max-width: 300px;
  font-size: 12px;
}

div.ant-picker-body {
  padding: 0px;
}

.filter-section {
  position: relative;
  display: inline-block;
}

.date-range-dropdown {
  position: absolute;
  top: 100%; /* directly below the buttons */
  left: 0;
  margin-top: 8px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  min-width: 280px;
}

/* ========== All notiifcation page  ========== */
.all-notifications-page {
  margin-top: 15px;
  margin-left: 15px;
}

@media (max-width: 768px) {
  .notifications-container {
    padding: 10px;
  }
  .filter-btn {
    width: 100%;
    text-align: center;
  }
  .filter-btn .filter-btn {
    padding: 12px 16px;
    font-size: 14px;
  }
  .notifications-list {
    flex-direction: column;
    gap: 12px;
  }
  .all-notification-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .notification-category-icon {
    margin-bottom: 10px;
  }
  .all-notification-row__body {
    width: 100%;
  }
  .date-picker-container {
    justify-content: center;
    margin-top: 10px;
  }
  .date-picker-container .ant-picker {
    width: 100%;
    max-width: 100%;
  }
  .no-data-image {
    margin-top: 30px;
    max-width: 70%;
  }
}
@media (max-width: 480px) {
  .filter-btn {
    font-size: 10px;
    padding: 5px 8px;
  }
  .date-picker-container {
    justify-content: center;
    margin-top: 20px;
    max-width: 70%;
    margin-right: 10px;
  }
  .ant-picker {
    font-size: 13px;
    max-width: 70%;
    margin-top: 40px;
  }
  .ant-picker-range .ant-picker-input > input {
    width: 100% !important;
  }
  .no-data-image {
    margin-top: 10px;
    min-width: 100%;
  }
  .ant-picker-panels {
    flex-direction: column !important;
    width: 100% !important;
  }
  .no-data-message {
    margin-top: 0px !important;
  }
  .ant-picker-panel {
    width: 100% !important;
    max-width: 100% !important;
  }
  .ant-picker-dropdown {
    width: 100vw !important;
    left: 0 !important;
    padding: 0 8px;
  }
  .ant-picker-range {
    width: 100% !important;
  }
}
.notifications-page-title {
  font-size: 28px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  color: #111827;
  margin-bottom: 2px;
  text-align: start;
  line-height: 1.4;
  margin-top: 0;
}

.notifications-page-description {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #374151;
  font-weight: 400;
  margin-bottom: 4px;
  text-align: start;
  line-height: 1.5;
  display: block;
}

.notifications-page-hint {
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  color: #374151;
  font-weight: 400;
  margin-bottom: 20px;
  text-align: start;
  line-height: 1.5;
  display: block;
}

/* ========== Category Card ========== */
.notification-category-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  margin-bottom: 10px;
  overflow: hidden;
}

.notification-category-header {
  width: 100%;
  padding: 12px 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-start;
  transition: background 0.15s;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: start;
}
.notification-category-header:hover {
  background: #f3f4f6;
}

.category-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 10px;
}

.category-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.category-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px !important;
  line-height: 24px;
  color: #334155 !important;
}

.category-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 16px;
  color: #94a3b8 !important;
}

.toggle-icon {
  color: #6b7280;
  font-size: 13px;
  flex-shrink: 0;
  margin-inline-start: auto;
}

/* ========== Notification Table ========== */
.notification-table-wrapper {
  border-top: 1px solid #e5e7eb;
  margin-top: 0;
  overflow: visible;
}

.notification-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.notification-table thead tr {
  background: #f9fafb;
}
.notification-table th {
  padding: 10px 16px;
  background-color: #fafafa !important;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  text-align: start;
  border-bottom: 1px solid #e5e7eb;
}
.notification-table tbody tr.activity-row-active {
  background: #fff;
}
.notification-table td {
  padding: 12px 16px;
  background-color: #fafafa !important;
  vertical-align: middle;
  border: none !important;
  border-bottom: 1px solid #e5e7eb !important;
}
.notification-table tbody tr:last-child td {
  border-bottom: none !important;
}

.notification-table th.activity-col {
  width: 58%;
  text-align: start;
}

.notification-table th.toggle-col {
  width: 8%;
  text-align: center;
}

.notification-table td.toggle-cell {
  text-align: center;
  vertical-align: middle;
}

.notification-table th.threshold-col {
  width: 18%;
  color: #6b7280 !important;
  text-align: center;
  white-space: nowrap;
}

.notification-table td.threshold-cell {
  text-align: center;
  vertical-align: middle;
}

.activity-details {
  vertical-align: middle;
  padding-top: 18px !important;
  padding-bottom: 18px !important;
}

/* Keeps the metric name and its (?) definition trigger on one centred line.
   No z-index handling needed: the popover is \`position: fixed\` and these headers
   aren't sticky, so it isn't clipped by the row. */
.activity-name-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* The trigger's 1px nudge is tuned for KPI card headings, not table rows. */
.activity-name-row .definition-tooltip__trigger {
  transform: none;
}

.activity-name {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  font-family: "Open Sans", sans-serif;
}

.activity-description {
  font-size: 12px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
}

/* ========== Toggle Switch ========== */
.notif-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}
.notif-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}
.notif-toggle input:checked + .notif-toggle-slider {
  background-color: #2c68ad;
}
.notif-toggle input:checked + .notif-toggle-slider::before {
  transform: translateX(20px);
}
.notif-toggle .notif-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  margin-top: 0;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: 0.3s;
}
.notif-toggle .notif-toggle-slider::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

/* ========== Configure Button & Badge ========== */
.configure-btn {
  padding: 5px 14px;
  min-height: 28px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  background: #2c68ad;
  color: white;
  cursor: pointer;
  transition: all 0.15s;
  font-family: "Open Sans", sans-serif;
}
.configure-btn:hover {
  background: #2a73c2;
}
.configure-btn--active {
  background: #2a73c2;
}

.threshold-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1a56db;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  flex: 1 1 auto;
  min-width: 0;
}
.threshold-badge span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  unicode-bidi: plaintext;
}
.threshold-badge .threshold-edit-icon {
  flex-shrink: 0;
}
.threshold-badge:hover {
  border-color: #1a56db;
  background: #dbeafe;
}
.threshold-badge--muted {
  border-color: #e5e7eb;
  background: #f9fafb;
  color: #6b7280;
}
.threshold-badge--muted:hover {
  border-color: #d1d5db;
  background: #f3f4f6;
}

.threshold-actions-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  width: 100%;
  min-width: 0;
}

.threshold-delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #fca5a5;
  background: #fef2f2;
  color: #b91c1c;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.15s;
  flex-shrink: 0;
}
.threshold-delete-btn:hover {
  background: #fee2e2;
  border-color: #dc2626;
}
.threshold-delete-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.threshold-delete-btn--muted {
  border-color: #e5e7eb;
  background: #f9fafb;
  color: #6b7280;
}
.threshold-delete-btn--muted:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.threshold-edit-icon {
  font-size: 12px;
  color: #6b7280;
  flex-shrink: 0;
}

/* ========== Configure Threshold Panel ========== */
.configure-panel-row td {
  padding: 0 !important;
  background: #f8faff;
  border: none !important;
}

.configure-threshold-panel {
  padding: 20px 24px;
  background: #fff;
}

.configure-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.configure-panel-title {
  font-size: 15px;
  font-weight: 700;
  color: #20262c;
  font-family: "Open Sans", sans-serif;
  margin-bottom: 0;
}

.configure-panel-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
  flex-shrink: 0;
}
.configure-panel-close:hover {
  border-color: #9ca3af;
  color: #374151;
  background: #f3f4f6;
}

.threshold-form-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.threshold-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.threshold-field--optional {
  order: 1;
}

.threshold-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  text-transform: capitalize;
}

.required-asterisk {
  color: #dc2626;
  margin-inline-start: 2px;
}

.threshold-label .definition-tooltip__trigger {
  transform: none;
  margin-inline-start: 4px;
}

.threshold-field-empty-note {
  padding: 10px 12px;
  border: 1px dashed #d7e1ee;
  border-radius: 7px;
  background: #f8fafc;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  font-family: "Open Sans", sans-serif;
}

.threshold-form-grid .filter-dropdown {
  width: 100% !important;
  min-width: 0 !important;
}

.threshold-value-input {
  height: 38px;
  border-radius: 6px !important;
  border: 1px solid #d1d5db !important;
  font-size: 14px;
}
.threshold-value-input:hover, .threshold-value-input:focus {
  border-color: #1a56db !important;
}

.threshold-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.threshold-cancel-btn {
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fafafa !important;
  color: #374151;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  transition: all 0.15s;
}
.threshold-cancel-btn:hover {
  border-color: #9ca3af;
  background: #f9fafb;
}

.threshold-save-btn {
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #2c68ad;
  color: white;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  transition: all 0.15s;
}
.threshold-save-btn:hover {
  background: #1648c0;
}

.category-title-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.notification-date-range-wrapper {
  margin: 0;
}

/* ========== All Notifications — toolbar & list (redesign) ========== */
.all-notifications-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 20px;
  margin-bottom: 28px;
}

.all-notifications-filter-select {
  min-width: 160px;
}

.filter-dropdown.all-notifications-filter-select .ant-select-selection-item {
  background-color: transparent !important;
  padding: 0 !important;
}

.all-notifications-list {
  display: flex;
  flex-direction: column;
}

.all-notification-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  background: transparent;
  font: inherit;
  text-align: start;
  cursor: pointer;
  padding: 20px 4px;
  transition: background 0.15s ease;
}
.all-notification-row:hover {
  background: #f9fafb;
}
.all-notification-row:focus-visible {
  outline: 2px solid #2c68ad;
  outline-offset: -2px;
}
.all-notification-row:last-child {
  border-bottom: none;
}

.notification-category-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  flex-shrink: 0;
}
.notification-category-icon--sales {
  background: #dbeafe;
  color: #2563eb;
}
.notification-category-icon--web {
  background: #f3e8ff;
  color: #9333ea;
}
.notification-category-icon--insights {
  background: #e8f5e9;
  color: #2e7d32;
}
.notification-category-icon--social {
  background: #fef3c7;
  color: #d97706;
}
.notification-category-icon--default {
  background: #f3f4f6;
  color: #64748b;
}

.all-notification-row__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.all-notification-row__title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  font-family: "Open Sans", sans-serif;
  line-height: 1.4;
}

.all-notification-row__description {
  font-size: 14px;
  color: #4b5563;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
}

.all-notification-row__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #999;
  font-family: "Open Sans", sans-serif;
  line-height: 1.4;
}

.all-notification-row__unread-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2c68ad;
  flex-shrink: 0;
}

@keyframes all-notification-row-flash {
  0%, 100% {
    background: transparent;
  }
  25%, 75% {
    background: #eff6ff;
  }
}
.all-notification-row--highlighted {
  animation: all-notification-row-flash 1.5s ease-in-out 2;
}

.all-notifications-pagination {
  margin-top: 12px;
}

.notifications-modal-content .all-notification-row {
  padding: 14px 4px;
  gap: 12px;
  cursor: pointer;
}
.notifications-modal-content .notification-category-icon {
  width: 36px;
  height: 36px;
}
.notifications-modal-content .all-notification-row__title {
  font-size: 14px;
}
.notifications-modal-content .all-notification-row__description {
  font-size: 13px;
}

@media (max-width: 768px) {
  .all-notifications-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
}
/* ========== Page loading state ========== */
@keyframes donut-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.preferences-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}

.preferences-loading__spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-left-color: #2c68ad;
  border-radius: 50%;
  animation: donut-spin 1.2s linear infinite;
}

/* ========== Digest Frequency Card ========== */
.digest-frequency-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 16px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
  margin-top: 0;
}

.digest-frequency-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.digest-clock-icon {
  font-size: 20px;
  color: #6b7280;
  flex-shrink: 0;
}

.digest-frequency-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.digest-frequency-title {
  font-size: 14px;
  font-weight: 600;
  color: #2A2929;
  font-family: "Open Sans", sans-serif;
}

.digest-frequency-subtitle {
  font-size: 13px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
}

.digest-frequency-note {
  font-size: 12px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  margin-top: 2px;
}

.digest-frequency-select {
  min-width: 220px !important;
  width: auto !important;
  flex-shrink: 0;
  align-self: center;
  margin: 0 !important;
}
.digest-frequency-select .ant-select-selector {
  height: 38px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  white-space: nowrap !important;
}
.digest-frequency-select .ant-select-selection-item {
  line-height: 38px !important;
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

/* ========== Enable Notification (channel master toggles) ========== */
.channel-masters-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  padding: 0 0 16px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

.channel-masters-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 620px;
}

.channel-masters-title {
  font-size: 14px;
  font-weight: 600;
  color: #2A2929;
  font-family: "Open Sans", sans-serif;
}

.channel-masters-subtitle {
  font-size: 12px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
}

.channel-masters-toggles {
  position: relative;
  display: flex;
  align-items: center;
  gap: 32px;
  flex-shrink: 0;
}

.channel-master-toggle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.channel-master-toggle__label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
}

.channel-masters-disabled-tooltip {
  position: absolute;
  top: calc(100% + 10px);
  inset-inline-end: 0;
  z-index: 5;
  display: none;
  width: 240px;
  padding: 10px 12px;
  border-radius: 7px;
  background: #ffffff;
  color: #6b7280;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.16);
}

.channel-masters-toggles--disabled:hover .channel-masters-disabled-tooltip {
  display: block;
}

@media (max-width: 640px) {
  .channel-masters-card {
    flex-direction: column;
    align-items: flex-start;
  }
  .channel-masters-toggles {
    justify-content: flex-start;
  }
}
/* ========== Preferred Language (notification delivery language) ========== */
.preferred-language-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  padding: 0 0 16px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

.preferred-language-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 620px;
}

.preferred-language-title {
  font-size: 14px;
  font-weight: 600;
  color: #2A2929;
  font-family: "Open Sans", sans-serif;
}

.preferred-language-subtitle {
  font-size: 12px;
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
}

.preferred-language-segmented {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.preferred-language-segmented-button {
  min-width: 88px;
  height: 38px;
  padding: 0 16px;
  border: 0;
  background: #ffffff;
  color: #6b7280;
  font-size: 13px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.preferred-language-segmented-button + .preferred-language-segmented-button {
  border-inline-start: 1px solid #e5e7eb;
}

.preferred-language-segmented-button--active {
  background: #2c68ad;
  color: #ffffff;
}

.preferred-language-segmented-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 640px) {
  .preferred-language-card {
    flex-direction: column;
    align-items: flex-start;
  }
}
/* ========== Toggle disabled state ========== */
.notif-toggle--disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.notif-toggle--disabled input,
.notif-toggle--disabled .notif-toggle-slider {
  cursor: not-allowed;
}

/* ========== Picker UI (campaigns, cities, pages) ========== */
.checkbox-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: 4px;
}

.checkbox-group--vertical {
  flex-direction: column;
  gap: 6px;
}

.checkbox-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #374151;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
}
.checkbox-option input[type=checkbox] {
  width: 14px;
  height: 14px;
  accent-color: #1a56db;
  cursor: pointer;
  flex-shrink: 0;
}

.picker-platform-label {
  font-size: 11px;
  color: #6b7280;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.selected-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  color: #1a56db;
}

.selected-tag-remove {
  border: none;
  background: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  display: flex;
  align-items: center;
}
.selected-tag-remove:hover {
  color: #dc2626;
}

.unavailable-note {
  font-size: 13px;
  color: #6b7280;
  font-style: italic;
  font-family: "Open Sans", sans-serif;
}

/* Full-width fields inside the configure grid */
.threshold-field--full {
  grid-column: 1/-1;
}

.threshold-field--toggle {
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.threshold-field--toggle .threshold-label {
  margin: 0;
}

.admin-portal-page .search-bar {
  margin-bottom: 1.5rem;
}
.admin-portal-page .search-bar input {
  max-width: 300px;
}
.admin-portal-page .announcement-list {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.admin-portal-page .announcement-card {
  background: #ffffff;
  border: 1px solid #3079bb;
  padding: 1.2rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 115, 230, 0.08);
}
.admin-portal-page .announcement-card .action-link {
  display: inline-block;
  font-size: 0.85rem;
  color: #03045e;
  word-break: break-all;
  text-decoration: underline;
}
.admin-portal-page .announcement-card .action-link:hover {
  color: \\\$brand-primary;
}
.admin-portal-page .announcement-card .announcement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.admin-portal-page .announcement-card .announcement-header h2 {
  margin: 0;
  font-size: 1.2rem;
  color: #023e8a;
}
.admin-portal-page .announcement-card .announcement-header .meta {
  font-size: 0.85rem;
  color: gray;
  display: block;
  margin-top: 0.25rem;
}
.admin-portal-page .announcement-card .announcement-header .ant-tag {
  font-size: 0.75rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
}
.admin-portal-page .announcement-card .body-text {
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
  color: #333;
}
.admin-portal-page .announcement-card .tags {
  margin-bottom: 0.75rem;
}
.admin-portal-page .announcement-card .tags .ant-tag {
  background-color: #2c68ad;
  color: white;
  border: none;
  font-size: 0.75rem;
}
.admin-portal-page .announcement-card .actions {
  display: flex;
  gap: 1rem;
}
.admin-portal-page .announcement-card .actions button {
  padding: 0;
  font-size: 0.85rem;
}

.truncate-notification {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* AnnouncementPopup.css */
.announcement-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  box-shadow: #222;
}

.popup-content {
  background-color: white;
  padding: 2rem;
  border-radius: 18px;
  width: 90%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-height: 400px;
}

.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}

.announcement-title {
  font-size: 1.3rem;
  color: #474747;
  margin: 0.5rem 0;
  line-height: 1.2;
  text-align: left;
  margin-left: 20px;
  margin-top: 80px;
  font-weight: bolder;
}

.feature-item {
  margin: 0.8rem 0;
  display: flex;
  align-items: flex-start;
}

.announcement-action-button {
  background-color: #ff6d00;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  width: 50%;
  font-weight: bold;
  text-transform: uppercase;
  transition: background-color 0.3s;
  margin-top: 80px;
  justify-content: center;
  margin-left: 100px;
  box-shadow: 0.5px 0.5px 2px rgba(182, 178, 178, 0.6), 2px 2px 6px rgba(182, 178, 178, 0.8);
}

.action-button:hover {
  background-color: #ff9100;
}

.logo-container {
  display: flex;
  justify-content: left;
  margin-bottom: 12px;
  margin-left: 20px;
  margin-top: 15px;
}

.logo-margin {
  margin-left: 12px;
}

.announcement-icon {
  margin-right: 8px;
  font-size: 1.2em; /* Adjust size if needed */
  vertical-align: middle;
}

.logo-title {
  margin-right: 10px;
}

.user-dropdown {
  position: absolute;
  top: 62px;
  inset-inline-end: 15px;
  background-color: #ffffff;
  border: 1px solid #CCD9F0;
  border-radius: 6px;
  min-width: 150px;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  padding: 0;
  font-family: "Segoe UI", sans-serif;
}
.user-dropdown__username {
  padding: 8px 12px;
  font-weight: 600;
  font-size: 13.5px;
  border-bottom: 1px solid #9ca3af;
  background-color: #e5e7eb;
  color: #222;
  line-height: 1.2;
}
.user-dropdown__item {
  padding: 7px 12px;
  display: flex;
  align-items: center;
  font-size: 13.5px;
  cursor: pointer;
  transition: background 0.2s ease;
  line-height: 1.2;
}
.user-dropdown__item:hover {
  background-color: #ffffff;
}
.user-dropdown__item--logout {
  color: #d93025;
}

.dropdown .ant-select-selector {
  border-radius: 6px;
  border: 1px solid #91d5ff;
  box-shadow: none;
  transition: 0.3s;
}
.dropdown .ant-select-selector:hover {
  border-color: #40a9ff;
}

.custom-dropdown {
  position: relative;
}
.custom-dropdown select {
  padding: 6px 10px;
  border-radius: 2px;
  border: 1px solid #ccc;
  font-size: 12px;
  background-color: #ffffff;
  appearance: none;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-inline-end: 20px;
}
.custom-dropdown select:hover {
  border-color: #888;
  border-radius: 0px;
}

.custom-submenu[aria-expanded=false] > .ant-menu-submenu-title::after {
  display: none !important;
}

.custom-divider {
  width: 100px;
}

.custom-dropdown {
  min-width: 200px;
}
.custom-dropdown .ant-select-selector {
  border-radius: 6px !important;
  padding: 4px 12px !important;
  border: 1px solid #ccd9f0 !important;
  font-size: 14px;
  background-color: #ffffff;
  transition: all 0.3s;
}
.custom-dropdown .ant-select-selector:hover {
  border-color: #999 !important;
}
.custom-dropdown .ant-select-selection-item,
.custom-dropdown .ant-select-selection-placeholder {
  color: #000000;
}
.custom-dropdown .ant-select-dropdown {
  border-radius: 6px;
}
.custom-dropdown .ant-select-item-option-selected {
  background-color: #e6f4ff !important;
  font-weight: 600;
}
.custom-dropdown .ant-select-item-option-active {
  background-color: #ffffff !important;
}

.ant-select-arrow {
  display: none;
}

.custom-dropdown .condition-btn {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  margin-inline-start: 5px;
}

.custom-dropdown .ant-select-selector {
  background-color: transparent !important; /* Removes \$white bg */
  border-color: #CCD9F0;
  border-radius: 6px;
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  transition: all 0.3s;
}

.filters-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 10px;
}
.filters-container .filters-inner {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filters-container .right-aligned-btns {
  display: flex;
  gap: 10px;
}

.filters-left {
  display: flex;
  align-items: center;
}

.view-filter {
  margin-inline-start: 16px;
  height: 32px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid #CCD9F0;
}

.styled-dropdown-container {
  position: relative;
  display: inline-block;
  min-width: 180px;
}

.styled-dropdown-select {
  width: 100%;
  padding: 10px 15px;
  padding-inline-end: 30px;
  border-radius: 20px; /* Changed to circular corners */
  border: 1px solid #CCD9F0;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  appearance: none;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  outline: none;
}

.styled-dropdown-select:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.styled-dropdown-select:focus {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
}

.styled-dropdown-arrow {
  position: absolute;
  top: 50%;
  inset-inline-end: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
}

.audience-actions {
  display: flex;
  align-items: center;
}

/* Pill dropdown */
.audience-dropdown {
  width: 40%;
  border-radius: 30px !important;
  height: 42px;
  background-color: #ffffff;
  border: none !important;
  box-shadow: 0.5px 0.5px 2px rgba(182, 178, 178, 0.6), 2px 2px 6px rgba(182, 178, 178, 0.8);
}

/* Selector (visible box before opening) */
.audience-dropdown .ant-select-selector {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 30px !important;
  height: 42px !important;
  display: flex;
  align-items: center;
  padding: 0 16px !important;
  color: #000000 !important;
  font-weight: 500;
}

/* Dropdown text */
.audience-dropdown .ant-select-selection-item {
  color: #000000 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  display: flex;
  align-items: center;
}

/* Export button small adjustment */
.export-btn {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  white-space: nowrap;
  margin-bottom: -3px;
}

.custom-dropdown {
  min-width: 220px;
}
.custom-dropdown .ant-select-selector {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 8px !important;
  height: 44px !important;
  min-height: 44px !important;
  padding-block: 6px !important;
  padding-inline: 10px 40px !important;
  display: flex !important;
  align-items: center !important;
  box-shadow: none !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.custom-dropdown.ant-select-focused .ant-select-selector, .custom-dropdown:hover .ant-select-selector {
  border-color: #000000 !important;
  box-shadow: none !important;
}
.custom-dropdown .ant-select-selection-overflow {
  gap: 6px;
}
.custom-dropdown .ant-select-selection-item {
  background-color: transparent !important;
  border-radius: 0 !important;
  padding: 0 !important;
  font-size: 16px !important;
  color: #000000 !important;
  margin-inline-end: 0 !important;
}
.custom-dropdown.ant-select-single .ant-select-selection-item {
  height: auto !important;
  line-height: normal !important;
}
.custom-dropdown .ant-select-selection-item-remove {
  margin-inline-start: 6px;
}
.custom-dropdown .ant-select-selection-placeholder {
  color: #777 !important;
  font-size: 14px;
}
.custom-dropdown .ant-select-selection-placeholder,
.custom-dropdown .ant-select-selection-search-input,
.custom-dropdown .ant-select-selection-item {
  text-align: start;
}
.custom-dropdown .ant-select-arrow {
  display: flex !important;
  align-items: center;
  justify-content: center !important;
  width: 28px;
  height: 28px;
  inset-inline-end: 8px;
  top: 28px;
  transform: translateY(-50%);
  color: #333;
}

.custom-dropdown--has-value .ant-select-selector {
  background-color: #e4e4e4 !important;
  border-color: #bac7d5 !important;
}

.custom-dropdown.ant-select-disabled .ant-select-selector {
  background-color: #e8e8e8 !important;
  border-color: #cbd5e1 !important;
}

.custom-dropdown.ant-select-disabled .ant-select-selection-item,
.custom-dropdown.ant-select-disabled .ant-select-selection-placeholder {
  color: #bac7d5 !important;
}

.custom-dropdown.ant-select-disabled .styled-dropdown-caret {
  border-top-color: #bac7d5;
}

.condition-dropdown {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

.condition-dropdown .ant-select-selector {
  background-color: #ffffff !important;
  border-color: #d9d9d9 !important;
}

.condition-static {
  height: 42px;
  border-radius: 12px;
  border: 1px solid #d9d9d9 !important;
  background-color: #ffffff !important;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #000000;
}

/* Match dropdown container background with static button */
.condition-dropdown .ant-select-selector {
  background-color: #ffffff !important;
}

.styled-dropdown-caret {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #333;
}

.custom-dropdown-menu {
  border-radius: 12px !important;
  background-color: #ffffff !important;
  padding: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.custom-dropdown-menu .ant-select-item {
  padding: 10px 12px;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.custom-dropdown-menu .ant-select-item-option-active {
  background-color: #f2f2f2 !important;
}

.custom-dropdown-menu .ant-select-item-option-selected {
  background-color: #e4e4e4 !important;
  color: #000000 !important;
  font-weight: 600;
}

.filter-dropdown {
  min-width: 220px;
}
.filter-dropdown.custom-dropdown {
  height: 42px !important;
}
.filter-dropdown.custom-dropdown .ant-select-selector {
  background-color: #ffffff !important;
  border: 1px solid #CCD9F0 !important;
  border-radius: 8px !important;
  height: 42px !important;
  min-height: 42px !important;
  max-height: 42px !important;
  overflow: hidden !important;
  padding-block: 6px !important;
  padding-inline: 10px 40px !important;
  display: flex !important;
  align-items: center !important;
  box-shadow: none !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.filter-dropdown.ant-select-focused .ant-select-selector,
.filter-dropdown .ant-select-selector:hover {
  border-color: #000000 !important;
  box-shadow: none !important;
}
.filter-dropdown .ant-select-selection-overflow {
  gap: 6px;
  flex-wrap: nowrap !important;
  overflow: hidden;
}
.filter-dropdown .ant-select-selection-item {
  background-color: #e4e4e4 !important;
  border-radius: 12px !important;
  padding: 0 10px !important;
  font-size: 14px !important;
  color: #000000 !important;
  margin-inline-end: 0 !important;
  flex: 0 0 auto !important;
  width: auto !important;
  display: inline-flex !important;
  align-items: center !important;
  line-height: 22px !important;
  height: 26px !important;
}
.filter-dropdown.ant-select-single .ant-select-selection-item {
  height: 26px !important;
  line-height: 22px !important;
}
.filter-dropdown.ant-select-single .ant-select-selection-overflow, .filter-dropdown.ant-select-single .ant-select-selection-overflow-item {
  flex: 0 0 auto !important;
}
.filter-dropdown.ant-select-multiple .ant-select-selection-overflow-item {
  flex: 0 0 auto !important;
}
.filter-dropdown .ant-select-selection-item-remove {
  margin-inline-start: 6px;
}
.filter-dropdown .ant-select-selection-search {
  height: 26px !important;
  line-height: 26px !important;
  margin-inline-start: 0 !important;
}
.filter-dropdown .ant-select-selection-search-input,
.filter-dropdown .ant-select-selection-search-mirror {
  height: 26px !important;
  line-height: 26px !important;
}
.filter-dropdown .ant-select-selection-placeholder {
  color: #777 !important;
  font-size: 14px;
}
.filter-dropdown .ant-select-selection-placeholder,
.filter-dropdown .ant-select-selection-search-input,
.filter-dropdown .ant-select-selection-item {
  text-align: start;
}
.filter-dropdown.custom-dropdown .ant-select-arrow {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  inset-inline-end: 8px;
  top: 50% !important;
  margin-top: -14px !important;
  transform: none !important;
  color: #333;
}

.filter-dropdown-menu {
  border-radius: 12px !important;
  background-color: #ffffff !important;
  padding: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.filter-dropdown-menu .ant-select-item {
  padding: 10px 12px;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.filter-dropdown-menu .ant-select-item-option-active {
  background-color: #f2f2f2 !important;
}

.filter-dropdown-menu .ant-select-item-option-selected {
  background-color: #e4e4e4 !important;
  color: #000000 !important;
  font-weight: 600;
}

.audience-sort-dropdown {
  margin-bottom: 9px !important;
}

.styled-input.ant-input-affix-wrapper {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  top: 2px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  padding: 0 12px;
  box-shadow: none;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.styled-input.ant-input-affix-wrapper:hover {
  border-color: #000000;
}

.styled-input.ant-input-affix-wrapper-focused {
  border-color: #000000;
  box-shadow: none;
}

.styled-input--has-value {
  background-color: #e4e4e4 !important;
  border-color: #bac7d5 !important;
}

.styled-input--has-value:hover,
.styled-input--has-value.ant-input-affix-wrapper-focused {
  border-color: #bac7d5 !important;
}

.styled-input.ant-input-affix-wrapper .ant-input {
  font-size: 16px;
  color: #000000;
}

.styled-input.ant-input-affix-wrapper .ant-input::placeholder {
  color: #777;
}

.styled-input.ant-input-affix-wrapper .ant-input-prefix {
  color: #000000;
  font-size: 18px;
  margin-right: 10px;
}

.styled-input.ant-input-affix-wrapper-disabled {
  background-color: #e8e8e8;
  border-color: #cbd5e1;
}

.styled-input.ant-input-affix-wrapper-disabled .ant-input,
.styled-input.ant-input-affix-wrapper-disabled .ant-input::placeholder,
.styled-input.ant-input-affix-wrapper-disabled .ant-input-prefix {
  color: #bac7d5;
}

.styled-text-input.ant-input {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  padding: 0 12px;
  box-shadow: none;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  font-size: 16px;
  color: #000000;
}

.styled-text-input.ant-input:hover {
  border-color: #000000;
}

.styled-text-input.ant-input:focus,
.styled-text-input.ant-input-focused {
  border-color: #000000;
  box-shadow: none;
}

.styled-text-input.ant-input-affix-wrapper {
  height: 44px;
  border-radius: 12px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  padding: 0 12px;
  box-shadow: none;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.styled-text-input.ant-input-affix-wrapper .ant-input {
  background-color: transparent !important;
  height: 100%;
}

.styled-text-input.ant-input-affix-wrapper:hover {
  border-color: #000000;
}

.styled-text-input.ant-input-affix-wrapper-focused {
  border-color: #000000;
  box-shadow: none;
}

.styled-text-input--has-value {
  background-color: #e4e4e4 !important;
  border-color: #bac7d5 !important;
}

.styled-text-input--has-value:hover,
.styled-text-input--has-value.ant-input-focused {
  border-color: #bac7d5 !important;
}

.styled-text-input.ant-input::placeholder {
  color: #777;
}

.styled-text-input.ant-input[disabled],
.styled-text-input.ant-input[disabled]::placeholder {
  background-color: #e8e8e8;
  border-color: #cbd5e1;
  color: #bac7d5;
}

.ant-menu-title-content {
  color: #ffffff !important;
}

@media (max-width: 480px) {
  .stats-grid {
    gap: 5px;
    grid-template-columns: 1fr !important;
  }
  .chart-section {
    min-height: 250px;
  }
  .ant-card {
    padding: -15px;
  }
  .controls-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .date-range-picker-container {
    gap: 14px !important;
  }
  .controls-row .ant-picker-range,
  .controls-row .ant-select {
    width: 100% !important;
  }
  .notification-date-range-wrapper {
    margin-top: 0px !important;
    margin-inline-end: 0px !important;
    margin-bottom: 10px;
  }
  /* Summary banner font scaling */
  .info-banner {
    font-size: 14px !important;
    line-height: 1.4;
    text-align: center;
  }
  /* Chart section adjustment */
  .chart-section {
    min-height: 270px !important;
    padding: 10px;
  }
  /* Headline inside chart */
  .chart-section .headline {
    font-size: 16px;
    text-align: center;
  }
  /* Table responsiveness */
  .pipeline-table {
    overflow-x: auto;
  }
  .pipeline-table .ant-table-content {
    min-width: 600px;
  }
  .pipeline-table .ant-table-thead > tr > th,
  .pipeline-table .ant-table-tbody > tr > td {
    white-space: nowrap;
  }
  /* Dropdown full width */
  .metric-selection {
    width: 100% !important;
    display: table-row;
  }
  /* Range picker full width */
  .ant-picker-range {
    width: 100% !important;
  }
  .campaign-dashboard .dashboard-header {
    display: table-row;
    justify-content: space-between;
    align-items: center;
    margin-top: 0px;
  }
  .filters-container {
    display: table-row;
    justify-content: space-between;
  }
  .create-campaign-container {
    padding: 16px;
  }
  .campaign-header-actions,
  .filters-container,
  .filters-left,
  .filters-right {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .campaign-header-actions button,
  .campaign-search-input,
  .campaign-dropdown,
  .button--primary,
  .button--outline {
    width: 100% !important;
  }
  .custom-dropdown-menu {
    width: 100% !important;
  }
  .input-row {
    flex-direction: column;
  }
  .input-row input,
  .input-row .ant-picker {
    width: 100%;
  }
  .recipient-selects {
    flex-direction: column;
    gap: 12px;
  }
  .custom-ribbon {
    font-size: 10px;
    line-height: 1;
    margin-bottom: 10px;
    margin-top: 0;
  }
  .heading-primary {
    font-size: 20px;
    text-align: center;
    margin-top: 30px;
  }
  .heading-secondary {
    font-size: 16px;
    margin-top: 20px;
    display: block;
    text-align: center;
  }
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  .action-buttons button {
    width: 100%;
  }
  .button--primary {
    width: 40%;
  }
  .ant-select-selector {
    width: 100%;
  }
  .container {
    padding: 10px;
    overflow-x: auto;
  }
  .header-cell {
    font-size: 14px;
  }
  .data-cell,
  .sample-cell,
  .select-cell {
    font-size: 13px;
  }
  .select-cell .ant-select {
    width: 100% !important;
  }
  .create-segment-container {
    padding: 16px;
  }
  .button {
    width: 100%;
    margin-bottom: 10px;
  }
  .segment-name-input {
    width: 100%;
    margin-bottom: 16px;
  }
  .definition-section {
    padding: 10px;
    border: 1px solid #ddd;
    margin-bottom: 16px;
    border-radius: 8px;
  }
  .custom-dropdown {
    flex-direction: column;
    gap: 10px;
  }
  .condition-btn {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .condition-row {
    flex-wrap: wrap;
    gap: 8px;
  }
  .section-title {
    font-size: 16px;
    margin: 12px 0 6px;
  }
  .logic-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }
  .action-buttons {
    margin-top: 24px;
  }
  .search-container {
    max-width: 150px;
    padding-inline-end: 10px;
    gap: 0px;
  }
  .custom-header-right {
    gap: 0px !important; /* tighter spacing on mobile */
  }
  .dashboards-heading {
    font-size: 10px !important;
    padding-inline-end: 10px;
    gap: 10px;
    padding-inline-start: 0;
  }
  .profile-container {
    gap: 6px;
  }
  .bell-icon-dashboard {
    margin-top: 10px;
    height: 30px !important;
    width: 20px !important;
  }
  .img {
    width: 10px;
  }
  .header-actions {
    gap: 30px;
  }
  .ant-layout {
    font-size: 12px;
    padding-inline-start: 0;
    background-color: #ffffff;
  }
  .connected-sources-container {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .connect-header {
    font-size: 24px;
    text-align: center;
  }
  .sub-heading {
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
  }
  .dashboard-prefix {
    display: none !important;
  }
  .smart-search-container {
    display: none !important;
  }
  .dashboard-image {
    display: none !important;
  }
  .app-sidebar {
    position: fixed;
    top: 0;
    inset-inline-start: 0;
    height: 100vh;
    width: 0;
    overflow: hidden;
    transition: width 0.3s ease;
    z-index: 1000;
    background-color: #2c68ad;
  }
  .app-sidebar.open {
    width: 200px;
    overflow-y: auto;
    padding: 10px 8px;
  }
  .ant-menu {
    width: 70%;
  }
  .ant-menu-inline {
    width: 100%;
  }
  .ant-layout-sider-children {
    width: 100%;
  }
  .ant-layout-sider {
    width: 100%;
  }
  .ant-menu-submenu {
    width: 100%;
  }
  .ant-menu-item {
    width: 100%;
  }
  .admin-portal-page .filters {
    display: table-row;
    gap: 16px;
    margin-bottom: -40px;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 10px;
  }
  .ant-select-selector {
    margin-top: 10px;
  }
  .ant-col-8 {
    display: table-row;
    height: 50%;
  }
  .avatar-icon-dashboard {
    margin-top: 22px;
    height: 50px !important;
    width: 40px !important;
  }
  .field-labels {
    display: flex;
    flex-direction: column; /* or 'column' to stack */
    gap: 8px;
    justify-content: space-between;
  }
  .field-labels > div {
    flex: 1 1; /* Equal width for all cards */
    min-width: 0; /* Prevents overflow */
    max-width: 100%;
  }
  .right-aligned-btns {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 20px;
  }
  .send-email-btn {
    background-color: #2c68ad;
    font-size: 10px;
    width: fit-content;
    height: 40px;
    color: #ffffff;
    border-color: #2c68ad;
    border: 1px;
    border-radius: 5px;
    font-size: 12px;
    margin-bottom: 20px;
  }
  .admin-portal-page .filters .filters-inner {
    padding-top: 10px;
    gap: 10px;
    width: 100%;
  }
  .admin-portal-page .filters-settings {
    display: flex;
    gap: 16px;
    margin-bottom: -40px;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 10px;
  }
  .cards-grid {
    grid-template-columns: 1fr; /* Stack cards vertically */
    grid-template-rows: none;
    gap: 24px;
    margin-top: 30px;
    justify-items: center;
  }
  .connected-card {
    width: 90%;
    height: 90%;
    padding: 16px;
  }
  .connector-img-shopify {
    width: 60%;
    height: 180px;
    object-fit: contain;
  }
  .connector-img-google-ads,
  .connector-img-google-analytics,
  .connector-img-facebook {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  .connector-img-instagram {
    width: 200px;
    height: 180px;
  }
  .overview-header-actions {
    margin-top: 5px;
  }
  .button--outline {
    margin-top: 16px;
  }
  .audience-dropdown {
    width: 100% !important;
  }
  .custom-list-header {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .header-actions-buttons {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .bulk-actions,
  .audience-actions {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .audience-search-input,
  .audience-dropdown,
  .export-btn,
  .bulk-actions button {
    width: 100% !important;
  }
  .campaign-header-actions {
    margin-top: 5px;
  }
  .filters-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .filters-left {
    order: 1;
    width: 100%;
  }
  .filters-left .ant-space {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .campaign-search-input {
    order: 1;
    width: 100% !important;
    margin-top: 10px;
  }
  .filters-right {
    order: 2;
    width: 100%;
    margin-top: 15px;
  }
  .campaign-search-input,
  .campaign-dropdown,
  .button--primary,
  .button--outline {
    width: 100% !important;
  }
  .custom-dropdown-menu {
    width: 100% !important;
  }
  .stats-row {
    display: flex;
    flex-direction: column;
  }
  .info-banner {
    font-size: 13px;
    padding: 8px 10px;
  }
  .heading-row {
    flex-direction: column;
    align-items: stretch;
  }
  .heading-row h3 {
    font-size: 1.2rem;
  }
  .ant-picker {
    width: 100%;
  }
  .connected-footer {
    position: static;
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .button-footer {
    width: 100%;
    max-width: 300px;
    font-size: 14px;
  }
  .disconnected-message {
    font-size: 13px;
    text-align: center;
    padding: 8px;
  }
  .logo-design {
    width: 120px;
    height: auto;
    margin-bottom: 1rem;
  }
  .signup-internal-container {
    width: 100%;
    max-width: 360px;
    padding: 1.5rem;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }
  .formdesign {
    width: 100%;
  }
  .signup-heading {
    font-size: 1.25rem;
    text-align: center;
  }
  .custom-google-button {
    width: 80%;
    padding: 0.6rem;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .input-container {
    margin-bottom: 1rem;
  }
  .input-style-2 {
    width: 100%;
    padding: 0.6rem;
    font-size: 1rem;
  }
  .button-style {
    width: 80%;
    padding: 0.7rem;
    font-size: 1rem;
    margin-top: 1rem;
  }
  .forgot-password-txt,
  .signup-page-text {
    text-align: center;
    font-size: 0.85rem;
    margin-top: 0.5rem;
  }
  .or {
    text-align: center;
    margin: 1rem 0;
  }
}
/* Tablet (≤768px) */
@media (max-width: 768px) {
  .app-sidebar {
    position: absolute;
    width: 0;
    overflow: hidden;
    transition: width 0.3s ease;
    z-index: 1000;
    background-color: #2c68ad;
  }
  .header-dashboard {
    flex-direction: row !important;
    flex-wrap: nowrap;
    align-items: center !important;
    padding: 10px;
    font-size: 12px;
  }
  img, svg {
    padding-inline-end: 5px;
    width: 30px;
  }
  .header-right {
    flex: 1 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
  .headline {
    font-size: 14px;
    margin-inline-start: 10px;
  }
  .input-row input,
  .input-row .ant-picker {
    flex: 1 1 100%;
  }
  .recipient-selects {
    flex-direction: column;
    gap: 16px;
  }
  .select-list {
    min-width: 100%;
  }
  .controls-row {
    flex-direction: column !important;
    column-gap: 20px;
  }
  .controls-row .ant-picker,
  .controls-row .ant-select {
    width: 40% !important;
  }
  .stats-grid {
    grid-template-columns: 1fr;
  }
  .chart-section {
    padding: 0 8px;
  }
  .headline {
    font-size: 14px;
    margin-bottom: 10px;
    margin-inline-end: 10px;
  }
  .action-buttons {
    justify-content: center;
  }
  .search-container {
    flex: 1 1 auto;
    max-width: 250px; /* Shrink it */
  }
  .profile-container {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .p-0 {
    font-size: 10px;
  }
  .bell-icon-dashboard {
    margin-top: 10px;
    height: 20px !important;
    width: 20px !important;
  }
  .breadcrumb-text {
    display: none;
  }
}
@media (min-width: 769px) {
  .hamburger-btn {
    display: none;
  }
  .ant-menu-title-content {
    color: #ffffff !important;
  }
  .ant-menu-inline.ant-menu-root .ant-menu-item {
    color: #ffffff !important;
  }
  .app-sidebar {
    position: absolute;
    width: 0;
    overflow: hidden;
    transition: width 0.3s ease;
    z-index: 1000;
    background-color: #2c68ad;
  }
}
@media screen and (max-width: 900px) {
  .formdesign {
    padding: 30px 4%;
    max-height: 65vh;
  }
}
.account-settings-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 100px;
  flex-wrap: nowrap;
  margin: 0 auto;
  max-width: 1200px;
  padding: 20px;
  margin-top: -30px;
}

.account-card .ant-card-head,
.password-card .ant-card-head {
  background-color: #2c68ad;
  color: white;
}

.photo-btns {
  color: #2c68ad !important;
  background-color: aliceblue !important;
  text-decoration: underline !important;
  padding: 5px !important;
}

/* Left card */
.account-card {
  width: 500px;
  min-height: 680px;
  border-radius: 8px !important;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25) !important;
}
.account-card div.ant-card-body {
  padding-left: 30px;
  padding-right: 30px;
}

.account-avatar-section {
  text-align: center;
  font-weight: 700;
  -webkit-text-decoration: solid;
          text-decoration: solid;
}

.account-avatar {
  font-size: 40px !important;
  width: 90px !important;
  height: 90px !important;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1); /* secondary subtle shadow */
}
.account-avatar.no-photo {
  background-color: #2c68ad;
}
.account-avatar.has-photo {
  background-color: transparent;
}

.profile-upload-input {
  display: none;
}

.photo-label {
  cursor: pointer;
}

.divider {
  margin: 0 8px;
  color: #ccc;
  font-weight: 300;
}

.photo-btns {
  color: #2c68ad;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}
.photo-btns:hover {
  color: #174c85;
  text-decoration: underline;
}

.account-upload {
  color: #023e8a;
  font-size: 24px;
  font-weight: 500;
}

.account-form .edit-icon,
.account-industry-dropdown .industry-edit-icon {
  cursor: pointer;
  color: #1890ff;
  font-size: 14px;
  line-height: 1;
}

.update-btn {
  margin-top: 16px;
  width: 100%;
}

/* Right card */
.password-card {
  width: 500px;
  height: 450px;
  border-radius: 12px !important;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25) !important;
}
.password-card div.ant-card-body {
  padding-left: 30px;
  padding-right: 30px;
}

.password-strength {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.strength-text {
  font-size: 12px;
}

.strength-text.success {
  color: #52c41a;
}

.strength-text.active {
  color: #faad14;
}

.strength-text.exception {
  color: #ff4d4f;
}

.account-photo-actions {
  display: flex;
  justify-content: center; /* centers under avatar */
  align-items: center;
  gap: 8px; /* space between items */
  margin-top: 8px;
  margin-bottom: 8px;
}

.setting-btn {
  width: 150px;
  height: 50px;
  border-radius: 8px;
  padding: 10px;
  background-color: #2c68ad;
  display: block;
  margin: 0 auto;
}

div.ant-col.ant-form-item-label.css-dev-only-do-not-override-vryruh {
  padding: 0px 0px 0px !important;
}

span.strength-text.active {
  background-image: none !important;
}

.account-industry-dropdown.custom-dropdown .ant-select-selector {
  height: 44px !important;
  min-height: 44px !important;
  border-radius: 8px !important;
  padding-left: 12px !important;
  padding-right: 68px !important;
}

.account-form .account-industry-dropdown {
  width: 100% !important;
  min-width: 0 !important;
}

.account-industry-dropdown .ant-select-arrow {
  width: auto !important;
  pointer-events: auto;
}

.account-industry-dropdown .industry-suffix-icons {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

@media (max-width: 1024px) {
  .account-settings-container {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 24px;
    max-width: 100%;
  }
  .account-card,
  .password-card {
    width: 100%;
    max-width: 100%;
  }
  .password-card {
    height: auto;
  }
}
/* Table container */
.Reusable-table .ant-table {
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  box-shadow: 0.5px 0.5px 2px rgba(182, 178, 178, 0.6), 2px 2px 6px rgba(182, 178, 178, 0.8) !important;
}

/* Header */
.Reusable-table .ant-table-thead > tr > th {
  font-weight: 500;
  font-size: 14px;
  color: #fff;
  background: #2C68AD;
  padding: 10px 14px;
  border-bottom: 1px solid #e5e5e5;
  font-family: "opensans", sans-serif;
  text-align: start;
  text-transform: uppercase;
}

/* Body cells */
.Reusable-table .ant-table-tbody > tr > td {
  font-size: 12px;
  font-weight: 500;
  padding: 12px 16px;
  color: #474747;
  border-bottom: 1px solid #EEEEEE;
  font-family: "opensans", sans-serif;
  background: #fff;
  text-align: start;
}

/* Row hover */
.Reusable-table .ant-table-tbody > tr:hover > td {
  background: #f9fbff;
}

/* Actions */
.table-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

/* Reset AntD default table spacing */
.Reusable-table .ant-table table {
  border-collapse: collapse !important; /* remove gaps */
  border-spacing: 0 !important; /* kills the white padding */
  border-radius: 0 !important; /* removes extra rounding */
  margin: 0 !important;
  padding: 0 !important;
}

/* Ensure header aligns flush with container */
.Reusable-table .ant-table-thead > tr > th:first-child {
  padding-inline-start: 12px !important; /* adjust as you want */
}

.action-icon {
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.action-icon.edit {
  color: #1890ff;
}

.action-icon.edit:hover {
  color: #40a9ff;
}

.action-icon.delete {
  color: #ff4d4f;
}

.action-icon.delete:hover {
  color: #ff7875;
}

/* Pagination */
.Reusable-table .ant-pagination {
  margin: 16px;
  display: flex;
  justify-content: flex-end;
}

/* Total text (left side) */
.pagination-total {
  font-size: 13px;
  color: #111827;
  font-family: "opensans", sans-serif;
  font-weight: 500;
  margin-inline-start: 50px;
}

.custom-pagination--compact {
  justify-content: space-between !important;
  width: 100%;
}

.custom-pagination--no-total {
  justify-content: flex-end !important;
}

.custom-pagination--rtl {
  direction: rtl;
  flex-direction: row-reverse;
}

.custom-pagination--rtl.custom-pagination--no-total {
  justify-content: flex-start !important;
}

.custom-pagination--ltr {
  direction: ltr;
}

.custom-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: 13px;
}

.pagination-number {
  font-size: 13px;
  color: #000000;
  font-family: "opensans", sans-serif;
  font-weight: 500;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-pagination--rtl .pagination-controls {
  direction: ltr;
}

.pagination-icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.pagination-icon-btn:hover:not(:disabled) {
  background: #f9fafb;
  color: #374151;
}

.pagination-icon-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.pagination-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.pagination-btn svg {
  width: 18px !important;
  height: 18px !important;
  padding-right: 0 !important;
  flex-shrink: 0;
  display: block;
}

.pagination-btn:hover:not(:disabled) {
  background: #f9fafb;
  color: #374151;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.pagination-page {
  font-weight: 600;
  color: #111827;
  font-size: 13px;
  font-family: "opensans", sans-serif;
}

.Reusable-table .ant-table-footer,
.campaign-table .ant-table-footer {
  padding: 12px 12px;
  padding: 16px;
  background: #fff;
  margin-top: 0;
  margin-right: 0;
  padding-bottom: 0;
}

.campaign-table .ant-table-container {
  background: #fff;
}

.custom-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* On mobile: reduce font size and padding */
@media (max-width: 768px) {
  .reusable-table-wrapper .ant-table-thead > tr > th,
  .reusable-table-wrapper .ant-table-tbody > tr > td {
    padding: 8px;
    font-size: 13px;
  }
  .table-actions .action-icon {
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .Reusable-table {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .Reusable-table .ant-table-thead > tr > th,
  .Reusable-table .ant-table-tbody > tr > td {
    padding: 6px;
    font-size: 12px;
    white-space: nowrap;
  }
  .table-actions .action-icon {
    font-size: 14px;
  }
  .pagination-controls {
    margin-inline-start: 100px;
    gap: 5px;
  }
}
.tenant-usage-monitor {
  padding: 20px;
  background-color: #f5f8fc;
}
.tenant-usage-monitor .tum-stat-row {
  margin-bottom: 20px;
}
.tenant-usage-monitor .tum-stat-card {
  border-radius: 12px;
  background: linear-gradient(145deg, #e6f0ff, #f0f5ff);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.tenant-usage-monitor .tum-stat-card .ant-statistic-title {
  color: #003a8c;
}
.tenant-usage-monitor .tum-stat-card .ant-statistic-content-value {
  color: #1677ff;
  font-weight: 600;
}
.tenant-usage-monitor .tum-search-input {
  margin-bottom: 16px;
  border-radius: 8px;
}
.tenant-usage-monitor .tum-table-card {
  border-radius: 12px;
  padding: 12px;
  overflow: hidden;
}
.tenant-usage-monitor .tum-table-card .ant-table-container,
.tenant-usage-monitor .tum-table-card .ant-table-content {
  overflow: visible;
}
.tenant-usage-monitor .tum-table-card .ant-table {
  width: 100%;
}
.tenant-usage-monitor .tum-table .ant-progress-bg {
  border-radius: 6px;
}
.tenant-usage-monitor .tum-tenant-cell {
  display: flex;
  flex-direction: column;
}
.tenant-usage-monitor .tum-tenant-cell .tum-tenant-id {
  font-size: 12px;
  color: #8c8c8c;
}
.tenant-usage-monitor .tum-metric-cell {
  font-size: 13px;
}
.tenant-usage-monitor .tum-progress {
  margin-top: 4px;
}
.tenant-usage-monitor .tum-progress-normal .ant-progress-bg {
  background-color: #1677ff !important;
}
.tenant-usage-monitor .tum-progress-warning .ant-progress-bg {
  background-color: #fa8c16 !important;
}
.tenant-usage-monitor .tum-progress-critical .ant-progress-bg {
  background-color: #ff4d4f !important;
}
.tenant-usage-monitor .tum-input-number {
  width: 100%;
}
.tenant-usage-monitor .tum-edit-btn {
  color: #1677ff;
}
.tenant-usage-monitor .usage-table .ant-table-cell,
.tenant-usage-monitor .usage-table .ant-table-thead > tr > th {
  white-space: normal;
  word-break: break-word;
}
.tenant-usage-monitor .usage-table .ant-table-cell {
  padding: 12px 8px;
  font-size: 12px;
}
.tenant-usage-monitor .usage-table .ant-table-thead > tr > th {
  padding: 12px 8px;
  font-size: 12px;
}

.tum-metric-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tum-tag {
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}

.tum-tag-normal {
  background-color: #52c41a;
}

.tum-tag-warning {
  background-color: #fa8c16;
}

.tum-tag-critical {
  background-color: #ff4d4f;
}

.tum-metric-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tum-metric-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tum-tag {
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}

.tum-tag-normal {
  background-color: #52c41a;
}

.tum-tag-warning {
  background-color: #fa8c16;
}

.tum-tag-critical {
  background-color: #ff4d4f;
}

/* TenantUsageMonitor.css */
.tum-progress-bar {
  width: 100%;
  display: inline-block;
}

@media (max-width: 1200px) {
  .usage-table .ant-table-cell,
  .usage-table .ant-table-thead > tr > th {
    padding: 10px 6px;
    font-size: 11px;
  }
}
@media (max-width: 992px) {
  .usage-table .ant-table-cell,
  .usage-table .ant-table-thead > tr > th {
    padding: 8px 4px;
    font-size: 10px;
  }
}
.edit-tenant-modal .ant-modal-content {
  border-radius: 8px;
  padding: 20px 24px;
}
.edit-tenant-modal .ant-modal-header {
  border-bottom: none;
  padding: 0 0 16px 0;
}
.edit-tenant-modal .ant-modal-header .ant-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f1f1f;
}
.edit-tenant-modal .ant-modal-footer {
  border-top: none;
  padding-top: 16px;
}
.edit-tenant-modal .ant-modal-footer .ant-btn {
  border-radius: 6px;
  padding: 0 20px;
  height: 34px;
}
.edit-tenant-modal .ant-modal-footer .ant-btn-primary {
  background-color: #1677ff;
}
.edit-tenant-modal .ant-form .ant-form-item {
  margin-bottom: 16px;
}
.edit-tenant-modal .ant-form .ant-form-item .ant-form-item-label {
  font-weight: 500;
  color: #444;
}
.edit-tenant-modal .ant-form .ant-form-item .ant-input-number {
  width: 100%;
}
.edit-tenant-modal .ant-form .ant-form-item .ant-input-number .ant-input-number-input {
  text-align: left;
  padding-right: 40px;
}
.edit-tenant-modal .ant-form .ant-form-item .ant-input-number-group-addon {
  background: transparent;
  border: none;
  padding: 0;
}
.edit-tenant-modal .ant-form .ant-form-item .ant-input-number-group-addon .ant-btn {
  padding: 0 6px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.edit-tenant-modal .ant-form .ant-form-item .ant-input-number-group-addon .ant-btn .anticon {
  font-size: 14px;
  color: #888 !important;
}
.edit-tenant-modal .ant-form .ant-form-item .ant-input-number-group-addon .ant-btn .anticon:hover {
  color: #1677ff;
}

.error-fallback {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  padding: 32px 16px;
  background: #ffffff;
}

.error-fallback-card {
  text-align: center;
  max-width: 760px;
  width: 100%;
}

.error-fallback-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.error-fallback-brand .logo-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.error-fallback-brand .popup-icon {
  width: 42px;
  height: 42px;
}

.error-fallback-brand .popup-logo {
  height: 32px;
}

.error-fallback-mark {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #2c68ad;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.error-fallback-mark img {
  width: 20px;
  height: 20px;
  display: block;
}

.error-fallback-name {
  font-family: "opensans", sans-serif;
  font-weight: 700;
  color: #2c68ad;
  letter-spacing: 1px;
  font-size: 18px;
}

.Error-image {
  height: 380px;
}

.error-fallback-title {
  font-family: "opensans", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #2c68ad;
  margin: 0 0 6px 0;
}

.error-fallback-message {
  font-family: "opensans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #8B8A8A;
  margin: 0 0 20px 0;
}

.error-fallback-illustration {
  display: flex;
  justify-content: center;
}

.error-fallback-illustration svg {
  width: 100%;
  max-width: 520px;
  height: auto;
}

.error-fallback-retry {
  margin-top: 18px;
  padding: 8px 20px;
  border-radius: 6px;
  background: #2c68ad;
  color: #ffffff;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.error-fallback-retry:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .error-fallback {
    min-height: calc(100vh - 120px);
  }
  .error-fallback-title {
    font-size: 20px;
  }
  .error-fallback-message {
    font-size: 12px;
  }
}
.tippy-box[data-theme~=dt] {
  background-color: #111111;
  color: #ffffff;
  font-size: 12px;
  line-height: 1.3;
  padding: 4px 6px;
  border-radius: 4px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.tippy-box[data-theme~=dt] .tippy-arrow {
  color: #111111;
}

.dt-tooltip__trigger {
  display: inline-flex;
}

.ant-menu {
  scrollbar-width: thin;
  scrollbar-color: #3079bb transparent; /* Firefox */
}
.ant-menu::-webkit-scrollbar {
  width: 8px;
}
.ant-menu::-webkit-scrollbar-track {
  background: transparent; /* Optional: light gray or transparent */
}
.ant-menu::-webkit-scrollbar-thumb {
  background-color: #3079bb; /* Blue thumb */
  border-radius: 4px;
}
.ant-menu::-webkit-scrollbar-thumb:hover {
  background-color: #3079bb; /* Darker on hover */
}

.dt {
  text-align: center;
  margin-top: 20px;
  justify-content: center;
  margin-inline-start: 18px;
  cursor: pointer;
  margin: "5px auto";
}

.layout-sub-menu ul {
  background-color: #ffffff !important;
}

.layout-sub-menu li {
  font-size: 10px !important;
}

.vertical-submenu {
  line-height: 10px !important;
  height: 20px !important;
}

.left-menu {
  color: #ffffff;
}

.ant-tooltip {
  display: none;
}

ul {
  color: #9ca3af;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  padding: 5px;
  font-weight: 400;
  line-height: 16px;
  /* 133.333% */
  text-align: start;
}

li {
  padding: 5px;
  text-align: start;
}

.fentry {
  text-align: start;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

td {
  text-align: start;
  border-bottom: 1px solid #e5e7eb;
  color: #6b7280;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.image {
  flex-basis: 70%;
  order: 2;
  float: left;
}

[dir=rtl] .image {
  float: right;
}

.imagestyle {
  width: 60.545px;
  height: 63.548px;
  margin-top: -75px;
  margin-inline-end: -50px;
}

.premium {
  width: 78.545px;
  height: 58.548px;
}

.pc {
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding-top: 20px;
}

.pcr {
  color: #9ca3af;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

/*******************magic screen********/
@media (max-width: 480px) {
  div.ant-progress.ant-progress-status-active.ant-progress-line.ant-progress-line-align-end.ant-progress-line-position-outer.ant-progress-show-info.ant-progress-default.custom-progress.css-dev-only-do-not-override-vryruh {
    width: 100% !important;
  }
}
.app {
  padding-inline-start: 0px;
}

.ant-switch {
  width: 35px !important;
  padding: 0 !important;
}

.ant-switch-checked {
  width: 35px !important;
}

.p-checkbox-input {
  margin-inline-end: 0.5% !important;
}

div.p-multiselect-label.p-placeholder,
div.p-multiselect-label {
  font-size: 12px;
  margin-inline-start: 2%;
  padding-top: 1%;
  padding-bottom: 1%;
}

div.p-multiselect-checkbox {
  margin-inline-end: 2%;
}

input.p-checkbox-input {
  margin-inline-start: 2% !important;
}

div.p-multiselect-header {
  margin: 10px;
  background-color: #ffffff;
  margin-bottom: -10px;
}

/**************************** Contact No. Field ****************************/
.PhoneInputInput {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.input-fields-acc-setting {
  border: 1px solid #cbd5e1;
  width: 100%;
  /* Flexible width */
  max-width: 389px;
  /* Limits the size */
  padding: 12px 10px;
  /* Adjust spacing to indirectly set height */
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;
  /* Scalable font size */
  margin-bottom: 22px;
  box-sizing: border-box;
  /* Ensures padding doesnâ€™t affect overall width */
}

.contact-field {
  border: 1px solid #cbd5e1;
  width: 100%;
  /* Flexible width */
  max-width: 389px;
  /* Limits the size */
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 14px;
  /* Scalable font size */
  margin-bottom: 22px;
  box-sizing: border-box;
  /* Ensures padding doesnâ€™t affect overall width */
  padding-inline-start: 15px;
}

@media (max-width: 768px) {
  .input-fields-acc-setting {
    max-width: 100%;
    /* Adapts to smaller screens */
    padding: 12px 10px;
    /* Slightly smaller padding */
  }
}
.confirmation-modal-footer {
  display: flex;
  justify-content: first baseline;
  gap: 20px;
  justify-content: end;
}

.highlight {
  border: 3px solid #28a745;
  /* Temporarily set a visible color */
  box-shadow: 0 0 10px rgba(40, 167, 69, 0.5);
  background-color: rgba(40, 167, 69, 0.2);
  width: 70px;
  height: 60px;
}

.confirmation-modal-content {
  margin-inline-start: 55px;
  margin-bottom: 35px;
}

.popup-msg-content {
  font-size: 16px;
  color: #1a1a1a;
}

.confirmation-modal-body {
  margin-top: 30px;
  margin-bottom: 25px;
  display: block;
  font-size: 14px;
  color: #1a1a1a;
  /* Ensure margins apply properly to inline elements */
}

.confirmation-modal-header {
  display: flex;
  gap: 18px;
  align-items: center;
}

.confirmation-modal-wrapper {
  margin-inline-start: 20px;
  /* Adjust the left margin as needed */
  margin-bottom: 15px;
  /* Adjust the bottom margin as needed */
}

.confirmation-modal-header,
.confirmation-modal-body,
.confirmation-modal-footer {
  text-align: start;
  /* Optional: Align inner content properly */
}

.create-connection-loading {
  background-color: #28a745;
  color: #ffffff;
  min-height: 50px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #9ca3af;
  transition: 0.4s;
  border-radius: 20px;
  margin-top: 2px;
  width: 40px;
  height: 21px;
}

.slider::before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 2px;
  top: 2px;
  background-color: #ffffff;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #03045e;
}

input:checked + .slider::before {
  transform: translateX(20px);
}

.category-title {
  flex-grow: 1;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 12px;
  margin-top: 10px;
}

.custom-google-button {
  background-color: #ffffff !important;
  color: #1a1a1a !important;
  font-family: "Open Sans", sans-serif;
  border: 1px solid #2a73c2 !important;
  border-radius: 4px !important;
  padding: 10px 20px !important;
  font-size: 14px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
}

.signup-page-text {
  text-align: center;
  font-size: 12px;
  margin-top: 0.5rem;
  margin-bottom: 10px;
}

.forgot-password-txt {
  font-size: 12px;
  margin-top: 0.5rem;
}

.category-description {
  color: #6b7280;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 15px;
}

.category-info {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-inline-start: 15px;
  gap: 2px;
}

.activity-details {
  display: flex;
  flex-direction: column;
}

.activity-description {
  color: #9ca3af;
  font-size: 10px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
  margin-bottom: -10px;
}

.activity-col {
  width: 50%;
}

.compact-suggestions-container {
  width: 100%;
  padding: 8px 0;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 10px;
}

.compact-suggestions-header {
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  margin-bottom: 8px;
  padding-inline-start: 12px;
}

.compact-suggestions-scroll {
  display: flex;
  overflow-x: auto;
  padding: 0 12px;
  padding-bottom: 4px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.compact-suggestions-scroll::-webkit-scrollbar {
  display: none;
}

.compact-input-area input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 8px 0;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
  background: #ffffff;
}

.compact-input-area input::placeholder {
  color: #6b7280;
}

/* Ensure chat container has sufficient height but not too tall */
.conversation-area {
  max-height: 50vh;
  overflow-y: auto;
}

/* Add this to your CSS file */
.without-suggestions {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.conversation-area {
  flex-grow: 1;
  overflow-y: auto;
}

.compact-input-area {
  margin-top: auto;
}

.p-multiselect-token {
  background-color: rgba(44, 104, 173, 0.15);
  padding-left: 8px;
  padding-right: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
  width: 100%;
}

.donut-spinner {
  display: inline-block;
  border: 4px solid #e5e7eb;
  border-left-color: #2a73c2;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: donut-spin 1.2s linear infinite;
}

@keyframes donut-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-center {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.email-editor-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  width: 100vw;
  height: 100vh;
  background: #fafafa;
  display: flex;
  flex-direction: column;
}
.email-editor-modal .editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  margin-bottom: 1rem;
}
.email-editor-modal .editor-header button {
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
}
.email-editor-modal iframe {
  flex-grow: 1;
  border: none;
  width: 100%;
}
.email-editor-modal .summary-box {
  background-color: rgba(44, 104, 173, 0.15);
  border-inline-start: 5px solid #2a73c2;
  padding: 0.5rem;
  margin-bottom: 0.8rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 0.5rem;
}
.email-editor-modal .summary-box .icon-info {
  width: 18px;
  height: 18px;
  background-color: #2a73c2;
  border-radius: 50%;
}
.email-editor-modal .filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.email-editor-modal .filters select {
  padding: 0.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
}
.email-editor-modal .performance-section {
  background-color: #fafafa;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 1rem;
}
.email-editor-modal .performance-section h3 {
  color: #1a1a1a;
  margin-bottom: 1rem;
}
.email-editor-modal .performance-section .chart-filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
.email-editor-modal .performance-section .chart-filters select {
  padding: 0.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
}

.email-editor-overlay {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(26, 26, 26, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.email-editor-modal {
  max-width: 1000px;
  max-height: 85vh;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  padding: 10px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
}

.email-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
}

.email-editor-close {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.2s;
}

.email-editor-close:hover {
  color: #e53935;
}

.recharts-wrapper > .recharts-surface {
  display: flex !important;
  justify-content: center !important; /* Centers horizontally */
  align-items: center !important; /* Centers vertically */
  width: 100%;
  height: 100%;
}

.legend {
  margin-top: 1rem;
}

.legend-item {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.subscriber-count {
  color: #1a1a1a;
  font-weight: 600;
}

.clickable {
  color: #1a1a1a;
  cursor: pointer;
}

.create-segment-container {
  padding: 10px;
  font-family: "Open Sans", sans-serif;
  color: #1a1a1a;
}

.input {
  padding: 0.75rem 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
}

.tag {
  background-color: rgba(44, 104, 173, 0.15);
  color: #1a1a1a;
  padding: 0.25rem 0.75rem;
  border-radius: 50%;
  font-size: 14px;
}

.upload-area {
  border: 2px dashed rgba(44, 104, 173, 0.15);
  padding: 2rem;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.import-contacts-container {
  padding: 40px;
  font-family: "Open Sans", sans-serif;
  color: #1a1a1a;
}

.metric-selection {
  min-width: 350px;
}

select {
  padding: 0.5rem 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 14px;
  color: #1a1a1a;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

/* Hide popup menus completely */
.ant-menu-submenu-popup {
  display: none !important;
}

.sidebar-scroll-container {
  height: 100vh;
  overflow-y: auto;
  padding-inline-end: 8px;
}

.admin-header-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.admin-search-input {
  width: 200px;
  margin-top: 8px;
}

.tabs-container {
  margin-top: -30px;
}

.role-permission-heading {
  margin-top: 20px;
  margin-inline-start: -1px;
}

.audit-log-heading {
  display: block;
  text-align: center;
  font-weight: bold;
}

/********************admin layout *******************/
/* Sidebar */
.sidebar {
  background-color: #2c68ad;
  height: 100%;
  z-index: 1000;
}

.sidebar-menu {
  background-color: #2c68ad;
  color: #ffffff;
}

/* Divider */
.sidebar-divider {
  margin: 11px auto;
  height: 1px;
  opacity: 0.3;
}

/* Menu item text color */
.sidebar-menu-item {
  color: #ffffff;
}

.menu-heading-wrapper img {
  width: 25px;
  height: 25px;
  margin-inline-start: -20px;
}

.bell-icon {
  cursor: pointer;
  font-size: 20px;
  margin-top: 8px;
}

.notification-badge {
  position: absolute;
  top: 3px;
  inset-inline-end: 73px;
  background-color: #e53935;
  color: #ffffff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.avatar-icon-dashboard .anticon {
  font-size: 20px;
  margin-top: 8px;
}

/* Content padding */
.layout-content-wrapper {
  padding: 4px;
}

.layout-content {
  padding: 10px;
  min-height: 86vh;
  overflow: hidden;
}

/************activity log*************/
.card-style {
  margin-bottom: 24;
  background-color: rgba(44, 104, 173, 0.15);
}

.anticon-user {
  padding-bottom: 8px;
}

.notifications-no-today {
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
  margin-bottom: -30px;
}

.upload-container {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 10px;
}

.Info-text span {
  font-size: 12px;
  color: #9ca3af;
}

.finishline {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #6b7280;
  font-weight: 600;
  display: block;
  margin-bottom: 10px;
}

.tags-container {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.tag-item {
  background: rgba(44, 104, 173, 0.18);
  padding: 2px 8px;
  border-radius: 8px;
  border: 1px solid rgb(44, 104, 173);
  font-size: 12px;
}

.audience-actionbuttons {
  cursor: pointer;
  color: #2c68ad !important;
  margin-inline-end: 10px;
}

.no-data-container {
  text-align: center;
  padding: 40px 20px;
  color: #9ca3af;
}

.no-data-image {
  max-width: 280px;
  margin-bottom: 20px;
}

.no-data-text {
  max-width: 400px;
  margin: 0 auto;
}

/*********barcharts styles**********/
/* Grid Lines */
.bar-chart-grid {
  stroke: rgba(26, 26, 26, 0.2);
  stroke-dasharray: 3 3;
}

/* X & Y Axis Tick Style */
.bar-chart-xaxis .recharts-cartesian-axis-tick-value,
.bar-chart-yaxis .recharts-cartesian-axis-tick-value {
  fill: #6b7280;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.bar-chart-xaxis .recharts-cartesian-axis-label,
.bar-chart-yaxis .recharts-cartesian-axis-label {
  fill: #6b7280;
  font-size: 14px;
}

.review-summary-heading {
  color: #1a1a1a;
  font-size: 20px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  margin-inline-start: 10px;
  margin-top: -20px;
}

.google-ads-sign-in {
  width: 20px;
  height: 20px;
  margin-inline-end: 10px;
}

.logo-fb {
  width: 150px;
  height: 50px;
}

.signup-google-logo {
  width: 18px;
  height: 18px;
  margin-inline-end: 10px;
}

.info-banner-audience {
  flex: 1 1;
  background: #fafafa;
  border-radius: 8px;
  padding: 3px 16px;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #1a1a1a;
  font-weight: 400;
  line-height: 1.4;
  box-shadow: inset 0 1px 2px rgba(26, 26, 26, 0.05);
  margin-top: 10px;
}

.info-banner-audience strong {
  font-weight: 600;
}

.tableau-scroll-wrapper {
  width: 100%;
  overflow-x: hidden;
}

.tableau-center {
  display: flex;
  justify-content: center;
  width: 100%;
}

.tableau-scroll-inner {
  width: 100%;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Styles.scss","webpack://./src/styles/typography.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_statCard.scss","webpack://./src/styles/_Controls.scss","webpack://./src/styles/Tables.scss","webpack://./src/layouts/SourceConnector/ConnectedSources.scss","webpack://./src/styles/message-styles.scss","webpack://./src/layouts/AdminPortal/AdminPortal.scss","webpack://./src/layouts/Authentication/Auth.scss","webpack://./src/styles/PrivacyPolicy.scss","webpack://./src/styles/_ui-elements.scss","webpack://./src/layouts/AskDatatram/Chatbot.scss","webpack://./src/layouts/HomePage/SidebarManagement/Sidebar.scss","webpack://./src/styles/media-utils.scss","webpack://./src/layouts/AdminPortal/Subscriptions/billing-ui.scss","webpack://./src/layouts/AdminPortal/Subscriptions/invoice.scss","webpack://./src/styles/Dashboard.scss","webpack://./src/layouts/Engagements/Campaigns/Campaign.scss","webpack://./src/layouts/UserManagement/UserManagement.scss","webpack://./src/styles/Button.scss","webpack://./src/styles/sequences.scss","webpack://./src/layouts/MyAccount/Notifications/Notifications.scss","webpack://./src/layouts/AdminPortal/AnnouncementsPage/Announcements.scss","webpack://./src/styles/DropDownStyle.scss","webpack://./src/styles/InputStyle.scss","webpack://./src/styles/responsivePages.scss","webpack://./src/layouts/MyAccount/Settings/AccountSettings.scss","webpack://./src/components/reusable/ReusableTable/ReusableTable.scss","webpack://./src/layouts/AdminPortal/UsageLimits/TenantUsageMonitor.scss","webpack://./src/components/reusable/ErrorFallback/ErrorFallback.scss","webpack://./src/components/reusable/StyledTooltip/StyledTooltip.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;EACE,eCyNa;EDxNb,gBC2NiB;ED1NjB,cCaa;EDZb,gBAAA;EACA,qBAAA;ADAF;;ACGA;EACE,eCiNa;EDhNb,gBCmNiB;EDlNjB,cCKa;EDJb,gBAAA;EACA,qBAAA;ADAF;;ACGA;EACE,eCwMa;EDvMb,gBC0MqB;EDzMrB,cCHa;EDIb,gBAAA;EACA,qBAAA;ADAF;;ACKA;EACE,oCC0LY;EDzLZ,yBCfiB;EDgBjB,cCba;AFWf;;ACKA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,cCrBa;EDsBb,gBCuLiB;EDtLjB,eCmLa;AFrLf;;ACKA;EAEE,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,cChCa;EDiCb,gBC4KiB;ED3KjB,eCwKa;EDvKb,4BAAA;ADHF;;ACMA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,eC+JW;EFlKb;AACF;ACOA;EACE;IACE,eCwJW;EF7Jb;AACF;ACSA;EACE;IACE,cAAA;IACA,eC6IW;ID5IX,gBCkJmB;IDjJnB,kBAAA;EDPF;AACF;ACSA;EACE,eC2Ia;ED1Ib,gBC6IiB;ED5IjB,cCjEa;EDkEb,mBAAA;EACA,kBAAA;ADPF;;ACUA;EACE,mBAAA;ADPF;;ACSA;EACE,mBAAA;EACA,cC3Ea;AFqEf;;ACQA;;EAEE,cC/Ea;EDgFT,eCyHS;EDxHX,mBAAA;EACA,eAAA;ADLJ;;ACQA;EACE,cCpFW;EDqFX,oCC8GY;ED7GZ,eC+Ga;ED9Gb,kBAAA;EACA,gBCiHmB;EDhHnB,iBAAA;ADLF;;ACQA;EACE,aAAA;EACA,mBAAA;ADLF;;ACQA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;ADLF;;ACQA;EACE,eCgGa;ED/Fb,gBCkGiB;AFvGnB;;ACOA;EACE,eC4Fa;ED3Fb,gBC4FmB;ED3FnB,cChHa;EDiHb,gBAAA;ADJF;;ACMA;EACE,cCxGO;EDyGP,eCkFa;AFrFf;;ACKA;EACE,cCtHW;EDuHX,eC8Ea;ED7Eb,eAAA;ADFF;;ACIA;EACE,gBCgFiB;ED/EjB,eC2Ea;AF5Ef;;ACGA;EACE,eCuEa;EDtEb,cCjIe;AFiIjB;;ACEA;EACE,eCqEa;EDpEb,gBCsEqB;EDrErB,cCvIa;EDwIb,mBAAA;ADCF;;ACEA;EACE,yBAAA;ADCF;;ACEA;EACE,kBAAA;ADCF;;ACCA;EACE,eCuDa;EDtDb,gBCyDiB;EDxDjB,mBAAA;ADEF;;AGvKA;EACE,mBDUM;ECTN,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;AH0KF;AGxKE;EACE,eAAA;EACA,cDXY;ECYZ,kBAAA;AH0KJ;AGvKE;EACE,eAAA;EACA,iBAAA;EACA,cDbO;ECcP,uBAAA;AHyKJ;AGtKE;EACE,eAAA;EACA,cD2BS;EC1BT,eAAA;AHwKJ;AGrKE;EACE,qBD3BmB;AFkMvB;AGtKI;EACE,cD3BK;AFmMX;AGpKE;EACE,qBDcS;AFwJb;AGrKI;EACE,cDaO;AF0Jb;;AG/JA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AHkKF;AGhKE;EALF;IAMI,mBAAA;EHmKF;AACF;;AGhKA;EACE,SAAA;EACA,yBD/CM;ECgDN,mBAAA;EACA,eAAA;EACA,0CAAA;AHmKF;AGjKE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cD7DQ;AFgOZ;;AG9JA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AHiKF;AG/JE;EACE,iBAAA;EACA,gBAAA;EACA,cD3EQ;AF4OZ;;AInPA;EACE,sBAAA;EACA,kBAAA;EACA,mBF8MU;EE7MV,gBAAA;EACA,eFoNa;EEnNb,oCFgNY;EE/MZ,eAAA;EACA,YAAA;EACA,uDAAA;EAEA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AJqPF;AInPE;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBFuLU;EEtLV,yBAAA;EACA,sBAAA;AJqPF;AInPI;EACA,oCAAA;AJqPJ;AIjPE;EACE,oCAAA;EACA,yBAAA;EACA,oCAAA;AJmPJ;AIlPI;EACE,qDAAA;EACA,yBAAA;EACA,gCAAA;AJoPN;AIhPE;EACE,oCAAA;EACA,yBAAA;AJkPJ;AIhPI;EACE,oCAAA;AJkPN;AI9OE;EACE,oCAAA;EACA,yBAAA;EACA,yDAAA;AJgPJ;AI/OI;EACE,oCAAA;EACA,yDAAA;AJiPN;;AI7OA;;EAEE,oCAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AJgPF;;AI7OA;EACG,oCAAA;EACC,yBAAA;EACE,sBAAA;EACJ,kBFgIU;EE/HV,gBAAA;EACA,eFuIa;EEtIb,eAAA;EACA,YAAA;EACA,uDAAA;EACA,yDAAA;AJgPF;;AI9OA;EACG,oCAAA;EACA,yDAAA;AJiPH;;AI5OA;EACE,yBF/Fc;EEgGd,cFrFM;EEsFN,YAAA;EACA,kBF6GU;EE5GV,iBAAA;EACA,gBAAA;EACA,YAAA;AJ+OF;;AI5OA;EACE,oCAAA;EACA,yBAAA;AJ+OF;;AK1VA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;EAyBA,6CAAA;ALqUF;AK5VE;EACE,yBHLY;EGMZ,cHKI;EGJJ,gBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,sBAAA;EACA,iBAAA;AL8VJ;AK3VE;EACE,aAAA;EACA,eAAA;EACA,cHfO;EGgBP,yBHVI;EGWJ,gCAAA;EACA,6BAAA;EACA,sBAAA;EACA,iBAAA;AL6VJ;AK1VE;EACE,4BAAA;EACA,kBAAA;AL4VJ;AKzVE;EACE,yBHXW;AFsWf;AKxVE;EACE,yBH3BI;AFqXR;;AKtVA;EACE,yBHVU;EGWV,cHVU;AFmWZ;;AKtVA;EACE,yBHEW;EGDX,cHCW;AFwVb;;AKtVA;;EAEE,yBHJW;EGKX,cHLW;AF8Vb;;AKtVA;EACE,yBHlCY;EGmCZ,cH5Ca;AFqYf;;AKvVA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;AL0VF;AKxVE;EACE,yBHzCQ;EG0CR,yBAAA;AL0VJ;AKvVE;EACE,yBH7BS;EG8BT,cH5DQ;AFqZZ;AKtVE;EACE,yBH/CO;EGgDP,yBAAA;ALwVJ;AKrVE;EACE,yBHxDQ;EGyDR,yBAAA;ALuVJ;AKrVE;EAGE,yBH7CS;EG8CT,cH9CS;AFmYb;AKnVE;EACE,yBHlEQ;EGmER,yBAAA;ALqVJ;AKlVE;EACE,yBHtDS;EGuDT,cH9FI;AFkbR;AKlVE;EACE,yBH3EQ;EG4ER,yBAAA;ALoVJ;AKjVE;EACE,yBH/DS;EGgET,cHvGI;AF0bR;AKhVE;EACE,yBHjHO;EGkHP,cH5GI;AF8bR;AKhVE;EACE,yBH9FK;EG+FL,cHxES;AF0Zb;AK/UE;EAEE,yBHwCW;EGvCX,cHtHI;AFscR;AK9UE;EACE,yBHnGQ;EGoGR,yBAAA;ALgVJ;AK7UE;EACE,yBHvFS;EGwFT,cH/HI;AF8cR;AK7UE;EACE,yBHpHU;EGqHV,cH9HW;AF6cf;;AKzUE;EACE,yBH1II;AFsdR;AKzUE;EACE,yBHlIW;AF6cf;AKxUE;EACE,yBHlJI;AF4dR;AKvUE;EACE,yBHjKY;EGkKZ,cHvJI;AFgeR;;AKpUA;EACE,YAAA;ALuUF;;AKpUA;EACE,aAAA;EACA,mBAAA;ALuUF;;AKpUA;EACE,gBAAA;ALuUF;;AKpUA;EACE,mBAAA;EACA,YAAA;EACA,oBAAA;ALuUF;;AKpUA;EACE,aAAA;EACA,mBAAA;ALuUF;;AKpUA;EACE,gBAAA;EACA,eAAA;ALuUF;;AKnUA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;ALsUF;;AKlUA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;ALqUF;AKnUE;;;EAGE,kBAAA;EACA,yBHpLQ;EGqLR,YAAA;EACA,aAAA;EACA,gBAAA;ALqUJ;AKnUI;;;EACE,cH3MS;AFkhBf;AKnUE;EACE,yBHhOY;AFqiBhB;AKpUI;EACE,cHvNE;AF6hBR;AKlUE;EACE,YAAA;ALoUJ;AKjUE;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;ALmUJ;;AK/TA;EACE,iEAAA;EAEA;IACE,iBAAA;ELiUF;EK9TA;IACE,iBAAA;IACA,aAAA;ELgUF;AACF;AK5TA;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AL8TF;;AK5TA;EACE;IACE,iBAAA;EL+TF;EK5TA;IACE,kBAAA;IACA,aAAA;EL8TF;AACF;AK3TA;EACE,mBAAA;EACA,uBAAA;AL6TF;;AK1TA;EACE,UAAA;AL6TF;;AK1TA;;;EAGE,YAAA;EACA,aAAA;AL6TF;;AK1TA;EAEE,kBAAA;AL4TF;;AK1TA;EAEE,gBAAA;EACA,QAAA;EACA,cHzRe;EG0Rf,eAAA;EACA,oCAAA;AL4TF;;AK1TA;EACE;IACE,iBAAA;IAEA,gBAAA;IACA,QAAA;IACA,cHnSa;IGoSb,cAAA;IACA,oCAAA;IACA,gBAAA;EL4TF;AACF;AK1TA;;;;;sBAAA;AAOA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AL2TF;;AKxTA;;EAEE,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBHnUM;AF8nBR;;AKzTA;EACE,cHhUe;EGiUf,eAAA;AL4TF;;AK1TA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AL6TF;AK3TE;;EAEE,YAAA;EACA,gBAAA;EACA,gCAAA;AL6TJ;AK1TE;EACE,yBH3UW;EG4UX,gBAAA;AL4TJ;AKzTE;EACE,yBHtUQ;AFioBZ;;AKvTA;EACE,cAAA;AL0TF;;AKvTA;EACE,mBHrWM;EGsWN,mBAAA;EACA,aAAA;EACA,4CAAA;AL0TF;;AKvTA;;EAEE,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AL0TF;AKxTE;;EACE,gBAAA;AL2TJ;;AKvTA;EACE,cHhYS;EGiYT,eAAA;AL0TF;;AKtTE;;EAEE,UAAA;ALyTJ;AKtTE;EACE,cHxSW;EGySX,eAAA;ALwTJ;AKrTE;EACE,eAAA;EACA,cH9UW;AFqoBf;;AKnTA;EACE,yBHzXU;EG0XV,cHrZU;EGsZV,gBAAA;ALsTF;;AKnTA;EACE,yBH/XU;EGgYV,sCAAA;ALsTF;;AKnTA;EACE,kBAAA;EACA,eAAA;ALsTF;;AKnTA;EACE,kBAAA;EACA,qBHlZY;EGmZZ,kCAAA;ALsTF;;AKnTA;EACE,gCAAA;EACA,6CAAA;ALsTF;;AKnTA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,cHraU;AF2tBZ;;AKpTA;EACE,YAAA;ALuTF;;AKpTA;EACE,YAAA;ALuTF;;AKpTA;EACE,YAAA;ALuTF;;AKpTA;EACE,YAAA;ALuTF;;AKpTA;EACE,YAAA;ALuTF;;AKpTA;EACE,yBHzSa;AFgmBf;;AKrTA;EACE,yBHlbU;EGmbV,iCAAA;ALwTF;;AKpTA;EACE,aAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBHrdM;AF4wBR;;AKpTA;EACE,kBAAA;EACA,mBH1dM;EG2dN,gBAAA;EACA,gCAAA;EACA,gBAAA;ALuTF;;AKpTA;EACE,kBAAA;EACA,gCAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ALuTF;;AKpTA;EACE,iBAAA;EACA,gCAAA;EACA,+BAAA;ALuTF;;AKpTA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;ALuTF;;AMrzBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,wBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;ANwzBF;;AMrzBA;EACE,SAAA;ANwzBF;;AMrzBA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;ANwzBF;;AMrzBA;EACE,YAAA;EACA,YAAA;ANwzBF;;AMtzBA;EACE,YAAA;EACA,aAAA;ANyzBF;;AMvzBA;EACE,YAAA;EACA,aAAA;AN0zBF;;AMxzBA;EACE,YAAA;EACA,aAAA;AN2zBF;;AMzzBA;EACI,YAAA;EACF,aAAA;AN4zBF;;AM1zBA;EACE,YAAA;EACA,aAAA;AN6zBF;;AM3zBA;;;;;;EAME,YAAA;EACA,YAAA;EACA,mBAAA;AN8zBF;;AM5zBA;EACE,mBAAA;AN+zBF;;AM5zBA;EACE,yBAAA;AN+zBF;;AM5zBA;;EAEE,yBAAA;AN+zBF;;AM5zBA;EACE,yBAAA;AN+zBF;;AM7zBA;EACI,oCAAA;ANg0BJ;;AM9zBA;EACE,yBAAA;ANi0BF;;AM/zBA;EACE,yBAAA;ANk0BF;;AMh0BA;EACE,yBAAA;ANm0BF;;AMj0BA;EACE,yBAAA;ANo0BF;;AMl0BA;EACE,yBAAA;ANq0BF;;AMn0BA;EACE,yBAAA;ANs0BF;;AMp0BA;EACE,yBAAA;ANu0BF;;AMp0BA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;ANu0BF;;AMp0BA;EACE,gBAAA;EACA,cAAA;ANu0BF;;AMp0BA;EACE,gBAAA;EACA,WAAA;ANu0BF;;AMr0BA;EACE,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;ANw0BF;;AMt0BA;EACE,iBAAA;ANy0BF;;AMv0BA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AN00BF;;AMx0BA;EACE,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,4CAAA;EACA,eAAA;EACA,oBAAA;AN20BF;;AMx0BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AN20BF;;AMx0BA;EACE,yBAAA;AN20BF;;AMx0BA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;AN20BF;;AMz0BA;EACE,yBAAA;AN40BF;;AMz0BA;EACE,yBAAA;AN40BF;;AMz0BA;EACE,yBAAA;AN40BF;;AMz0BA;EACE,yBAAA;AN40BF;;AMx0BA,iDAAA;AAEA,oCAAA;AACA;EACE;IACE,0BAAA;IACA,wBAAA;IACA,SAAA;IACA,qBAAA;EN00BF;EMv0BA;IACE,WAAA;IACA,gBAAA;IACA,YAAA;ENy0BF;EMt0BA;IACE,eAAA;ENw0BF;EMr0BA;IACE,WAAA;IACA,gBAAA;ENu0BF;EMp0BA;IACE,gBAAA,EAAA,eAAA;IACA,gBAAA;IACA,kBAAA;ENs0BF;AACF;AMn0BA,4CAAA;AACA;EACE;IACE,qCAAA;IACA,wBAAA;IACA,SAAA;IACA,qBAAA;ENq0BF;EMl0BA;IACE,WAAA;IACA,gBAAA;ENo0BF;EMh0BA;IACE,eAAA;ENk0BF;EM/zBA;IACE,WAAA;IACA,gBAAA;ENi0BF;EM9zBA;IACE,gBAAA;IACA,gBAAA;IACA,kBAAA;ENg0BF;AACF;AM7zBA,8DAAA;AACA;EACE;IACE,qCAAA;IACA,wBAAA;IACA,qBAAA;EN+zBF;EM5zBA;IACE,WAAA;IACA,gBAAA;EN8zBF;AACF;AOjkCA;EACE,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;APmkCF;;AOjkCA;EACE,yBAAA;APokCF;;AOjkCA,sBAAA;AAEA;EACE,cLcO;AFqjCT;;AOhkCA;EACE,yBAAA;APmkCF;;AOhkCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBLmJa;EKlJb,4BAAA;EACA,sBAAA;EACA,cLTU;EKUV,eAAA;APmkCF;AOjkCE;EACE,oBAAA;EACA,mBAAA;APmkCJ;;AO/jCA;EACE;IACE,cLZK;IKaL,cAAA;EPkkCF;AACF;AOzjCA;EACE,cL+Ea;EK9Eb,iBAAA;AP2jCF;;AOxjCA;EACE,eAAA;EACA,cLyEa;EKxEb,mBAAA;AP2jCF;;AOzjCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AP4jCF;AO1jCE;EANF;IAOI,mBAAA;EP6jCF;AACF;;AO1jCA;;EAEE,SAAA;EACA,yBLhEM;EKiEN,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,kBAAA;AP6jCF;;AO3jCA;EACE,aAAA;EACA,WAAA;AP8jCF;;AO3jCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBLtEa;EKuEb,sBAAA;AP8jCF;AO5jCE;EACE,iBAAA;AP8jCJ;AO3jCE;EACE,YAAA;AP6jCJ;AO3jCI;EACE,cAAA;EACA,eAAA;EACA,sBAAA;AP6jCN;AO1jCI;EACE,SAAA;EACA,kBAAA;EACA,cLbS;AFykCf;AOzjCI;EACE,kBAAA;EACA,cL5FQ;AFupCd;AOvjCE;EACE,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;APyjCJ;AOtjCE;EACE,qBLqCW;EKpCX,yBL2CW;AF6gCf;AOtjCI;EACE,yBLiCS;EKhCT,cL1GG;AFkqCT;AOpjCE;EACE,qBL6BW;EK5BX,yBLsCW;AFghCf;AOpjCI;EACE,yBLiCS;EKhCT,cL/BS;AFqlCf;AOljCE;EACE,qBLzDW;EK0DX,yBLIW;AFgjCf;AOljCI;EACE,yBL9BS;EK+BT,cL/FS;AFmpCf;AOhjCE;EACE,qBL/CW;EKgDX,yBLrCW;AFulCf;AOhjCI;EACE,yBLxCS;EKyCT,cLzFS;AF2oCf;;AO7iCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBLnKM;EKoKN,mBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,4CAAA;EACA,cAAA;EACA,UAAA;EACA,oCAAA;APgjCF;;AO7iCA;EACE,UAAA;APgjCF;;AO7iCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;APgjCF;;AO5iCA,sCAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AP+iCF;;AO5iCA;EACE,yBLzDa;EK0Db,yBAAA;EACA,cL9MqB;EK+MrB,iBAAA;AP+iCF;;AO5iCA;EACE,cAAA;EACA,cL/Ga;EKgHb,eAAA;EACA,iBAAA;AP+iCF;;AO3iCA;EACE,oCAAA;EACA,oCAAA;EACA,qBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AP8iCF;;AO1iCA;EACE,yBAAA;EACA,eAAA;AP6iCF;;AO1iCA,qGAAA;AACA;;EAEE,qBAAA;AP6iCF;;AO1iCA;EACE,8BAAA;EACA,qDAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0DAAA;EACA,8CAAA;AP6iCF;;AO1iCA;EACE,yBAAA;AP6iCF;;AQ7yCA;EACE,gBAAA;ARgzCF;;AQ7yCA;EACE,gBAAA;ARgzCF;;AQ7yCA;EACE,kCAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;ARgzCF;;AQ5yCA;EACE,UAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AR+yCF;;AQ7yCA;EACE,2BAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;ARgzCF;;AQ9yCA;EACE,2BAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;ARizCF;;AQ/yCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;ARkzCF;;AQ/yCA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;ARkzCF;;AQ/yCA;EACE,yBAAA;EACA,sBAAA;EACI,uBAAA;EACF,WAAA;EACA,cAAA;ARkzCJ;;AQ/yCA;EACE,wBAAA;ARkzCF;;AQ/yCA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;ARkzCF;;AQ/yCA;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;ARkzCF;;AQ/yCA;EACE,8BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;ARkzCF;;AQ/yCA;EACE,2BAAA;ARkzCF;;AQ/yCA;EACE;IACE,eAAA;ERkzCF;EQ/yCA;IACE,kBAAA;IACA,YAAA;ERizCF;EQ9yCA;IACE,eAAA;ERgzCF;AACF;AQ7yCA;EACE;IACE,cAAA;ER+yCF;EQ5yCA;IACE,cAAA;IACA,kBAAA;ER8yCF;EQ3yCA;IACE,WAAA;ER6yCF;EQ1yCA;IACE,iBAAA;IACA,WAAA;IACA,iBAAA;ER4yCF;EQ1yCF;IACE,2BAAA;ER4yCA;EQ1yCA;IACE,gBAAA;IACA,WAAA;ER4yCF;EQzyCA;IACE,gBAAA;IACA,uBAAA;IACA,sBAAA;ER2yCF;EQxyCA;IACE,gBAAA;IACA,uBAAA;IACA,sBAAA;ER0yCF;EQvyCA;IACE,cAAA;IACA,2BAAA;ERyyCF;AACF;AQtyCA;EACE,WAAA;EACA,eAAA;EACA,eAAA;ARwyCF;;AQryCA;EACE;IACE,WAAA;IACA,eAAA;IACA,eAAA;ERwyCF;AACF;AQpyCA;EACE;IACE,WAAA;IACA,0BAAA;IACA,0BAAA;ERsyCF;AACF;AQnyCA;EACE,4BAAA;ARqyCF;;AQlyCA;EACE;IACE,iBAAA;ERqyCF;AACF;AQlyCA;EACE;IACE,4BAAA;ERoyCF;AACF;AQjyCA;EACE,4BAAA;ARmyCF;AQjyCE;EAHF;IAII,4BAAA;ERoyCF;AACF;AQlyCE;EAPF;IAQI,4BAAA;ERqyCF;AACF;;AQlyCA;EACE,6BAAA;ARqyCF;AQnyCE;EAHF;IAII,4BAAA;ERsyCF;AACF;;AQnyCA;EACE,mBAAA;ARsyCF;AQpyCE;EAHF;IAII,mBAAA;ERuyCF;AACF;;AQnyCA,2BAAA;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;ARoyCJ;AQlyCI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;ARoyCN;AQlyCQ;EACF,iBAAA;EACA,cN3PK;AF+hDX;AQjyCI;EACE,yBNlNO;EMmNP,YAAA;ARmyCN;AQjyCM;EACE,yBNrNK;AFw/Cb;AQ9xCE;EACE,eAAA;EACA,cN5NS;EM6NT,gBAAA;ARgyCJ;AQ7xCE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AR+xCJ;AQ7xCI;;EAEE,YAAA;AR+xCN;;AQ3xCA;EACE,wBAAA;AR8xCF;;AQ3xCA;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,8BAAA;AR8xCF;AQ5xCE;EACE,qBAAA;AR8xCJ;AQ5xCE;EACE,qBAAA;AR8xCJ;AQ5xCE;EACE,qBAAA;AR8xCJ;AQ3xCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AR6xCJ;AQ1xCE;EACE,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AR4xCJ;AQzxCE;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;AR2xCJ;AQxxCE;EACE,mBAAA;AR0xCJ;AQxxCI;EACE,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;AR0xCN;;AQrxCA;EACE,qBAAA;EACA,mBAAA;EACA,iBAAA;ARwxCF;;AQrxCA;EACE,uBAAA;EACA,2BAAA;ARwxCF;;AQrxCA;EACE,uBAAA;EACA,2BAAA;ARwxCF;;AQrxCA;EACE,uBAAA;ARwxCF;;AQrxCA;EACE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,8BAAA;ARwxCF;;AQlxCA;EACE,gBAAA;ARqxCF;;AQlxCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;ARqxCF;;AQlxCA;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;ARqxCF;;AQlxCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;ARqxCF;;AQlxCA;EACE,YAAA;ARqxCF;;AQlxCA;EACE,YAAA;EAEA,cAAA;ARoxCF;;AQjxCA;EACE,YAAA;ARoxCF;;AQjxCA;EACE,uBAAA;EACA,kBAAA;EACA,wCAAA;ARoxCF;;AQlxCA;EACE,kBAAA;EACA,kBAAA;ARqxCF;;AQnxCA;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;ARsxCF;;AQnxCA;EACE,kBAAA;EACA,kBAAA;ARsxCF;;AQpxCA;EACI,YAAA;EACF,kBAAA;EACA,wCAAA;ARuxCF;;AQrxCA;EACE,kBAAA;EACA,kBAAA;ARwxCF;;ASltDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,UAAA;ATqtDF;;ASltDA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;ATqtDF;;ASltDA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,sCAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;ATqtDF;;ASltDA;EACE,qBAAA;ATqtDF;;ASltDA;EACE,aAAA;EACA,0BAAA;EACA,iBAAA;ATqtDF;;ASltDA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;ATqtDF;;ASltDA;EACE,yBAAA;EACA,0BAAA;EACA,+BAAA;EACA,2BAAA;ATqtDF;;ASltDA;EACE,cAAA;EACA,eAAA;ATqtDF;;ASltDA;EACE,QAAA;ATqtDF;;AShtDA;EACE,aAAA;EACA,sBAAA;EAEA,WAAA;EACA,iBAAA;ATktDF;;AS/sDA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACE,cAAA;EACF,eAAA;EACA,gBAAA;EACA,gBAAA;ATktDF;;AS/sDA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;ATktDF;;AS/sDA;EACE,qBAAA;ATktDF;;AS/sDA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;ATktDF;;AS/sDA,iBAAA;AACA;;EAEE,mBAAA;ATktDF;;AS/sDA;EACE,UAAA;ATktDF;;AS/sDA;EACE,UAAA;ATktDF;;AS/sDA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ATktDF;;AS/sDA;EACE,aAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;ATktDF;;AS/sDA;;EAGE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;ATitDF;;AS9sDA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;ATitDF;;AS9sDA;EACE,yBAAA;EACA,YAAA;ATitDF;;AS9sDA;EACE,yBAAA;EACA,WAAA;ATitDF;;AS7sDA;EACE;IACE,gBAAA;IACA,iBAAA;IACA,YAAA;IACA,aAAA;ETgtDF;ES7sDA;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,eAAA;ET+sDF;ES5sDA;IACE,gBAAA;IACA,cAAA;IACA,aAAA;ET8sDF;AACF;AS3sDA;EACE;IACE,gBAAA;IACA,aAAA;IACA,iBAAA;IACA,YAAA;ET6sDF;ES1sDA;IACE,YAAA;IACA,kBAAA;IACA,oBAAA;ET4sDF;ESzsDA;IACE,gBAAA;IACA,iBAAA;IACA,UAAA;ET2sDF;AACF;ASvsDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ATysDF;;AStsDA;EACE,aAAA;EACA,QAAA;ATysDF;;AStsDA;EACE,SAAA;EACA,mBAAA;ATysDF;;AStsDA;EACE,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;ATysDF;;AStsDA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;ATysDF;ASvsDE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;ATysDJ;ASvsDI;EACE,yBAAA;ATysDN;ASrsDE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;ATusDJ;ASrsDI;EACE,yBAAA;ATusDN;;ASnsDA;EACE,eAAA;EACA,eAAA;ATssDF;;ASpsDA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;ATusDF;;ASpsDA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;ATusDF;;ASpsDA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ATusDF;;ASpsDA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;ATusDF;;ASnsDE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ATssDJ;ASnsDE;EACE,eAAA;EACA,YAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;ATqsDJ;ASnsDI;EACE,8BAAA;ATqsDN;ASlsDI;EACE,8BAAA;EACA,sBAAA;EACA,gBAAA;ATosDN;AShsDA;EACE,8BAAA;ATksDF;AS9rDE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;ATgsDJ;;AS5rDA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AT+rDF;AS7rDE;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AT+rDJ;AS7rDI;EACE,mBAAA;AT+rDN;;AS1rDA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AT6rDF;AS3rDE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AT6rDJ;AS1rDE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AT4rDJ;AS1rDI;EACE,mBAAA;AT4rDN;;ASxrDA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACI,cAAA;AT2rDN;;ASxrDA;EACE,cAAA;EACA,gBAAA;AT2rDF;;ASxrDA;;EAEE,kBAAA;AT2rDF;;ASxrDA;EACE,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AT2rDF;ASzrDE;EAEE,oCAAA;EACA,gCAAA;AT0rDJ;;ASrrDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;ATwrDJ;ASrrDE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;ATurDJ;ASprDE;EACE,cAAA;EACA,gBAAA;ATsrDJ;ASnrDE;;;EAGE,kBAAA;EACA,qBAAA;ATqrDJ;ASprDI;;;;;EAEE,qBAAA;EACA,6CAAA;ATyrDN;ASrrDE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;ATurDJ;ASrrDI;EACE,iBAAA;EACA,kBAAA;ATurDN;ASprDI;EACE,yBAAA;EACA,qBAAA;ATsrDN;ASrrDM;EACE,yBAAA;EACA,qBAAA;ATurDR;;ASlrDA;EAEE,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EAEA,cAAA;EACA,mBAAA,EAAA,oBAAA;EACA,4BAAA;EACA,+BAAA;ATmrDF;;AShrDA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,+CAAA;EACA,mBAAA;EACA,yBAAA;ATmrDF;;AShrDA;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;ATmrDF;;ASjrDA;EACE,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ATorDF;;ASjrDA,sGAAA;AAEA;EACE,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ATmrDF;;AShrDA;EACE;IACE,cAAA;IACA,uBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;ETmrDF;AACF;AShrDA;EACE;IACE,WAAA;IACA,gCAAA;IACA,yBAAA;IACA,YAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,sBAAA;IACA,kBAAA;IACA,iBAAA;IACA,eAAA;IACA,eAAA;IACA,YAAA;IACA,iBAAA;ETkrDF;AACF;AShrDA;EACE;IACE,YAAA;IACA,YAAA;IACA,YAAA;IACA,yBAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;IACA,aAAA;IACA,gBAAA;IACA,mBAAA;IACA,QAAA;IACA,mBAAA;IACA,eAAA;IACA,uBAAA;IACA,iBAAA;ETkrDF;ES/qDA;IACE,cAAA;IACA,cAAA;ETirDF;ES9qDA;IACE,eAAA;IACA,yBAAA;IACA,mBAAA;ETgrDF;AACF;AS1qDA;EACE,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AT4qDF;;ASzqDA;EAEE,qBAAA;EACA,4BAAA;EACA,0BAAA;AT2qDF;;ASxqDA;EACE,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AT2qDF;;ASxqDA;EACE,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AT2qDF;;ASxqDA;EACE,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AT2qDF;;AStqDA;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;ATyqDF;;AStqDA;EACE,iBAAA;ATyqDF;;ASrqDA;EACE,cAAA;ATwqDF;;ASrqDA;EACE,oBAAA;EACA,iBAAA;ATwqDF;;ASrqDA;EACE,kBAAA;ATwqDF;;ASrqDA;EACE,kBAAA;ATwqDF;;ASrqDA;EACE,WAAA;EACA,mBAAA;ATwqDF;;ASnqDA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;ATsqDF;;ASnqDA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;ATqqDF;;ASlqDA;EAGE,sBAAA;EAEA,YAAA;EAEA,4BAAA;EAEA,2BAAA;EAEA,kBAAA;EAEA,kBAAA;AT8pDF;;AS3pDA;EACE,SAAA;EACA,UAAA;AT8pDF;;AS3pDA;EACM,mBAAA;EACF,mBAAA;EACA,kBAAA;AT8pDJ;;AS5pDA;EAEE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AT8pDF;;AS3pDA;EACE,gBAAA;AT8pDF;;AS3pDA;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AT8pDF;;AS3pDA;EACE,sBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AT8pDF;;AS3pDA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AT8pDF;;AS3pDA;EACE;IACE,iBAAA;ET8pDF;ES3pDA;IACE,YAAA;IACA,YAAA;IACA,kBAAA;IACA,oBAAA;IACA,iBAAA;ET6pDF;AACF;AS1pDA;EACE,qBAAA;EACA,kBAAA;AT4pDF;;ASzpDA;EACE,cAAA;AT4pDF;;AU55EA;EACE,oCAAA;EACA,aAAA;EACA,kBAAA;AV+5EF;;AU55EA;EACE,cREM;EQDN,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AV+5EF;;AU55EA;EACE,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;AV+5EF;;AU55EA;EACE,kBAAA;EACA,mBAAA;AV+5EF;;AU55EA;EACE,cRlBM;EQmBN,gBAAA;EACA,eAAA;AV+5EF;;AU55EA;EACE,eAAA;EACA,cR9BU;AF67EZ;;AU55EA;EACE,cRnCS;EQoCT,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AV+5EF;;AU55EA;EACE,yBRvBY;EQwBZ,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AV+5EF;;AU15EA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AV65EF;;AU15EA;EACE,eAAA;EACA,iBAAA;EACA,cRlDU;EQmDV,kBAAA;AV65EF;;AU15EA;EACE,iBAAA;EACA,cRyBa;EQxBb,eAAA;AV65EF;;AUz5EA,+CAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cRvFc;EQwFd,kBAAA;EACA,WAAA;EACA,gBAAA;AV45EF;;AUz5EA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;AV45EF;;AUz5EA;EACE,eAAA;EACA,YAAA;EAEA,mBAAA;AV25EF;;AUr5EA,yBAAA;AACA;EACE,gBAAA;EACA,kBAAA;AVw5EF;;AUr5EA;EACE,eAAA;AVw5EF;;AUr5EA;EACE,eAAA;EACA,cRlDa;EQmDb,qBAAA;AVw5EF;;AUr5EA;EACE,0BAAA;AVw5EF;;AUr5EA;EACE,aAAA;EACA,mBAAA;AVw5EF;;AUr5EA;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AVw5EF;;AUr5EA;EACE,UAAA;EACA,mBAAA;AVw5EF;;AWviFA;EACE,eAAA;EACA,cTSM;AFiiFR;;AWviFA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AX0iFF;;AWxiFA;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AX2iFF;;AWziFA;EACE,cTcQ;AF8hFV;;AWziFA;EACE,eAAA;EACA,cTpBqB;ESqBrB,kCAAA;EACA,mBAAA;AX4iFF;;AWxiFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AX2iFF;;AWxiFA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AX2iFF;;AWxiFA;EACE,sBAAA;EACA,YAAA;AX2iFF;;AWziFA;EACE,aAAA;EACA,mBAAA;AX4iFF;;AW1iFA;;;;;;;;EA4CE,yBAAA;AXygFF;;AWvgFA;EACE,yBAAA;AX0gFF;;AWvgFA;EACE,yBAAA;AX0gFF;;AWvgFE;EACE,WAAA;EACA,6CAAA;AX0gFJ;;AWvgFE,+DAAA;AACA;EACE,WAAA;EACA,+CAAA;AX0gFJ;;AWvgFE;EACE,WAAA;EACA,iCAAA;AX0gFJ;;AWvgFE,8DAAA;AACA;EACE;IACE,WAAA;IACA,6BAAA;EX0gFJ;EWvgFE;IACE,WAAA;EXygFJ;EWtgFE;IACE,WAAA;EXwgFJ;AACF;AWrgFE;EACE;IACE,WAAA;IACA,6BAAA;EXugFJ;AACF;AWpgFE;EACE,iBAAA;EACA,iBAAA;AXsgFJ;;AWngFE,8CAAA;AACA;EACE,gBAAA;AXsgFJ;;AWngFE;EACE,mBAAA;AXsgFJ;;AWngFE;EACE,iBAAA;AXsgFJ;;AWngFE;EACE,kBAAA;AXsgFJ;;AWngFE;EACE,cAAA;AXsgFJ;;AWngFE;EACE,mBAAA;EACA,0CAAA;EACA,yBTpDW;AF0jFf;;AWpgFE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AXugFJ;;AWpgFE;EACE,aAAA;AXugFJ;;AWrgFE;EACE,WAAA;EACA,YAAA;AXwgFJ;;AWtgFI;EACA,cT1HW;ES2HX,eAAA;AXygFJ;;AWvgFI;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AX0gFJ;;AWtgFA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,oCAAA;AXygFF;;AWtgFA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AXygFF;;AWtgFA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;AXygFF;;AWvgFA;EACE,mBAAA;AX0gFF;;AWxgFA;EACE,eAAA;EACA,cTlOqB;AF6uFvB;;AWzgFA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AX4gFF;;AW1gFA;EACE,oBAAA;AX6gFF;;AW3gFA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AX8gFF;;AW5gFA;EACE,WAAA;EACA,YAAA;AX+gFF;;AW7gFA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,iBAAA;AXghFF;;AW7gFA;EACE,iBAAA;EACA,+BT7PoB;AF6wFtB;;AW7gFA;;EAEE,cTlIa;AFkpFf;;AW7gFA;;EAEE,cT3OQ;AF2vFV;;AW7gFA;;EAEE,eAAA;EACA,sBAAA;AXghFF;;AW7gFA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AXghFF;;AW7gFA;EACE,cAAA;EACA,iBAAA;AXghFF;;AW7gFA;;EAEE,uBAAA;AXghFF;;AW7gFA;EACE,yBAAA;EACA,kBAAA;AXghFF;;AW7gFA;EACE,6BAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,iCAAA;AXghFF;;AW9gFA;EACE,cTxRe;ESyRf,YAAA;EACA,WAAA;AXihFF;;AW/gFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AXkhFF;;AWhhFA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,yBTlTM;ESmTN,kBAAA;EAEA,8BAAA;EACA,QAAA;EACA,SAAA;AXkhFF;;AYt1FA,yDAAA;AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AZw1FF;;AYr1FA;EACE,eAAA;EAEA,aAAA;AZu1FF;;AYr1FA;EACE,uBAAA;EACF,0BAAA;AZw1FA;;AYr1FA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;EACE,6BAAA;AZw1FJ;;AYr1FA;EACE,qBAAA,EAAA,sBAAA;AZw1FF;;AYr1FA;EACE,qBAAA,EAAA,yBAAA;EACA,aAAA;EACA,6CAAA;AZw1FF;;AYr1FA;EACE,WAAA;AZw1FF;;AYr1FA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AZw1FF;;AYt1FA;EACE,eAAA;AZy1FF;;AYt1FA;EACE,UAAA,EAAA,0BAAA;EACA,YAAA;EACA,cAAA,EAAA,8BAAA;EACA,cAAA,EAAA,yBAAA;EACA,gBAAA;AZy1FF;;AYt1FA;EACE,sBAAA;EACA,mBAAA;EACA,uCAAA;EACA,YAAA;EAEA,aAAA;EACA,aAAA;EACA,sBAAA;AZw1FF;;AYr1FA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AZw1FF;;AYr1FA;EACI,YAAA;EACA,YAAA;AZw1FJ;;AYt1FA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AZy1FJ;;AYv1FA;EACE,cAAA;EACA,eAAA;AZ01FF;;AYv1FA;EACE,aAAA;EACA,8BAAA,EAAA,kCAAA;EACA,mBAAA,EAAA,2BAAA;EACA,WAAA,EAAA,gCAAA;EACA,aAAA,EAAA,0BAAA;AZ01FF;;AYv1FA;EACE,gBAAA;EACA,aAAA;AZ01FF;;AYx1FA;EACE,kBAAA;EACA,qBAAA;AZ21FF;;AYx1FA;EACE,kBAAA;EACA,YAAA,EAAA,8BAAA;EACA,sBAAA,EAAA,oBAAA;EACA,WAAA,EAAA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;AZ21FF;;AYx1FA;0FAAA;AAEA;EACE,OAAA;AZ21FF;;AYx1FA;EACE,UAAA;EACA,QAAA;AZ21FF;;AYx1FA;EACE,UAAA;EACA,mBAAA;AZ21FF;;AYz1FA;EACE,WAAA,EAAA,gBAAA;EACA,YAAA;EACA,kBAAA,EAAA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA,EAAA,eAAA;EACA,0BAAA,EAAA,sBAAA;EACA,eAAA;EACA,eAAA,EAAA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AZ41FF;;AY11FA;EACE,gBAAA;AZ61FF;;AY11FA;EACE,WAAA;EACA,YAAA;AZ61FF;;AY31FA;EACE,0BAAA,EAAA,8BAAA;EACA,mBAAA,EAAA,8BAAA;AZ81FF;;AY31FA;EACE,gCAAA;EACA,iBAAA;AZ81FF;;AY31FA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;AZ81FF;;AY31FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AZ81FF;;AY31FA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AZ81FF;;AY31FA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AZ81FF;;AY31FA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AZ81FF;;AY31FA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AZ81FF;;AY31FA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AZ81FF;;AY31FA;EACE,WAAA;EACA,YAAA;AZ81FF;;AY31FA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AZ81FF;;AY31FA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AZ81FF;;AY31FA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;AZ81FF;;AY31FA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AZ81FF;;AY31FA;EACE,YAAA;AZ81FF;;AY31FA;EACE,iBAAA;EACA,kBAAA;AZ81FF;;AY51FA;EACE,iBAAA;EACA,kBAAA;AZ+1FF;;AY51FA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AZ+1FF;;AY51FA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA,EAAA,yBAAA;EACA,kBAAA;AZ+1FF;;AY51FA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mCAAA;EACI,YAAA;AZ+1FN;;AY51FA;EACE,sBAAA;EACA,kDAAA,EAAA,oBAAA;EAEA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;AZ81FF;;AY31FA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AZ81FF;;AY31FA;EACA,kBAAA;EACI,mBAAA;EACA,eAAA;EACI,cAAA;EACJ,mCAAA;EACA,gBAAA;EACA,eAAA;AZ81FJ;;AY31FA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,eAAA;EACA,uCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACE,gBAAA;EACF,mCAAA;AZ81FF;;AY31FA;EACE,yBAAA;AZ81FF;;AY31FA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA,EAAA,qBAAA;EACA,gBAAA;AZ81FF;;AY31FA;EACE,qBAAA;EACA,uBAAA;AZ81FF;;AY31FA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AZ81FF;;AY31FA;;EAEE,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AZ81FF;;AY31FA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AZ81FF;;AY51FA;EACE,WAAA;EACA,YAAA;AZ+1FF;;AY71FA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AZg2FF;;AY71FA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AZg2FF;;AY71FA;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AZg2FF;;AY91FA;EACE,kDAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mCAAA;AZi2FF;;AY/1FA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AZk2FF;;AY/1FA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,8DAAA;AZk2FF;;AY/1FA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AZk2FF;;AY/1FA;EACE,WAAA;EACA,YAAA;AZk2FF;;AY/1FA;EACE,qBAAA;AZk2FF;;AY/1FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AZk2FF;;AY/1FA;EACE,cAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AZk2FF;;AY/1FA;EACE,WAAA;EACA,YAAA;AZk2FF;;AY/1FA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AZk2FF;;AY/1FA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AZk2FF;;AY/1FA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AZk2FF;;AY/1FA;EACE,yBAAA;EACA,qBAAA;AZk2FF;;AYh2FA;EACC,wCAAA;EACG,YAAA;EACF,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AZm2FF;;AYh2FA;EACE,wBAAA;EACA,+BAAA;EACA,kBAAA;AZm2FF;;AYj2FA;EACE,yBAAA;EACA,+BAAA;EACA,kBAAA;AZo2FF;;AYl2FA;EACE,aAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AZq2FF;;AYl2FA;EACE,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;AZq2FF;;AYl2FA;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AZq2FF;;AYl2FA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AZq2FF;;AYl2FA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AZq2FF;;AYl2FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,wDAAA;EACA,iBAAA;AZq2FF;;AYl2FA;EACE,qBVzmBc;EU0mBd,8CAAA;AZq2FF;;AYl2FA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AZq2FF;;AYl2FA;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mCAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;AZq2FF;;AYl2FA;EACE,WAAA;AZq2FF;;AYl2FA;EACE,2BAAA;AZq2FF;;AYl2FA;EACC,gBAAA;EACC,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,sBAAA;AZq2FF;;AYl2FA;EACE,qBVjoBU;EUkoBV,mBVzoBiB;AF8+GnB;;AYl2FA;EACE,0CAAA;EACE,qBV3pBY;AFggHhB;;AYl2FA;EACE,eAAA;EACA,mCAAA;EACA,gBAAA;AZq2FF;;AYl2FA;EACE,aAAA;EACA,yBAAA;AZq2FF;;AYl2FA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AZq2FF;AYp2FI;EACA,yBAAA;AZs2FJ;AYn2FE;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AZq2FJ;;AYj2FA;EACE,mBAAA;AZo2FF;;AYl2FA;EACE,aAAA;EACA,qCAAA,EAAA,cAAA;EACA,SAAA,EAAA,4BAAA;EACA,iBAAA;AZq2FF;;AYl2FA;EACC,yBAAA;EACC,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA,EAAA,mCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8DAAA;AZq2FF;;AYl2FA;EACE,qBAAA;EACA,wCAAA;AZq2FF;;AYl2FA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AZq2FF;;AYl2FA;EACE,qBAAA;AZq2FF;;AYl2FA;EACE,4CAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,wCAAA;EACA,qBAAA;EACA,iBAAA;AZq2FF;;AYn2FA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACE,cAAA;EACF,mCAAA;EACJ,gBAAA;AZs2FA;;AYn2FA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AZs2FF;;AYn2FA;EACE,mBAAA;AZs2FF;;AYn2FA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AZs2FF;;AYn2FA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AZs2FF;;AYn2FA;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AZs2FF;;AYn2FA;EACE,mBAAA;AZs2FF;;AYn2FA;EACA,WAAA;EACI,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AZs2FJ;;AYn2FA;EACE,gBAAA;AZs2FF;;AYn2FA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AZs2FF;;AYn2FA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AZs2FF;;AYn2FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AZs2FF;;AYn2FA;EACE,mBAAA;AZs2FF;;AYn2FA;EACE,WAAA;EACA,YAAA;AZs2FF;;AYp2FA,eAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;AZu2FF;;AYp2FA,YAAA;AACA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AZu2FF;;AYp2FA;;;EAGE,mBAAA;AZu2FF;;AYp2FA;;EAEE,gBAAA;EACA,qBAAA;AZu2FF;;AYp2FA;EACE,iBAAA;EACA,eAAA;AZu2FF;;AYp2FA;EACE,gBAAA;AZu2FF;;AYp2FA;EACE,aAAA;AZu2FF;;AYp2FA;EACE,gBAAA;AZu2FF;;AYp2FA,iCAAA;AACA;EACE,4CAAA;EACA,cAAA;EACE,mCAAA;EACF,gBAAA;EACA,eAAA;EACI,gBAAA;AZu2FN;;AYp2FA,2CAAA;AACA;EACE,mBAAA;EACA,WAAA;EACA,iBAAA,EAAA,kBAAA;EACA,+BAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;AZu2FF;;AYr2FA;EACI,6BAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAAA;EACE,cAAA;EACJ,cAAA;EACA,aAAA;AZw2FF;;AYt2FA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AZy2FF;;AYt2FA;EACE,kCAAA;EACA,2BAAA;EACA,qBAAA;AZy2FF;;AYv2FA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AZ02FF;;AYv2FA;EACE,4CAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AZ02FF;;AYx2FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACI,eAAA;AZ22FN;;AYv2FA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;AZ02FF;;AYv2FA;EACE;IAAW,UAAA;EZ22FX;EY12FA;IAAM,YAAA;EZ62FN;AACF;AY32FA;EACE,aAAA;EACA,QAAA;AZ62FF;;AY12FA;EACE,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;AZ62FF;;AY12FA;EACE,mBAAA;AZ62FF;;AY12FA;EACE,qBAAA;AZ62FF;;AY12FA;EACE,qBAAA;AZ62FF;;AY12FA;EACE;IACE,YAAA;IACA,wBAAA;EZ62FF;EY32FA;IACE,UAAA;IACA,2BAAA;EZ62FF;EY32FA;IACE,YAAA;IACA,wBAAA;EZ62FF;AACF;AY32FA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AZ62FF;;AY12FA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;AZ62FF;;AY12FA;EACE,yBAAA;EACA,WAAA;AZ62FF;;AY12FA;EACE,yBAAA;AZ62FF;;AY12FA;EACE,yBAAA;EACA,WAAA;AZ62FF;;AY12FA;EACE,yBAAA;AZ62FF;;AY32FA;EACE,wBAAA;AZ82FF;;AY32FA;EACE,mBAAA;AZ82FF;;AY32FA;;EAEM,eAAA;EACF,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;AZ82FJ;;AY12FA;EACE,aAAA;AZ62FF;;AY12FA,+EAAA;AACA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wDACE;EAEF,iBAAA;AZ22FF;;AYx2FA;;EAEE,qBAAA;EACA,6CAAA;AZ22FF;;AYx2FA;;EAEE,qBAAA;EACA,8CAAA;AZ22FF;;AYx2FA;;EAEE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AZ22FF;;AYx2FA;;EAEE,SAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,UAAA;AZ22FF;;AYx2FA;;EAEE,cAAA;EACA,gBAAA;AZ22FF;;AYx2FA;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AZ22FF;;AYx2FA;EACE,2BAAA;AZ22FF;;AYx2FA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AZ22FF;;AYv2FA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AZ02FF;;AYv2FA;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACI,kBAAA;AZ02FN;;AYx2FA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AZ22FF;AYz2FE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kDAAA;EACA,YAAA;AZ22FJ;AYz2FI;EACE,qBAAA;EACA,UAAA;AZ22FN;;AYv2FA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AZ02FF;;AYv2FA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AZ02FF;;AYv2FA;EACE,mBAAA;AZ02FF;;AYv2FA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACI,iBAAA;AZ02FN;;AYx2FA;EACE,gBAAA;EACA,eAAA;EACA,kDAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA;EACA,iBAAA;EACE,gBAAA;EACF,kCAAA;AZ22FF;AYz2FE;EACE;IACE,UAAA;IACA,2BAAA;EZ22FJ;EYz2FE;IACE,UAAA;IACA,wBAAA;EZ22FJ;AACF;;AYv2FA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mCAAA;AZ02FF;;AYx2FA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mCAAA;AZ22FF;;AYz2FA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACE,WAAA;EACF,mCAAA;AZ42FF;;AY12FA;EACE,cAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mCAAA;AZ62FF;;AY12FA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,wDAAA;EACF,mCAAA;AZ62FA;AY52FE;EACE,qBAAA;EACA,4CAAA;EACA,aAAA;AZ82FJ;;AY32FA;EACE,cAAA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AZ82FJ;;AY52FA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AZ+2FF;;AY52FA;EACE,yBVjxCM;EUkxCN,yBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACE,gBAAA;EACF,yBAAA;AZ+2FF;AY72FE;EACG,mBV3xCc;AF0oInB;AY52FE;EACC,0CAAA;EACC,qBAAA;AZ82FJ;;AY32FA;EACE,gBAAA;AZ82FF;;AY52FA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACE,kBAAA;AZ+2FJ;;AY72FA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AZg3FF;;AY72FA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AZg3FF;;AY92FA;EACE,UAAA;EACA,gBAAA;AZi3FF;;AY/2FA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;AZk3FF;;AY/2FA,sCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AZk3FF;;AY/2FA,sCAAA;AACA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AZk3FF;;AY/2FA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AZk3FF;;AY/2FA,oFAAA;AACA;EACE,uBAAA;EACA,kCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,SAAA;AZk3FF;;AY/2FA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;AZk3FF;;AY/2FA;EACE,kBAAA;EACA,sBAAA;AZk3FF;;AY/2FA,yFAAA;AACA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AZk3FF;;AY/2FA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AZk3FF;;AY/2FA,qEAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AZk3FF;;AY/2FA;EACE,SAAA;EACA,YAAA;AZk3FF;;AY/2FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AZk3FF;;AY/2FA;EACE,cAAA;EACA,oBAAA;EACA,cAAA;AZk3FF;;AY/2FA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AZk3FF;;AY/2FA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AZk3FF;;AY/2FA;EACE,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,cAAA;AZk3FF;;AY/2FA;EACE,gBAAA;AZk3FF;;AY/2FA;EACE,mBAAA;AZk3FF;;AY/2FA;EACE,2CAAA;EACA,mBAAA;AZk3FF;;AY/2FA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AZk3FF;;AY92FA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AZi3FF;;AY92FA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AZi3FF;;AY92FA;EACE,WAAA;EACA,YAAA;AZi3FF;;AY92FA;EACE,oBAAA;AZi3FF;;AY92FA;EACE,0BAAA;EACA,oBAAA;AZi3FF;;AY92FA;EACE,aAAA;EACA,mBAAA;AZi3FF;;AY92FA;EACE,cAAA;AZi3FF;;AY92FA,mCAAA;AACA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA;0EAAA;EAEA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AZi3FF;;AY/2FA;EACE,eAAA;EACA,aAAA;AZk3FF;;AY/2FA;EACE,yBAAA;AZk3FF;;AY/2FA;EACE,2BAAA;AZk3FF;;AY/2FA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AZk3FF;;AY/2FA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AZk3FF;;AYh3FA;EACE,YAAA;EACA,oBAAA;AZm3FF;;AYj3FA;EACE,YAAA;EACA,mBAAA;AZo3FF;;AYl3FA;EACE,gBAAA;AZq3FF;;AYl3FA;EACE;IACE,QAAA;IACA,QAAA;IACA,SAAA;IACA,SAAA;IACA,gBAAA;IACA,WAAA;IACA,cAAA;EZq3FF;EYl3FA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EZo3FF;EYj3FA;IACE,aAAA;EZm3FF;EYh3FA;;IAEE,0BAAA;EZk3FF;EY/2FA;IACE,4BAAA;EZi3FF;AACF;Aa9/IA;;;EAGE,YAAA;EACA,SAAA;AbggJF;;Aa7/IA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AbggJF;;Aa7/IA;EACE,iBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AbggJF;;Aa7/IA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;AbggJF;;Aa9/IA;EACE,gBAAA;EACA,aAAA;AbigJF;;Aa//IA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AbkgJF;;Aa//IA;EACE,UAAA;AbkgJF;;Aa//IA;EACE,uBAAA;AbkgJF;;Aa//IA;EACE,+BAAA;EACA,mBAAA;AbkgJF;;Aa//IA;EACE,8BAAA;AbkgJF;;Aa//IA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AbkgJF;;Aa//IA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AbkgJF;;Aa//IA;EACE,iCAAA;EACA,kCAAA;AbkgJF;;Aa//IA;EACE,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AbkgJF;;Aa//IA;EACE,eAAA;EACA,SAAA;EACA,wBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;AbkgJF;;Aa//IA;EACE,cAAA;AbkgJF;;Aa//IA;EACE,YAAA;AbkgJF;;Aa//IA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,oEAAA;AbkgJF;;Aa//IA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AbkgJF;;Aa//IA;EACE,UAAA;AbkgJF;;Aa//IA;EACE,qCAAA;EACA,mBAAA;AbkgJF;;Aa//IA;EACE,qCAAA;EACA,mBAAA;EACA,2CAAA;AbkgJF;;Aa//IA;EACE,oCAAA;AbkgJF;;Aa//IA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AbkgJF;;Aa//IA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;AbkgJF;;Aa//IA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AbkgJF;;Aa//IA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AbkgJF;;Aa//IA;EACE,qCAAA;AbkgJF;;Aa//IA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AbkgJF;;Aa//IA;EACE,SAAA;AbkgJF;;Aa//IA;EACE,WAAA;EACA,YAAA;AbkgJF;;Aa//IA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AbkgJF;;Aa//IA;EACE,qCAAA;AbkgJF;;Aa//IA;EACE,gBAAA;AbkgJF;;AahgJA;EACE,eAAA;EACA,aAAA;EACA,2BAAA;AbmgJF;;AajgJA;EACE,mBAAA;AbogJF;;AajgJA;EACE,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AbogJF;;AajgJA;EACE,qCAAA;AbogJF;;AajgJA;EACE,mBAAA;EACA,cAAA;AbogJF;;AajgJA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AbogJF;;AajgJA;;;EAGE,aAAA;AbogJF;;AajgJA;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AbogJF;;AajgJA;EACE,mBAAA;EACA,YAAA;AbogJF;;AajgJA;;EAEE,yBAAA;EACA,YAAA;AbogJF;;AajgJA;;EAEE,YAAA;AbogJF;;AajgJA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AbogJF;;AajgJA;EACE,qCAAA;AbogJF;;AajgJA;EACE,uBAAA;EACA,aAAA;AbogJF;;AajgJA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AbogJF;;AajgJA;;EAEE,yBAAA;AbogJF;;AajgJA;EACE;;;IAGE,yBAAA;IACA,sBAAA;EbogJF;EajgJA;IACE,iCAAA;IACA,kCAAA;EbmgJF;AACF;Ac11JA,kCAAA;AAEA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;Ad21JF;;Acx1JA;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,cZJM;AF+1JR;;Acx1JA;EACE,yFAAA;EACA,sBAAA;EACA,YAAA;EAEA,4BAAA;EAEA,2BAAA;EAEA,kBAAA;EAEA,kBAAA;Adu1JF;;Acp1JA;EACE,kBAAA;Adu1JF;;Acp1JA;EACE,gBAAA;EACA,UAAA;Adu1JF;;Acp1JA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;Adu1JF;;Acp1JA;EACE,YAAA;EACA,WAAA;Adu1JF;;Acp1JA;EACE,UAAA;Adu1JF;;Acp1JA;EACE,UAAA;EACA,qCAAA;Adu1JF;;Acp1JA;EACE,UAAA;Adu1JF;;Acp1JA;EACE,UAAA;EACA,sCAAA;Adu1JF;;Acp1JA;EACE,yBAAA;Adu1JF;;Acp1JA;EACE,gBAAA;Adu1JF;;Acp1JA;EACE,yBAAA;EACA,gBAAA;Adu1JF;;Acp1JA;EACE,yBAAA;Adu1JF;;Acp1JA;EACE,UAAA;EACA,iCAAA;Adu1JF;;Acp1JA;EACE,UAAA;EACA,6BAAA;Adu1JF;;Acp1JA;EACE;IACE,UAAA;Edu1JF;Ecp1JA;IACE,UAAA;Eds1JF;AACF;Acn1JA;EACE,yBAAA;EACA,wCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;Adq1JF;;Acl1JA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;Adq1JF;;Acj1JA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;Ado1JF;;Acj1JA;EACE,qBAAA;EACA,WAAA;Ado1JF;;Ach1JA;EACE,kBAAA;EACA,iBAAA;Adm1JF;;Ach1JA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;Adm1JF;;Ach1JA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;Adm1JF;;Ac/0JA;EACE,sBAAA;EACA,qBZzFa;EY0Fb,kBAAA;Adk1JF;;Ac/0JA;EACE,8DAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;Adk1JF;;Ac/0JA;EACE,sBAAA;EACA,qBZzGa;EY0Gb,kBAAA;Adk1JF;;Ach1JA;EACE,8DAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;Adm1JF;;AehhKA,8GAAA;AAEA;EACE;IACE,mBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EfkhKF;AACF;Ae9gKA;EAEE;IACE,mBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;Ef+gKF;Ee1+JA,2GAAA;Af4+JF;Ae7gKE;EACE;IACE,2BAAA;IACA,sBAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;Ef+gKJ;AACF;AeliKA;EAuBE;IACE,aAAA;IACA,kBAAA;Ef8gKF;Ee1gKA;IACE,mBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;Ef4gKF;EexgKA;IACE,aAAA;IACA,kBAAA;IACA,gBAAA;Ef0gKF;AACF;AepgKE;EACE;IACE,mBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;IACA,iBAAA;EfsgKJ;AACF;Ae5jKA;EAyDE;IACE,aAAA;IACA,kBAAA;IACA,gBAAA;EfsgKF;EengKA;IACE,WAAA;IACA,YAAA;EfqgKF;EelgKA;IACE,cAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EfogKF;EejgKA;IACE,aAAA;IACA,kBAAA;EfmgKF;Ee7/JA;IACE,cAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;Ef+/JF;Ee3/JA;IACE,aAAA;Ef6/JF;Eez/JA;;IAEE,aAAA;IACA,kBAAA;Ef2/JF;Eev/JA;IACE,gBAAA;Efy/JF;Eer/JA;IACE,aAAA;Efu/JF;Eeh/JA;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;Efk/JF;Ee9+JA;IACE,gBAAA;Efg/JF;Eez+JA;IACE,gBAAA;Ef2+JF;Eev+JA;IACE,cAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;Efy+JF;Eer+JA;IACE,gBAAA;IACA,cAAA;Efu+JF;Een+JA;IACE,kCAAA;IACA,sBAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;Efq+JF;AACF;Aen+JA;EACE,aAAA;EACA,kBAAA;Afq+JF;;Ael+JA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;Afq+JF;;Ael+JA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;Afq+JF;;Aej+JA,0CAAA;AAEA;EACE,aAAA;EACA,mBAAA;Afm+JF;;Ae99JE;EACE;IACE,YAAA;IACA,aAAA;IACA,aAAA;Efi+JJ;AACF;Ae79JI;EACE;IACE,gBAAA;IACA,yBAAA;IACA,kBAAA;IACA,wBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;Ef+9JN;AACF;Ae19JE;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;Af49JF;;Aez9JA;;;;;;;;;;;EAAA;AAYA;;EAEE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;Af49JF;;Aez9JA;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,sBAAA;Af49JF;;Aez9JA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;Af49JF;;Aez9JA;EACE,gBAAA;EACA,mBAAA;Af49JF;;Aez9JA;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,uBAAA;Af49JF;;Aez9JA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;Af49JF;;Aez9JA;EACE,gBAAA;Af49JF;;Aez9JA;EACE,yBAAA;EACA,eAAA;EACA,sBAAA;Af49JF;;Aez9JA;EACE,eAAA;Af49JF;;Aez9JA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;Af49JF;;Aez9JA;EACE,eAAA;EACA,sBAAA;Af49JF;;Aez9JA;EACE,aAAA;EACA,WAAA;Af49JF;;Aez9JA;EACE,WAAA;EACA,gBAAA;Af49JF;;Aez9JA;EACE,wBAAA;Af49JF;;Aez9JA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;Af49JF;;Aez9JA;EACE,eAAA;EACA,kBAAA;Af49JF;;Ae19JA;;EAEE,sBAAA;EACA,eAAA;Af69JF;;Ae19JA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;Af69JF;;Ae19JA;EACE,2BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;Af69JF;;Ae19JA;EACE,aAAA;EACA,gCAAA;Af69JF;;Ae19JA;EACE,aAAA;Af69JF;;Ae19JA;EACE,UAAA;Af69JF;;Ae19JA;EACE,UAAA;EACA,kBAAA;Af69JF;;Ae19JA;EACE,UAAA;EACA,kBAAA;Af69JF;;Ae19JA;EACE,UAAA;EACA,iBAAA;Af69JF;;Ae19JA;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;Af69JF;;Ae19JA;EACE,kBAAA;Af69JF;;Ae19JA;EACE,UAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;Af69JF;;Ae19JA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;Af69JF;;Ae19JA;EACE,eAAA;Af69JF;;Ae19JA;EACE,UAAA;EACA,gBAAA;Af69JF;;Ae19JA;EACE,UAAA;EACA,iBAAA;Af69JF;;Ae19JA;EACE,iBAAA;Af69JF;Ae39JE;EACE,kBAAA;Af69JJ;Ae19JE;EACE,2BAAA;EACA,YAAA;EACA,2BAAA;EACA,8BAAA;Af49JJ;Aez9JE;EACE,2BAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;Af29JJ;;Aev9JA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;Af09JF;;Aev9JA;EACE,eAAA;EACA,0BAAA;Af09JF;;Aev9JA;EACE,eAAA;EACA,sBAAA;EACA,iBAAA;Af09JF;;Aev9JA;EACE,gBAAA;EACA,YAAA;Af09JF;;Aev9JA;EACE,eAAA;EACA,0BAAA;Af09JF;;Aev9JA;EACE,gBAAA;Af09JF;;Aet9JA,YAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;Efy9JF;Eet9JA;IACE,eAAA;Efw9JF;Eer9JA;IACE,eAAA;Efu9JF;Eep9JA;IACE,WAAA;Efs9JF;AACF;Aen9JA,kBAAA;AACA;EACE;IACE,WAAA;IACA,aAAA;IACA,iBAAA;Efq9JF;Eel9JA;IACE,eAAA;Efo9JF;Eej9JA;IACE,eAAA;Efm9JF;Eeh9JA;;;IAGE,eAAA;Efk9JF;Ee/8JA;IACE,eAAA;IACA,gBAAA;Efi9JF;Ee98JA;;IAEE,sBAAA;IACA,eAAA;Efg9JF;Ee78JA;IACE,sBAAA;IACA,uBAAA;IACA,aAAA;Ef+8JF;Ee58JA;IACE,eAAA;IACA,WAAA;IACA,mBAAA;Ef88JF;Ee38JA;IACE,aAAA;Ef68JF;AACF;Ae38JA,+GAAA;AAGE;EACE;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,0CAAA;Ef28JJ;AACF;Aex8JE;EACE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;Ef08JJ;AACF;Aet8JE;EACE;IACE,kBAAA;IACA,cAAA;IACA,eAAA;IACA,0BAAA;IACA,iBAAA;IACA,eAAA;Efw8JJ;AACF;Aen8JE;EACE;IACE,oEAAA;IACA,iBAAA;IACA,yBAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;IACA,cAAA;Efq8JJ;Eej8JE;;IAEE,eAAA;Efm8JJ;Eeh8JE;IACE,gBAAA;IACA,cAAA;IACA,eAAA;Efk8JJ;Ee/7JE;IACE,YAAA;IACA,sBAAA;IACA,cAAA;Efi8JJ;Ee97JE;IACE,gBAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,sBAAA;IACA,kBAAA;IACA,yBAAA;IACA,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,wBAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,YAAA;Efg8JJ;Ee77JE;IACE,WAAA;Ef+7JJ;AACF;Ae17JA;EACE,eAAA;EACA,kCAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;Af47JF;;Aex7JA;EACE,yBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;Af27JF;;Aex7JA;EACE,kCAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;Af27JF;;Aez7JA;EACE,cAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;Af47JF;;Aez7JA;EACE,cAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;Af47JF;;Aez7JA,8DAAA;AACA;EACE,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;Af47JF;;Aez7JA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;Af47JF;;Aex7JA;EACE,2BAAA;EACA,mBAAA;EACA,WAAA;Af27JF;;Aex7JA;EACE,eAAA;Af27JF;;Aex7JA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;Af27JF;;AgBvqLA;;EAEE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AhB0qLF;;AgBvqLA;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AhB0qLF;;AgBvqLA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;AhB0qLF;;AgBvqLA;EACE,gBAAA;AhB0qLF;;AgBvqLA;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,uBAAA;AhB0qLF;;AgBvqLA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AhB0qLF;;AgBvqLA;EACE,gBAAA;AhB0qLF;;AgBvqLA;EACE,yBAAA;EACA,eAAA;EACA,sBAAA;AhB0qLF;;AgBvqLA;EACE,eAAA;AhB0qLF;;AgBvqLA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AhB0qLF;;AgBvqLA;EACE,eAAA;EACA,sBAAA;AhB0qLF;;AgBvqLA;EACE,aAAA;EACA,WAAA;AhB0qLF;;AgBvqLA;EACE,WAAA;EACA,gBAAA;AhB0qLF;;AgBvqLA;EACE,wBAAA;AhB0qLF;;AgBxqLA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AhB2qLF;;AgBxqLA,8DAAA;AACA;EACE,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AhB2qLF;;AgBxqLA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;AhB2qLF;;AgBzqLA;;EAEE,sBAAA;EACA,eAAA;EACA,mBAAA;AhB4qLF;;AgB1qLA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AhB6qLF;;AgB1qLA;EACE,2BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;AhB6qLF;;AgB1qLA;EACE,aAAA;EACA,gCAAA;AhB6qLF;;AgB1qLA;EACE,aAAA;AhB6qLF;;AgB1qLA;EACE,UAAA;AhB6qLF;;AgB1qLA;EACE,UAAA;EACA,kBAAA;AhB6qLF;;AgB1qLA;EACE,UAAA;EACA,kBAAA;AhB6qLF;;AgB1qLA;EACE,UAAA;EACA,iBAAA;AhB6qLF;;AgB1qLA;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;AhB6qLF;;AgB1qLA;EACE,kBAAA;AhB6qLF;;AgB1qLA;EACE,UAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AhB6qLF;;AgB1qLA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;AhB6qLF;;AgB1qLA;EACE,eAAA;AhB6qLF;;AgB1qLA;EACE,UAAA;EACA,gBAAA;AhB6qLF;;AgB1qLA;EACE,UAAA;EACA,iBAAA;AhB6qLF;;AgB1qLA;EACE,iBAAA;AhB6qLF;AgB3qLE;EACE,kBAAA;AhB6qLJ;AgB1qLE;EACE,2BAAA;EACA,YAAA;EACA,2BAAA;EACA,8BAAA;AhB4qLJ;AgBzqLE;EACE,2BAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;AhB2qLJ;;AgBvqLA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AhB0qLF;;AgBvqLA;EACE,eAAA;EACA,0BAAA;AhB0qLF;;AgBvqLA;EACE,eAAA;EACA,sBAAA;EACA,iBAAA;AhB0qLF;;AgBvqLA;EACE,eAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AhB0qLF;;AgBvqLA;EACE,gBAAA;EACA,YAAA;AhB0qLF;;AgBvqLA;EACE,eAAA;EACA,0BAAA;AhB0qLF;;AgBvqLA;EACE,gBAAA;AhB0qLF;;AgBvqLA;EACE,aAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AhB0qLF;AgBxqLE;EACE,kBAAA;AhB0qLJ;AgBvqLE;EACE,sBAAA;AhByqLJ;;AgBpqLA,YAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EhBuqLF;EgBpqLA;IACE,eAAA;EhBsqLF;EgBnqLA;IACE,eAAA;EhBqqLF;EgBlqLA;IACE,WAAA;EhBoqLF;AACF;AgBjqLA,kBAAA;AACA;EACE;IACE,WAAA;IACA,aAAA;IACA,iBAAA;EhBmqLF;EgBhqLA;IACE,eAAA;EhBkqLF;EgB/pLA;IACE,eAAA;EhBiqLF;EgB9pLA;;;IAGE,eAAA;EhBgqLF;EgB7pLA;IACE,eAAA;IACA,gBAAA;EhB+pLF;EgB5pLA;;IAEE,sBAAA;IACA,eAAA;EhB8pLF;EgB3pLA;IACE,sBAAA;IACA,uBAAA;IACA,aAAA;EhB6pLF;EgB1pLA;IACE,eAAA;IACA,WAAA;IACA,mBAAA;EhB4pLF;EgBzpLA;IACE,aAAA;EhB2pLF;AACF;AgBxpLA;EACE,eAAA;EACA,cAAA;AhB0pLF;;AgBxpLA;EACE,mBAAA;AhB2pLF;;AgBxpLA;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;AhB2pLF;;AgBxpLA;EACE,yBAAA;AhB2pLF;;AgBxpLA;EACE,WAAA;AhB2pLF;;AgBxpLA;EACE,gBAAA;AhB2pLF;;AgBzpLA;EACE,WAAA;AhB4pLF;;AiBzhMA;EACE,WAAA;EACA,yBfUM;EeTN,kBAAA;EACA,YAAA;AjB4hMF;;AiB1hMA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AjB6hMF;;AiB1hMA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cfSY;EeRZ,qBAAA;EACA,mBAAA;EACA,oBAAA;AjB6hMF;;AiB1hMA;EACE,iBAAA;EACA,oBAAA;AjB6hMF;;AiB3hMA;EACE,mCAAA;EACA,cfZa;AF0iMf;AiB5hME;EACE,aAAA;EACA,8BAAA;EAEA,eAAA;AjB6hMJ;AiB3hMI;EACE,iBAAA;EACA,cf0BS;AFmgMf;;AiBvhMA;EACE,aAAA;EACA,yBfXK;EeYL,mCAAA;EACA,cflBW;AF4iMb;;AiBvhMA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AjB0hMF;;AiBvhMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AjB0hMF;;AiBvhMA;EACE,gBAAA;AjB0hMF;;AiBvhMA;EACE,6BAAA;EACA,cf/De;EegEf,YAAA;EACA,iBAAA;EACA,eAAA;AjB0hMF;;AiBvhMA;EACE,yBflEM;EemEN,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;AjB0hMF;;AiBvhMA;EACE,aAAA;EACA,6BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AjB0hMF;;AiBvhMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AjB0hMF;;AiBvhMA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AjB0hMF;;AiBvhMA;EACE,aAAA;EACA,yBf3Ca;AFqkMf;;AiBvhMA;EACE,aAAA;EACA,yBf1Ca;AFokMf;;AiBvhMA;EACE,YAAA;EACA,yBftCa;AFgkMf;;AiBvhMA;EACE,YAAA;EACA,yBfhBa;AF0iMf;;AiBvhMA;EACE,YAAA;EACA,yBffa;AFyiMf;;AiBvhMA;EACE,YAAA;EACA,yBfTa;AFmiMf;;AiBvhMA;EACE,YAAA;EACA,yBfOa;AFmhMf;;AiBvhMA;EACE,kBAAA;EACA,gBAAA;AjB0hMF;;AiBvhMA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,cfvHW;AFipMb;;AiBvhMA;EACE,sBAAA;EACA,kBAAA;AjB0hMF;;AiBxhMA;EACE,mBflJM;EemJN,mBAAA;EACA,yCAAA;EACA,aAAA;AjB2hMF;;AiBzhMA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cflJU;EemJV,kBAAA;AjB4hMF;;AiB1hMA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,cfzJU;Ee0JV,kBAAA;AjB6hMF;;AiB3hMA;EACE,cfrHa;EesHb,mBAAA;EACA,kBAAA;AjB8hMF;;AiB3hMA;EACE,mBfxFa,EewFc,gBAAA;EAC3B,qBf/Fa;AF6nMf;;AiB3hMA;EACE,iCAAA,EAAA,qBAAA;EACA,mBAAA,EAAA,yBAAA;EACA,oBAAA,EAAA,0BAAA;AjB8hMF;;AiB5hMA;EACE,gBAAA;AjB+hMF;;AiB5hMA;EACE,cAAA;AjB+hMF;;AiB7hMA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;AjBgiMF;;AiB7hMA;EACE;;IAEE,aAAA;EjBgiMF;AACF;AkBnvMA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AlBqvMF;AkBnvME;EACE,iBAAA;EACA,cAAA;AlBqvMJ;AkBlvME;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AlBovMJ;AkBjvME;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AlBmvMJ;AkBhvME;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;AlBkvMJ;AkB/uME;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AlBivMJ;AkB/uMI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AlBivMN;AkB/uMM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AlBivMR;AkB9uMM;EAEE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AlB+uMR;AkB5uMA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;AlB8uMF;AkB3uMA;EACE,qBAAA,EAAA,kBAAA;AlB6uMF;AkB3uMA;EACE,gBAAA,EAAA,kCAAA;AlB6uMF;AkB3uMI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AlB6uMN;AkB3uMM;EACE,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AlB6uMR;AkB1uMM;EACC,mBAAA;EACC,cAAA;AlB4uMR;;AkBtuMA;EACE,eAAA;EACA,cAAA;EAwFA,wEAAA;AlBkpMF;AkBxuME;EACE,mBAAA;AlB0uMJ;AkBvuME;EACE,iBAAA;AlByuMJ;AkBtuME;EACE,mBAAA;AlBwuMJ;AkBruME;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AlBuuMJ;AkBpuME;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlBsuMJ;AkBnuME;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AlBquMJ;AkBluME;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AlBouMJ;AkBjuME;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AlBmuMJ;AkBhuME;EACE,WAAA;EACA,aAAA;AlBkuMJ;AkB/tME;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AlBiuMJ;AkB/tMI;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,6CAAA;EACA,+BAAA;EACA,gBAAA;EACA,aAAA;AlBiuMN;AkB/tMM;EACE,2BAAA;AlBiuMR;AkB5tMM;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;AlB8tMR;AkBxtME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AlB0tMJ;AkBxtMI;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,WAAA;AlB0tMN;AkBvtMI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,yBAAA;AlBytMN;AkBvtMM;EACE,eAAA;AlBytMR;AkBrtMI;EACE,gBAAA;EACA,2BAAA;AlButMN;AkBrtMM;EACE,gBAAA;EACA,UAAA;AlButMR;AkBptMM;EACE,oBAAA;EACA,QAAA;AlBstMR;AkBntMM;EACE,eAAA;AlBqtMR;AkBjtMI;;EAEE,aAAA;EACA,WAAA;EACA,cAAA;AlBmtMN;AkBhtMI;;EAEE,aAAA;AlBktMN;AkB/sMI;EACE,WAAA;AlBitMN;AkB/sMM;EACE,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,UAAA;AlBitMR;AkB9sMM;EACE,aAAA;EACA,iDAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AlBgtMR;AkB7sMM;EACE,iBAAA;EACA,gBAAA;AlB+sMR;AkB5sMM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AlB8sMR;AkB3sMM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AlB6sMR;AkB1sMM;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AlB4sMR;AkBvsME;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AlBysMJ;AkBvsMI;EACE,mBAAA;EACA,oBAAA;AlBysMN;AkBtsMI;EACE,oBAAA;EACA,mBAAA;AlBwsMN;AkBrsMI;EACE,oBAAA;EACA,mBAAA;AlBusMN;AkBlsMI;EACE,mBAAA;AlBosMN;AkBjsMI;EACE,mBAAA;AlBmsMN;AkB9rMI;EACE,mBAAA;AlBgsMN;AkB7rMI;EACE,mBAAA;AlB+rMN;AkB1rMI;EACE,mBAAA;AlB4rMN;AkBzrMI;EACE,mBAAA;AlB2rMN;AkBtrMI;EACE,mBAAA;AlBwrMN;AkBrrMI;EACE,mBAAA;AlBurMN;AkBlrMI;EACE,mBAAA;AlBorMN;AkBjrMI;EACE,mBAAA;AlBmrMN;AkB/qME;EACE,UAAA;EACA,cAAA;AlBirMJ;AkB/qMI;EACE,gBAAA;EACA,yBAAA;AlBirMN;;AkB5qMA;EACE,6BAAA;AlB+qMF;AkB7qME;EACE,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AlB+qMJ;AkB5qME;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AlB8qMJ;;AkB1qMA;EACE,yBAAA;AlB6qMF;;AkB1qMA;EACE,yBAAA;AlB6qMF;;AkB1qMA;EACE,yBAAA;AlB6qMF;;AkB1qMA;EAEI;IACE,0BAAA;ElB4qMJ;EkBzqME;IACE,0BAAA;ElB2qMJ;AACF;AkBvqMA;EACE,chB1ac;EgB2ad,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,4BAAA;EACA,oBAAA;AlByqMF;;AkBtqMA;EACE,cAAA;EACA,eAAA;EAEA,2BAAA,EAAA,uCAAA;AlBwqMF;;AkBrqMA;EACE,cAAA;EACA,0BAAA;AlBwqMF;;AkBtqMA;EACE,yBAAA;EACA,sCAAA;AlByqMF;;AkBtqMA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AlByqMF;;AkBtqMA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AlByqMF;;AkBtqMA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AlByqMF;;AkBtqMA;EACE,cAAA;AlByqMF;;AkBtqMA;EACE,yBAAA;EACA,sCAAA;AlByqMF;;AkBvqMA;EACE,oBAAA;AlB0qMF;;AkBvqMA;EACE,gCAAA;EACA,4BAAA;EACA,wBAAA;EAEA,uBAAA;AlByqMF;;AkBvqMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AlB0qMF;;AkBxqMA;EACE,yBAAA;EACA,YAAA;AlB2qMF;;AkBxqMA;EACE,gBAAA;EACA,cAAA;AlB2qMF;;AkBxqMA;EACE,aAAA;EACA,4DAAA;AlB2qMF;;AkBxqMA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;AlB2qMF;;AkBxqMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AlB2qMF;;AkBxqMA;EACE,aAAA;AlB2qMF;;AkBzqMA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AlB4qMF;;AkB1qMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AlB6qMF;;AkB3qMA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AlB8qMF;;AkB5qMA;EACE,yBAAA;EACA,mBAAA;AlB+qMF;;AkB7qMA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AlBgrMF;;AkB9qMA;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AlBirMF;;AkB/qMA;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AlBkrMF;;AkBhrMA;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AlBmrMF;;AkBjrMA;EACE,yBAAA;EACA,mBAAA;AlBorMF;;AkBlrMA;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;AlBqrMF;;AkBnrMA;EACE,kBAAA;EACA,mBAAA;AlBsrMF;;AkBprMA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AlBurMF;;AkBrrMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AlBwrMF;;AkBtrMA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AlByrMF;;AkBtrMA,uDAAA;AACA;EACE;IACE,sBAAA;IACA,oBAAA;ElByrMF;EkBtrMA;IACE,sBAAA;IACA,WAAA;ElBwrMF;EkBrrMA;IACE,WAAA;ElBurMF;EkBrrMA;IACE,eAAA;IACA,mBAAA;ElBurMF;AACF;AkBrrMA;EACE;IACE,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;ElBurMF;EkBprMA;;IAEE,eAAA;IACA,kBAAA,EAAA,uCAAA;IACA,gBAAA;ElBsrMF;EkBnrMA;IACE,aAAA;IACA,sBAAA;IACA,iBAAA;IACA,qBAAA;ElBqrMF;EkBlrMA;IACE,WAAA;IACA,mBAAA;ElBorMF;EkBjrMA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;ElBmrMF;EkBhrMA;;IAEE,WAAA;ElBkrMF;EkBhrMA;IACE,eAAA;IACA,mBAAA;ElBkrMF;AACF;AkB/qMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AlBirMF;;AkB/qMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AlBkrMF;;AkB/qMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AlBkrMF;;AkBhrMA;EACE,gBAAA;AlBmrMF;;AkBjrMA;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AlBorMF;;AkBjrMA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AlBorMF;;AkBlrMA,6BAAA;AACA;EACE,4BAAA;EACA,2BAAA;AlBqrMF;;AkBlrMA;EACE,UAAA;AlBqrMF;;AkBlrMA;EACE,gBAAA;EACA,kBAAA;AlBqrMF;;AkBlrMA;EACE,gBAAA;AlBqrMF;;AkBlrMA,sCAAA;AACA;EACE,2BAAA;EACA,2BAAA;AlBqrMF;;AkBlrMA,+CAAA;AACA;EACE,iBAAA;AlBqrMF;;AkBlrMA,0BAAA;AACA;EACE,wBAAA;AlBqrMF;;AkBnrMA;EACE,aAAA;EACA,sBAAA,EAAA,2BAAA;EACA,uBAAA;AlBsrMF;;AkBnrMA;EACC,eAAA;EACC,gBAAA;EACC,mCAAA;EACC,cAAA;EACF,SAAA;EACA,gBAAA;AlBsrMF;;AkBnrMA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACC,eAAA;EACA,iBAAA;AlBsrMF;;AkBprMA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AlBurMF;;AkBrrMA;EACE,cAAA;EACA,gBAAA;EACF,mBAAA;AlBwrMA;;AkBrrMA;EACE,aAAA;EACA,SAAA,EAAA,yCAAA;EACC,yBAAA;EACA,iBAAA;AlBwrMH;;AkBrrMA;EACE,aAAA;EACA,SAAA,EAAA,yCAAA;EACC,yBAAA;EACA,iBAAA;AlBwrMH;;AkBrrMA;EACE,aAAA;EACA,SAAA,EAAA,yCAAA;EACC,yBAAA;EACA,iBAAA;AlBwrMH;;AkBrrMA;EACE,kBAAA;AlBwrMF;;AkBrrMA,gCAAA;AACA;EACE,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,2BAAA;EACA,qBAAA;AlBwrMF;;AkBrrMA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACC,0FACC;EAEF,yBAAA;EACA,iCAAA;AlBsrMF;;AkBnrMA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,oBAAA;EACA,kCAAA;EACA,mCAAA;EACA,0BAAA;AlBsrMF;;AkBprMA;EACE,aAAA;EACA,8BAAA,EAAA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;EACE,kBAAA;EACA,mBAAA;EACF,iBAAA;AlBurMF;;AkBprMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AlBurMF;;AkBprMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AlBurMF;;AkBrrMA;EACE,iBAAA;EACI,YAAA;EACJ,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACG,0FACD;AlBurMJ;;AkBnrMA;EACE,cAAA;EACA,gBAAA;AlBsrMF;;AkBnrMA;EACE,WAAA;EACA,mBAAA,EAAA,oBAAA;AlBsrMF;;AkBnrMA,uDAAA;AACA;EACE,uBAAA;EACA,2BAAA;EACA,kCAAA,EAAA,aAAA;EACA,yBAAA;EACA,8BAAA;AlBsrMF;;AkBnrMA;EACE,uBAAA;EACA,kCAAA;EACA,2BAAA;AlBsrMF;;AkBnrMA;EACA,SAAA;EACI,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,mCAAA;EACA,chB14BQ;EgB24BR,gBAAA;EACA,gBAAA;EACA,+CAAA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;AlBsrMR;;AkBprMA;EACE,YAAA;EACA,mBAAA;EACA,chBn4BS;EgBo4BT,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uDAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AlBurMF;;AkBprMA;EACE,yBhBn6Be;EgBo6Bf,chBx6BU;AF+lOZ;;AkBprMA;EACE,gBAAA;AlBurMF;;AkBrrMA;EACE,gBAAA;EACA,chBh7BU;EgBi7BV,eAAA;AlBwrMF;;AkBrrMA;EACE,WAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACG,0FACD;EAqBF,2BAAA;AlBmqMF;AkBrrME;EACE,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,sBAAA;AlBurMJ;AkBprME;EACE,sBAAA;EACA,gBAAA;AlBsrMJ;AkBlrME;EACE,sBAAA;EACA,gBAAA;AlBorMJ;;AkBhrMA,eAAA;AACA;EACE,oCAAA;EACA,sBAAA;AlBmrMF;;AkBhrMA,kBAAA;AACA;EACE,8BAAA;EACA,iCAAA;EACA,cAAA;EACA,sBAAA;AlBmrMF;AkBjrME;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;AlBmrMJ;AkBhrME;EACE,oCAAA;AlBkrMJ;AkB/qME;EACE,oCAAA;EACA,sBAAA;AlBirMJ;;AkB9qMA,kBAAA;AACA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA,EAAA,uBAAA;EACA,kCAAA;EACA,8BAAA,EAAA,UAAA;EACA,mBAAA;AlBirMF;;AkB7qMA;EACE,wBAAA;EACA,8BAAA;AlBgrMF;;AkB5qMA;EACE,mBhBnhCM;EgBohCN,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AlB+qMF;;AkB5qMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AlB+qMF;;AkB5qMA;EACE,eAAA;EACA,gBAAA;EACA,chBjiCU;EgBkiCV,oChBj2BY;AFghOd;;AkB5qMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AlB+qMF;;AkB5qMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AlB+qMF;;AkB5qMA;;+CAAA;AAGA;EAyKE,oEAAA;EAkCA,uEAAA;EA8BA;sCAAA;EAsEA,uEAAA;EAOA,gDAAA;EA4BA,yCAAA;AlBo2LF;AkBrrME;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;AlBurMJ;AkBprME;EACE,aAAA;EACA,0CAAA;EACA,kDACE;EAEF,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AlBorMJ;AkBjrME;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AlBmrMJ;AkBhrME;EACE,gBAAA;AlBkrMJ;AkB/qME;EACE,gBAAA;EACA,mBAAA;AlBirMJ;AkB9qME;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AlBgrMJ;AkB7qME;EACE,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AlB+qMJ;AkB5qME;EACE,WAAA;EACA,kBAAA;AlB8qMJ;AkB5qMI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AlB8qMN;AkB3qMI;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlB6qMN;AkB1qMI;EACE,qBAAA;EACA,+CAAA;AlB4qMN;AkBzqMI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AlB2qMN;AkBvqME;EACE,gBAAA;EACA,YAAA;AlByqMJ;AkBtqME;EACE,gBAAA;EACA,YAAA;AlBwqMJ;AkBrqME;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AlBuqMJ;AkBpqME;EACE;IACE,0CAAA;IACA,kDACE;IAEF,gBAAA;IACA,aAAA;ElBoqMJ;EkBjqME;IACE,iBAAA;IACA,WAAA;IACA,eAAA;IACA,YAAA;ElBmqMJ;EkBhqME;IACE,mBAAA;IACA,WAAA;IACA,YAAA;IACA,iCAAA;ElBkqMJ;EkB/pME;IACE,iBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;ElBiqMJ;EkB9pME;IACE,iBAAA;IACA,QAAA;ElBgqMJ;EkB7pME;IACE,kCAAA;IACA,YAAA;ElB+pMJ;AACF;AkB3pME;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBhBjvCI;EgBkvCJ,chBzuCQ;EgB0uCR,oChBziCU;EgB0iCV,eAAA;EACA,gBAAA;EACA,eAAA;EACA,wDAAA;AlB6pMJ;AkB3pMI;EACE,mBhBxsCS;EgBysCT,qBAAA;AlB6pMN;AkBzpME;EACE,mBAAA;EACA,qBAAA;EACA,chBlwCI;AF65OR;AkBzpMI;EACE,mBAAA;EACA,qBAAA;AlB2pMN;AkBtpME;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBhBhuCW;AFw3Of;AkBrpME;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oChBhlCU;EgBilCV,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iDAAA;AlBupMJ;AkBrpMI;EACE,mBhBlyCE;EgBmyCF,chB1xCM;EgB2xCN,yCAAA;AlBupMN;AkBjpME;EACE,eAAA;AlBmpMJ;AkBhpME;EACE,QAAA;EAEA,mBAAA;EACA,oBAAA;AlBipMJ;AkB9oME;EACE,YAAA;EACA,gBAAA;AlBgpMJ;AkB7oME;EACE,mBAAA;EACA,UAAA;EACA,6BAAA;AlB+oMJ;AkB5oME;;;EAGE,6BAAA;AlB8oMJ;AkB3oME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AlB6oMJ;AkB1oME;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AlB4oMJ;AkBzoME;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AlB2oMJ;AkBxoME;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBhBj2CI;EgBk2CJ,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AlB0oMJ;AkBvoME;EACE,YAAA;EACA,mBAAA;AlByoMJ;AkBroME;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;AlBuoMJ;AkBnoME;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oChBjrCU;EgBkrCV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AlBqoMJ;AkBloME;EACE,mBAAA;EACA,cAAA;AlBooMJ;AkBjoME;EACE,mBAAA;EACA,cAAA;AlBmoMJ;AkBhoME;EACE,mBhB31CW;EgB41CX,cAAA;AlBkoMJ;AkB9nME;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AlBgoMJ;AkB7nME;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AlB+nMJ;AkB5nME;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,YAAA;AlB8nMJ;AkB3nME;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AlB6nMJ;AkB1nME;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AlB4nMJ;AkB1nMI;EACE,sBAAA;EACA,uBAAA;AlB4nMN;AkBxnME;;EAEE,gBAAA;EACA,gBAAA;AlB0nMJ;AkBxnMI;;EACE,sBAAA;EACA,uBAAA;AlB2nMN;AkBvnME;EACE,yBAAA;AlBynMJ;AkBtnME;EACE;IACE,aAAA;IACA,0CAAA;IACA,qDACE;IAEF,mBAAA;IACA,gBAAA;IACA,aAAA;ElBsnMJ;EkBnnME;IACE,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,mBAAA;IACA,YAAA;IACA,mBAAA;ElBqnMJ;EkBnnMI;IACE,mBAAA;ElBqnMN;EkBjnME;IACE,iBAAA;ElBmnMJ;EkBhnME;IACE,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,yBAAA;IACA,iBAAA;IACA,YAAA;ElBknMJ;EkB/mME;IACE,iBAAA;IACA,WAAA;IACA,yBAAA;IACA,mBAAA;ElBinMJ;EkB9mME;IACE,uBAAA;IACA,gBAAA;IACA,gBAAA;ElBgnMJ;AACF;;AkB5mMA;sCAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AlB+mMF;AkB7mME;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,qBAAA;AlB+mMJ;AkB5mME;EACE,UAAA;AlB8mMJ;AkB3mME;EACE,uBAAA;AlB6mMJ;AkB1mME;EACE,oBAAA;EACA,mBAAA;AlB4mMJ;AkBzmME;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AlB2mMJ;AkBxmME;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlB0mMJ;AkBvmME;EACE,mBAAA;AlBymMJ;AkBtmME;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AlBwmMJ;AkBrmME;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AlBumMJ;;AkBnmMA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AlBsmMF;AkBpmME;EACE,4BAAA;EACA,2BAAA;AlBsmMJ;AkBnmME;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AlBqmMJ;;AkBjmMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACE,gCAAA;EACF,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AlBomMF;;AkBjmMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AlBomMF;;AkBjmMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AlBomMF;;AkBjmMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,chBjpDc;AFqvPhB;;AkBjmMA;EACE,QAAA;AlBomMF;;AkBjmMA;;EAEE,cAAA;AlBomMF;;AkBjmMA;EACE,gBAAA;AlBomMF;;AkBjmMA;EACE,uBAAA;AlBomMF;;AkBjmMA;EACE,mBhBzmDa;AF6sPf;;AkBjmMA;EACE,mBhB1qDc;EgB2qDd,chBhqDM;AFowPR;;AkBjmMA;EACE,mBhB9qDoB;AFkxPtB;;AkBjmMA;EACA,WAAA;EACI,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AlBomMJ;;AkBjmMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBhBnsDc;EgBosDd,chBzrDM;EgB0rDN,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iBAAA;AlBomMF;;AkBjmMA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AlBomMF;;AkBjmMA;EACE,yBAAA;EACA,mBhBrkDa;AFyqPf;;AkBjmMA;EACE,YAAA;AlBomMF;;AkBjmMA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBhBxlDa;AF4rPf;;AkBjmMA;EACE,eAAA;AlBomMF;;AkBjmMA;EACE,gBAAA;AlBomMF;;AkBjmMA;EACE,iBAAA;AlBomMF;;AkBjmMA;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AlBomMF;;AkBjmMA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AlBomMF;;AkBjmMA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AlBomMF;;AkBjmMA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AlBomMF;;AkBjmMA;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlBomMF;;AkBjmMA;EACE,aAAA;AlBomMF;;AkBjmMA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlBomMF;;AkBjmMA;EACE,eAAA;EACA,cAAA;EACA,YAAA;AlBomMF;;AkBjmMA;EACE,cAAA;AlBomMF;;AkBjmMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AlBomMF;;AkBlmMA;EACE,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AlBqmMF;;AkBlmMA;EACE,uBAAA;AlBqmMF;;AkBnmMA;;;yEAAA;AAIA;EACE,sBAAA;EACA,kBAAA;AlBsmMF;;AkBpmMA;;EAEE,qBAAA;EACA,oBAAA;AlBumMF;;AkBrmMA;;EAEE,wBAAA;EACA,wBAAA;AlBwmMF;;AkBtmMA;EACE,eAAA;EACA,kBAAA;AlBymMF;;AkBvmMA;EACE,mBhBr0DM;EgBs0DN,chBxwDa;EgBywDb,eAAA;EACA,gBAAA;EACA,oChB/nDY;EgBgoDZ,kBAAA;EACA,gCAAA;AlB0mMF;;AkBxmMA;EACE,wBAAA;EACA,wBAAA;AlB2mMF;;AkBxmMA;EACE,eAAA;AlB2mMF;;AkBxmMA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,chB5xDa;EgB6xDb,gCAAA;EACA,8BAAA;AlB2mMF;;AkBxmMA;EACE,8BAAA;AlB2mMF;;AkBxmMA;EACE,eAAA;AlB2mMF;;AkBxmMA;EACE,mBhBx2DM;AFm9PR;;AkBxmMA;EACE,mBhB52DM;AFu9PR;;AkBxmMA;EACE,mBhBh3DM;AF29PR;;AkBxmMA;EACE,mBAAA;AlB2mMF;;AkBxmMA;EACE,WAAA;EACA,mCAAA;AlB2mMF;;AkBxmMA;EACE,4BAAA;AlB2mMF;;AkBxmMA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;AlB2mMF;AkBzmME;EACE,gCAAA;AlB2mMJ;;AkBvmMA;EACE,wBAAA;AlB0mMF;;AkBvmMA;EACE,qBAAA;EACA,8BAAA;AlB0mMF;;AkBvmMA;EACE,8BAAA;AlB0mMF;;AkBvmMA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,kBAAA;EACA,oCAAA;AlB0mMF;;AkBvmMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AlB0mMF;;AkBvmMA;EACE,kBAAA;AlB0mMF;;AkBvmMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AlB0mMF;;AkBvmMA;EACE,chB/3Da;EgBg4Db,eAAA;EACA,gBAAA;AlB0mMF;;AkBvmMA;EACE;IACE,gDAAA;ElB0mMF;AACF;AkBvmMA;EACE;IACE,gDAAA;ElBymMF;AACF;AkBtmMA;EACE,mBhB/8DM;EgBg9DN,mBAAA;EACA,aAAA;EACA,gBAAA;AlBwmMF;;AkBrmMA;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;AlBwmMF;;AkBrmMA;EACE,UAAA;EACA,kBAAA;AlBwmMF;;AkBrmMA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,chBj5Da;AFy/Pf;;AkBrmMA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AlBwmMF;;AkBrmMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AlBwmMF;;AkBrmMA;EACE,mBAAA;AlBwmMF;;AkBrmMA;EACE,mBAAA;AlBwmMF;;AkBrmMA;EACE,mBAAA;AlBwmMF;;AkBrmMA;EACE,mBAAA;AlBwmMF;;AkBrmMA;EACE,mBAAA;AlBwmMF;;AkBrmMA;EACE,mBAAA;AlBwmMF;;AkBrmMA;EACE,mBAAA;AlBwmMF;;AkBrmMA;EACE,aAAA;EACA,yBAAA;AlBwmMF;;AkBrmMA;EACE,eAAA;EACA,gBAAA;EACA,WhBn8DU;EgBo8DV,oBAAA;EACA,mBAAA;EACA,QAAA;AlBwmMF;;AkBrmMA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AlBwmMF;;AkBrmMA;EACE,gBAAA;AlBwmMF;;AkBtmMA;EACE,yBhBvhES;AFgoQX;;AkBvmMA;EACE;IACE,uBAAA;IACA,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;ElB0mMF;EkBvmMA;IACE,WAAA,EAAA,uBAAA;IACA,kBAAA;ElBymMF;AACF;AkBvmMA;EACE;IACE,sBAAA;IACA,oBAAA;ElBymMF;EkBtmMA;;IAEE,WAAA;IACA,gBAAA;ElBwmMF;EkBrmMA;IACE,sBAAA;IACA,mBAAA;IACI,UAAA;IACA,gBAAA;ElBumMN;AACF;AkBpmMA;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;AlBsmMF;;AkBnmMA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AlBsmMF;;AkBnmMA;EACE,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AlBsmMF;;AkBnmMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AlBsmMF;;AkBnmMA;EACE,gBAAA;AlBsmMF;;AkBnmMA;EACE,gBAAA;AlBsmMF;;AkBnmMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AlBsmMF;;AkBnmMA;EACE,gBAAA;EACA,2BAAA;AlBsmMF;;AkBnmMA;EACE,YAAA;EACA,8BAAA;EACA,oBAAA;AlBsmMF;;AkBnmMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AlBsmMF;;AkBnmMA;EACE,eAAA;AlBsmMF;;AkBnmMA;EACE,aAAA;EACA,mBAAA;AlBsmMF;;AkBnmMA,0CAAA;AACA;EACE;IAEE,uBAAA;ElBqmMF;EkBlmMA;IAEE,yBAAA;IACA,eAAA;ElBmmMF;EkBhmMA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;ElBkmMF;EkB/lMA;;IAEE,WAAA;IACA,eAAA;ElBimMF;EkB9lMA;;;IAGE,sBAAA;IACA,0BAAA;ElBgmMF;EkB7lMA;IACE,WAAA;IACA,YAAA;ElB+lMF;AACF;AkB5lMA;EACE;IACE,kBAAA;IACA,mBAAA;ElB8lMF;EkB3lMA;IACE,kBAAA;IACA,mBAAA;ElB6lMF;EkB1lMA;IACE,QAAA;ElB4lMF;EkBzlMA;IACE,WAAA;IACA,YAAA;ElB2lMF;EkBxlMA;;;IAGE,6BAAA;ElB0lMF;EkBvlMA;IACE,sBAAA;IACA,oBAAA;ElBylMF;EkBtlMA;;;IAGE,oBAAA;IACA,2BAAA;ElBwlMF;EkBrlMA;IACE,sBAAA;IACA,oBAAA;ElBulMF;EkBplMA;IACE,8BAAA;IACA,eAAA;ElBslMF;EkBnlMA;;IAEE,WAAA;ElBqlMF;AACF;AkBllMA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,YAAA;ElBolMF;AACF;AkBjlMA;EACE;IACE,eAAA;ElBmlMF;EkBhlMA;;IAEE,eAAA;ElBklMF;EkB/kMA;IACE,WAAA;IACA,uBAAA;ElBilMF;EkB9kMA;IACE,2BAAA;ElBglMF;AACF;AkB7kMA,iDAAA;AACA;EACE;IACE,2BAAA;ElB+kMF;EkB5kMA;IACE,gBAAA;ElB8kMF;EkB3kMA;IACE,2BAAA;ElB6kMF;EkB1kMA;IACE,gBAAA;ElB4kMF;AACF;AkBzkMA;EACE;IACE,kBAAA;ElB2kMF;EkBxkMA;IACE,SAAA;ElB0kMF;EkBvkMA;IACE,WAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,SAAA;ElBykMF;EkBtkMA;;;;IAIE,sBAAA;IACA,cAAA;IACA,wBAAA;ElBwkMF;EkBrkMA;IACE,SAAA;ElBukMF;EkBpkMA;IACE,WAAA;IACA,2BAAA;IACA,SAAA;IACA,8BAAA;IACA,mBAAA;ElBskMF;EkBnkMA;IACE,YAAA;IACA,eAAA;ElBqkMF;EkBlkMA;IACE,oBAAA;ElBokMF;EkBjkMA;IACE,eAAA;ElBmkMF;EkBhkMA;IACE,eAAA;IACA,aAAA;ElBkkMF;EkB/jMA;IACE,QAAA;ElBikMF;AACF;AkB9jMA;EACE;IACE,gBAAA;ElBgkMF;EkB7jMA;IACE,eAAA;ElB+jMF;EkB5jMA;IACE,iBAAA;IACA,8BAAA;IACA,mBAAA;IACA,WAAA;ElB8jMF;EkB3jMA;IACE,mCAAA;IACA,YAAA;IACA,wBAAA;ElB6jMF;EkB1jMA;IACE,cAAA;IACA,wBAAA;ElB4jMF;EkBzjMA;IACE,kBAAA;ElB2jMF;EkBxjMA;IACE,eAAA;ElB0jMF;EkBvjMA;IACE,eAAA;ElByjMF;EkBtjMA;IACE,sBAAA;IACA,cAAA;ElBwjMF;EkBrjMA;IACE,eAAA;ElBujMF;EkBpjMA;IACE,eAAA;ElBsjMF;EkBnjMA;IACE,mBAAA;ElBqjMF;EkBljMA;IACE,eAAA;ElBojMF;AACF;AmB/9QA,6CAAA;AAEA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AnBg+QF;;AmB79QA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AnBg+QF;;AmB79QA;EACE,cAAA;EACA,YAAA;AnBg+QF;;AmB79QA;EACE,gBAAA;AnBg+QF;;AmB79QA,yFAAA;AAIA;EACE;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;EnB69QF;EmB19QA;IACE,YAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;EnB49QF;AACF;AmBz9QA;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;AnB29QF;;AmBx9QA;EAEE;IACE,gBAAA;IACE,2BAAA;EnB09QJ;AACF;AmBv9QA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AnBy9QF;;AmBt9QA;EACE,eAAA;AnBy9QF;;AmBt9QA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACC,eAAA;EACA,iBAAA;AnBy9QF;;AmBt9QA;EACE,0BAAA;AnBy9QF;;AmBt9QA;;EAEE,kBAAA;EACA,WAAA;AnBy9QF;;AmBt9QA;EACE,uBAAA;AnBy9QF;;AmBr9QA;EACE;IACE,sBAAA;IACA,uBAAA;EnBw9QF;EmBr9QA;;IAEE,WAAA;IACA,mBAAA;EnBu9QF;AACF;AmBp9QA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AnBs9QF;;AmBn9QA;;;EAGE,eAAA;EACA,mBAAA;AnBs9QF;;AmBp9QA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,4BAAA;AnBu9QF;;AmBp9QA;EACC,eAAA;EACC,gBAAA;EACC,mCAAA;EACC,cAAA;EACF,SAAA;AnBu9QF;;AmBn9QA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EnBs9QF;EmBn9QA;;;IAGE,WAAA;EnBq9QF;AACF;AmBn9QA;EACE,sDAAA;EACA;IACE,eAAA,EAAA,6BAAA;EnBq9QF;EmBl9QA;IACE,eAAA,EAAA,mCAAA;EnBo9QF;EmBl9QA;IACE,kBAAA;EnBo9QF;EmBj9QA;IACE,sBAAA;IACA,uBAAA;EnBm9QF;EmB/8QA;;IAEE,kBAAA;IACA,mBAAA;EnBi9QF;AACF;AmB98QE;EACE,kBAAA;AnBg9QJ;;AmB78QA;EACE,YAAA;EACA,kBAAA;AnBg9QF;;AmB78QA;EACE,oCAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AnBg9QF;;AmB78QA;EACE;IACE,YAAA;IACA,aAAA;IACA,eAAA;EnBg9QF;AACF;AmB78QA;EACE;IACE,YAAA;IACA,aAAA;IACA,iBAAA;EnB+8QF;AACF;AmB18QA,sCAAA;AACA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AnB48QF;;AmBz8QA;;EAEE,oCAAA,EAAA,gBAAA;EACA,sBAAA;EACA,8BAAA;AnB48QF;;AmBz8QA;EACE,YAAA;EACA,eAAA;AnB48QF;;AmBz8QA;EACE,yBAAA;AnB48QF;;AmBz8QA;EACE,gCAAA;EACA,eAAA;EACA,4BAAA;AnB48QF;;AmB18QA,yBAAA;AACA;EACE;IACE,sBAAA;IACA,cAAA;IACA,gBAAA;EnB68QF;EmB18QA;;;IAGE,sBAAA;IACA,eAAA;EnB48QF;EmBz8QA;IACE,mBAAA;IACA,iBAAA;IACA,kBAAA;IACI,wBAAA;IACJ,uBAAA;IACA,mBAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;IACA,mBAAA;IACA,YAAA;IACA,iBAAA;EnB28QF;AACF;AmBx8QA,2BAAA;AACA;EACE;IACE,kBAAA;IACA,YAAA;EnB08QF;EmBv8QA;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,cAAA;EnBy8QF;EmBt8QA;IACE,WAAA;IACA,YAAA;EnBw8QF;EmBr8QA;IACE,eAAA;IACA,gBAAA;EnBu8QF;EmBp8QA;IACE,WAAA;IACA,gBAAA;EnBs8QF;AACF;AmBl8QA;EACE,YAAA;EACA,uBAAA;AnBo8QF;;AmBj8QA;EACE,2BAAA;AnBo8QF;;AmBj8QA;EACE,YAAA;AnBo8QF;;AmBj8QA;EACE,aAAA;EACA,mBAAA;AnBo8QF;;AmBj8QA;EACE,gBAAA;AnBo8QF;;AmBj8QA;EACE,mBAAA;EACA,YAAA;EACA,oBAAA;AnBo8QF;;AmBj8QA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AnBo8QF;;AmBj8QA;;EAEE,8BAAA;AnBo8QF;;AmBj8QA;EACE,gBAAA;EACA,eAAA;AnBo8QF;;AmB/7QA,2BAAA;AACA;EAEE;IACE,sBAAA;IACA,uBAAA;EnBi8QF;EmB97QA;IACE,sBAAA;IACA,mBAAA;IACA,UAAA;IACA,gBAAA;EnBg8QF;EmB77QA;;;IAGE,sBAAA;IACA,eAAA;EnB+7QF;EmB57QA;IACE,sBAAA;IACA,uBAAA;EnB87QF;EmB37QA;IACE,kBAAA;IACA,kBAAA;EnB67QF;EmB17QA;IACE,eAAA;EnB47QF;EmBz7QA;IACE,eAAA;EnB27QF;EmBz7QA;IACE,cAAA;EnB27QF;AACF;AmBz7QA,2BAAA;AACA;EACE;IACE,sBAAA;IACA,uBAAA;EnB27QF;EmBx7QA;IACE,sBAAA;IACA,oBAAA;IACA,WAAA;EnB07QF;EmBv7QA;;;IAGE,eAAA;IACA,mBAAA;EnBy7QF;EmBr7QA;IACE,sBAAA;IACA,uBAAA;EnBu7QF;EmBp7QA;IACE,kBAAA;IACA,kBAAA;EnBs7QF;EmBn7QA;IACE,eAAA;EnBq7QF;EmBl7QA;IACE,gBAAA;EnBo7QF;AACF;AmBl7QA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AnBo7QF;;AmBj7QA,sBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;AnBo7QF;;AmBh7QA;EACE,aAAA;EACA,mBAAA;AnBm7QF;;AmBh7QA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AnBm7QF;;AmBh7QA;EACE,YAAA;EACA,YAAA;EACA,cAAA;AnBm7QF;;AmBh7QA;EACE,YAAA;EACA,YAAA;EACA,cAAA;AnBm7QF;;AmBh7QA;EACE,YAAA;AnBm7QF;;AmBj7QA;EACE,eAAA;AnBo7QF;;AmBj7QA,uCAAA;AACA;EACE,sBAAA;EACA,gBAAA;AnBo7QF;;AmBj7QA;EACE,mBAAA;AnBo7QF;;AmBj7QA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AnBo7QF;;AmBj7QA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AnBo7QF;;AmBj7QA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AnBo7QF;;AmBj7QA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AnBo7QF;;AmBj7QA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AnBo7QF;;AmBj7QA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AnBo7QF;;AmBj7QA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AnBo7QF;;AmBj7QA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AnBo7QF;;AmBj7QA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AnBo7QF;;AmBj7QA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AnBo7QF;;AmBj7QA;EACE,uBAAA;EACA,SAAA;AnBo7QF;;AmBj7QA;EACE,YAAA;EACA,SAAA;AnBo7QF;;AmBj7QA;EAGE,aAAA;AnBk7QF;;AmB/6QA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AnBk7QF;;AmB/6QA;EACE,6BAAA;AnBk7QF;;AmB/6QA;EACE,gBAAA;AnBk7QF;;AmB/6QA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AnBk7QF;;AmB/6QA;EACE,2CAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AnBk7QF;;AmB/6QA;EAKE,8BAAA;AnB86QF;;AmB36QA;EACE,8BAAA;AnB86QF;;AmB36QA;EAKE,8BAAA;AnB06QF;;AmBv6QA;EAKE,8BAAA;AnBs6QF;;AmBn6QA;;;EAiBE,yBAAA;AnBw5QF;;AmBr5QA;EAKE,yBAAA;EACA,YAAA;AnBo5QF;;AmBj5QA;EAME,0BAAA;AnB+4QF;;AmB54QA;;EAYE,yBAAA;EACA,qBAAA;AnBq4QF;;AmBl4QA;EAME,oCAAA;AnBg4QF;;AmB73QA;EAKE,8BAAA;AnB43QF;;AmBx3QA;EACE,iBAAA;AnB23QF;;AmBx3QA;EAKE,uBAAA;EACA,2BAAA;EACA;0CAAA;EAEA,2BAAA;EACA,qCAAA;EACA,mCAAA;AnBu3QF;;AmBp3QA;;EAUE,0BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AnB+2QF;;AmB52QA;EAKE,mBAAA;EACA,sCAAA;EACA,YAAA;EACA,WAAA;EACA;;;0DAAA;EAIA,sBAAA;AnB22QF;;AmBx2QA;EAIE,aAAA;EACA,mBAAA;EACA,gBAAA;AnBw2QF;;AmBr2QA;EACE;IACE,sBAAA;IACA,oBAAA;EnBw2QF;EmBr2QA;IACE,WAAA;IACA,2BAAA;IACA,eAAA;EnBu2QF;EmBp2QA;IACE,sBAAA;EnBs2QF;EmBn2QA;IACE,sBAAA;EnBq2QF;AACF;AmBl2QA;EACE;IACE,eAAA;EnBo2QF;EmBj2QA;IAEE,uBAAA;IACA,SAAA;EnBk2QF;EmBh2QA;IACE,sBAAA;EnBk2QF;AACF;AoBvoSA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;ApByoSF;AoBvoSE;EACE,clBRY;EkBSZ,yBlBEI;EkBDJ,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;ApByoSJ;AoBvoSI;EACE,mBlBlBU;EkBmBV,clBRE;AFipSR;;AoBpoSA;EACE,yBAAA;ApBuoSF;;AoBroSA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACE,iBAAA;EACF,iBAAA;ApBwoSF;;AoBroSA;EACE;IACE,eAAA;IACA,cAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;EpBwoSF;AACF;AoBroSA;EACE;IACE,eAAA;IACA,cAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;EpBuoSF;AACF;AoBnoSA;EACE;IACE,aAAA;IACA,yBlBSW;IkBRX,clBrDI;IkBsDJ,kBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;IACA,YAAA;IACA,elB3DI;IkB4DJ,iBAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;EpBqoSF;AACF;AoBjoSA;EACE;IACE,kBAAA;EpBmoSF;EoBhoSA;IACE,kBAAA;EpBkoSF;AACF;AoB/nSA;EACE,yBlBOa;EkBNb,clBhFM;EkBiFN,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;ApBioSF;;AoB9nSA;EACE,yBlBjBa;AFkpSf;;AoB9nSA;EACE,aAAA;ApBioSF;;AoB9nSA;EACE,6BAAA;EACA,8BAAA;ApBioSF;;AoB9nSA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;ApBioSF;;AoB9nSA;EACE,yBlBrGY;EkBsGZ,WlBrBU;AFspSZ;;AoB9nSA;EACE,yBlB1GY;AF2uSd;;AoB9nSA;EACE,yBlBgDa;EkB/Cb,clBJa;AFqoSf;;AoB9nSA;EACE,yBlByCa;AFwlSf;;AoB9nSA;EACE,yBlBQa;EkBPb,clBvDa;AFwrSf;;AoB9nSA;EACE,yBlBtBa;AFupSf;;AoB9nSA;EACE,yBlB0Ba;EkBzBb,clB/IM;EkBgJN,YAAA;ApBioSF;;AoB9nSA;EACE,oCAAA;EACA,yBAAA;ApBioSF;;AoB9nSA;EACE,yBlB3IY;EkB4IZ,yBAAA;ApBioSF;;AoB9nSA;EACE,yBlBlCa;AFmqSf;;AoB9nSA;EACE,mBlBjJO;EkBkJP,clBnKM;EkBoKN,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;ApBioSF;;AoB9nSA;EACE,mBlBvLc;EkBwLd,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,clBlLM;EkBmLN,SAAA;ApBioSF;;AoB7nSA;;EAEE,kBAAA;EACA,sBAAA;EACA,yBlBtMc;EkBuMd,clB5LM;EkB6LN,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ApBgoSF;;AoB7nSA;EACE,gBAAA;EACA,YAAA;EACA,clBzHa;EkB0Hb,eAAA;EACA,eAAA;EACA,mBAAA;ApBgoSF;;AoB5nSA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ApB+nSF;AoB5nSE;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;ApB8nSJ;AoB3nSE;EACD,yBlB9NO;EkB+NJ,yBAAA;EACA,clB3OY;AFw2ShB;AoB3nSI;EACE,yBlB7ES;AF0sSf;;AoBxnSA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ApB2nSF;;AoBvnSA;EACE,yBlBpMa;AF8zSf;;AoBvnSA;EACE,WAAA;EACA,YAAA;ApB0nSF;;AoBvnSA,6BAAA;AACA;EACE,yBlB7Ma;EkB8Mb,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;ApB0nSF;;AoBvnSA;EACE,yBlB1Ja;AFoxSf;;AoBvnSA,8BAAA;AACA;EACE,cAAA;EACA,kDAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,clB5QU;EkB6QV,eAAA;EACA,sCAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACD,gBAAA;EACA,oCAAA;ApB0nSD;;AoBxnSA;EACE,gBAAA;EACA,YAAA;EACA,clBjNa;EkBkNb,eAAA;EACA,0BAAA;EACA,kBAAA;ApB2nSF;;AoBvnSA;EACE,eAAA;EACA,SAAA,EAAA,qBAAA;EACA,OAAA;EACA,aAAA;EACA,yBlBpOa;EkBqOb,clBjTM;EkBkTN,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;EACA,0CAAA;ApB0nSF;;AoBvnSA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;ApB0nSF;;AoBxnSA;EACE,oCAAA;EACA,gBAAA;EACA,qBlBzTU;EkB0TV,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,6CAAA;ApB2nSF;;AoBvnSA;EACE,oCAAA;EACA,YAAA;EACA,qBlB1UU;EkB2UV,kCAAA;EAEA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,6CAAA;ApBynSF;;AoBtnSA;EACE,oCAAA;EACA,qBlB1VU;EkB2VV,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,6CAAA;ApBynSF;;AoBtnSA;EACE,oCAAA;EACA,qBlBzWU;EkB0WV,kCAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,6CAAA;ApBynSF;;AoBvnSA;EACE,sBAAA;EACA,kCAAA;ApB0nSF;;AoBxnSA;EACE,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBlBnTa;EkBoTb,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ApB2nSF;;AoBxnSA;EACE,iBAAA;ApB2nSF;;AoBznSA;EACE,aAAA;EACA,yBlBrVa;EkBsVb,clBnZM;EkBoZN,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,elBzZM;EkB0ZN,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ApB4nSF;;AoBxnSA;EACE,yBlBvWa;AFk+Sf;;AoBznSA;;EAEE,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;ApB4nSF;;AoBxnSA;EACE,yBlB/Sa;EkBgTb,clBxXa;AFm/Sf;;AoBvnSA;EACE,yBlBpaO;EkBsaP,clBvbM;EkBwbN,qBlBvaO;AFgiTT;;AoBrnSA;EACE,yBlB7bM;EkB+bN,clBjbY;EkBkbZ,qBlBlbY;AFyiTd;;AoBnnSA;;EAEE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;ApBsnSF;;AoBlnSA;EACE,eAAA;EACA,aAAA;EACA,wCAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;ApBqnSF;;AoBjnSA;EACE,kCAAA;EACA,0BAAA;ApBonSF;;AoBjnSA;EACE,4BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,clBjeM;EkBkeN,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;ApBonSF;;AoBhnSA;EACE,iBAAA;EACA,yBAAA;EACA,yBlB7eM;EkB8eN,kBAAA;EACA,eAAA;EACA,2BAAA;EAEA,8BAAA;EACA,wBAAA;EAEA,oCAAA;EACA,mDAAA;EAEA,mCAAA;ApBgnSF;AoB/mSE;EACE,SAAA;ApBinSJ;;AoB7mSA;EACE,aAAA;EACA,gBAAA;ApBgnSF;;AoB7mSA;;EAEE,yBlB3ba;EkB4bb,clBtgBM;EkBugBN,qBlB7ba;AF6iTf;;AoB7mSA;EACE,gBAAA;EACA,YAAA;EACA,clBnea;EkBoeb,eAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;ApBgnSF;;AoB7mSA;EACE,cAAA;EACA,wBAAA;EACA,yBlB3da;EkB4db,qBlB5da;EkB6db,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;ApBgnSF;;AoB5mSA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;ApB+mSF;AoB5mSE;EACE,yBlBtZW;AFogTf;AoB3mSE;EACE,yBlB5YW;AFy/Sf;;AoBzmSA;EACE,uBAAA;EACA,clB3jBU;EkB4jBV,iBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;ApB4mSF;AoB1mSE;EACE,yBlB9aW;AF0hTf;;AoBxmSA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;ApB2mSF;;AoBxmSA;EACE,4BAAA;EACA,clB1kBM;EkB2kBN,gBAAA;EACA,wCAAA;ApB2mSF;;AoBvmSA;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;ApB0mSF;;AoBvmSA;EACE;IACE,kBAAA;EpB0mSF;EoBvmSA;IACE,kBAAA;EpBymSF;AACF;AoBtmSA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ApBwmSF;;AoBrmSA;EACE,YAAA;EACA,YAAA;ApBwmSF;;AoBrmSA;EACE,kBAAA;EACA,yBAAA;EACA,yBlB/mBM;EkBinBN,YAAA;EACA,clB/hBa;EkBgiBb,eAAA;EACA,eAAA;EACA,iCAAA;EACA,sBAAA;EAEA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;ApBsmSF;;AoBnmSA;EACE,yBlBhjBa;EkBijBb,clBpoBM;AF0uTR;;AoBnmSA;EACE,yBlBrjBa;EkBsjBb,clBzoBM;AF+uTR;;AoBnmSA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBlBvkBa;EkBwkBb,clBjpBM;EkBkpBN,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;ApBsmSF;;AoBnmSA;EACE,aAAA;EACA,YAAA;EACA,yBlB1lBa;EkB2lBb,clBpqBM;EkBqqBN,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;ApBsmSF;;AqB5xTA,uFAAA;AAEA;EACE,qBAAA;EACA,UAAA;ArB8xTF;;AqB3xTA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;ArB8xTF;;AqB1xTA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;ArB6xTF;;AqB1xTA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,yBnBkFa;EmBjFb,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;ArB6xTF;;AqB3xTA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;ArB8xTF;;AqB5xTA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;ArB+xTF;;AqB5xTA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cnB7CM;EmB8CN,WAAA;ArB+xTF;;AqB7xTA;EACE,cnBxCU;AFw0TZ;;AqB9xTA;EACE,yBAAA;EAEA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;ArBgyTF;;AqB5xTA;EACE,yBAAA;EAEA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;ArB8xTF;;AqB3xTA;EACE,cnB1EU;EmB2EV,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;ArB8xTF;;AqB3xTA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBnBba;EmBcb,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;ArB8xTF;;AqB1xTA,sBAAA;AACA;EACE,gBAAA;ArB6xTF;;AqB3xTA;EACE,uBAAA;EACA,cnBzGa;AFu4Tf;AqB5xTE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;ArB8xTJ;AqB3xTE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cnBnHQ;EmBoHR,qBAAA;EACA,gBAAA;ArB6xTJ;AqB1xTE;EACE,kBAAA;EACA,cnB7Ha;EmB8Hb,eAAA;ArB4xTJ;AqBzxTE;EACE,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ArB2xTJ;AqBzxTI;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;ArB2xTN;AqBzxTM;EACE,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBnB5JA;EmB6JA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,wDAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cnBlKO;EmBmKP,QAAA;ArB2xTR;AqBzxTQ;EACE,oCAAA;EACA,qBnBvLM;EmBwLN,+CAAA;ArB2xTV;AqBxxTQ;EACE,kBAAA;EACA,cnBzKE;AFm8TZ;AqBvxTQ;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cnBhLE;AFy8TZ;AqBtxTQ;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;ArBwxTV;;AqBjxTA;EACE,uBAAA;EACA,cnBrMa;AFy9Tf;AqBlxTE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ArBoxTJ;AqBjxTE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cnBhNQ;EmBiNR,gBAAA;EACA,kBAAA;ArBmxTJ;AqBhxTE;EACE,kBAAA;EACA,cnB1Na;EmB2Nb,eAAA;EACA,gBAAA;EACA,kBAAA;ArBkxTJ;AqB/wTE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ArBixTJ;AqB9wTE;EACE,eAAA;EACA,gBAAA;EACA,cnB1OW;EmB2OX,eAAA;ArBgxTJ;AqB7wTE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ArB+wTJ;AqB5wTE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;ArB8wTJ;AqB3wTE;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;ArB6wTJ;AqB1wTE;EACE,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBnBnRI;EmBoRJ,kBAAA;ArB4wTJ;AqBzwTE;EACE,QAAA;ArB2wTJ;AqBxwTE;EACE,cnBvSY;EmBwSZ,kBAAA;ArB0wTJ;AqBvwTE;EACE,cnBxRQ;EmByRR,eAAA;EACA,gBAAA;ArBywTJ;AqBtwTE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;ArBwwTJ;AqBrwTE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;ArBuwTJ;AqBpwTE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBnB7TI;AFmkUR;AqBnwTE;EACE,eAAA;EACA,cnBzTQ;EmB0TR,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;ArBqwTJ;AqBlwTE;EACE,cnBnUQ;EmBoUR,yBAAA;EACA,cAAA;ArBowTJ;AqBjwTE;EACE,SAAA;EACA,uBAAA;EACA,cnB/VY;EmBgWZ,eAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;ArBmwTJ;AqBhwTE;EACE,eAAA;EACA,yBAAA;EACA,SAAA;ArBkwTJ;;AqB9vTA;EACE,uBAAA;EACA,cnB/Va;AFgmUf;AqB/vTE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;ArBiwTJ;AqB9vTE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cnB1WQ;EmB2WR,gBAAA;ArBgwTJ;AqB7vTE;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;ArB+vTJ;AqB5vTE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ArB8vTJ;AqB3vTE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cnBnYW;AFgoUf;AqB1vTE;EACE,eAAA;ArB4vTJ;AqBzvTE;EACE,YAAA;EACA,kBAAA;ArB2vTJ;AqBxvTE;EACE,kBAAA;ArB0vTJ;AqBvvTE;EACE,yBAAA;EACA,kBAAA;EACA,mBnB3ZI;EmB4ZJ,uBAAA;EACA,iBAAA;ArByvTJ;AqBtvTE;EACE,WAAA;EACA,YAAA;ArBwvTJ;AqBrvTE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cnBpaW;AF2pUf;AqBpvTE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ArBsvTJ;AqBnvTE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBnBzbI;EmB0bJ,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,8DAAA;ArBqvTJ;AqBnvTC;EACC,gCAAA;ArBqvTF;AqBnvTE;EACE,+CAAA;EACA,gCAAA;EACA,yBAAA;ArBqvTJ;AqBlvTE;EACE,aAAA;EACA,mBAAA;ArBovTJ;AqBjvTE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;EACA,iBAAA;ArBmvTJ;AqBhvTE;EACE,oBAAA;EACA,QAAA;EACA,gBAAA;ArBkvTJ;AqB/uTE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qBnB9eY;EmB+eZ,cnB/eY;AFguUhB;AqB9uTE;;EAEE,8BAAA;EACA,yBAAA;EACA,gCAAA;ArBgvTJ;AqB7uTE;EACE,SAAA;EACA,uBAAA;EACA,cnB5fY;EmB6fZ,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;ArB+uTJ;AqB5uTE;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;ArB8uTJ;AqB3uTE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;ArB6uTJ;AqB1uTE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBnBhiBY;EmBiiBZ,cnBthBI;EmBuhBJ,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;ArB4uTJ;AqBzuTE;EACE,eAAA;EACA,aAAA;EACA,yBAAA;ArB2uTJ;;AqBvuTA;EAEI;IACE,eAAA;ErByuTJ;EqBtuTE;IACE,aAAA;ErBwuTJ;EqBruTE;IACE,gBAAA;IACA,YAAA;IAAA,cAAA;IAAA,2BAAA;ErBuuTJ;EqBpuTE;IACE,WAAA;IACA,gBAAA;ErBsuTJ;AACF;AqBluTA;EAEI;IACE,eAAA;ErBmuTJ;EqBhuTE;IACE,cAAA;ErBkuTJ;EqB/tTE;IACE,QAAA;ErBiuTJ;EqB9tTE;IACE,eAAA;IACA,cAAA;ErBguTJ;EqB7tTE;IACE,WAAA;IACA,WAAA;ErB+tTJ;AACF;AqB3tTA;EACE,uBAAA;EACA,cnBjlBa;AF8yUf;AqB3tTE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;ArB6tTJ;AqB1tTE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cnB/lBW;EmBgmBX,gBAAA;ArB4tTJ;AqBztTE;EACE,kBAAA;EACA,cnBpmBa;EmBqmBb,eAAA;EACA,gBAAA;ArB2tTJ;AqBxtTE;EACE,gBAAA;ArB0tTJ;AqBvtTE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBnBvnBI;EmBwnBJ,iBAAA;EACA,WAAA;EACA,cAAA;ArBytTJ;AqBttTE;EACE,aAAA;ArBwtTJ;AqBrtTE;EACE,eAAA;EACA,gBAAA;EACA,cnB/nBW;AFs1Uf;AqBptTE;EACE,eAAA;EACA,cnBpoBW;EmBqoBX,YAAA;ArBstTJ;AqBntTE;EACE,cnBzoBW;AF81Uf;AqBltTE;EACE,gBAAA;ArBotTJ;AqBjtTE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;ArBmtTJ;;AqB/sTA;EACE,uBAAA;EACA,2BAAA;ArBktTF;;AqB/sTA;;EAEE,0BAAA;ArBktTF;;AqBhtTA;EACE,aAAA;EACA,eAAA;EACA,WAAA;ArBmtTF;;AqBjtTA;EACE;IACE,aAAA;ErBotTF;EqBjtTA;IACE,sBAAA;IACA,mBAAA;ErBmtTF;EqBhtTA;IACE,YAAA;IACA,iBAAA;IACA,eAAA;ErBktTF;AACF;AqB/sTA;EACE;IACE,gBAAA;ErBitTF;EqB9sTA;;;IAGE,sBAAA;ErBgtTF;EqB7sTA;IACE,2BAAA;ErB+sTF;EqB5sTA;IACE,gBAAA;ErB8sTF;AACF;AqB3sTA;EACE;IACE,sBAAA;ErB6sTF;EqB1sTA;IACE,eAAA;IACA,mBAAA;ErB4sTF;EqBzsTA;IACE,aAAA;IACA,SAAA;ErB2sTF;EqBxsTA;IACE,sBAAA;ErB0sTF;EqBvsTA;;;IAGE,cAAA;IACA,eAAA;ErBysTF;EqBtsTA;IACE,kBAAA;ErBwsTF;EqBrsTA;IACE,WAAA;ErBusTF;EqBpsTA;IACE,gBAAA;IACA,yBAAA;IACA,WAAA;ErBssTF;EqBnsTA;IACE,sBAAA;IACA,gBAAA;IACA,wBAAA;ErBqsTF;EqBlsTA;;;IAGE,sBAAA;IACA,eAAA;ErBosTF;EqBjsTA;IACE,sBAAA;ErBmsTF;EqBhsTA;IACE,eAAA;ErBksTF;EqB/rTA;IACE,eAAA;ErBisTF;EqB9rTA;IACE,kBAAA;ErBgsTF;EqB7rTA;IACE,gBAAA;ErB+rTF;EqB5rTA;IACE,sBAAA;IACA,gBAAA;ErB8rTF;AACF;AqB3rTA;EACE;IACE,eAAA;ErB6rTF;EqB1rTA;IACE,WAAA;IACA,gBAAA;ErB4rTF;EqBzrTA;IACE,eAAA;ErB2rTF;EqBxrTA;IACE,eAAA;ErB0rTF;EqBvrTA;IACE,mBAAA;IACA,yBAAA;IACA,eAAA;ErByrTF;EqBtrTA;IACE,gBAAA;ErBwrTF;EqBrrTA;IACE,eAAA;ErBurTF;EqBprTA;IACE,mBAAA;ErBsrTF;EqBnrTA;IACE,gBAAA;ErBqrTF;AACF;AsB1gVA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA;;;2CAAA;EAIA,gBAAA;EACA,gBAAA;AtB4gVF;;AsBzgVA;;EAEE,YAAA;AtB4gVF;;AsBzgVA,6DAAA;AACA;EACE,mBAAA;EACA,gBAAA;AtB4gVF;;AsBzgVA,wBAAA;AACA;EACE,eAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA,EAAA,aAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AtB4gVF;;AsBzgVA,WAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AtB4gVF;;AsBzgVA;EACE,eAAA,EAAA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AtB4gVF;;AsBzgVA;EACE,YAAA;EACA,uBAAA;EACA,cpB3Dc;EoB4Dd,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,oCAAA;EACA,UAAA;AtB4gVF;AsB1gVE;EACE,WpB+CQ;EoB9CR,mBAAA;EACA,qBAAA;AtB4gVJ;;AsBxgVA;EACE,SAAA;EACA,gBAAA;AtB2gVF;;AsBvgVE;EACE,kBAAA;AtB0gVJ;;AsBtgVA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cpBzEe;EoB0Ef,oCAAA;EACA,qBAAA;AtBygVF;;AsBtgVA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AtBwgVF;AsBtgVE;EACE,0BAAA;EACA,mBAAA;AtBwgVJ;;AsBpgVA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,cpB3Hc;EoB4Hd,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,qBAAA;AtBugVF;AsBrgVE;EACE,cpBnIkB;AF0oVtB;;AsBngVA,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AtBsgVF;;AsBngVA;EACE,UAAA,EAAA,SAAA;AtBsgVF;;AsBngVA,+EAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AtBqgVF;;AsBlgVA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AtBqgVF;;AsBlgVA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AtBqgVF;;AsBlgVA;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;AtBqgVF;;AsBlgVA;EACE,kBAAA;EACA,QAAA;AtBqgVF;;AsBlgVA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AtBqgVF;;AsBlgVA;EACE,eAAA;AtBqgVF;;AsBlgVA;EACE,gBAAA;EACA,eAAA;AtBqgVF;;AsBlgVA;EACE,YAAA;AtBqgVF;;AsBlgVA;EACE,kBAAA;EACA,qBAAA;AtBqgVF;;AsBlgVA;EACE,kBAAA;EACA,SAAA,EAAA,+BAAA;EACA,OAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;AtBqgVF;;AsBlgVA,iDAAA;AAEA;EACE,gBAAA;EACA,iBAAA;AtBogVF;;AsBjgVA;EACE;IACE,aAAA;EtBogVF;EsBjgVA;IACE,WAAA;IACA,kBAAA;EtBmgVF;EsBlgVE;IACE,kBAAA;IACA,eAAA;EtBogVJ;EsBhgVA;IACE,sBAAA;IACA,SAAA;EtBkgVF;EsB//UA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EtBigVF;EsB9/UA;IACE,mBAAA;EtBggVF;EsB7/UA;IACE,WAAA;EtB+/UF;EsB5/UA;IACE,uBAAA;IACA,gBAAA;EtB8/UF;EsB3/UA;IACE,WAAA;IACA,eAAA;EtB6/UF;EsB3/UA;IACE,gBAAA;IACA,cAAA;EtB6/UF;AACF;AsB1/UA;EACE;IACE,eAAA;IACA,gBAAA;EtB4/UF;EsB1/UA;IACE,uBAAA;IACA,gBAAA;IACA,cAAA;IACA,kBAAA;EtB4/UF;EsB1/UA;IACE,eAAA;IACA,cAAA;IACA,gBAAA;EtB4/UF;EsBz/UA;IACE,sBAAA;EtB2/UF;EsBx/UA;IACE,gBAAA;IACA,eAAA;EtB0/UF;EsBx/UA;IACE,iCAAA;IACA,sBAAA;EtB0/UF;EsBx/UF;IACI,0BAAA;EtB0/UF;EsBx/UA;IACE,sBAAA;IACA,0BAAA;EtB0/UF;EsBv/UA;IACE,uBAAA;IACA,kBAAA;IACA,cAAA;EtBy/UF;EsBt/UA;IACE,sBAAA;EtBw/UF;AACF;AsBr/UA;EACE,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AtBu/UF;;AsBp/UA;EACE,eAAA;EACA,oCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AtBu/UF;;AsBp/UA;EACE,eAAA;EACA,oCAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AtBu/UF;;AsBp/UA,wCAAA;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AtBs/UF;;AsBn/UA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;EAEA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AtBq/UF;AsBn/UE;EACE,mBAAA;AtBq/UJ;;AsBj/UA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AtBo/UF;;AsBj/UA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AtBo/UF;;AsBj/UA;EACE,gCAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;AtBo/UF;;AsBj/UA;EACE,gCAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;AtBo/UF;;AsBj/UA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AtBo/UF;;AsBj/UA,6CAAA;AAEA;EACE,6BAAA;EACA,aAAA;EACA,iBAAA;AtBm/UF;;AsBh/UA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;AtBm/UF;AsBj/UE;EACE,mBAAA;AtBm/UJ;AsBh/UE;EACE,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,iBAAA;EACA,gCAAA;AtBk/UJ;AsB9+UI;EACE,gBAAA;AtBg/UN;AsB5+UE;EACE,kBAAA;EACA,oCAAA;EACA,sBAAA;EACA,uBAAA;EACA,2CAAA;AtB8+UJ;AsB3+UE;EACE,8BAAA;AtB6+UJ;;AsBz+UA;EACE,UAAA;EACA,iBAAA;AtB4+UF;;AsBz+UA;EACE,SAAA;EACA,kBAAA;AtB4+UF;;AsBz+UA;EACE,kBAAA;EACA,sBAAA;AtB4+UF;;AsBz+UA;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AtB4+UF;;AsBz+UA;EACE,kBAAA;EACA,sBAAA;AtB4+UF;;AsBz+UA;EACE,sBAAA;EACA,4BAAA;EACA,+BAAA;AtB4+UF;;AsBz+UA;;mDAAA;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AtB4+UF;;AsBz+UA,4EAAA;AACA;EACE,eAAA;AtB4+UF;;AsBz+UA;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;AtB4+UF;;AsBz+UA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;AtB4+UF;;AsBz+UA,wCAAA;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AtB2+UF;AsBz+UE;EACE,UAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AtB2+UJ;AsBz+UI;EACE,yBAAA;AtB2+UN;AsBx+UI;EACE,2BAAA;AtB0+UN;AsBt+UE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AtBw+UJ;AsBt+UI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AtBw+UN;;AsBn+UA,mDAAA;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBpBzlBc;EoB0lBd,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;AtBq+UF;AsBn+UE;EACE,mBpB/lBkB;AFokWtB;AsBl+UE;EACE,mBpBnmBkB;AFukWtB;;AsBh+UA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;AtBm+UF;AsBj+UE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AtBm+UJ;AsBh+UE;EACE,cAAA;AtBk+UJ;AsB/9UE;EACE,qBAAA;EACA,mBAAA;AtBi+UJ;AsB99UE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AtBg+UJ;AsB99UI;EACE,qBAAA;EACA,mBAAA;AtBg+UN;;AsB39UA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AtB89UF;;AsB39UA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AtB89UF;AsB59UE;EACE,mBAAA;EACA,qBAAA;AtB89UJ;AsB39UE;EACE,YAAA;EACA,mBAAA;AtB69UJ;AsB19UE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AtB49UJ;AsB19UI;EACE,mBAAA;EACA,qBAAA;AtB49UN;;AsBv9UA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AtB09UF;;AsBv9UA,oDAAA;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,uBAAA;AtBy9UF;;AsBt9UA;EACE,kBAAA;EACA,gBAAA;AtBy9UF;;AsBt9UA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AtBy9UF;;AsBt9UA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;AtBy9UF;;AsBt9UA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AtBy9UF;AsBv9UE;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AtBy9UJ;;AsBr9UA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AtBw9UF;;AsBr9UA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AtBw9UF;;AsBn9UA;EACE,QAAA;AtBs9UF;;AsBn9UA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,0BAAA;AtBs9UF;;AsBn9UA;EACE,cAAA;EACA,wBAAA;AtBs9UF;;AsBn9UA;EACE,eAAA;EACA,wBAAA;AtBs9UF;;AsBn9UA;EACE,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;AtBs9UF;;AsBn9UA;EACE,sBAAA;EACA,uBAAA;AtBs9UF;;AsBn9UA;EACE,YAAA;EACA,6BAAA;EACA,oCAAA;EACA,eAAA;AtBs9UF;AsBp9UE;EACE,gCAAA;AtBs9UJ;;AsBl9UA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AtBq9UF;;AsBl9UA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,qBAAA;AtBq9UF;AsBn9UE;EACE,qBAAA;EACA,mBAAA;AtBq9UJ;;AsBj9UA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,qBAAA;AtBo9UF;AsBl9UE;EACE,mBAAA;AtBo9UJ;;AsBh9UA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AtBm9UF;;AsBj9UA;EACE,SAAA;AtBo9UF;;AsBj9UA,wEAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AtBm9UF;;AsBh9UA;EACE,gBAAA;AtBm9UF;;AsBv8UA;EACE,wCAAA;EACA,qBAAA;AtB08UF;;AsBv8UA;EACE,aAAA;EACA,sBAAA;AtB08UF;;AsBv8UA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AtB08UF;AsBx8UE;EACE,mBpBtvBW;AFgsWf;AsBn8UE;EACE,0BAAA;EACA,oBAAA;AtBq8UJ;AsBl8UE;EACE,mBAAA;AtBo8UJ;;AsB97UA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AtBi8UF;AsB/7UE;EACE,mBpBnzBW;EoBozBX,cpB32BW;AF4yWf;AsB97UE;EACE,mBAAA;EACA,cAAA;AtBg8UJ;AsB77UE;EACE,mBpB/yBW;EoBgzBX,cpB92BW;AF6yWf;AsB57UE;EACE,mBAAA;EACA,cAAA;AtB87UJ;AsB37UE;EACE,mBpB9yBW;EoB+yBX,cpB12BW;AFuyWf;;AsBz7UA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AtB47UF;;AsBz7UA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EAKA,gBAAA;AtBw7UF;;AsBr7UA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;AtBw7UF;;AsBr7UA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WpBj4BU;EoBk4BV,oCAAA;EACA,gBAAA;AtBw7UF;;AsBr7UA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBpB9/Bc;EoB+/Bd,cAAA;AtBw7UF;;AsBn7UA;EACE;IAAW,uBAAA;EtBu7UX;EsBt7UA;IAAW,mBpB32BE;EFoyWb;AACF;AsBv7UA;EACE,wDAAA;AtBy7UF;;AsBt7UA;EACE,gBAAA;AtBy7UF;;AsBp7UE;EACE,iBAAA;EACA,SAAA;EACA,eAAA;AtBu7UJ;AsBp7UE;EACE,WAAA;EACA,YAAA;AtBs7UJ;AsBn7UE;EACE,eAAA;AtBq7UJ;AsBl7UE;EACE,eAAA;AtBo7UJ;;AsBh7UA;EACE;IACE,sBAAA;IACA,oBAAA;EtBm7UF;AACF;AsBh7UA,6CAAA;AAEA;EACE;IAAO,uBAAA;EtBk7UP;EsBj7UA;IAAO,yBAAA;EtBo7UP;AACF;AsBl7UA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AtBo7UF;;AsBj7UA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BpBjkCc;EoBkkCd,kBAAA;EACA,0CAAA;AtBo7UF;;AsBj7UA,gDAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;AtBm7UF;;AsBh7UA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AtBm7UF;;AsBh7UA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AtBm7UF;;AsBh7UA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AtBm7UF;;AsBh7UA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AtBm7UF;;AsBh7UA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;AtBm7UF;;AsBh7UA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;AtBm7UF;;AsBh7UA;EACE,2BAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AtBm7UF;AsBj7UE;EACE,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8BAAA;AtBm7UJ;AsBh7UE;EACE,4BAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;AtBk7UJ;;AsB96UA,uEAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AtBg7UF;;AsB76UA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AtBg7UF;;AsB76UA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AtBg7UF;;AsB76UA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;AtBg7UF;;AsB76UA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AtBg7UF;;AsB76UA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AtBg7UF;;AsB76UA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,oCAAA;AtBg7UF;;AsB76UA;EACE,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8CAAA;AtBg7UF;;AsB76UA;EACE,cAAA;AtBg7UF;;AsB76UA;EACE;IACE,sBAAA;IACA,uBAAA;EtBg7UF;EsB76UA;IACE,2BAAA;EtB+6UF;AACF;AsB56UA,8EAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AtB66UF;;AsB16UA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AtB66UF;;AsB16UA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AtB66UF;;AsB16UA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;AtB66UF;;AsB16UA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AtB66UF;;AsB16UA;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,yDAAA;AtB66UF;;AsB16UA;EACE,sCAAA;AtB66UF;;AsB16UA;EACE,mBAAA;EACA,cAAA;AtB66UF;;AsB16UA;EACE,YAAA;EACA,mBAAA;AtB66UF;;AsB16UA;EACE;IACE,sBAAA;IACA,uBAAA;EtB66UF;AACF;AsB16UA,gDAAA;AAEA;EACE,YAAA;EACA,mBAAA;AtB26UF;AsBz6UE;;EAEE,mBAAA;AtB26UJ;;AsBv6UA,+DAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AtBy6UF;;AsBt6UA;EACE,sBAAA;EACA,QAAA;AtBy6UF;;AsBt6UA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;AtBy6UF;AsBv6UE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AtBy6UJ;;AsBr6UA;EACE,eAAA;EACA,cAAA;AtBw6UF;;AsBr6UA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AtBw6UF;;AsBr6UA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AtBw6UF;;AsBr6UA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AtBw6UF;AsBt6UE;EACE,cAAA;AtBw6UJ;;AsBp6UA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,oCAAA;AtBu6UF;;AsBp6UA,gDAAA;AACA;EACE,iBAAA;AtBu6UF;;AsBp6UA;EACE,mBAAA;EACA,mBAAA;EACA,SAAA;AtBu6UF;AsBr6UE;EACE,SAAA;AtBu6UJ;;AuBp0XE;EACE,qBAAA;AvBu0XJ;AuBr0XI;EACE,gBAAA;AvBu0XN;AuBn0XE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AvBq0XJ;AuBl0XE;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6CAAA;AvBo0XJ;AuBl0XI;EACE,qBAAA;EACA,kBAAA;EACA,crBnBK;EqBoBL,qBAAA;EACA,0BAAA;AvBo0XN;AuBl0XM;EACE,sBAAA;AvBo0XR;AuBh0XI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AvBk0XN;AuBh0XM;EACE,SAAA;EACA,iBAAA;EACA,crBtCG;AFw2XX;AuB/zXM;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AvBi0XR;AuB9zXM;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AvBg0XR;AuB5zXI;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;AvB8zXN;AuB3zXI;EACE,sBAAA;AvB6zXN;AuB3zXM;EACE,yBrBrEQ;EqBsER,YAAA;EACA,YAAA;EACA,kBAAA;AvB6zXR;AuBzzXI;EACE,aAAA;EACA,SAAA;AvB2zXN;AuBzzXM;EACE,UAAA;EACA,kBAAA;AvB2zXR;;AuBrzXA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AvBwzXF;;AuBpzXA,0BAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AvBuzXF;;AuBpzXA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;AvBuzXF;;AuBpzXA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AvBuzXF;;AuBpzXA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACG,gBAAA;EACH,iBAAA;EACA,gBAAA;EACA,mBAAA;AvBuzXF;;AuBpzXA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AvBuzXF;;AuBpzXA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,iCAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACE,0FACA;AvBszXJ;;AuBlzXA;EACE,yBAAA;AvBqzXF;;AuBlzXA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AvBqzXF;;AuBlzXA;EACE,iBAAA;AvBqzXF;;AuBnzXA;EACE,iBAAA;EACA,gBAAA,EAAA,0BAAA;EACA,sBAAA;AvBszXF;;AuBpzXA;EACE,kBAAA;AvBuzXF;;AwB3/XA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,yBtBQM;EsBPN,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;EACA,mCAAA;AxB8/XF;AwB5/XE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,yBtBKW;EsBJX,WtB+DQ;EsB9DR,gBAAA;AxB8/XJ;AwB3/XE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;AxB6/XJ;AwB3/XI;EACE,yBtBtBE;AFmhYR;AwB1/XI;EACE,ctBiGS;AF25Xf;;AwBv/XE;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AxB0/XJ;AwBx/XI;EACE,qBtBiDS;AFy8Xf;;AwBt/XA;EACE,kBAAA;AxBy/XF;AwBx/XE;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBtBjDI;EsBkDJ,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;AxB0/XJ;AwBv/XE;EACE,kBtB0CQ;EsBzCR,kBAAA;AxBy/XJ;;AwBr/XA;EACE,wBAAA;AxBw/XF;;AwBr/XA;EACE,YAAA;AxBw/XF;;AwBl/XA;EACE,gBAAA;AxBq/XF;AwBn/XE;EACE,6BAAA;EACA,4BAAA;EACA,oCAAA;EACA,eAAA;EACA,yBtBjFI;EsBkFJ,oBAAA;AxBq/XJ;AwBn/XI;EACE,6BAAA;AxBq/XN;AwBj/XE;;EAEE,ctBlFQ;AFqkYZ;AwBh/XE;EACE,kBAAA;AxBk/XJ;AwB/+XE;EACE,oCAAA;EACA,gBAAA;AxBi/XJ;AwB9+XE;EACE,oCAAA;AxBg/XJ;;AwB5+XA;EACE,aAAA;AxB++XF;;AwB5+XA;EACE,oCAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,wBAAA;AxB++XF;;AwB3+XA;EACE,wCAAA,EAAA,sBAAA;EACA,qBtB5GgB;EsB6GhB,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AxB8+XF;;AwB1+XA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AxB6+XF;AwB3+XE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AxB6+XJ;AwB1+XE;EACE,aAAA;EACA,SAAA;AxB4+XJ;;AwBx+XA;EACE,aAAA;EACA,mBAAA;AxB2+XF;;AwBx+XA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AxB2+XF;;AwBz+XA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;AxB4+XF;;AwBz+XA;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA,EAAA,gCAAA;EACA,yBAAA;EACA,yBtBhLM;EsBiLN,eAAA;EACA,gBAAA;EACA,ctB9Ka;EsB+Kb,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,yBAAA;EACA,aAAA;AxB4+XF;;AwBz+XA;EACE,qBtBhIa;EsBiIb,6CAAA;AxB4+XF;;AwBz+XA;EACE,qBtBrIa;EsBsIb,6CAAA;AxB4+XF;;AwBz+XA;EACE,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0BAAA;AxB4+XF;;AwBv+XA;EACE,aAAA;EACA,mBAAA;AxB0+XF;;AwBv+XA,kBAAA;AACA;EACE,UAAA;EACA,8BAAA;EACA,YAAA;EACA,yBtB9NM;EsB+NN,uBAAA;EACA,0FACE;AxBy+XJ;;AwBr+XA,0CAAA;AACA;EACE,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;AxBw+XF;;AwBr+XA,kBAAA;AACA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AxBw+XF;;AwBr+XA,mCAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACI,mBAAA;AxBw+XN;;AwBp+XA;EACE,gBAAA;AxBu+XF;AwBr+XI;EACE,oCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,wBAAA;EACA,8BAAA;EACA,2BAAA;EACA,wDAAA;AxBu+XN;AwBp+XI;EAEE,gCAAA;EACA,2BAAA;AxBq+XN;AwBl+XE;EACE,QAAA;AxBo+XJ;AwBj+XE;EACE,wCAAA;EACA,2BAAA;EACA,qBAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;AxBm+XJ;AwBh+XI;EACE,uBAAA;EACA,8BAAA;AxBk+XN;AwB/9XE;EACE,wBAAA;AxBi+XJ;AwB99XE;EACE,sBAAA;EACA,eAAA;AxBg+XJ;AwB79XE;;;EAGE,iBAAA;AxB+9XJ;AwB59XI;EACE,wBAAA;EACA,mBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EACA,WtBzPM;AFutYZ;;AwB19XE;EACE,oCAAA;EACA,gCAAA;AxB69XJ;;AwB19XE;EACE,oCAAA;EACA,gCAAA;AxB69XJ;;AwB19XE;;EAEE,yBAAA;AxB69XJ;;AwB19XA;EACE,yBtBhPa;AF6sYf;;AwB19XA;EACE,oCAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;AxB69XF;;AwB19XA;EACE,oCAAA;EACA,gCAAA;AxB69XF;;AwB19XA;EACE,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,ctB5WU;AFy0YZ;;AwB19XA,2DAAA;AACA;EACE,oCAAA;AxB69XF;;AwB19XA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0BAAA;AxB69XF;;AwB19XA;EACE,8BAAA;EACA,oCAAA;EACA,YAAA;EACA,0CAAA;AxB69XF;;AwB19XA;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;AxB69XF;;AwB19XA;EACE,oCAAA;AxB69XF;;AwB19XA;EACE,oCAAA;EACA,yBAAA;EACA,gBAAA;AxB69XF;;AwBz9XA;EACE,gBAAA;AxB49XF;AwBp9XE;EACE,uBAAA;AxBs9XJ;AwBn9XE;EACE,oCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,wBAAA;EACA,8BAAA;EACA,2BAAA;EACA,wDAAA;AxBq9XJ;AwBl9XE;;EAEE,gCAAA;EACA,2BAAA;AxBo9XJ;AwBj9XE;EACE,QAAA;EACA,4BAAA;EACA,gBAAA;AxBm9XJ;AwBh9XE;EACE,oCAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,uBAAA;AxBk9XJ;AwB/8XE;EACE,uBAAA;EACA,4BAAA;AxBi9XJ;AwB98XE;EAEE,yBAAA;AxB+8XJ;AwB58XE;EACE,yBAAA;AxB88XJ;AwB38XE;EACE,wBAAA;AxB68XJ;AwB18XE;EACE,uBAAA;EACA,4BAAA;EACA,iCAAA;AxB48XJ;AwBz8XE;;EAEE,uBAAA;EACA,4BAAA;AxB28XJ;AwBx8XE;EACE,sBAAA;EACA,eAAA;AxB08XJ;AwBv8XE;;;EAGE,iBAAA;AxBy8XJ;AwBt8XE;EACE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,WtBzbQ;AFi4YZ;;AwBp8XA;EACE,8BAAA;EACA,oCAAA;EACA,YAAA;EACA,0CAAA;AxBu8XF;;AwBp8XA;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;AxBu8XF;;AwBp8XA;EACE,oCAAA;AxBu8XF;;AwBp8XA;EACE,oCAAA;EACA,yBAAA;EACA,gBAAA;AxBu8XF;;AwBp8XA;EACE,6BAAA;AxBu8XF;;AyBv/YA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,yBvBKM;EuBJN,eAAA;EACA,gBAAA;EACA,8DAAA;AzB0/YF;;AyBv/YA;EACE,qBvBOU;AFm/YZ;;AyBv/YA;EACE,qBvBGU;EuBFV,gBAAA;AzB0/YF;;AyBv/YA;EACE,oCAAA;EACA,gCAAA;AzB0/YF;;AyBv/YA;;EAEE,gCAAA;AzB0/YF;;AyBv/YA;EACE,eAAA;EACA,cvBbU;AFugZZ;;AyBv/YA;EACE,WvBwEU;AFk7YZ;;AyBv/YA;EACE,cvBrBU;EuBsBV,eAAA;EACA,kBAAA;AzB0/YF;;AyBv/YA;EACE,yBvBwGa;EuBvGb,qBvBgFa;AF06Yf;;AyBv/YA;;;EAGE,cvBkEa;AFw7Yf;;AyBv/YA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBvBnDM;EuBoDN,eAAA;EACA,gBAAA;EACA,8DAAA;EACA,eAAA;EACA,cvB/CU;AFyiZZ;;AyBv/YA;EACE,qBvBnDU;AF6iZZ;;AyBv/YA;;EAEE,qBvBxDU;EuByDV,gBAAA;AzB0/YF;;AyBv/YA;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBvBzEM;EuB0EN,eAAA;EACA,gBAAA;EACA,8DAAA;AzB0/YF;;AyBv/YA;EACE,wCAAA;EACA,YAAA;AzB0/YF;;AyBv/YA;EACE,qBvB5EU;AFskZZ;;AyBv/YA;EACE,qBvBhFU;EuBiFV,gBAAA;AzB0/YF;;AyBv/YA;EACE,oCAAA;EACA,gCAAA;AzB0/YF;;AyBv/YA;;EAEE,gCAAA;AzB0/YF;;AyBv/YA;EACE,WvBNU;AFggZZ;;AyBv/YA;;EAEE,yBvB+Ba;EuB9Bb,qBvBOa;EuBNb,cvBFa;AF4/Yf;;A0BpnZA;EACI,yBAAA;A1BunZJ;;A0BpnZA;EACK;IACD,QAAA;IAED,qCAAA;E1BsnZD;E0BnnZA;IACE,iBAAA;E1BqnZF;E0BnnZA;IACE,cAAA;E1BqnZF;E0BnnZD;IACG,sBAAA;IACA,oBAAA;IACA,SAAA;E1BqnZF;E0BnnZF;IACI,oBAAA;E1BqnZF;E0BnnZA;;IAEE,sBAAA;E1BqnZF;E0BnnZF;IACI,0BAAA;IACA,iCAAA;IACA,mBAAA;E1BqnZF;E0BlnZA,gCAAA;EACA;IACE,0BAAA;IACA,gBAAA;IACA,kBAAA;E1BonZF;E0BjnZA,6BAAA;EACA;IACE,4BAAA;IACA,aAAA;E1BmnZF;E0BhnZA,0BAAA;EACA;IACE,eAAA;IACA,kBAAA;E1BknZF;E0B/mZA,yBAAA;EACA;IACE,gBAAA;E1BinZF;E0B9mZA;IACE,gBAAA;E1BgnZF;E0B7mZA;;IAEE,mBAAA;E1B+mZF;E0B5mZA,wBAAA;EACA;IACE,sBAAA;IACA,kBAAA;E1B8mZF;E0B3mZA,4BAAA;EACA;IACE,sBAAA;E1B6mZF;E0B3mZA;IACE,kBAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;E1B6mZF;E0B3mZF;IACI,kBAAA;IACA,8BAAA;E1B6mZF;E0B1mZE;IACA,aAAA;E1B4mZF;E0B1mZF;;;;IAII,sBAAA;IACA,oBAAA;IACA,WAAA;E1B4mZF;E0BzmZA;;;;;IAKE,sBAAA;E1B2mZF;E0BxmZA;IACE,sBAAA;E1B0mZF;E0BxmZA;IACE,sBAAA;E1B0mZF;E0BvmZA;;IAEE,WAAA;E1BymZF;E0BtmZA;IACE,sBAAA;IACA,SAAA;E1BwmZF;E0BrmZA;IACE,eAAA;IACA,cAAA;IACA,mBAAA;IACA,aAAA;E1BumZF;E0BpmZA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;E1BsmZF;E0BlmZA;IACE,eAAA;IACA,gBAAA;IACA,cAAA;IACA,kBAAA;E1BomZF;E0BjmZA;IACE,sBAAA;IACA,mBAAA;E1BmmZF;E0BhmZA;IACE,WAAA;E1BkmZF;E0BhmZA;IACE,UAAA;E1BkmZF;E0BhmZA;IACE,WAAA;E1BkmZF;E0BhmZE;IACA,aAAA;IACA,gBAAA;E1BkmZF;E0B/lZA;IACE,eAAA;E1BimZF;E0B9lZA;;;IAGE,eAAA;E1BgmZF;E0B7lZA;IACE,sBAAA;E1B+lZF;E0B7lZE;IACA,aAAA;E1B+lZF;E0B5lZA;IACC,WAAA;IACC,mBAAA;E1B8lZF;E0B3lZA;IACE,WAAA;IACA,mBAAA;E1B6lZF;E0B1lZA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;E1B4lZF;E0BzlZA;IACE,sBAAA;IACA,SAAA;E1B2lZF;E0BxlZA;IACE,sBAAA;IACA,mBAAA;E1B0lZF;E0BvlZA;IACE,eAAA;IACA,QAAA;E1BylZF;E0BtlZA;IACE,eAAA;IACA,kBAAA;E1BwlZF;E0BrlZA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;E1BulZF;E0BplZA;IACE,gBAAA;E1BslZF;E0BplZE;IACA,gBAAA;IACA,wBAAA;IACA,QAAA;E1BslZF;E0BplZA;IACE,mBAAA,EAAA,8BAAA;E1BslZF;E0BplZA;IACE,0BAAA;IACA,wBAAA;IACA,SAAA;IACA,uBAAA;E1BslZF;E0BnlZA;IACE,QAAA;E1BqlZF;E0BnlZE;IACA,gBAAA;IACA,uBAAA;IACA,sBAAA;E1BqlZF;E0BnlZF;IACE,WAAA;E1BqlZA;E0BnlZE;IACA,SAAA;E1BqlZF;E0BnlZA;IACE,eAAA;IACA,uBAAA;IACA,yBxB3PI;EFg1ZN;E0BnlZA;IACE,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,sBAAA;E1BqlZF;E0BllZA;IACE,eAAA;IACA,kBAAA;E1BolZF;E0BjlZA;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;E1BmlZF;E0BjlZA;IACE,wBAAA;E1BmlZF;E0BhlZA;IACE,wBAAA;E1BklZF;E0BhlZA;IACF,wBAAA;E1BklZE;E0BhlZA;IACE,eAAA;IACA,MAAA;IACA,qBAAA;IACA,aAAA;IACA,QAAA;IACA,gBAAA;IACA,2BAAA;IACA,aAAA;IACA,yBxB5SY;EF83Zd;E0B/kZA;IACE,YAAA;IACA,gBAAA;IACA,iBAAA;E1BilZF;E0B/kZF;IACE,UAAA;E1BilZA;E0B/kZA;IACE,WAAA;E1BilZF;E0B/kZA;IACE,WAAA;E1BilZF;E0B/kZA;IACE,WAAA;E1BilZF;E0B/kZA;IACE,WAAA;E1BilZF;E0B/kZA;IACE,WAAA;E1BilZF;E0B/kZE;IACA,kBAAA;IACA,SAAA;IACA,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;E1BilZF;E0B/kZF;IACE,gBAAA;E1BilZA;E0B/kZF;IACE,kBAAA;IACA,WAAA;E1BilZA;E0B/kZC;IACK,gBAAA;IACA,uBAAA;IACA,sBAAA;E1BilZN;E0B/kZA;IACE,aAAA;IACA,sBAAA,EAAA,yBAAA;IACA,QAAA;IACA,8BAAA;E1BilZF;E0B9kZA;IACE,SAAA,EAAA,8BAAA;IACA,YAAA,EAAA,sBAAA;IACA,eAAA;E1BglZF;E0B9kZF;IACI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,SAAA;IACA,gBAAA;E1BglZF;E0B9kZF;IACI,yBxB9WY;IwB+WZ,eAAA;IACA,kBAAA;IACA,YAAA;IACA,cxBvWI;IwBwWJ,qBxBnXY;IwBoXZ,WAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;E1BglZF;E0B9kZF;IACE,iBAAA;IACA,SAAA;IACA,WAAA;E1BglZA;E0B9kZE;IACA,aAAA;IACA,SAAA;IACA,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;E1BglZF;E0B7kZA;IACE,0BAAA,EAAA,2BAAA;IACA,wBAAA;IACA,SAAA;IACA,gBAAA;IACA,qBAAA;E1B+kZF;E0B5kZA;IACE,UAAA;IACA,WAAA;IACA,aAAA;E1B8kZF;E0B5kZD;IACC,UAAA;IACA,aAAA;IACA,mBAAA;E1B8kZA;E0B3kZA;;;IAGE,WAAA;IACA,YAAA;IACA,mBAAA;E1B6kZF;E0B3kZF;IACI,YAAA;IACA,aAAA;E1B6kZF;E0B3kZF;IACI,eAAA;E1B6kZF;E0B3kZF;IACE,gBAAA;E1B6kZA;E0B3kZF;IACI,sBAAA;E1B6kZF;E0B1kZF;IACA,aAAA;IACQ,sBAAA;IACA,iBAAA;E1B4kZN;E0B1kZA;IACE,sBAAA;IACA,oBAAA;IACA,WAAA;E1B4kZF;E0BzkZA;;IAEE,sBAAA;IACA,oBAAA;IACA,WAAA;E1B2kZF;E0BxkZA;;;;IAIE,sBAAA;E1B0kZF;E0BxkZF;IACI,eAAA;E1B0kZF;E0BxkZA;IACE,sBAAA;IACA,uBAAA;E1B0kZF;E0BvkZA;IACE,QAAA;IACA,WAAA;E1BykZF;E0BtkZA;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;E1BwkZF;E0BrkZA;IACE,QAAA;IACA,sBAAA;IACA,gBAAA;E1BukZF;E0BpkZA;IACE,QAAA;IACA,WAAA;IACA,gBAAA;E1BskZF;E0BnkZA;;;;IAIE,sBAAA;E1BqkZF;E0BlkZA;IACE,sBAAA;E1BokZF;E0BlkZF;IACI,aAAA;IACI,sBAAA;E1BokZN;E0BjkZA;IACE,eAAA;IACA,iBAAA;E1BmkZF;E0BhkZA;IACE,sBAAA;IACA,oBAAA;E1BkkZF;E0B/jZA;IACE,iBAAA;E1BikZF;E0B9jZA;IACE,WAAA;E1BgkZF;E0B9jZA;IACE,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,uBAAA;E1BgkZF;E0B7jZA;IACE,WAAA;IACA,gBAAA;IACA,eAAA;E1B+jZF;E0B5jZA;IACE,eAAA;IACA,kBAAA;IACA,YAAA;E1B8jZF;E0B5jZA;IACE,YAAA;IACA,YAAA;IACA,mBAAA;E1B8jZF;E0B3jZA;IACE,WAAA;IACA,gBAAA;IACA,eAAA;IACA,yBxBvhBI;IwBwhBJ,kBAAA;IACA,0CAAA;E1B6jZF;E0B1jZA;IACE,WAAA;E1B4jZF;E0BzjZA;IACE,kBAAA;IACA,kBAAA;E1B2jZF;E0BxjZA;IACE,UAAA;IACA,eAAA;IACA,iBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;E1B0jZF;E0BvjZA;IACE,mBAAA;E1ByjZF;E0BtjZA;IACE,WAAA;IACA,eAAA;IACA,eAAA;E1BwjZF;E0BrjZA;IACE,UAAA;IACA,eAAA;IACA,eAAA;IACA,gBAAA;E1BujZF;E0BpjZA;;IAEE,kBAAA;IACA,kBAAA;IACA,kBAAA;E1BsjZF;E0BnjZA;IACE,kBAAA;IACA,cAAA;E1BqjZF;AACF;A0BljZA,oBAAA;AACA;EACE;IACE,kBAAA;IACA,QAAA;IACA,gBAAA;IACA,2BAAA;IACA,aAAA;IACA,yBxB/lBY;EFmpad;E0BljZE;IACA,8BAAA;IACA,iBAAA;IACA,8BAAA;IACA,aAAA;IACA,eAAA;E1BojZF;E0BljZF;IACE,uBAAA;IACA,WAAA;E1BojZA;E0BjjZA;IACE,SAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,QAAA;E1BmjZF;E0BjjZF;IACE,eAAA;IAEA,yBAAA;E1BkjZA;E0B/iZA;;IAEE,cAAA;E1BijZF;E0B9iZA;IACE,sBAAA;IACA,SAAA;E1BgjZF;E0B7iZA;IACE,eAAA;E1B+iZF;E0B7iZA;IACE,iCAAA;IACA,gBAAA;E1B+iZF;E0B5iZA;;IAEE,qBAAA;E1B8iZF;E0B3iZA;IACE,0BAAA;E1B6iZF;E0B1iZA;IACE,cAAA;E1B4iZF;E0BziZA;IACD,eAAA;IACO,mBAAA;IACA,uBAAA;E1B2iZN;E0BziZA;IACE,uBAAA;E1B2iZF;E0BziZA;IACE,cAAA;IACA,gBAAA,EAAA,cAAA;E1B2iZF;E0BxiZA;IACE,aAAA;IACA,mBAAA;IACA,SAAA;E1B0iZF;E0BxiZA;IACE,eAAA;E1B0iZF;E0BxiZD;IACG,gBAAA;IACA,uBAAA;IACA,sBAAA;E1B0iZF;E0BxiZA;IACE,aAAA;E1B0iZF;AACF;A0BviZA;EACE;IACE,aAAA;E1ByiZF;E0BviZA;IACE,yBAAA;E1ByiZF;E0BviZA;IACE,yBAAA;E1ByiZF;E0BviZE;IACA,kBAAA;IACA,QAAA;IACA,gBAAA;IACA,2BAAA;IACA,aAAA;IACA,yBxBxsBY;EFivad;AACF;A0BtiZA;EACE;IACE,gBAAA;IACA,gBAAA;E1BwiZF;AACF;A2B1vaA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;A3B4vaF;;A2BzvaA;;EAEE,yBAAA;EACA,YAAA;A3B4vaF;;A2B1vaA;EACE,yBAAA;EACA,sCAAA;EACA,qCAAA;EACA,uBAAA;A3B6vaF;;A2B1vaA,cAAA;AACA;EACE,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,uDAAA;A3B6vaF;A2B3vaE;EACE,kBAAA;EACA,mBAAA;A3B6vaJ;;A2BzvaA;EACE,kBAAA;EAEA,gBAAA;EACA,8BAAA;UAAA,sBAAA;A3B2vaF;;A2BxvaA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,uEAAA,EACuD,4BAAA;A3ByvazD;A2BvvaI;EACA,yBAAA;A3ByvaJ;A2BtvaE;EACE,6BAAA;A3BwvaJ;;A2BpvaA;EACE,aAAA;A3BuvaF;;A2BrvaA;EACE,eAAA;A3BwvaF;;A2BrvaA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;A3BwvaF;;A2BrvaA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,2BAAA;A3BwvaF;A2BtvaE;EACE,cAAA;EACA,0BAAA;A3BwvaJ;;A2BrvaA;EACE,czBlFS;EyBmFT,eAAA;EACA,gBAAA;A3BwvaF;;A2BrvaA;;EAEE,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;A3BwvaF;;A2BrvaA;EACE,gBAAA;EACA,WAAA;A3BwvaF;;A2BrvaA,eAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,uDAAA;A3BwvaF;A2BvvaE;EACE,kBAAA;EACA,mBAAA;A3ByvaJ;;A2BrvaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;A3BwvaF;;A2BrvaA;EACE,eAAA;A3BwvaF;;A2BrvaA;EACE,cAAA;A3BwvaF;;A2BtvaA;EACE,cAAA;A3ByvaF;;A2BvvaA;EACE,cAAA;A3B0vaF;;A2BvvaA;EACE,aAAA;EACA,uBAAA,EAAA,yBAAA;EACA,mBAAA;EACA,QAAA,EAAA,wBAAA;EACA,eAAA;EACA,kBAAA;A3B0vaF;;A2BlvaA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;A3BqvaF;;A2BlvaA;EACE,+BAAA;A3BqvaF;;A2BlvaA;EACE,iCAAA;A3BqvaF;;A2BlvaA;EACE,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;A3BqvaF;;A2BlvaA;EACE,sBAAA;EACA,uBAAA;A3BqvaF;;A2BlvaA;EACE,sBAAA;EACA,oBAAA;A3BqvaF;;A2BlvaA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;A3BqvaF;;A2BlvaA;EACE;IACE,sBAAA;IACA,oBAAA;IACA,2BAAA;IACA,SAAA;IACA,eAAA;E3BqvaF;E2BlvaA;;IAEE,WAAA;IACA,eAAA;E3BovaF;E2BjvaA;IACE,YAAA;E3BmvaF;AACF;A4Bv8aA,oBAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACI,qGACF;A5Bw8aJ;;A4Bp8aA,WAAA;AACA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mCAAA;EACA,iBAAA;EACA,yBAAA;A5Bu8aF;;A4Bp8aA,eAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,mCAAA;EAEA,gBAAA;EACA,iBAAA;A5Bs8aF;;A4Bn8aA,cAAA;AACA;EACE,mBAAA;A5Bs8aF;;A4Bn8aA,YAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;A5Bs8aF;;A4Bn8aA,qCAAA;AACA;EACE,oCAAA,EAAA,gBAAA;EACA,4BAAA,EAAA,4BAAA;EACA,2BAAA,EAAA,2BAAA;EACA,oBAAA;EACA,qBAAA;A5Bs8aF;;A4Bn8aA,8CAAA;AACA;EACE,qCAAA,EAAA,uBAAA;A5Bs8aF;;A4Bn8aA;EACE,eAAA;EACA,eAAA;EACA,2BAAA;A5Bs8aF;;A4Bn8aA;EACE,cAAA;A5Bs8aF;;A4Bn8aA;EACE,cAAA;A5Bs8aF;;A4Bn8aA;EACE,cAAA;A5Bs8aF;;A4Bn8aA;EACE,cAAA;A5Bs8aF;;A4Bn8aA,eAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;A5Bs8aF;;A4Bn8aA,2BAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACE,yBAAA;A5Bs8aJ;;A4Bp8aA;EACE,yCAAA;EACA,WAAA;A5Bu8aF;;A4Br8aA;EACE,oCAAA;A5Bw8aF;;A4Bt8aA;EACE,cAAA;EACA,2BAAA;A5By8aF;;A4Bv8aA;EACE,sCAAA;A5B08aF;;A4Bx8aA;EACE,cAAA;A5B28aF;;A4Bz8aA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;A5B48aF;;A4B18aA;EACE,eAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;A5B68aF;;A4B38aA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A5B88aF;;A4B58aA;EACE,cAAA;A5B+8aF;;A4B58aA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iDAAA;A5B+8aF;;A4B58aA;EACE,mBAAA;EACA,cAAA;A5B+8aF;;A4B58aA;EACE,YAAA;EACA,eAAA;A5B+8aF;;A4B58aA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iDAAA;A5B+8aF;;A4B58aA;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,cAAA;A5B+8aF;;A4B58aA;EACE,mBAAA;EACA,cAAA;A5B+8aF;;A4B58aA;EACE,YAAA;EACA,eAAA;A5B+8aF;;A4B58aA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;A5B+8aF;;A4B78aA;;EAEE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;A5Bg9aF;;A4B58aA;EACE,gBAAA;A5B+8aF;;A4B58aA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;A5B+8aF;;A4B78aA,4CAAA;AACA;EACE;;IAEE,YAAA;IACA,eAAA;E5Bg9aF;E4B78aA;IACE,eAAA;E5B+8aF;AACF;A4B58aA;EACE;IACE,gBAAA;IACA,iCAAA;E5B88aF;E4B38aA;;IAEE,YAAA;IACA,eAAA;IACA,mBAAA;E5B68aF;E4B18aA;IACE,eAAA;E5B48aF;E4B18aA;IACE,0BAAA;IACA,QAAA;E5B48aF;AACF;A6BzsbA;EACE,aAAA;EACA,yBAAA;A7B2sbF;A6BzsbE;EACE,mBAAA;A7B2sbJ;A6BxsbE;EACE,mBAAA;EACA,qDAAA;EACA,yCAAA;A7B0sbJ;A6BxsbI;EACE,cAAA;A7B0sbN;A6BvsbI;EACE,cAAA;EACA,gBAAA;A7BysbN;A6BrsbE;EACE,mBAAA;EACA,kBAAA;A7BusbJ;A6BpsbE;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;A7BssbJ;A6BpsbE;;EAEE,iBAAA;A7BssbJ;A6BpsbE;EACE,WAAA;A7BssbJ;A6BlsbI;EACE,kBAAA;A7BosbN;A6BhsbE;EACE,aAAA;EACA,sBAAA;A7BksbJ;A6BhsbI;EACE,eAAA;EACA,cAAA;A7BksbN;A6B9rbE;EACE,eAAA;A7BgsbJ;A6B7rbE;EACE,eAAA;A7B+rbJ;A6B5rbE;EACE,oCAAA;A7B8rbJ;A6B3rbE;EACE,oCAAA;A7B6rbJ;A6B1rbE;EACE,oCAAA;A7B4rbJ;A6BzrbE;EACE,WAAA;A7B2rbJ;A6BxrbE;EACE,cAAA;A7B0rbJ;A6BxrbE;;EAEE,mBAAA;EACA,sBAAA;A7B0rbJ;A6BvrbE;EACE,iBAAA;EACA,eAAA;A7ByrbJ;A6BtrbE;EACE,iBAAA;EACA,eAAA;A7BwrbJ;;A6BrrbA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;A7BwrbF;;A6BrrbA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;A7BwrbF;;A6BrrbA;EACE,yBAAA;A7BwrbF;;A6BrrbA;EACE,yBAAA;A7BwrbF;;A6BrrbA;EACE,yBAAA;A7BwrbF;;A6BrrbA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;A7BwrbF;;A6BrrbA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;A7BwrbF;;A6BrrbA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;A7BwrbF;;A6BrrbA;EACE,yBAAA;A7BwrbF;;A6BrrbA;EACE,yBAAA;A7BwrbF;;A6BrrbA;EACE,yBAAA;A7BwrbF;;A6BrrbA,2BAAA;AACA;EACE,WAAA;EACA,qBAAA;A7BwrbF;;A6BrrbA;EACE;;IAEE,iBAAA;IACA,eAAA;E7BwrbF;AACF;A6BrrbA;EACE;;IAEE,gBAAA;IACA,eAAA;E7BurbF;AACF;A6BjrbE;EACE,kBAAA;EACA,kBAAA;A7BmrbJ;A6BhrbE;EACE,mBAAA;EACA,mBAAA;A7BkrbJ;A6BhrbI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;A7BkrbN;A6B9qbE;EACE,gBAAA;EACA,iBAAA;A7BgrbJ;A6B9qbI;EACE,kBAAA;EACA,eAAA;EACA,YAAA;A7BgrbN;A6B7qbI;EACE,yBAAA;A7B+qbN;A6B1qbI;EACE,mBAAA;A7B4qbN;A6B1qbM;EACE,gBAAA;EACA,WAAA;A7B4qbR;A6BzqbM;EACE,WAAA;A7B2qbR;A6BzqbQ;EACE,gBAAA;EACA,mBAAA;A7B2qbV;A6BtqbM;EACE,uBAAA;EACA,YAAA;EACA,UAAA;A7BwqbR;A6BtqbQ;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A7BwqbV;A6BtqbU;EACE,eAAA;EACA,sBAAA;A7BwqbZ;A6BtqbY;EACE,cAAA;A7Bwqbd;;A8Bl6bA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;A9Bq6bF;;A8Bl6bA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;A9Bq6bF;;A8Bl6bA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;A9Bq6bF;;A8Bl6bA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;A9Bq6bF;;A8Bl6bA;EACE,WAAA;EACA,YAAA;A9Bq6bF;;A8Bl6bA;EACE,YAAA;A9Bq6bF;;A8Bl6bA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;A9Bq6bF;;A8Bl6bA;EACE,WAAA;EACA,YAAA;EACA,cAAA;A9Bq6bF;;A8Bl6bA;EACE,mCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;A9Bq6bF;;A8Bl6bA;EACE,aAAA;A9Bq6bF;;A8Bn6bA;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;A9Bs6bF;;A8Bn6bA;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;A9Bs6bF;;A8Bn6bA;EACE,aAAA;EACA,uBAAA;A9Bs6bF;;A8Bn6bA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;A9Bs6bF;;A8Bn6bA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;A9Bs6bF;;A8Bn6bA;EACE,YAAA;A9Bs6bF;;A8Bn6bA;EACE;IACE,+BAAA;E9Bs6bF;E8Bn6bA;IACE,eAAA;E9Bq6bF;E8Bl6bA;IACE,eAAA;E9Bo6bF;AACF;A+BzhcA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oC7B8MY;E6B7MZ,gBAAA;EACA,yCAAA;A/B2hcF;;A+BxhcA;EACE,cAAA;A/B2hcF;;A+BxhcA;EACE,oBAAA;A/B2hcF;;AA9gcA;EACE,qBAAA;EACA,oCAAA,EAAA,YAAA;AAihcF;AA/gcE;EACE,UAAA;AAihcJ;AA9gcE;EACE,uBAAA,EAAA,wCAAA;AAghcJ;AA7gcE;EACE,yBEzCmB,EFyCsB,eAAA;EACzC,kBEkKQ;AF62bZ;AA5gcE;EACE,yBE9CmB,EF8CsB,oBAAA;AA8gc7C;;AA1gcA;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AA6gcF;;AA1gcA;EACE,oCAAA;AA6gcF;;AA1gcA;EACE,0BAAA;AA6gcF;;AA1gcA;EACE,4BAAA;EACA,uBAAA;AA6gcF;;AA3gcA;EACE,cEvDa;AFqkcf;;AA3gcA;EACE,aAAA;AA8gcF;;AA3gcA;EACE,cEhEW;EFiEX,oCEkIY;EFjIZ,eEmIa;EFlIb,YAAA;EACA,gBEqImB;EFpInB,iBAAA;EACA,aAAA;EACA,iBAAA;AA8gcF;;AA3gcA;EACE,YAAA;EACA,iBAAA;AA8gcF;;AA3gcA;EACE,iBAAA;EACA,cEnFa;EFoFb,oCEiHY;EFhHZ,eEkHa;EFjHb,kBAAA;EACA,gBEqHqB;EFpHrB,iBAAA;AA8gcF;;AA3gcA;EACE,iBAAA;EACA,gCAAA;EACA,cE7Fe;EF8Ff,kBAAA;EACA,oCEqGY;EFpGZ,eEsGa;EFrGb,kBAAA;EACA,gBEwGmB;EFvGnB,iBAAA;AA8gcF;;AA3gcA;EACE,eAAA;EACA,QAAA;EACA,WAAA;AA8gcF;;AA3gcA;EACE,YAAA;AA8gcF;;AA3gcA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AA8gcF;;AA3gcA;EACE,eAAA;EACA,gBAAA;AA8gcF;;AA3gcA;EACE,cE7He;EF8Hf,oCEsEY;EFrEZ,eEuEa;EFtEb,kBAAA;EACA,gBE0EqB;EFzErB,iBAAA;EACA,iBAAA;AA8gcF;;AA3gcA;EACE,cEtIW;EFuIX,oCE4DY;EF3DZ,eE6Da;EF5Db,kBAAA;EACA,gBE+DmB;AF+8brB;;AA3gcA,wCAAA;AAEA;EACE;IACE,sBAAA;EA6gcF;AACF;AAzgcA;EACE,yBAAA;AA2gcF;;AAxgcA;EACE,sBAAA;EACA,qBAAA;AA2gcF;;AAxgcA;EACE,sBAAA;AA2gcF;;AAxgcA;EACE,kCAAA;AA2gcF;;AAxgcA;;EAEE,eE4Ba;EF3Bb,uBAAA;EACA,eAAA;EACA,kBAAA;AA2gcF;;AAxgcA;EACE,qBAAA;AA2gcF;;AAxgcA;EACE,kCAAA;AA2gcF;;AAxgcA;EACE,YAAA;EACA,yBEhMM;EFiMN,oBAAA;AA2gcF;;AAxgcA,4EAAA;AACA;EACE,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,2BAAA;AA2gcF;;AAzgcA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,4CAAA;EACA,kBEhBU;EFiBV,aAAA;EACA,mBAAA;EACA,eETa;EFUb,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mDAAA;AA4gcF;;AAzgcA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBEhCU;EFiCV,aAAA;EACA,mBAAA;EACA,eEzBa;EF0Bb,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mDAAA;EACA,0BAAA;AA4gcF;;AAzgcA;EACE;IACE,eAAA;IACA,8BAAA;IACA,kBAAA;IACA,6BAAA;EA4gcF;AACF;AAzgcA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACC,oBAAA;AA2gcH;;AAvgcA;EACE,yBAAA;EACA,oCAAA;EACA,2CAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;AA0gcF;;AAvgcA;EACE,yBAAA;EACA,mBAAA;AA0gcF;;AAvgcA;EACE,eEhEa;EFiEb,cE1Qa;AFoxcf;;AAvgcA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eEzEa;EF0Eb,cElRa;EFmRb,qDAAA;AA0gcF;;AAvgcA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AA0gcF;;AAvgcA;EACE,yBAAA;EACA,qCAAA;EACA,mBAAA;EACA,uCAAA;AA0gcF;;AAvgcA;;;EAGE,iBAAA;EACA,2CAAA;AA0gcF;;AAvgcA;EACE,yBE5RQ;EF6RR,cEzSa;EF0Sb,gBAAA;AA0gcF;;AAvgcA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AA0gcF;;AAvgcA;EACE,UAAA;EACA,QAAA;EACA,SAAA;AA0gcF;;AAvgcA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBEjUW;EFkUX,gBAAA;EACA,mBEpIU;EFqIV,eAAA;EACA,WAAA;EACA,YAAA;AA0gcF;;AAvgcA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,yBEvVM;EFwVN,gBAAA;EACA,kBElJa;AF4pcf;;AAvgcA;EACE,yBEnWS;AF62cX;;AAvgcA;EACE,2BAAA;AA0gcF;;AAvgcA;EACE,YAAA;EACA,oCE5JY;EF6JZ,gBEtJqB;EFuJrB,cEnWa;EFoWb,eE7Ja;EF8Jb,gBAAA;AA0gcF;;AAxgcA;EACE,oCAAA;EACA,yBAAA;EACA,oCErKY;EFsKZ,oCAAA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,WAAA;AA2gcF;;AAzgcA;EACE,kBAAA;EACA,eEhLa;EFiLb,kBAAA;EACA,mBAAA;AA4gcF;;AA1gcA;EACE,eErLa;EFsLb,kBAAA;AA6gcF;;AA3gcA;EACE,cE/Xe;EFgYf,oCE5LY;EF6LZ,eE3La;EF4Lb,gBExLmB;EFyLnB,mBAAA;AA8gcF;;AA3gcA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,QAAA;AA8gcF;;AA3gcA;EACE,aAAA;EACA,sBAAA;AA8gcF;;AA5gcA;EACE,cElZW;EFmZX,eE/Ma;EFgNb,gBE3MmB;EF4MnB,oCElNY;EFmNZ,oBAAA;AA+gcF;;AA5gcA;EACE,UAAA;AA+gcF;;AA5gcA;EACE,WAAA;EACA,cAAA;EACA,yBEvaM;EFwaN,6BAAA;EACA,gCAAA;EACA,mBAAA;AA+gcF;;AA5gcA;EACE,yBAAA;EACA,eEpOa;EFqOb,gBE/NqB;EFgOrB,cE1aW;EF2aX,kBAAA;EACA,0BAAA;AA+gcF;;AA5gcA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,qBAAA;AA+gcF;;AA5gcA;EACE,aAAA;AA+gcF;;AA5gcA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,cEpca;EFqcb,eE7Pa;EF8Pb,gBE3PmB;EF4PnB,oCElQY;EFmQZ,mBE7cM;AF49cR;;AA5gcA;EACE,cE3ce;AF09cjB;;AA5gcA,iEAAA;AACA;EACE,gBAAA;EACA,gBAAA;AA+gcF;;AA5gcA,8BAAA;AACA;EACE,aAAA;EACA,sBAAA;EAEA,YAAA;AA8gcF;;AA3gcA;EACE,YAAA;EACA,gBAAA;AA8gcF;;AA3gcA;EACE,gBAAA;AA8gcF;;AA5gcA;EACE,0CEnfoB;EFofpB,iBAAA;EACA,kBAAA;EACA,eElSa;EFmSb,gBE9RqB;EF+RrB,cE3ea;AF0/cf;;AA5gcA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;AA+gcF;;AA5gcA;EACE,qBAAA;EACA,yBAAA;EACA,0BExgBoB;EFygBpB,kBExTa;EFyTb,WAAA;EACA,YAAA;EACA,0CAAA;AA+gcF;;AA5gcA;EACE;IACE,uBAAA;EA+gcF;EA7gcA;IACE,yBAAA;EA+gcF;AACF;AA5gcA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA8gcF;;AA3gcA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBE3hBiB;EF4hBjB,aAAA;EACA,sBAAA;AA8gcF;AA5gcE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cE7hBW;EF8hBX,mBAAA;AA8gcJ;AA5gcI;EACE,uBAAA;EACA,YAAA;EACA,cEniBS;EFoiBT,eE7VS;EF8VT,eAAA;AA8gcN;AA1gcE;EACE,YAAA;EACA,YAAA;EACA,WAAA;AA4gcJ;AAzgcE;EACE,0CEhkBkB;EFikBlB,sCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBExXQ;EFyXR,aAAA;EACA,mBAAA;EACA,eElXW;EFmXX,WAAA;AA2gcJ;AAzgcI;EACE,WAAA;EACA,YAAA;EACA,yBE/kBgB;EFglBhB,kBE/XS;AF04cf;AAvgcE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAygcJ;AAvgcI;EACE,eAAA;EACA,yBAAA;EACA,kBE9YM;AFu5cZ;AArgcE;EACE,yBErlBe;EFslBf,yBAAA;EACA,mBEpZQ;EFqZR,aAAA;AAugcJ;AArgcI;EACE,cExlBS;EFylBT,mBAAA;AAugcN;AApgcI;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAsgcN;AApgcM;EACE,eAAA;EACA,yBAAA;EACA,kBEraI;EFsaJ,eE7ZO;AFm6cf;;AAhgcA;EACE,eAAA;EACA,MAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAmgcF;;AAhgcA;EACE,iBAAA;EACA,gBAAA;EACA,mBEhoBM;EFioBN,kBE7bU;EF8bV,aAAA;EACA,gBAAA;EACA,yCEldU;EFmdV,aAAA;EAEA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAKA,aAAA;AA8/bF;;AA3/bA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA8/bF;;AA3/bA;EACE,uBAAA;EACA,YAAA;EACA,eE9ca;EF+cb,eAAA;EACA,cEzpBe;EF0pBf,sBAAA;AA8/bF;;AA3/bA;EACE,cEnpBO;AFipdT;;AA1/bA;EACE,wBAAA;EACA,kCAAA,EAAA,yBAAA;EACA,8BAAA,EAAA,uBAAA;EACA,WAAA;EACA,YAAA;AA6/bF;;AA1/bA;EACE,gBAAA;AA6/bF;;AA1/bA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA6/bF;;AA1/bA;EACE,cEtrBa;EFurBb,gBE3eqB;AFw+cvB;;AA1/bA;EACE,cE3rBa;EF4rBb,eAAA;AA6/bF;;AA1/bA;EACE,aAAA;EAEA,oCE7fY;EF8fZ,cEnsBa;AF+rdf;;AAz/bA;EACE,qBAAA;EACA,yBAAA;EACA,kBE1gBU;AFsgdZ;;AAz/bA;EACE,0CE1tBoB;EF2tBpB,cE9sBa;EF+sBb,wBAAA;EACA,kBE9gBa;EF+gBb,eEzgBa;AFqgdf;;AA1/bA;EACE,2CAAA;EACA,aAAA;EACA,kBAAA;EACA,mBEvhBU;EFwhBV,eAAA;AA6/bF;;AA3/bA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AA8/bF;;AA3/bA;EACE,aAAA;EACA,oCE9hBY;EF+hBZ,cEpuBa;AFkudf;;AA3/bA;EACE,gBAAA;AA8/bF;;AA3/bA;EACE,oBAAA;EACA,yBAAA;EACA,kBE/iBU;EFgjBV,yBEpvBM;EFqvBN,eExiBa;EFyiBb,cEjvBa;AF+udf;;AA3/bA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AA8/bF;;AA3/bA,gCAAA;AACA;EACE,wBAAA;AA8/bF;;AA1/bA;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;AA6/bF;;AAz/bA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA4/bF;;AAz/bA;EACE,YAAA;EACA,eAAA;AA4/bF;;AA1/bA;EACE,iBAAA;AA6/bF;;AA1/bA;EACE,gBAAA;EACA,yBAAA;AA6/bF;;AA1/bA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AA6/bF;;AA1/bA,qDAAA;AACA,YAAA;AACA;EACE,yBEtzBc;EFwzBd,YAAA;EACA,aAAA;AA4/bF;;AAz/bA;EACE,yBE7zBc;EF8zBd,cE3yBa;AFuydf;;AAx/bA,YAAA;AACA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AA2/bF;;AAx/bA,yBAAA;AACA;EACE,cExzBa;AFmzdf;;AAx/bA;EACE,WAAA;EACA,YAAA;EACA,0BAAA;AA2/bF;;AAx/bA;EACE,eAAA;EACA,eE5nBa;EF6nBb,eAAA;AA2/bF;;AAx/bA;EACE,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,yBEl0BO;EFm0BP,cE50Ba;EF60Bb,kBE9oBa;EF+oBb,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eE/oBa;AF0odf;;AAx/bA;EACE,eEhpBa;EFipBb,eAAA;AA2/bF;;AAx/bA,oBAAA;AACA;EACE,YAAA;AA2/bF;;AAx/bA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AA2/bF;;AAx/bA,sCAAA;AACA;EACE,iBAAA;EACA,0CEz3BoB;AFo3dtB;;AAx/bA;EACE,mBAAA;AA2/bF;;AAz/bA;EACE,eE5qBa;EF6qBb,cEl3BW;EFm3BX,kBAAA;EACA,oBAAA;AA4/bF;;AA1/bA;EACE,aAAA;EAEA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA4/bF;;AAz/bA;EACE,eE1rBa;EF2rBb,cEh4BW;AF43db;;AA1/bA;EACE,eE7rBa;EF8rBX,oCEjsBU;EFksBZ,cEt4Be;EFu4Bf,gBE5rBqB;EF6rBrB,cAAA;EACA,mBAAA;AA6/bF;;AA3/bA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA8/bF;;AA3/bA;EACE,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eEhtBa;AF8sdf;;AA5/bA;EACE,eAAA;EACA,yBAAA;EACA,uBAAA;AA+/bF;;AA7/bA;EACE,kBAAA;EACA,kBAAA;EACA,cE/5BW;AF+5db;;AA7/bA;EACE,gBAAA;EACA,mBAAA;AAggcF;;AA7/bA;EACE,gBAAA;EACA,cAAA;AAggcF;;AA7/bA,oCAAA;AACA,eAAA;AACA;EACE,6BAAA;EACA,qBAAA;AAggcF;;AA7/bA,0BAAA;AACA;;EAEE,aEv7Be;EFw7Bf,eElvBa;EFmvBX,gBE9uBmB;EF+uBrB,kBAAA;AAggcF;;AA7/bA;;EAEE,aE/7Be;EFg8Bf,eEzvBa;AFyvdf;;AA7/bA;EACI,cEr8BW;EFs8BX,eE5vBW;EF6vBX,gBE3vBmB;EF4vBnB,oCEnwBU;EFowBV,yBAAA;EACA,iBAAA;AAggcJ;;AA9/bA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AAigcF;;AA//bA;EACE,YAAA;EACA,YAAA;AAkgcF;;AAhgcA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AAmgcF;;AAjgcA;EACI,SAAA;EACA,mBE/9Be;EFg+Bf,kBE9xBQ;EF+xBR,iBAAA;EACA,eEvxBW;EFwxBX,oCE3xBU;EF4xBV,cEj+BW;EFk+BX,gBEvxBiB;EFwxBjB,gBAAA;EACA,kDAAA;EACA,gBAAA;AAogcJ;;AAjgcA;EACE,gBE7xBqB;AFiydvB;;AAlgcA;EACE,WAAA;EACA,kBAAA;AAqgcF;;AAlgcA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAqgcF;;AAlgcA;EACE,WAAA;EACA,eAAA;AAqgcF","sourcesContent":["@import \"../src/styles/typography.scss\";\n@import \"../src/styles/statCard\";\n@import \"../src/styles/variables\";\n@import \"../src/styles/Controls\";\n@import \"../src/styles/Tables.scss\";\n@import \"../src/layouts/SourceConnector/ConnectedSources.scss\";\n@import \"../src/styles/message-styles.scss\";\n@import \"../src/layouts/AdminPortal/AdminPortal.scss\";\n@import \"../src/layouts/Authentication/Auth.scss\";\n@import \"../src/styles/PrivacyPolicy.scss\";\n@import \"../src/styles/_ui-elements\";\n@import \"../src/layouts/AskDatatram/Chatbot.scss\";\n@import \"../src/layouts/HomePage/SidebarManagement/Sidebar.scss\";\n@import \"../src/styles/media-utils.scss\";\n@import \"../src/layouts/AdminPortal/Subscriptions/billing-ui.scss\";\n@import \"../src/layouts/AdminPortal/Subscriptions/invoice.scss\";\n@import \"../src/styles/Dashboard.scss\";\n@import \"../src/layouts/Engagements/Campaigns/Campaign.scss\";\n@import \"../src/layouts//UserManagement/UserManagement.scss\";\n@import \"../src/styles/Button.scss\";\n@import \"../src/styles/sequences.scss\";\n@import \"../src/layouts/MyAccount/Notifications/Notifications.scss\";\n@import \"../src/layouts/AdminPortal/AnnouncementsPage/Announcements.scss\";\n@import \"../src/styles/DropDownStyle.scss\";\n@import \"../src/styles/InputStyle.scss\";\n@import \"../src/styles/responsivePages.scss\";\n@import \"../src/layouts/MyAccount/Settings/AccountSettings.scss\";\n@import \"../src/components/reusable/ReusableTable/ReusableTable.scss\";\n@import \"../src/layouts/AdminPortal/UsageLimits/TenantUsageMonitor.scss\";\n@import \"../src/components/reusable/ErrorFallback/ErrorFallback.scss\";\n@import \"../src/components/reusable/StyledTooltip/StyledTooltip.scss\";\n\n.ant-menu {\n  scrollbar-width: thin;\n  scrollbar-color: $brand-primary-strong transparent; /* Firefox */\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent; /* Optional: light gray or transparent */\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: $brand-primary-strong; /* Blue thumb */\n    border-radius: $radius-sm;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: $brand-primary-strong; /* Darker on hover */\n  }\n}\n\n.dt {\n  text-align: center;\n  margin-top: 20px;\n  justify-content: center;\n  margin-inline-start: 18px;\n  cursor: pointer;\n  margin: \"5px auto\";\n}\n\n.layout-sub-menu ul {\n  background-color: $white !important;\n}\n\n.layout-sub-menu li {\n  font-size: $font-size-xs !important;\n}\n\n.vertical-submenu {\n  line-height: 10px !important;\n  height: 20px !important;\n}\n.left-menu {\n  color: $text-inverse;\n}\n\n.ant-tooltip {\n  display: none;\n}\n\nul {\n  color: $text-muted;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  padding: 5px;\n  font-weight: $font-weight-normal;\n  line-height: 16px;\n  /* 133.333% */\n  text-align: start;\n}\n\nli {\n  padding: 5px;\n  text-align: start;\n}\n\n.fentry {\n  text-align: start;\n  color: $text-primary;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  font-style: normal;\n  font-weight: $font-weight-semibold;\n  line-height: 20px;\n}\n\ntd {\n  text-align: start;\n  border-bottom: 1px solid $border-light;\n  color: $text-secondary;\n  text-align: center;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: 20px;\n}\n\n.image {\n  flex-basis: 70%;\n  order: 2;\n  float: left;\n}\n\n[dir=\"rtl\"] .image {\n  float: right;\n}\n\n.imagestyle {\n  width: 60.545px;\n  height: 63.548px;\n  margin-top: -75px;\n  margin-inline-end: -50px;\n}\n\n.premium {\n  width: 78.545px;\n  height: 58.548px;\n}\n\n.pc {\n  color: $text-secondary;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  font-style: normal;\n  font-weight: $font-weight-semibold;\n  line-height: 20px;\n  padding-top: 20px;\n}\n\n.pcr {\n  color: $text-muted;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  font-style: normal;\n  font-weight: $font-weight-normal;\n}\n\n/*******************magic screen********/\n\n@media (max-width: 480px) {\n  div.ant-progress.ant-progress-status-active.ant-progress-line.ant-progress-line-align-end.ant-progress-line-position-outer.ant-progress-show-info.ant-progress-default.custom-progress.css-dev-only-do-not-override-vryruh {\n    width: 100% !important;\n  }\n}\n\n//UNSURE THE ONES BELOW\n.app {\n  padding-inline-start: 0px;\n}\n\n.ant-switch {\n  width: 35px !important;\n  padding: 0 !important;\n}\n\n.ant-switch-checked {\n  width: 35px !important;\n}\n\n.p-checkbox-input {\n  margin-inline-end: 0.5% !important;\n}\n\ndiv.p-multiselect-label.p-placeholder,\ndiv.p-multiselect-label {\n  font-size: $font-size-sm;\n  margin-inline-start: 2%;\n  padding-top: 1%;\n  padding-bottom: 1%;\n}\n\ndiv.p-multiselect-checkbox {\n  margin-inline-end: 2%;\n}\n\ninput.p-checkbox-input {\n  margin-inline-start: 2% !important;\n}\n\ndiv.p-multiselect-header {\n  margin: 10px;\n  background-color: $white;\n  margin-bottom: -10px;\n}\n\n/**************************** Contact No. Field ****************************/\n.PhoneInputInput {\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n.input-fields-acc-setting {\n  border: 1px solid $border-default;\n  width: 100%;\n  /* Flexible width */\n  max-width: 389px;\n  /* Limits the size */\n  padding: 12px 10px;\n  /* Adjust spacing to indirectly set height */\n  border-radius: $radius-sm;\n  display: flex;\n  align-items: center;\n  font-size: $font-size-md;\n  /* Scalable font size */\n  margin-bottom: 22px;\n  box-sizing: border-box;\n  /* Ensures padding doesnâ€™t affect overall width */\n}\n\n.contact-field {\n  border: 1px solid $border-default;\n  width: 100%;\n  /* Flexible width */\n  max-width: 389px;\n  /* Limits the size */\n  border-radius: $radius-sm;\n  display: flex;\n  align-items: center;\n  font-size: $font-size-md;\n  /* Scalable font size */\n  margin-bottom: 22px;\n  box-sizing: border-box;\n  /* Ensures padding doesnâ€™t affect overall width */\n  padding-inline-start: 15px;\n}\n\n@media (max-width: 768px) {\n  .input-fields-acc-setting {\n    max-width: 100%;\n    /* Adapts to smaller screens */\n    padding: 12px 10px;\n    /* Slightly smaller padding */\n  }\n}\n\n.confirmation-modal-footer {\n  display: flex;\n  justify-content: first baseline;\n  gap: 20px;\n   justify-content: end;\n\n}\n\n.highlight {\n  border: 3px solid $success;\n  /* Temporarily set a visible color */\n  box-shadow: 0 0 10px rgba($success, 0.5);\n  background-color: rgba($success, 0.2);\n  width: 70px;\n  height: 60px;\n}\n\n.confirmation-modal-content {\n  margin-inline-start: 55px;\n  margin-bottom: 35px;\n}\n\n.popup-msg-content {\n  font-size: $font-size-lg;\n  color: $text-primary;\n}\n\n.confirmation-modal-body {\n  margin-top: 30px;\n  margin-bottom: 25px;\n  display: block;\n  font-size: $font-size-md;\n  color: $text-primary;\n  /* Ensure margins apply properly to inline elements */\n}\n\n.confirmation-modal-header {\n  display: flex;\n  gap: 18px;\n  align-items: center;\n}\n\n.confirmation-modal-wrapper {\n  margin-inline-start: 20px;\n  /* Adjust the left margin as needed */\n  margin-bottom: 15px;\n  /* Adjust the bottom margin as needed */\n}\n\n.confirmation-modal-header,\n.confirmation-modal-body,\n.confirmation-modal-footer {\n  text-align: start;\n  /* Optional: Align inner content properly */\n}\n\n.create-connection-loading {\n  background-color: $success;\n  color: $text-inverse;\n  min-height: 50px;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: $text-muted; \n  transition: 0.4s;\n  border-radius: $radius-xl;\n  margin-top: 2px;\n  width: 40px;\n  height: 21px;\n}\n\n.slider::before {\n  content: \"\";\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  top: 2px;\n  background-color: $white;\n  transition: 0.4s;\n  border-radius: $radius-round;\n}\n\ninput:checked + .slider {\n  background-color: $blue-400;\n}\n\ninput:checked + .slider::before {\n  transform: translateX(20px);\n}\n\n.category-title {\n  flex-grow: 1;\n  font-family: $font-family;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  font-size: $font-size-sm;\n  margin-top: 10px;\n}\n.custom-google-button {\n  background-color: $white !important;\n  color: $text-primary !important;\n  font-family: $font-family;\n  border: 1px solid $brand-primary-hover !important;\n  border-radius: $radius-sm !important;\n  padding: 10px 20px !important;\n  font-size: $font-size-md !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 100%;\n}\n.signup-page-text {\n  text-align: center;\n  font-size: $font-size-sm;\n  margin-top: 0.5rem;\n  margin-bottom: 10px;\n}\n.forgot-password-txt {\n  font-size: $font-size-sm;\n  margin-top: 0.5rem;\n}\n.category-description {\n  color: $text-secondary;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  font-weight: $font-weight-normal;\n  margin-bottom: 15px;\n}\n\n.category-info {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin-inline-start: 15px;\n  gap: 2px;\n}\n\n.activity-details {\n  display: flex;\n  flex-direction: column;\n}\n.activity-description {\n  color: $text-muted;\n  font-size: $font-size-xs;\n  font-weight: $font-weight-normal;\n  font-family: $font-family;\n  margin-bottom: -10px;\n}\n\n.activity-col {\n  width: 50%;\n}\n\n.compact-suggestions-container {\n  width: 100%;\n  padding: 8px 0;\n  background-color: $white;\n  border-top: 1px solid $border-light;\n  border-bottom: 1px solid $border-light;\n  margin-bottom: 10px;\n}\n\n.compact-suggestions-header {\n  text-transform: uppercase;\n  font-size: $font-size-xs;\n  font-weight: $font-weight-semibold;\n  color: $text-muted;\n  margin-bottom: 8px;\n  padding-inline-start: 12px;\n}\n\n.compact-suggestions-scroll {\n  display: flex;\n  overflow-x: auto;\n  padding: 0 12px;\n  padding-bottom: 4px;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.compact-suggestions-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.compact-input-area input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 8px 0;\n  color: $text-primary;\n  font-size: $font-size-md;\n  font-weight: $font-weight-normal;\n  font-family: $font-family;\n  background: $white;\n}\n\n.compact-input-area input::placeholder {\n  color: $text-secondary;\n}\n\n/* Ensure chat container has sufficient height but not too tall */\n.conversation-area {\n  max-height: 50vh;\n  overflow-y: auto;\n}\n\n/* Add this to your CSS file */\n.without-suggestions {\n  display: flex;\n  flex-direction: column;\n // justify-content: space-between;\n  height: 100%;\n}\n\n.conversation-area {\n  flex-grow: 1;\n  overflow-y: auto;\n}\n\n.compact-input-area {\n  margin-top: auto;\n}\n.p-multiselect-token {\n  background-color: $brand-primary-light;\n  padding-left: 8px;\n  padding-right: 8px;\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n}\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 200px); \n  width: 100%;\n}\n\n.donut-spinner {\n  display: inline-block;\n  border: 4px solid $border-light;\n  border-left-color: $brand-primary-hover;\n  border-radius: $radius-round;\n  width: 50px;\n  height: 50px;\n  animation: donut-spin 1.2s linear infinite;\n}\n\n@keyframes donut-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loader-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.email-editor-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  width: 100vw;\n  height: 100vh;\n  background: $background-light;\n  display: flex;\n  flex-direction: column;\n\n  .editor-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: $text-inverse;\n    margin-bottom: 1rem;\n\n    button {\n      background: transparent;\n      border: none;\n      color: $text-inverse;\n      font-size: $font-size-xl;\n      cursor: pointer;\n    }\n  }\n\n  iframe {\n    flex-grow: 1;\n    border: none;\n    width: 100%;\n  }\n\n  .summary-box {\n    background-color: $brand-primary-light;\n    border-inline-start: 5px solid $brand-primary-hover;\n    padding: 0.5rem;\n    margin-bottom: 0.8rem;\n    border-radius: $radius-md;\n    display: flex;\n    align-items: center;\n    font-size: $font-size-md;\n    gap: 0.5rem;\n\n    .icon-info {\n      width: 18px;\n      height: 18px;\n      background-color: $brand-primary-hover;\n      border-radius: $radius-round;\n    }\n  }\n\n  .filters {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    select {\n      padding: 0.5rem;\n      border: 1px solid $border-default;\n      border-radius: $radius-md;\n    }\n  }\n\n  .performance-section {\n    background-color: $background-light;\n    border: 1px solid $border-default;\n    border-radius: $radius-lg;\n    padding: 1rem;\n\n    h3 {\n      color: $text-primary;\n      margin-bottom: 1rem;\n    }\n\n    .chart-filters {\n      display: flex;\n      gap: 1rem;\n      margin-bottom: 0.5rem;\n\n      select {\n        padding: 0.5rem;\n        border: 1px solid $border-default;\n        border-radius: $radius-md;\n        font-size: $font-size-md;\n      }\n    }\n  }\n}\n\n.email-editor-overlay {\n  position: fixed;\n  top: 0;\n  inset-inline-start: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba($text-primary, 0.55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.email-editor-modal {\n  max-width: 1000px;\n  max-height: 85vh;\n  background: $white;\n  border-radius: $radius-md;\n  display: flex;\n  overflow: hidden;\n  box-shadow: $shadow-lg;\n  padding: 10px;\n\n  position: fixed;\n  top: 50%; \n  left: 50%; \n  transform: translate(\n    -50%,\n    -50%\n  ); \n\n  display: flex; \n}\n\n.email-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.email-editor-close {\n  background: transparent;\n  border: none;\n  font-size: $font-size-xl;\n  cursor: pointer;\n  color: $text-secondary;\n  transition: color 0.2s;\n}\n\n.email-editor-close:hover {\n  color: $danger;\n}\n\n\n.recharts-wrapper > .recharts-surface {\n  display: flex !important;\n  justify-content: center !important; /* Centers horizontally */\n  align-items: center !important; /* Centers vertically */\n  width: 100%;\n  height: 100%;\n}\n\n.legend {\n  margin-top: 1rem;\n}\n\n.legend-item {\n  margin-bottom: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.subscriber-count {\n  color: $text-primary;\n  font-weight: $font-weight-semibold;\n}\n\n.clickable {\n  color: $text-primary;\n  cursor: pointer;\n}\n\n.create-segment-container {\n  padding: 10px;\n\n  font-family: $font-family;\n  color: $text-primary;\n}\n\n.input {\n  padding: 0.75rem 1rem;\n  border: 1px solid $border-default;\n  border-radius: $radius-md;\n}\n\n.tag {\n  background-color: $brand-primary-light;\n  color: $text-primary;\n  padding: 0.25rem 0.75rem;\n  border-radius: $radius-round;\n  font-size: $font-size-md;\n}\n.upload-area {\n  border: 2px dashed $brand-primary-light;\n  padding: 2rem;\n  text-align: center;\n  border-radius: $radius-lg;\n  cursor: pointer;\n}\n.upload-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.import-contacts-container {\n  padding: 40px;\n  font-family: $font-family;\n  color: $text-primary;\n}\n\n.metric-selection {\n  min-width: 350px;\n}\n\nselect {\n  padding: 0.5rem 1rem;\n  border: 1px solid $border-default;\n  border-radius: $radius-md;\n  background-color: $white;\n  font-size: $font-size-md;\n  color: $text-primary;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n/* Hide popup menus completely */\n.ant-menu-submenu-popup {\n  display: none !important;\n}\n\n//************************************SCROLLBAR ON SIDEBAR ****************************/\n.sidebar-scroll-container {\n  height: 100vh;\n  overflow-y: auto;\n  padding-inline-end: 8px;\n}\n\n// ******************************Settings**********************************/\n.admin-header-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.admin-search-input {\n  width: 200px;\n  margin-top: 8px;\n}\n.tabs-container {\n  margin-top: -30px;\n}\n\n.role-permission-heading {\n  margin-top: 20px;\n  margin-inline-start: -1px;\n}\n\n.audit-log-heading {\n  display: block;\n  text-align: center;\n  font-weight: bold;\n}\n\n/********************admin layout *******************/\n/* Sidebar */\n.sidebar {\n  background-color: $brand-primary;\n  //position: fixed;\n  height: 100%;\n  z-index: 1000;\n}\n\n.sidebar-menu {\n  background-color: $brand-primary;\n  color: $text-inverse;\n}\n\n\n/* Divider */\n.sidebar-divider {\n  margin: 11px auto;\n  height: 1px;\n  opacity: 0.3;\n}\n\n/* Menu item text color */\n.sidebar-menu-item {\n  color: $text-inverse;\n}\n\n.menu-heading-wrapper img {\n  width: 25px;\n  height: 25px;\n  margin-inline-start: -20px;\n}\n\n.bell-icon {\n  cursor: pointer;\n  font-size: $font-size-xl;\n  margin-top: 8px;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 3px;\n  inset-inline-end: 73px;\n  background-color: $danger;\n  color: $text-inverse;\n  border-radius: $radius-round;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: $font-size-sm;\n}\n\n.avatar-icon-dashboard .anticon {\n  font-size: $font-size-xl;\n  margin-top: 8px;\n}\n\n/* Content padding */\n.layout-content-wrapper {\n  padding: 4px;\n}\n\n.layout-content {\n  padding: 10px;\n  min-height: 86vh;\n  overflow: hidden;\n}\n\n/************activity log*************/\n.card-style {\n  margin-bottom: 24;\n  background-color: $brand-primary-light;\n}\n\n.anticon-user {\n  padding-bottom: 8px;\n}\n.notifications-no-today {\n  font-size: $font-size-sm;\n  color: $text-muted;\n  text-align: center;\n  margin-bottom: -30px;\n}\n.upload-container {\n  display: flex;\n  //justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  margin-bottom: 10px;\n}\n\n.Info-text span {\n  font-size: $font-size-sm;\n  color: $text-muted;\n}\n.finishline{\n  font-size: $font-size-md;\n    font-family: $font-family;\n  color: $text-secondary;\n  font-weight: $font-weight-semibold;\n  display: block;\n  margin-bottom: 10px;\n}\n.tags-container {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.tag-item {\n  background: rgba(44, 104, 173, 0.18);\n  padding: 2px 8px;\n  border-radius: 8px;\n  border: 1px solid rgba(44, 104, 173, 1);\n  font-size: $font-size-sm;\n}\n.audience-actionbuttons{\n  cursor: pointer;\n  color: $brand-primary !important ;\n  margin-inline-end: 10px;\n}\n.no-data-container {\n  text-align: center;\n  padding: 40px 20px;\n  color: $text-muted;\n}\n\n.no-data-image {\n  max-width: 280px;\n  margin-bottom: 20px;\n}\n\n.no-data-text {\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n/*********barcharts styles**********/\n/* Grid Lines */\n.bar-chart-grid {\n  stroke: rgba($text-primary, 0.2);\n  stroke-dasharray: 3 3;\n}\n\n/* X & Y Axis Tick Style */\n.bar-chart-xaxis .recharts-cartesian-axis-tick-value,\n.bar-chart-yaxis .recharts-cartesian-axis-tick-value {\n  fill: $text-secondary;\n  font-size: $font-size-sm;\n    font-weight: $font-weight-semibold;\n  text-align: center;\n}\n\n.bar-chart-xaxis .recharts-cartesian-axis-label,\n.bar-chart-yaxis .recharts-cartesian-axis-label {\n  fill: $text-secondary;\n  font-size: $font-size-md;\n\n}\n.review-summary-heading {\n    color: $text-primary;\n    font-size: $font-size-xl;\n    font-weight: $font-weight-semibold;\n    font-family: $font-family;\n    margin-inline-start: 10px;\n    margin-top: -20px;\n}\n.google-ads-sign-in{\n  width:20px;\n  height:20px;\n  margin-inline-end: 10px;\n}\n.logo-fb{\n  width:150px;\n  height:50px;\n}\n.signup-google-logo{\n  width: 18px;\n  height: 18px;\n  margin-inline-end: 10px;\n}\n.info-banner-audience {\n    flex: 1 1;\n    background: $background-light;\n    border-radius: $radius-md;\n    padding: 3px 16px;\n    font-size: $font-size-md;\n    font-family: $font-family;\n    color: $text-primary;\n    font-weight: $font-weight-normal;\n    line-height: 1.4;\n    box-shadow: inset 0 1px 2px rgba($text-primary, 0.05);\n    margin-top: 10px;\n}\n\n.info-banner-audience strong {\n  font-weight: $font-weight-semibold;\n}\n.tableau-scroll-wrapper {\n  width: 100%;\n  overflow-x: hidden; \n}\n\n.tableau-center {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.tableau-scroll-inner {\n  width: 100%; \n  max-width: 100%;\n}\n","@import \"./variables\";\n\n.heading-primary {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-bold;\n  color: $text-primary;\n  line-height: 1.2;\n  margin-bottom: 0.5rem;\n}\n// subheadings\n.heading-secondary {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-bold;\n  color: $text-primary;\n  line-height: 1.2;\n  margin-bottom: 0.2rem;\n}\n// field labels\n.field-labels {\n  font-size: $font-size-lg;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  line-height: 1.2;\n  margin-bottom: 0.3rem;\n}\n\n\n// headings\nbody {\n  font-family: $font-family;\n  background-color: $background-light;\n  color: $text-primary;\n}\n\n.mainheading {\n  margin-top: 2rem;\n  text-align: left;\n  margin-left: 0.1rem;\n  /* Using rem for better responsiveness */\n  color: $text-primary;\n  font-weight: $font-weight-bold;\n  font-size: $font-size-xl;\n}\n\n.mainheading3 {\n  ///margin-top: 2rem;\n  /* Using rem for scalability */\n  text-align: left;\n  margin-left: 2rem;\n  /* Using rem for better responsiveness */\n  color: $text-primary;\n  font-weight: $font-weight-bold;\n  font-size: $font-size-xl;\n  /* Using rem instead of px */\n}\n\n@media screen and (max-width: 480px) {\n  .mainheading {\n    margin-top: 1rem;\n    margin-left: 1.5rem;\n    font-size: $font-size-lg;\n  }\n}\n\n//heading\n@media (max-width: 480px) {\n  .h2design {\n    font-size: $font-size-lg;\n  }\n}\n\n//Text Above Containers\n@media (max-width: 480px) {\n  label {\n    display: block;\n    font-size: $font-size-xs; //changed the font dize to fit smaller screens\n    font-weight: $font-weight-semibold;\n    margin-bottom: 5px;\n  }\n}\n.error-heading {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-bold;\n  color: $text-primary;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.overview-heading {\n  margin-bottom: 10px;\n}\n.list-section h2 {\n  margin-bottom: 12px;\n  color: $text-primary;\n}\nh2,\nh3 {\n  color: $text-primary;\n      font-size: $font-size-lg;\n    margin-bottom: 15px;\n    margin-top: 5px;\n}\n\n.subtxt {\n  color: $text-muted;\n  font-family: $font-family;\n  font-size: $font-size-sm;\n  font-style: italic;\n  font-weight: $font-weight-normal;\n  line-height: 16px;\n}\n\n.textOne {\n  display: flex;\n  align-items: center;\n}\n\n.textOne img {\n  width: 60px;\n  /* Adjust image size */\n  margin-right: 20px;\n}\n\n.textOne span {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-bold;\n}\n.error-text-data-fetching {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-normal;\n  color: $text-primary;\n  text-align: left;\n}\n.error-text-signIn {\n  color: $danger;\n  font-size: $font-size-sm;\n}\n.zero-notification-text {\n  color: $text-muted;\n  font-size: $font-size-sm;\n  margin-top: 5px;\n}\n.upload-text {\n  font-weight: $font-weight-bold;\n  font-size: $font-size-lg;\n}\n.upload-subtext {\n  font-size: $font-size-md;\n  color: $text-secondary;\n}\n.page-title {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  margin-bottom: 30px;\n}\n\n.ant-menu-title-content {\n  color: inherit !important;\n}\n\n.centered-modal .ant-modal-title {\n  text-align: center;\n}\n.title {\n  font-size: $font-size-xl;\n  font-weight: $font-weight-bold;\n  margin-bottom: 1rem;\n}\n\r\n\r\n\r\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);","@import \"./variables\"; \n\n.stat-box {\n  background: $white;\n  border: 1px solid $brand-primary-strong;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 51, 102, 0.1);\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n\n  .label {\n    font-size: 16px;\n    color: $brand-primary;\n    margin-bottom: 8px;\n  }\n\n  .value {\n    font-size: 28px;\n    font-weight: bold;\n    color: $blue-400; // Darkest Blue for the value\n    unicode-bidi: plaintext;\n  }\n\n  .description {\n    font-size: 14px;\n    color: $orange-200;\n    margin-top: 4px;\n  }\n\n  &.success {\n    border-color: $brand-primary-strong;\n    .value {\n      color: $blue-300;\n    }\n  }\n\n  &.error {\n    border-color: $orange-100;\n    .value {\n      color: $orange-200;\n    }\n  }\n}\n\n\n//////////////panel/cards ////////////\n\n.panel-row {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n\n  @media (min-width: 992px) {\n    flex-direction: row;\n  }\n}\n\n.panel-card {\n  flex: 1;\n  background-color: $white;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n\n  .panel-header {\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    color: $blue-base;\n  }\n}\n\n\n.panel-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n\n  h3 {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: $blue-base;\n  }\n}\n\n","@import \"./variables\";\n.button {\n  padding: 0.6rem 1.3rem;\n  margin-top: -0.3px;\n  border-radius: $radius-lg;\n  font-weight: 400;\n  font-size: $font-size-md;\n  font-family: $font-family;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  //box-shadow: $shadow-button !important;\n  height: auto;\n  min-height: 44px;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n\n  &--primary {\n  width: auto;\n  min-width: fit-content;\n  min-height: 40px;\n  background-color: $brand-primary !important;\n  color: $white !important;\n  font-weight: 400;\n  border-radius: $radius-lg;\n  transition: all 0.2s ease;\n  padding: 0.6rem 1.4rem;\n\n    &:hover {\n    background-color: $brand-primary-hover !important;\n    }\n  }\n\n  &--outline {\n    background-color: $white !important;\n    color: $brand-primary !important;\n    border: 2px solid $brand-primary !important;\n    &:hover {\n      background-color: $brand-primary-light !important;\n      color: $brand-primary-hover !important;\n      border-color: $brand-primary-hover !important;\n    }\n  }\n\n  &--danger {\n    background-color: $danger !important;\n    color: $white !important;\n\n    &:hover {\n      background-color: $danger-hover !important;\n    }\n  }\n\n  &--connection {\n    background-color: $success !important;\n    color: $white !important;\n    box-shadow: $shadow-button-subtle !important;\n    &:hover {\n      background-color: $success-hover !important;\n      box-shadow: $shadow-button-subtle !important;\n    }\n  }\n}\n.button--disabled,\n.button:disabled {\n  background-color: $disabled-gray !important;\n  color: $white !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  opacity: 0.8;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.ant-modal .ant-modal-footer >.ant-btn+.ant-btn {\n   background-color: $brand-primary-hover !important;\n    color: $white !important;\n      padding: 0.6rem 1.2rem;\n  border-radius: $radius-md;\n  font-weight: 500;\n  font-size: $font-size-md;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  box-shadow: $shadow-button-subtle !important;\n}\n.ant-modal .ant-modal-footer >.ant-btn+.ant-btn:hover{\n   background-color: $brand-primary-hover !important;\n   box-shadow: $shadow-button-subtle !important;\n}\n\n// back button\n\n.competitive-back-button {\n  background-color: $brand-primary;\n  color: $white;\n  border: none;\n  border-radius: $radius-md;\n  padding: 6px 12px;\n  font-weight: 500;\n  height: 32px;\n}\n\n.competitive-back-button:hover {\n  background-color: $brand-primary-hover !important;\n  color: $white !important;\n}\n\n\n","@import \"./variables\";\n.custom-table {\n  border: 1px solid $brand-primary;\n  margin-top: 10px;\n  height: fit-content;\n\n  .ant-table-thead > tr > th {\n    background-color: $brand-primary;\n    color: $white;\n    font-weight: 600;\n    font-size: 14px;\n    padding: 12px;\n    text-transform: uppercase;\n    border-bottom: 2px solid $blue-400;\n    text-align: center !important;\n    vertical-align: middle;\n    overflow: visible;\n  }\n\n  .ant-table-tbody > tr > td {\n    padding: 12px;\n    font-size: 13px;\n    color: $blue-400;\n    background-color: $white;\n    border-bottom: 1px solid $border-dark;\n    text-align: center !important;\n    vertical-align: middle;\n    overflow: visible;\n  }\n  /* CSS override (global or module-specific) */\n  .ant-table-cell {\n    overflow: visible !important;\n    position: relative;\n  }\n\n  .even-row {\n    background-color: $border-light;\n  }\n\n  .odd-row {\n    background-color: $white;\n  }\n}\n\n.status-healthy {\n  background-color: $green-100; // from global variables\n  color: $green-700;\n}\n\n.status-degraded {\n  background-color: $orange-100;\n  color: $orange-100;\n}\n\n.status-failing,\n.status-down {\n  background-color: $orange-100;\n  color: $orange-100;\n}\n\n.status-default {\n  background-color: $border-dark;\n  color: $text-primary;\n}\n.status-badge {\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  text-transform: capitalize;\n  text-align: center;\n  display: inline-block;\n  min-width: 60px;\n  color: $white !important;\n\n  &--positive {\n    background-color: $green-100;\n    color: $green-700 !important;\n  }\n\n  &--negative {\n    background-color: $orange-100;\n    color: $text-dark;\n  }\n\n  &--neutral {\n    background-color: $gray-200;\n    color: $text-primary !important; \n  }\n\n  &--healthy {\n    background-color: $green-100;\n    color: $green-700 !important;\n  }\n  &--degraded,\n  &--failing,\n  &--down {\n    background-color: $orange-100;\n    color: $orange-100;\n  }\n  &--success {\n    background-color: $green-100;\n    color: $green-700 !important;\n  }\n\n  &--failed {\n    background-color: $orange-100;\n    color: $white;\n  }\n  &--active {\n    background-color: $green-100;\n    color: $green-700 !important;\n  }\n\n  &--inactive {\n    background-color: $orange-100;\n    color: $white;\n  }\n\n  &--suspended {\n    background-color: $blue-400;\n    color: $white;\n  }\n  &--error {\n    background-color: $danger;\n    color: $orange-200;\n  }\n\n  &--warning,\n  &--pending {\n    background-color: $color-f9ee24;\n    color: $white;\n  }\n  &--paid {\n    background-color: $green-100;\n    color: $green-700 !important;\n  }\n\n  &--overdue {\n    background-color: $orange-100;\n    color: $white;\n  }\n  &--default {\n    background-color: $border-dark;\n    color: $text-primary;\n  }\n}\n\n// modify file(userside)\n.custom-table {\n  .ant-table {\n    background-color: $white;\n  }\n\n  .even-row {\n    background-color: $border-light;\n  }\n\n  .odd-row {\n    background-color: $white;\n  }\n\n  th {\n    background-color: $brand-primary;\n    color: $white;\n  }\n}\n\n// user management (user side)\n.access-level-select {\n  width: 150px;\n}\n\n.status-cell {\n  display: flex;\n  align-items: center;\n}\n\n.status-text {\n  margin-left: 8px;\n}\n\n.user-management-icon.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.user-management-icons {\n  display: flex;\n  align-items: center;\n}\n\n.delete-icon {\n  margin-left: 4px;\n  margin-top: 2px;\n}\n\n//paginations\n.custom-pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n// Customize Ant Design Pagination\n.pipeline-table .ant-pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n\n  .ant-pagination-item,\n  .ant-pagination-prev,\n  .ant-pagination-next {\n    border-radius: 6px; // Rounded corners\n    background-color: $green-100;\n    border: none;\n    margin: 0 4px;\n    font-weight: 500;\n\n    a {\n      color: $text-primary;\n    }\n  }\n\n  .ant-pagination-item-active {\n    background-color: $brand-primary;\n    a {\n      color: $white;\n    }\n  }\n\n  .ant-pagination-disabled {\n    opacity: 0.5;\n  }\n\n  .ant-pagination-prev,\n  .ant-pagination-next {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  /* Apply different styles for screens with a max-width of 768px */\n\n  .tablediv table {\n    margin-left: 50px;\n  }\n\n  .payment-confirmation {\n    padding-left: 5px;\n    display: grid;\n  }\n}\n\n// from styles.scss\n.tablediv {\n  align-items: center;\n  justify-content: center;\n  overflow-x: auto;\n  max-width: 100%;\n  margin-left: -30px;\n}\n@media screen and (max-width: 768px) {\n  .tablediv table {\n    margin-left: 50px;\n  }\n\n  .payment-confirmation {\n    padding-left: 50px;\n    display: grid;\n  }\n}\n\ntbody {\n  align-items: center;\n  justify-content: center;\n}\n\ntr {\n  width: 90%;\n}\n\ntable,\ntr,\ntd {\n  border: none;\n  padding: 15px;\n}\n\ntbody tr:nth-child(odd) {\n  //background-color: $border-light;\n  border-radius: 5px;\n}\n.tableBody {\n  // max-height: 410px;\n  overflow-y: auto;\n  gap: 5px;\n  color: $text-secondary;\n  font-size: 12px;\n  font-family: \"Open Sans\", sans-serif;\n}\n@media (max-width: 480px) {\n  .tableBody {\n    max-height: 700px;\n    // max-width: 250px;\n    overflow-y: auto;\n    gap: 5px;\n    color: $text-secondary;\n    font-size: 8px;\n    font-family: \"Open Sans\", sans-serif;\n    overflow-x: auto;\n  }\n}\n/* `.notification-table-wrapper` is styled by\n   layouts/MyAccount/Notifications/Notifications.scss, the only place that markup\n   lives. The duplicate block that used to sit here fought it — its\n   `margin-top: -30px` pulled the table up under the section header (hiding the\n   first activity row) and its `overflow-x: auto` turned the wrapper into a\n   scroll container. */\n\n.notification-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  table-layout: fixed;\n  align-self: center;\n}\n\n.notification-table th,\n.notification-table td {\n  padding: 10px;\n  border-bottom: 1px solid $white;\n  text-align: left;\n  background-color: $white;\n}\n.table-main-row {\n  color: $text-secondary;\n  font-size: 10px;\n}\n.campaign-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  margin-bottom: 1rem;\n\n  th,\n  td {\n    padding: 5px;\n    text-align: left;\n    border-bottom: 1px solid $border-dark;\n  }\n\n  th {\n    background-color: $border-light;\n    font-weight: 500;\n  }\n\n  tbody tr:hover {\n    background-color: $green-100;\n  }\n}\n\n.chart-container {\n  margin: 20px 0;\n}\n\n.data-table {\n  background: $white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 4px 10px rgba(0, 82, 204, 0.1);\n}\n\n.data-table-header,\n.data-table-row {\n  display: grid;\n  grid-template-columns: 60px 1fr 1fr 1fr 100px;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid $green-100;\n\n  span {\n    font-weight: 500;\n  }\n}\n\n.data-table-header {\n  color: $blue-300;\n  font-size: 14px;\n}\n\n.data-table-row {\n  input,\n  .dropdown {\n    width: 90%;\n  }\n\n  .sample-data {\n    color: $color-595959;\n    font-size: 13px;\n  }\n\n  .data-type {\n    font-size: 13px;\n    color: $color-1890ff;\n  }\n}\n\n.styled-data-table .ant-table-thead > tr > th {\n  background-color: $green-100;\n  color: $blue-base;\n  font-weight: 600;\n}\n\n.styled-data-table .ant-table-tbody > tr:hover {\n  background-color: $green-100;\n  transition: background-color 0.2s ease;\n}\n\n.styled-data-table .ant-table-cell {\n  padding: 12px 16px;\n  font-size: 14px;\n}\n\n.styled-data-table .ant-input {\n  border-radius: 6px;\n  border-color: $border-dark;\n  transition: border-color 0.2s ease;\n}\n\n.styled-data-table .ant-input:focus {\n  border-color: $color-1890ff !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n.column-status span {\n  display: inline-block;\n  width: 60px;\n  margin-left: 1rem;\n  text-align: left;\n  color: $text-dark;\n}\n.column-name {\n  width: 250px;\n}\n\n.column-email {\n  width: 250px;\n}\n\n.column-access-level {\n  width: 250px;\n}\n\n.column-status {\n  width: 250px;\n}\n\n.column-actions {\n  width: 250px;\n}\n\n.greyrow {\n  background-color: $color-f8f9fa;\n}\n.highlighted-row {\n  background-color: $green-100; // light blue\n  transition: background-color 0.3s;\n}\n\n//////////////////////csv table///////////\n.container {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr 1fr 1.2fr;\n  border: 1px solid $border-light;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 24px;\n  font-family: Arial, sans-serif;\n  background-color: $white;\n}\n\n.header-cell {\n  padding: 12px 16px;\n  background: $white;\n  font-weight: 600;\n  border-bottom: 1px solid $border-light;\n  text-align: left;\n}\n\n.data-cell {\n  padding: 12px 16px;\n  border-bottom: 1px solid $border-dark;\n  border-right: 1px solid $border-dark;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.select-cell {\n  padding: 8px 16px;\n  border-bottom: 1px solid $border-dark;\n  border-right: 1px solid $border-dark;\n}\n\n.sample-cell {\n  padding: 12px 16px;\n  border-bottom: 1px solid $border-dark;\n  white-space: nowrap;\n}\n\n\n\n","\n.connected-sources-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 86vh;\n  padding-inline-start: 50px;\n  padding-inline-end: 40px;\n  background: #fff;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.connected-sources-content {\n  flex: 1;\n}\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 24px;\n  margin-top: 50px;\n  max-width: 1480px;\n}\n\n.connector-img-shopify {\n  width: 110px;\n  height: 40px;\n}\n.connector-img-google-ads {\n  width: 220px;\n  height: 100px;\n}\n.connector-img-google-analytics {\n  width: 220px;\n  height: 100px;\n}\n.connector-img-facebook {\n  width: 220px;\n  height: 100px;\n}\n.connector-img-instagram{\n    width: 200px;\n  height: 100px;\n}\n.connector-img-odoo {\n  width: 220px;\n  height: 100px;\n}\n.connector-img-zid,\n.connector-img-salla,\n.connector-img-tiktok,\n.connector-img-snapchat,\n.connector-img-whatsapp,\n.connector-img-blinkco {\n  width: 150px;\n  height: 56px;\n  object-fit: contain;\n}\n.card span {\n  white-space: nowrap;\n}\n\n.shopify {\n  background-color: #eef7ee;\n}\n\n.google-ads,\n.facebook {\n  background-color: #f7f8fc;\n}\n\n.google-analytics {\n  background-color: #fef4e8;\n}\n.instagram{\n    background-color: #fce4ec !important;\n}\n.odoo {\n  background-color: #f6edf3;\n}\n.zid {\n  background-color: #f4eef8;\n}\n.salla {\n  background-color: #eaf7f5;\n}\n.tiktok {\n  background-color: #f4f4f6;\n}\n.snapchat {\n  background-color: #fffde7;\n}\n.whatsapp {\n  background-color: #e9f8ef;\n}\n.blinkco {\n  background-color: #fff7e6;\n}\n\n.connected-footer {\n  position: absolute;\n  inset-inline-end: 40px;\n  bottom: 40px;\n}\n\n.highlight {\n  font-weight: 600;\n  color: #ff6c00;\n}\n\n.highlight-orange {\n  font-weight: 300;\n  color: #000;\n}\n.connect-header {\n  font-weight: 600;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 35px;\n  text-align: start;\n}\n.sub-heading {\n  text-align: start;\n}\n.button-footer {\n  width: 250px;\n  height: 50px;\n  padding: 5px;\n  gap: 10px;\n  background-color: #1c60c6;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n.connected-card {\n  border: 2px solid transparent;\n  border-radius: 12px;\n  padding: 20px;\n  width: 180px;\n  max-width: 100%;\n  height: 180px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f8f8f8;\n  transition: border 0.3s ease;\n  box-shadow: 0 30px 20px rgba(4, 11, 5, 0.15);\n  cursor: default;\n  justify-self: center;\n}\n\n.connected-card img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.connected-card.highlight-border {\n  border: 3px solid #ff6c00;\n}\n\n.disconnected-message {\n  font-size: 10px;\n  text-align: start;\n  padding: 10px;\n  color: #000;\n  font-weight: 400;\n  font-family: \"Open Sans\", sans-serif;\n}\n.shopify {\n  background-color: #eef7ee;\n}\n\n.google-ads {\n  background-color: #f0f4f8;\n}\n\n.google-analytics {\n  background-color: #fff3e0;\n}\n\n.facebook {\n  background-color: #f1f4fb;\n  // margin-top: 20px;\n}\n\n/* ========== RESPONSIVE BREAKPOINTS ========== */\n\n/* Mobile: ≤480px → 1 card per row */\n@media (max-width: 480px) {\n  .cards-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n    gap: 20px;\n    justify-items: center;\n  }\n\n  .connected-card {\n    width: 100%;\n    max-width: 300px;\n    height: auto;\n  }\n\n  .connect-header {\n    font-size: 22px;\n  }\n\n  .button-footer {\n    width: 100%;\n    max-width: 280px;\n  }\n\n  .connected-footer {\n    position: static; /* no overlap */\n    margin-top: 20px;\n    text-align: center;\n  }\n}\n\n/* Tablet: 481px – 768px → 2 cards per row */\n@media (min-width: 481px) and (max-width: 768px) {\n  .cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    gap: 25px;\n    justify-items: center;\n  }\n\n  .connected-card {\n    width: 100%;\n    max-width: 250px;\n    //height: auto;\n  }\n\n  .connect-header {\n    font-size: 28px;\n  }\n\n  .button-footer {\n    width: 100%;\n    max-width: 280px;\n  }\n\n  .connected-footer {\n    position: static;\n    margin-top: 30px;\n    text-align: center;\n  }\n}\n\n/* Small laptop: 769px – 1240px → still 3 cards but flexible */\n@media (min-width: 769px) and (max-width: 1240px) {\n  .cards-grid {\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: auto;\n    justify-items: center;\n  }\n\n  .connected-card {\n    width: 100%;\n    max-width: 200px;\n  }\n}\n","@import \"./variables\";\n.error-message {\n  color: var(--error-red, $color-d21c1c);\n  font-family: Open Sans;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\ninput:invalid[focused=\"true\"] {\n  border: 1px solid $danger;\n}\n\n/* Resetpassword.css */\n\n.error-message {\n  color: $danger;\n}\n\n.input-error {\n  border: 1px solid $danger;\n}\n\n.error-message-source-connector {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background-color: $color-fde2e2;\n  border: 0.1rem solid $danger;\n  border-radius: 0.25rem;\n  color: $text-dark;\n  font-size: 1rem;\n\n  .error-icon-source-connector {\n    margin-right: 0.5rem;\n    font-size: 1.125rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .error-message {\n    color: $danger;\n    font-size: 8px;\n  }\n}\n\n.ant-form-item-explain-error {\n  @extend .error-message; // If you're using SCSS and have .error-message class defined\n}\n\n//Alerts\n\n.alert {\n  color: $color-d21c1c;\n  font-weight: bold;\n}\n\n.red-icon {\n  font-size: 1rem;\n  color: $color-d21c1c;\n  margin-bottom: 10px;\n}\n.alerts-health-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin-bottom: 10px;\n\n  @media (min-width: 992px) {\n    flex-direction: row;\n  }\n}\n\n.alert-panel,\n.api-health-panel {\n  flex: 1;\n  background-color: $white;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n  margin-top: 2.5rem;\n}\n.alert-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.alert-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  border-radius: 0.75rem;\n  margin-bottom: 1rem;\n  background-color: $border-light;\n  border-left: 4px solid;\n\n  .alert-icon {\n    font-size: 1.4rem;\n  }\n\n  .alert-content {\n    flex-grow: 1;\n\n    strong {\n      display: block;\n      font-size: 1rem;\n      margin-bottom: 0.25rem;\n    }\n\n    p {\n      margin: 0;\n      font-size: 0.85rem;\n      color: $color-475569;\n    }\n\n    .alert-meta {\n      font-size: 0.75rem;\n      color: $border-dark;\n    }\n  }\n\n  .alert-tag {\n    padding: 0.25rem 0.5rem;\n    border-radius: 9999px;\n    font-size: 0.75rem;\n    font-weight: 500;\n  }\n\n  &.high {\n    border-color: $color-f87171;\n    background-color: $color-fde2e2;\n\n    .alert-tag {\n      background-color: $color-f87171;\n      color: $danger;\n    }\n  }\n\n  &.medium {\n    border-color: $color-f9ee24;\n    background-color: $color-fef9c3;\n\n    .alert-tag {\n      background-color: $color-fef08a;\n      color: $color-92400e;\n    }\n  }\n\n  &.low {\n    border-color: $color-34d399;\n    background-color: $color-ecfdf5;\n\n    .alert-tag {\n      background-color: $color-bbf7d0;\n      color: $color-065f46;\n    }\n  }\n\n  &.info {\n    border-color: $color-91d5ff;\n    background-color: $color-bbf7d0;\n\n    .alert-tag {\n      background-color: $color-bbf7d0;\n      color: $color-1d4ed8;\n    }\n  }\n}\n\n.error-container-data-fetching {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: $white;\n  border-radius: 12px;\n  padding: 30px;\n  width: 750px;\n  height: 250px;\n  box-shadow: 0px 20px 12px rgba(0, 0, 0, 0.2);\n  margin: 0 auto;\n  opacity: 0;\n  transition: opacity 5.5s ease-in-out;\n}\n\n.error-container-data-fetching.fade-in {\n  opacity: 2;\n}\n\n.error-content {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n\n/* More compact chat message styling */\n.message {\n  max-width: 75%;\n  margin: 8px 12px;\n  padding: 8px 12px;\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n.message.user {\n  background-color: $color-e6f7ff;\n  border: 1px solid $color-91d5ff;\n  color: $brand-primary-strong;\n  margin-left: auto;\n}\n\n.timestamp {\n  font-size: 9px;\n  color: $color-595959;\n  margin-top: 3px;\n  text-align: right;\n}\n\n////////////////subscribe message///////////////////\n.custom-ribbon:where(.css-dev-only-do-not-override-vryruh).ant-ribbon {\n  background-color: $white !important;\n  border: 2px solid $brand-primary !important;\n  width: 50% !important; // Half width\n  white-space: normal !important; // Allow wrapping\n  height: auto !important; // Adjust height\n  margin-bottom: 20px;\n}\n\n// This is the crucial part to override the text color\n.custom-ribbon :where(.ant-ribbon .ant-ribbon-text) {\n  color: $text-dark !important;\n  font-size: 12px;\n}\n\n/* Branded toast for API `detail` (e.g. template generation limits) — use with showApiDetailToast() */\n.datatram-api-detail-toast.ant-message-notice,\n.datatram-api-detail-toast .ant-message-notice {\n  padding: 0 !important;\n}\n\n.datatram-api-detail-toast .ant-message-notice-content {\n  background: #edf3fb !important;\n  border: 1px solid rgba(44, 104, 173, 0.45) !important;\n  color: $brand-primary !important;\n  border-radius: 10px !important;\n  padding: 12px 16px !important;\n  font-size: 13px !important;\n  line-height: 1.45 !important;\n  font-weight: 500 !important;\n  box-shadow: 0 4px 14px rgba(44, 104, 173, 0.12) !important;\n  max-width: min(520px, calc(100vw - 32px)) !important;\n}\n\n.datatram-api-detail-toast .anticon {\n  color: $brand-primary !important;\n}\n\n","// *************************Admin Code*****************************//\n.admin-portal-layout.ant-layout-has-sider {\n  overflow-y: auto;\n}\n\n.admin-portal-layout .ant-layout-content {\n  overflow-y: auto;\n}\n\n.headline {\n  color: var(--dark-purple, #140054);\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  margin-inline-start: 30px;\n  gap:5px;\n}\n\n//HERE DASHBOARD HEADER\n.header-dashboard {\n  padding: 0;\n  background-color: colorBgContainer;\n  color: black;\n  width: 100%;\n  z-index: 1000;\n  position: relative;\n  overflow: visible;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.dashboards-heading {\n  color: var(--text, #718096);\n  font-family: Open Sans;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: lighter;\n  line-height: normal;\n  margin-bottom: -5%;\n  margin-top: -15px;\n  margin-inline-start: 5px;\n}\n.dashboards-headings {\n  color: var(--text, #718096);\n  font-family: Open Sans;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: lighter;\n  line-height: normal;\n  margin-bottom: -5%;\n  margin-top: -18px;\n  margin-inline-start: 5px;\n}\n.filters-settings-container {\n  display: flex;\n  justify-content: space-between; \n  align-items: center;\n  margin: 20px 0;\n}\n\n.dashboard-image {\n  margin-inline-end: 5px;\n  width:25px;\n  height:25px;\n}\n\n.chart-image {\n  margin-inline-start: 15px;\n  margin-inline-end: 3px;\n      height: 25px !important;\n    width: 25px;\n    color:#2c68ad;\n}\n\n.dashboard-image-2 {\n  margin-inline-start: 7px;\n}\n\n.header-search-dashboard {\n  border-radius: 0px;\n  width: 300px;\n  height: 30px;\n  margin-top: 18px;\n  margin-right: 140px;\n  font-size: 14px;\n  padding: 5px;\n}\n\n.bell-icon-dashboard {\n  background: white;\n  cursor: pointer;\n  color: grey;\n  width: 30px;\n  margin-top: 4px;\n  margin-right: 15px !important;\n}\n\n.avatar-icon-dashboard {\n  background: #2eb67d !important;\n  cursor: pointer;\n  margin-top: 8px;\n  margin-right: 10px;\n}\n\n.p-0 {\n  margin-left: 3px !important;\n}\n\n@media screen and (max-width: 768px) {\n  .dashboards-heading {\n    font-size: 12px;\n  }\n\n  .header-search-dashboard {\n    border-radius: 0px;\n    width: 200px;\n  }\n\n  .p-0 {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .headline {\n    font-size: 6px;\n  }\n\n  .dashboards-heading {\n    font-size: 4px;\n    margin-left: -10px;\n  }\n\n  .dashboard-image {\n    width: 10px;\n  }\n\n  .chart-image {\n    margin-right: 3px;\n    width: 15px;\n    margin-left: 10px;\n  }\n.anticon{\n  margin-left: 5px !important;\n}\n  .dashboard-image-2 {\n    margin-left: 5px;\n    width: 30px;\n  }\n\n  .bell-icon-dashboard {\n    margin-top: 22px;\n    height: 20px !important;\n    width: 20px !important;\n  }\n\n  .avatar-icon-dashboard {\n    margin-top: 22px;\n    height: 20px !important;\n    width: 20px !important;\n  }\n\n  .p-0 {\n    font-size: 2px;\n    margin-left: 2px !important;\n  }\n}\n\n.ant-layout-sider {\n  width: 50px;\n  max-width: 50px;\n  min-width: 50px;\n}\n\n@media (max-width: 768px) {\n  .ant-layout-sider {\n    width: 60px;\n    max-width: 60px;\n    min-width: 60px;\n  }\n}\n\n\n@media (max-width: 480px) {\n  .ant-layout-sider {\n    width: 50px;\n    max-width: 50px !important;\n    min-width: 50px !important;\n  }\n}\n\n.ant-layout-content-css-dev-only-do-not-override-vryruh {\n  margin-left: 80px !important;\n}\n\n@media (max-width: 768px) {\n  .ant-layout-content-css-dev-only-do-not-override-vryruh {\n    margin-left: 40px;\n  }\n}\n\n@media (max-width: 480px) {\n  .ant-layout-css-dev-only-do-not-override-vryruh {\n    margin-left: 60px !important;\n  }\n}\n\n.responsive-margin {\n  margin-left: 80px !important;\n\n  @media (max-width: 768px) {\n    margin-left: 80px !important;\n  }\n\n  @media (max-width: 480px) {\n    margin-left: 50px !important;\n  }\n}\n\n.header-style {\n  margin-left: 210px !important;\n\n  @media (max-width: 480px) {\n    margin-left: 50px !important;\n  }\n}\n\n.responsive-margin-right {\n  margin-right: 110px;\n\n  @media (min-width: 769px) {\n    margin-right: 230px;\n  }\n}\n\n\n/* PipelineDashboard.scss */\n\n.admin-portal-page {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0px;\n    padding: 5px;\n    margin-bottom: 1.5rem;\n\n    h2 {\n      font-size: 24px;\n      font-weight: 600;\n      color: #003366;\n    }\n        h1 {\n      font-size: 1.8rem;\n      color: $blue-400;\n    }\n\n    button {\n      background-color: $orange-100;\n      border: none;\n\n      &:hover {\n        background-color: $orange-200;\n      }\n    }\n  }\n\n  .last-refreshed {\n    font-size: 12px;\n    color: $orange-200;\n    font-weight: 700;\n  }\n\n  .filters {\n    display: flex;\n    gap: 16px;\n    margin-bottom: -40px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n\n    .status-select,\n    .date-picker {\n      width: 300px;\n    }\n  }\n}\n.ant-tooltip {\n  z-index: 9999 !important;\n}\n\n.announcement-card {\n  background: #ffffff;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  border-left: 5px solid #007acc;\n\n  &.published {\n    border-color: #2db584;\n  }\n  &.scheduled {\n    border-color: #f0ad4e;\n  }\n  &.draft {\n    border-color: #6c757d;\n  }\n\n  .announcement-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .status-badge {\n    background: #e0ecf8;\n    padding: 0.25rem 0.75rem;\n    border-radius: 15px;\n    font-size: 0.8rem;\n    color: #007acc;\n  }\n\n  .meta {\n    font-size: 0.85rem;\n    color: #6b778c;\n    margin: 0.3rem 0 1rem;\n  }\n\n  .tags {\n    margin-top: 0.75rem;\n\n    .tag {\n      background: #e3ecf6;\n      color: #274c6c;\n      padding: 0.3rem 0.7rem;\n      border-radius: 14px;\n      font-size: 0.75rem;\n      margin-right: 0.5rem;\n      display: inline-block;\n    }\n  }\n}\n\n.blue-outline-card {\n  border-color: #00b4d8;\n  border-style: solid;\n  border-width: 1px;\n}\n\n:where(.ant-table-wrapper) table {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n:where(.ant-table-wrapper) .ant-table-container {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n:where(.ant-table-wrapper) .ant-table {\n  border: none !important;\n}\n\n.sidebar-admin-portal {\n  position: \"fixed\";\n  height: \"100%\";\n  zindex: 1000;\n  background: $blue-400 !important;\n}\n\n\n///////////// admin user ////////////\n\n.user-management-container {\n  min-height: 80vh;\n}\n\n.user-management-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  align-items: center;\n}\n\n.add-user-button-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: -130px;\n  margin-right: 20px;\n}\n\n.user-filters {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.filter-input {\n  width: 240px;\n}\n\n.filter-select {\n  height: 32px;\n\n  padding: 0 8px;\n}\n\n.refresh-btn {\n  height: 32px;\n}\n\n.admin-search {\n  width: 300px !important;          \n  border-radius: 8px;   \n  box-shadow: 0 1px 3px rgba(0,0,0,0.1); \n}\n.admin-search .ant-input {\n  border-radius: 8px;\n  padding-left: 36px;     \n}\n.announcement-search {\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n}\n\n.announcement-search .ant-input {\n  border-radius: 8px;\n  padding-left: 36px;\n}\n.DataSourceSearch{\n    width: 380px;          \n  border-radius: 8px;   \n  box-shadow: 0 1px 3px rgba(0,0,0,0.1); \n}\n.DataSourceSearch .ant-input {\n  border-radius: 8px;\n  padding-left: 36px;\n}\n",".logo-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 480px;\n  margin-inline-start: 122px;\n  padding: 0;\n}\n\n.body {\n  position: relative;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.body::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background-image: var(--auth-bg-image);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n[dir=\"rtl\"] .body::before {\n  transform: scaleX(-1);\n}\n\n.app {\n  display: flex;\n  padding-inline-start: 10px;\n  min-height: 100vh;\n}\n\n.formdesign {\n  background-color: #ffffff;\n  padding: 30px 75px;\n  border-radius: 5px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\n  max-height: 80vh;\n  margin-inline-start: 92px;\n  max-width: 480px;\n  margin-top: -17px;\n  text-align: start;\n}\n\n.or {\n  color: #bac7d5 !important;\n  font-size: 12px !important;\n  margin-bottom: -10px !important;\n  margin-top: -3px !important;\n}\n\n.logo-design {\n  display: block;\n  padding-left: 0;\n}\n\n.logo-wrapper .language-switcher {\n  order: 1;\n}\n\n\n// *************************************FormInput.css************************************//\n.formInput {\n  display: flex;\n  flex-direction: column;\n  //width: 250px;\n  width: auto;\n  margin-left: 30px;\n}\n\nlabel {\n  font-size: 12px;\n  color: #5d3f85;\n  font-weight: bold;\n    display: block;\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.span {\n  font-size: 12px;\n  color: grey;\n  display: none;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\ninput:invalid[focused=\"true\"] {\n  border: 1px solid red;\n}\n\n.password-toggle-icon {\n  display: none;\n  position: absolute;\n  right: -38px;\n  top: 40%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n/* Form styling */\n.form-selection,\n.form-input {\n  margin-bottom: 20px;\n}\n\n.form-selection {\n  width: 50%;\n}\n\n.access-tkn-fb {\n  width: 70%;\n}\n\ninput {\n  width: 100%;\n  padding: 10px;\n  font-size: 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.button-group {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-start;\n  margin-top: 28px;\n}\n\n.create-connection,\n.cancel\n {\n  padding: 10px 15px;\n  font-size: 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 50px;\n}\n\n.remove-connection {\n  padding: 5px 5px;\n  font-size: 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  background-color: #28a745;\n  color: white;\n}\n\n.create-connection {\n  background-color: #28a745;\n  color: white;\n}\n\n.cancel {\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n\n@media screen and (max-width: 768px) {\n  .formdesign {\n    padding: 30px 4%;\n    max-height: 568px;\n    width: 611px;\n    height: 820px;\n  }\n\n  .logo-design {\n    height: 70px;\n    padding-left: 0;\n    padding-top: 25px;\n    margin-bottom: 5vw;\n    margin-top: 2vh;\n  }\n\n  .logo-wrapper {\n    max-width: 611px;\n    margin-left: 0;\n    padding: 0 4%;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .formdesign {\n    padding: 30px 3%;\n    height: 600px;\n    margin-left: 20px;\n    width: 280px;\n  }\n\n  .logo-design {\n    width: 105px;\n    padding-left: 20px;\n    padding-bottom: 30px;\n  }\n\n  .logo-wrapper {\n    max-width: 280px;\n    margin-left: 20px;\n    padding: 0;\n  }\n}\n\n\n.add-user-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.form-row {\n  display: flex;\n  gap: 8px;\n}\n\n.form-item {\n  flex: 1;\n  margin-bottom: 2dvh;\n}\n\n.form-item-invitation {\n  font-size: 5px !important;\n  color: red;\n  font-weight: bold;\n  margin-bottom: 0px;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-bottom: 0;\n\n  .cancel-button {\n    background-color: #f5f5f5;\n    color: #595959;\n    border: 1px solid #d9d9d9;\n\n    &:hover {\n      background-color: #e6e6e6;\n    }\n  }\n\n  .add-user-button {\n    background-color: #1890ff;\n    color: #fff;\n    border: none;\n\n    &:hover {\n      background-color: #1677e6;\n    }\n  }\n}\n.ant-form-item-control-input-content {\n  font-size: 12px;\n  min-height: 0px;\n}\n.ant-form-item-explain-error {\n  color: #ff4d4f; // default AntD red, change as needed\n  font-size: 10px;\n  margin-top: 1px;\n  font-weight: bold;\n}\n\n.segment-form {\n  background: #ffffff;\n  border: 1px solid #d9e2f3;\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.segment-name-input {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 1px solid #a6c1f3;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.section-title {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n\n.segment-conditions {\n  .condition-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 16px;\n  }\n\n  .condition-btn {\n    padding: 0 16px;\n    height: 42px;\n    background: #ffffff !important;\n    border: 1px solid #d9d9d9 !important;\n    border-radius: 12px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #ffffff !important;\n    }\n\n    &.active {\n      background: #2c5bbd !important;\n      color: #fff !important;\n      font-weight: 500;\n    }\n  }\n\n.ant-select-selector {\n  background: #ffffff !important;\n //   border: 1px solid #a6c1f3 !important;\n}\n\n  .trash-icon {\n    font-size: 18px;\n    margin-left: auto;\n    align-self: center;\n    cursor: pointer;\n  }\n}\n\n.logic-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n\n  .logic-btn {\n    padding: 8px 20px;\n    background: #f0f4ff;\n    border: 1px solid #a6c1f3;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n\n    &:hover {\n      background: #dbe9ff;\n    }\n  }\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  gap: 12px;\n\n  .cancel-btn {\n    background: #fff;\n    border: 1px solid #b3c5e6;\n    padding: 10px 18px;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .submit-btn {\n    background: #2c5bbd;\n    color: white;\n    border: none;\n    padding: 10px 18px;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n\n    &:hover {\n      background: #1e429f;\n    }\n  }\n}\n.form-container {\n  display: grid;\n  gap: 1rem;\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n      padding-top: 0;\n}\n\n.login-form .ant-form-item-label > label {\n  color: #003366;\n  font-weight: 500;\n}\n\n.login-form .ant-input,\n.login-form .ant-input-password {\n  border-radius: 6px;\n}\n\n.login-btn {\n  background-color: #0052cc;\n  border-color: #0052cc;\n  border-radius: 6px;\n  font-weight: 500;\n\n  &:hover,\n  &:focus {\n    background-color: #003d99 !important;\n    border-color: #003d99 !important;\n  }\n}\n\n.add-admin-modal {\n  .modal-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #1a3f75;\n  }\n\n  .modal-subtitle {\n    margin-bottom: 16px;\n    color: #5a6d8c;\n    font-size: 14px;\n  }\n\n  .ant-form-item-label > label {\n    color: #1a3f75;\n    font-weight: 500;\n  }\n\n  .ant-input,\n  .ant-input-password,\n  .ant-select-selector {\n    border-radius: 6px;\n    border-color: #c4d3ec;\n    &:hover,\n    &:focus {\n      border-color: #2d64bc;\n      box-shadow: 0 0 0 2px rgba(45, 100, 188, 0.2);\n    }\n  }\n\n  .modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 24px;\n\n    .ant-btn {\n      margin-left: 12px;\n      border-radius: 6px;\n    }\n\n    .ant-btn-primary {\n      background-color: #2d64bc;\n      border-color: #2d64bc;\n      &:hover {\n        background-color: #1e4fa3;\n        border-color: #1e4fa3;\n      }\n    }\n  }\n}\n.login-container {\n//  background-image: url(\"D:\\Datatram\\datatram-fe\\public\\images\\Loading-Background.jpg\") !important;\n  background-size: cover;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n\n  /* 3D effect */\n  perspective: 1000px; /* set perspective */\n  transform-style: preserve-3d;\n  transition: transform 0.5s ease;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  padding: 2rem 2.5rem;\n  box-shadow: 0 10px 25px rgba(0, 102, 204, 0.15);\n  border-radius: 12px;\n  background-color: #ffffff;\n}\n\n.login-title {\n  text-align: center;\n  font-size: 1.8rem;\n  margin-bottom: 1.5rem;\n  color: #003366;\n  font-weight: 600;\n}\n.signup-heading {\n  color: #130054;\n  font-family: sans-serif;\n  font-size: 23px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n/***************************************************SignUp Page***************************************/\n//Heading\n.signup-heading {\n  color: #130054;\n  font-family: sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n@media (max-width: 480px) {\n  .signup-heading {\n    color: #130054;\n    font-family: sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n  }\n}\n\n@media (max-width: 480px) {\n  .custom-google-button {\n    width: 100%;\n    border-color: #2596be !important;\n    color: #2596be !important;\n    width: 200px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background: white;\n    font-size: 10px;\n    cursor: pointer;\n    color: black;\n    margin-left: 30px;\n  }\n}\n@media (max-width: 480px) {\n  .button-style {\n    width: 200px;\n    height: 25px;\n    border: none;\n    background-color: #2596be;\n    color: white;\n    font-weight: bold;\n    cursor: pointer;\n    margin-bottom: 12px;\n    display: flex;\n    padding: 5px 5px;\n    align-items: center;\n    gap: 8px;\n    align-self: stretch;\n    font-size: 10px;\n    justify-content: center;\n    margin-left: 30px;\n  }\n\n  .alreadyRegistered_text {\n    font-size: 8px;\n    margin-top: 5%;\n  }\n\n  .viewTerms_text {\n    font-size: 13px;\n    margin-top: 5% !important;\n    align-items: center;\n  }\n}\n\n\n///PASSWORDS\n/// // *************************************ResetPassword************************************//\n.user-lock {\n  color: #38abd2;\n  font-family: Font Awesome 6 Pro;\n  font-size: 65px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 32px;\n  padding-top: 3rem;\n  padding-bottom: 25px;\n}\n\n.reset-pass-bg {\n//  background-image: url(\"D:\\Datatram\\datatram-fe\\public\\Icons\\forget-password-bg.svg\");\n  background-size: auto;\n  background-repeat: no-repeat;\n  background-position: right;\n}\n\n.Reset-password {\n  color: #140054;\n  font-family: Open Sans;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px;\n  padding-top: 10px;\n  padding-bottom: 15px;\n}\n\n.Reset-detail {\n  color: #718096;\n  font-family: Open Sans;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  /* 150% */\n  padding-top: 5px;\n  text-align: left;\n}\n\n.email-sent-detail {\n  color: #718096;\n  font-family: Open Sans;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  /* 150% */\n  padding-top: 10px;\n  text-align: left;\n  //padding-bottom: 4rem;\n}\n////////////////////////// makeNewPassword.tsx /////////////////////\n\n.password-msgs span {\n  margin-left: 2%;\n  font-size: 0.75rem;\n  vertical-align: middle;\n}\n\n.password-msgs {\n  max-height: 110px;\n  //overflow-y: auto;\n}\n\n.condition-row {\n  margin-top: 1%;\n}\n\n.open-lock {\n  padding-bottom: 1rem;\n  padding-top: 1rem;\n}\n\n.password-field {\n  position: relative;\n}\n\n.password-input-container {\n  position: relative;\n}\n\n.password-input-container input {\n  width: 100%;\n  padding-right: 40px;\n}\n\n// *************************************OTP************************************//\n\n.new-email {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  margin-top: 15%;\n}\n\n.entercode {\n  color: rgb(107, 42, 119);\n  font-size: 25px;\n  padding-top: 20px;\n  padding-bottom: 5px;\n\n  font-family: Open Sans;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px;\n  /* 133.333% */\n}\n\n.bg {\n  //background-image: url(\"D:\\Datatram\\datatram-fe\\public\\images\\DatatramSignup.png\");\n\n  background-size: cover;\n\n  height: 100%;\n\n  background-repeat: no-repeat;\n\n  background-position: center;\n\n  overflow-x: hidden;\n\n  overflow-y: hidden;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\n.header-language-switcher{\n      margin-bottom: 10px;\n    margin-right: -20px;\n    margin-left: -15px;\n}\n.logo-design {\n  // width: 408px;\n  height: 70px;\n  padding-top: 25px;\n  margin-bottom: 10px;\n  margin-top: 2vh;\n  margin-left: -20px;\n}\n\n.signup-internal-container {\n  margin-top: 20px;\n}\n\n.Otp-Detail {\n  text-align: justify;\n  color: grey;\n  font-weight: 10px;\n  font-size: medium;\n  padding-bottom: 25px;\n  padding-top: 10px;\n}\n\n.otp-boxes {\n  width: 42px !important;\n  border-radius: 5px;\n  border-color: 1px solid #c3e6f2;\n  text-align: center;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.resend-email {\n  margin-top: 15%;\n  color: grey;\n  font-size: 12px;\n  text-align: center;\n}\n\n@media screen and (max-width: 480px) {\n  .app {\n    padding-left: 0px;\n  }\n\n  .logo-design {\n    width: 208px;\n    height: 41px;\n    padding-left: 20px;\n    padding-bottom: 10px;\n    padding-top: 35px;\n  }\n}\n\nh1 {\n  color: rgb(77, 1, 77);\n  text-align: center;\n}\n\na {\n  color: #2596be;\n}\n","@import \"./variables\";\n\n// *************************************PrivacyPolicy Page************************************//\n\n.policy-blue-bg {\n  background-color: $blue-300 !important;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n.date-prop {\n  color: $white;\n  text-align: center;\n  /* Center the text horizontally */\n  font-size: 14px;\n  margin-top: -5px;\n}\n\n.privacy-logo {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  width: 220px;\n  height: 90px;\n}\n\n.privacy-policy-body {\n  margin-left: 100px;\n  margin-right: 100px;\n}\n\n.private-policy-title {\n  color: $white;\n  margin-top: 10px;\n  font-size: 40px;\n}\n\n.policy-heading {\n  font-size: 26px;\n  color: $blue-base;\n}\n\n.policy-description {\n  color: $blue-400;\n  font-size: 14px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-weight: bold;\n}\n\n.policy-card-design {\n  background-color: $border-dark;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  padding: 20px;\n  border-radius: 5px;\n  height: 100%;\n  align-items: center;\n  text-align: center;\n}\n\n\n\n.policy-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.policy-subheading {\n  font-size: 16px;\n  font-weight: bold;\n  color: $text-dark;\n  margin-bottom: 5px;\n}\n\n.policy-details {\n  margin: 5px 0 0 0;\n  color: $color-4f5e71;\n  font-size: 14px;\n}\n\n\n/* src/components/reusable/NoDataDisplay.scss */\n.no-data-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: $brand-primary;\n  text-align: center;\n  width: 100%;\n  overflow: hidden;\n}\n\n.no-data-message {\n  font-size: 14px;\n  font-weight: bold;\n  margin-top: -80px;\n}\n\n.no-data-image {\n  max-width: 100%;\n  height: auto;\n\n  object-fit: contain;\n}\n\n\n///////////////help/////////////\n\n/* Help section styling */\n.help-section {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.help-section p {\n  font-size: 16px;\n}\n\n.help-section a {\n  font-size: 16px;\n  color: $color-1890ff;\n  text-decoration: none;\n}\n\n.help-section a:hover {\n  text-decoration: underline;\n}\n\n.shopify-signin {\n  display: flex;\n  flex-direction: row;\n}\n\n.shopify-signin-btn {\n  width: 50%;\n  margin-left: 20px;\n  height: fit-content;\n  margin-top: 28px;\n}\n\n#shopify-logo {\n  width: 35%;\n  margin-bottom: 25px;\n}\n\n\n","@import \"./variables\";\n\n.menu-icon {\n  font-size: 40px;\n  color: $white;\n}\n\n.top-sub-icons {\n  width: 25px;\n  height: 19px;\n  font-family: sans-serif;\n}\n.plan-over-icon {\n  width: 70px;\n  height: 75.32px;\n  top: 0px;\n  margin-bottom: 1vh;\n}\n.green-icon {\n  color: $success;\n}\n\n.policy-icon {\n  font-size: 40px;\n  color: $brand-primary-strong;\n  /* Adjust the color of the icons */\n  margin-bottom: 10px;\n}\n\n\n.facebook-icon {\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n}\n\n.step-icon {\n  width: 30px;\n  height: 30px;\n  border: 2px solid $white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 15px;\n}\n\n.step-icon.completed {\n  background-size: cover;\n  border: none;\n}\n.heading-icon-container {\n  display: flex;\n  align-items: center;\n}\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-item\n  .ant-menu-item-icon\n  + span,\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-item-group\n  > .ant-menu-item-group-list\n  > .ant-menu-item\n  .ant-menu-item-icon\n  + span,\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-item-group\n  > .ant-menu-item-group-list\n  > .ant-menu-submenu\n  > .ant-menu-submenu-title\n  .ant-menu-item-icon\n  + span,\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-submenu\n  > .ant-menu-submenu-title\n  .ant-menu-item-icon\n  + span,\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-item\n  .anticon\n  + span,\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-item-group\n  > .ant-menu-item-group-list\n  > .ant-menu-item\n  .anticon\n  + span,\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-item-group\n  > .ant-menu-item-group-list\n  > .ant-menu-submenu\n  > .ant-menu-submenu-title\n  .anticon\n  + span,\n:where(.css-dev-only-do-not-override-vryruh).ant-menu-inline-collapsed\n  > .ant-menu-submenu\n  > .ant-menu-submenu-title\n  .anticon\n  + span {\n  color: $white !important;\n}\n.custom-progress .ant-progress-status-success .anticon-check-circle {\n  color: $color-1890ff !important;\n}\n\n.anticon-check-circle {\n  font-size: 2vw !important;\n}\n\n  .plan-icon {\n    width: 20px;\n    /* Adjust the width as per your requirement */\n  }\n\n  /* Optionally, you can add different sizes for specific plans */\n  .plan-icon-large {\n    width: 30px;\n    /* Larger size for images, e.g., Premium Plan */\n  }\n\n  .plan-icon-small {\n    width: 15px;\n    /* Smaller size for other cases */\n  }\n\n  /* If you want to make images responsive for smaller screens */\n  @media screen and (max-width: 768px) {\n    .plan-icon {\n      width: 18px;\n      /* Smaller size for tablets */\n    }\n\n    .plan-icon-large {\n      width: 25px;\n    }\n\n    .plan-icon-small {\n      width: 12px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .plan-icon {\n      width: 10px;\n      /* Smaller size for tablets */\n    }\n  }\n\n  .icon-grid {\n    padding-top: 20px;\n    margin-left: 20px;\n  }\n\n  /* Onboarding: Connect Sources zigzag layout */\n  .zigzag-icons-container {\n    margin-top: 24px;\n  }\n\n  .zigzag-icon {\n    margin-bottom: 24px;\n  }\n\n  .zigzag-left {\n    margin-left: 40px;\n  }\n\n  .zigzag-right {\n    margin-left: 120px;\n  }\n\n  .social-media-image {\n    display: block;\n  }\n\n  .connector-highlight {\n    border-radius: 12px;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n    background-color: $color-bbf7d0;\n  }\n  .source-connector-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  .source-connector-header .language-switcher__trigger {\n    margin-top: 0;\n  }\n  .money-check-icon {\n    width: 30px;\n    height: 25px;\n  }\n    .upgrade-icon {\n    color: $color-1890ff;\n    margin-top: 2px;\n  }\n    .mastercard-icon {\n    width: 35px;\n    height: 35px;\n    margin-top: -20px;\n  }\n  \n\n.user-management-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  margin-left: 18px;\n  padding-bottom: 0px !important;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.user-management-icons {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n}\n\n.disabled-icon {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.audience_icon {\n  margin-bottom: 10px;\n}\n.upload-icon {\n  font-size: 2rem;\n  color: $brand-primary-strong;\n}\n.p-icon.p-multiselect-token-icon {\n  margin-left: 5px;\n  width: 12px;\n  height: 12px;\n}\n.chatbot-icon {\n  justify-content: end;\n}\n.openclose-Icons {\n  width: 18px;\n  height: 18px;\n  margin-left: auto;\n}\n.confirmation-Icon {\n  width: 75px;\n  height: 75px;\n}\n.icon-heading {\n  display: flex;\n  flex-direction: row;\n  gap: 1%;\n  margin-bottom: 2%;\n}\n\n.icon-heading label {\n  font-size: 1.2rem;\n  color: $brand-primary-light;\n}\n\n.cross-filled-icon,\n.invalid-msg {\n  color: $color-d21c1c;\n}\n\n.tick-filled-icon,\n.valid-msg {\n  color: $success;\n}\n\n.cross-filled-icon,\n.tick-filled-icon {\n  margin-left: 1%;\n  vertical-align: middle;\n}\n\n.tick-filled-icon {\n  width: 12px;\n  height: 12px;\n  vertical-align: middle;\n}\n\n.password-msgs {\n  margin-top: 2%;\n  margin-bottom: 1%;\n}\n\ndiv.PhoneInputCountryIcon.PhoneInputCountryIcon--border,\nimg.PhoneInputCountryIconImg {\n  border: none !important;\n}\n\n.PhoneInputInput::placeholder {\n  color: $border-dark !important;\n  font-style: italic;\n}\n\n.eye-icon {\n  position: absolute !important;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  vertical-align: middle !important;\n}\nsvg.p-icon.p-multiselect-trigger-icon.p-c {\n  color: $border-default;\n  height: 15px;\n  width: 14px;\n}\n.error-icon-data-fetching {\n  width: 40px;\n  height: 40px;\n  margin-right: 20px;\n}\n.shopify-login {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 50px;\n  background-color: $white;\n  border-radius: 8px;\n\n  font-family: Arial, sans-serif;\n  top: 50%;\n  left: 50%;\n}\n\n\n","/***********************Ask Datatram*********************/\n@import '../../styles/variables.scss';\n.chatbot-container {\n  position: fixed;\n  bottom: 42px;\n  right: 20px;\n  background: #2c68ad;\n  z-index: 9999;\n  border-radius: 20px;\n  margin-right: 10px;\n  margin-bottom: -10px;\n}\n\ndiv.chatbot-header {\n  cursor: pointer;\n\n  padding: 10px;\n}\n.campaign-search-input{\n  height: 45px !important;\ncolor: rgba(0, 0, 0, 0.88);\n\n}\n.campaign-search-input {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 8px 12px;\n  transition: border-color 0.2s ease;\n    margin-bottom: 2px !important;\n}\n\n.campaign-search-input:hover {\n  border-color: #3b82f6; /* Tailwind blue-500 */\n}\n\n.campaign-search-input:focus {\n  border-color: #3b82f6; /* Blue border on focus */\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);\n}\n\n.header-shadow {\n  color: grey;\n}\n\n.bot-description {\n  color: #a0aec0;\n  font-size: small;\n  padding: 14px;\n  text-align: center;\n}\nimg.enterBTN-chat {\n  cursor: pointer;\n}\n\n.convo-background {\n  width: 40%; /* Adjust size as needed */\n  height: auto;\n  display: block; /* Ensures margin auto works */\n  margin: 0 auto; /* Centers horizontally */\n  margin-top: 15px;\n}\n\n.chatbox {\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n  width: 370px;\n  //min-height: 450px !important;\n  height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n.menuHeading {\n  color: #140054;\n  font-size: 14px;\n  font-weight: bolder;\n}\n\n.askDT-logo {\n    width: 100px;\n    height: 80px;\n}\n.askDT-logo-inside {\n    width: 70px;\n    height: 50px;\n    margin-right: -20px;\n    margin-left: -10px;\n}\n.menuOption span {\n  color: #718096;\n  font-size: 12px;\n}\n\n.menuHeader {\n  display: flex;\n  justify-content: space-between; /* Pushes items to opposite ends */\n  align-items: center; /* Aligns them vertically */\n  width: 100%; /* Ensures it takes full width */\n  padding: 10px; /* Optional: Add spacing */\n}\n\ndiv.chatbot-container.closed {\n  outline: #007bff;\n  z-index: 9999;\n}\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip-text {\n  position: absolute;\n  bottom: 120%; /* Position above the circle */\n  background-color: #555; /* Grey background */\n  color: #fff; /* White text */\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease;\n  z-index: 1000;\n}\n\n/* The launcher is draggable anywhere on screen, so a fixed centered tooltip can run off\n   whichever edge it's dragged near — grow away from that edge instead of straddling it. */\n.tooltip-text--left {\n  left: 0;\n}\n\n.tooltip-text--right {\n  left: auto;\n  right: 0;\n}\n\n.tooltip-container:hover .tooltip-text {\n  opacity: 1;\n  visibility: visible;\n}\n.chatbot-border {\n  width: 60px;              /* circle size */\n  height: 60px;\n  border-radius: 50%;       /* makes it a perfect circle */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #2C68AD;        /* inner fill */\n  border: 10px solid #2C68AD; /* thick blue border */\n  cursor: pointer;\n  position: fixed;          /* floating button */\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n}\n.chatbot-border:active {\n  cursor: grabbing;\n}\n\n.chatbot-logo {\n  width: 40px;\n  height: 40px;\n}\n.chatbot-border:focus {\n  outline: 3px solid #007bff;  /* blue outline when focused */\n  outline-offset: 2px;         /* small spacing from border */\n}\n\n.blue-border {\n  border-color: #0172cb !important;\n  border-width: 2px;\n}\n\n.chatbox-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #2c68ad;\n  padding: 0 8px;\n  border-bottom: 1px solid #007bff;\n}\n\n.chatbox-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chatbot-heading {\n  font-size: 14px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.chatbox-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chatbot {\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 10px;\n  border-radius: 25px;\n  border: #007bff;\n  cursor: pointer;\n  color: white;\n}\n\n.chatbot-button .logo {\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n}\n\n.chatbot-title {\n  color: white;\n  font-weight: bolder;\n  margin-right: 10px;\n}\n\n.chatbox-header .logo {\n  width: 25px;\n  height: 25px;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.conversation-area {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n  background: white;\n}\n\n.input-area {\n  display: flex;\n  padding: 8px;\n  background: #fff;\n  border-top: 1px solid #ddd;\n}\n\n.input-area input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  font-size: 12px;\n  margin-right: 15px;\n}\n\n.enterBTN-chat {\n  padding: 5px;\n}\n\n.options-chatbot {\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n.menuOption img {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n\n.chat-messages {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 1px;\n  overflow-y: auto;\n}\n\n.message {\n  padding: 8px 12px;\n  max-width: 80%;\n  position: relative;\n  min-width: 80px;\n  min-height: 50px;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */\n  margin-bottom: 2px;\n}\n\n.message.user {\n  align-self: flex-end;\n  background-color: #2C68AD;\n  color: white;\n  font-size: 12px;\n  border-radius: 10px;\n  font-weight: 400;\n  font-family: 'opensans', sans-serif;\n      width: 200px;\n}\n\n.message.bot {\n  align-self: flex-start;\n  background-color: #2C68AD29; /* light gray/blue */\n // padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #000000;\n  text-align: left;\n  max-width: 80%;\n  font-weight: 500;\n  font-family: 'opensans', sans-serif;\n  margin-left: 35px;\n}\n\n.timestamp {\n  font-size: 10px;\n  position: absolute;\n  bottom: 4px;\n  right: 8px;\n  font-style: italic;\n  margin-top: 5px;\n  color: #fff;\n}\n\n.message-text {\nmargin-bottom: 5px;\n    text-align: justify;\n    font-size: 14px;\n        color: #000000;\n    font-family: \"opensans\", sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n}\n\n.suggested-question {\n  border-radius: 25px; \n  border: 2px solid skyblue; \n  background-color: #e0f7ff; \n  padding: 5px 8px;\n  font-size: 12px;\n  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1); \n  cursor: pointer; \n  transition: background 0.2s ease-in-out;\n  margin: 5px 10px; \n  min-height: 50px; \n  display: flex;\n  align-items: center;\n  justify-content: center; \n  text-align: center;\n  color:#FFFFFF;\n    font-weight: 400;\n  font-family: 'opensans', sans-serif;\n}\n\n.suggested-question:hover {\n  background-color: #cceeff;\n}\n\n.chatbot-header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; /* ✅ left alignment */\n  text-align:left;\n}\n\n.expand-icon {\n  opacity: 1 !important;\n  filter: none !important;\n}\n\n.suggested-questions-heading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n  margin: 10px 0;\n  position: relative;\n  text-transform: uppercase;\n}\n\n.suggested-questions-heading::before,\n.suggested-questions-heading::after {\n  content: \"\";\n  flex: 1;\n  height: 2px;\n  background-color: #cceeff;\n  margin: 0 10px;\n}\n\n.submenu-question {\n  font-size: 10px;\n  color: #718096;\n  padding-left: 45px;\n  padding-top: 5px;\n  padding-right: 10px;\n  border-radius: 5px;\n  background-color: #fff;\n  cursor: pointer;\n}\n.menuOption img:last-child {\n  width: 10px;\n  height: 10px;\n}\n.question-icon {\n  width: 20px;\n  height: 10px;\n  padding-right: 10px;\n}\n\n.chatbot-welcome-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.chatbot-avatar {\n  flex-shrink: 0;\n  margin-right: 8px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: #2C68AD !important;\n  overflow: hidden;\n  width: 32px;\n  height: 32px;\n  margin-top: 0; \n  align-self: flex-start; \n}\n.chatbot-welcome-message {\n  background-color: #2C68AD29; \n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #000000;\n  text-align: left;\n  max-width: 80%;\n  font-weight: 400;\n  font-family: 'opensans', sans-serif;\n}\n.quick-action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 0 18px;\n  margin: 0 0 8px;\n}\n\n.chatbot-action-button {\n  background-color:#fff;\n  border: 1px solid #b8d2f1;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f63ad;\n  cursor: pointer;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.chatbot-action-button .arrow {\n  width: 12px;\n  height: 12px;\n  margin-top: 10px;\n  margin-left: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chatbot-action-button .arrow img {\n  width: 12px;\n  height: 12px;\n}\n\n[dir=\"rtl\"] .chatbot-action-button .arrow img {\n  transform: scaleX(-1);\n}\n\n.chatbot-action-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chatbot-action-icon {\n  color: #1f63ad;\n  line-height: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n}\n\n.chatbot-action-icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.chatbot-action-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.chatbot-action-title {\n  color: #1f63ad;\n  font-size: 12px;\n  line-height: 1.2;\n  font-weight: 700;\n}\n\n.chatbot-action-subtitle {\n  color: #6b7280;\n  font-size: 10px;\n  line-height: 1.2;\n  font-weight: 400;\n}\n\n.chatbot-action-button:hover {\n  background-color: #edf3fb;\n  border-color: #8db6e5;\n}\n.chatbot-send-button{\n background-color: transparent !important;\n    border: none;\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin-left: 18px;\n  padding: 0;\n\n}\n.send-icon {\n  transform: rotate(45deg); \n  transition: transform 0.2s ease;\n  margin-right: 15px;\n}\n.clip-icon {\n  transform: rotate(-90deg); \n  transition: transform 0.2s ease;\n  margin-right: 15px;\n}\n.category-bubble-container {\n  display: flex;\n  margin: 8px 0;\n  max-width: 100%;\n  align-items: flex-start;\n  padding: 0 16px 0 0; \n  width: 100%;\n  box-sizing: border-box;\n}\n\n.category-selection-container {\n  background: #2C68AD29;\n  border-radius: 18px;\n  padding: 12px 16px;\n  margin-left: 5px; \n  max-width: calc(100% - 64px); \n  position: relative;\n  word-wrap: break-word;\n  margin-right: 16px;\n  box-sizing: border-box;\n  flex: 1;\n  align-self: flex-start; \n}\n\n.category-prompt {\n  font-size: 14px;\n  margin-bottom: 12px;\n  color: #333;\n}\n\n.category-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.category-search-empty {\n  font-size: 13px;\n  color: #555;\n  margin: 0 0 10px;\n  line-height: 1.4;\n}\n\n.category-grid .category-search-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  padding: 8px 10px;\n  border: 1px solid $text-dark;\n  border-radius: 8px;\n  background-color: #fff;\n  align-self: start;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  grid-column: 1 / -1;\n}\n\n.category-grid .category-search-cell:focus-within {\n  border-color: $brand-primary;\n  box-shadow: 0 0 0 2px rgba(44, 104, 173, 0.12);\n}\n\n.category-grid .category-search-icon {\n  flex-shrink: 0;\n  color: #64748b;\n  width: 12px;\n  height: 12px;\n}\n\n.category-grid .category-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 12px;\n  font-family: \"opensans\", sans-serif;\n  font-weight: 400;\n  color: #333;\n  padding: 0;\n  text-align: start;\n}\n\n.category-grid .category-search-input::placeholder {\n  color: #888;\n}\n\n[dir=\"rtl\"] .category-search-cell {\n  flex-direction: row-reverse;\n}\n\n.category-item {\n padding: 8px 0px;\n  border: 1px solid $text-dark;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.2s ease-in-out;\n  background-color: #fff;\n}\n\n.category-item:hover {\n  border-color: $text-dark;\n  background: $background-light;\n}\n\n.category-item.selected {\n  background-color: rgba(44, 104, 173, 0.18); \n    border-color: $brand-primary;\n}\n\n.category-name {\n  font-size: 12px;\n  font-family: 'opensans', sans-serif;\n  font-weight: 400;\n}\n\n.category-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.proceed-button {\n  background: #2C68AD;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  margin-right: 5px;\n    &:hover:not(:disabled) {\n    background-color: #23538A;\n  }\n\n  &:disabled {\n    background-color: #9ca3af;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n}\n\n.proceed-button:hover {\n  background: #3a7bb0;\n}\n.campaign-options-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* 2 per row */\n  gap: 12px; /* spacing between buttons */\n  margin: 12px 12px;\n}\n\n.campaign-option-button {\n background-color: #ffffff;\n  border: 2px solid #9E9B9B;\n  padding: 5px 8px;\n  border-radius: 8px;\n  font-size: 10px;\n  font-weight: 500;\n  color: #000000;\n  cursor: pointer;\n  text-align: left; /* so text + arrow align properly */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.campaign-option-button:hover {\n  border-color: #ff6c00;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n}\n\n.campaign-option-button .arrow img {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n[dir=\"rtl\"] .campaign-option-button .arrow img {\n  transform: scaleX(-1);\n}\n\n.promptbox-container {\n  background: #2C68AD29;\n  border-radius: 12px;\n  padding: 16px;\n  margin: 15px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  width: 80% !important;\n  margin-left: 35px;\n}\n.promptbox-subtitle {\n    margin-bottom: 5px;\n    text-align: justify;\n    font-size: 14px;\n      color: #000000;\n    font-family: 'opensans',sans-serif;\nfont-weight: 400;\n}\n\n.promptbox-textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  margin-bottom: 16px;\n}\n\n.promptbox-tone-section {\n  margin-bottom: 16px;\n}\n\n.promptbox-tone-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.promptbox-tone-btn {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 6px 12px;\n  background: #f7f7f7;\n  cursor: pointer;\n}\n\n.promptbox-tone-btn.active {\n  background: #2C68AD;\n  color: #fff;\n  border-color: #2C68AD;\n}\n\n.promptbox-form-section {\n  margin-bottom: 12px;\n}\n\n.promptbox-input {\nwidth: 100%;\n    padding: 6px 10px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-size: 12px;\n}\n\n.promptbox-loading {\n  margin-left: 8px;\n}\n\n.menu-questions-container {\n  margin: 12px 0;\n  padding: 12px;\n  background: #f9f9f9;\n  border-radius: 12px;\n  width: 80%;\n}\n\n.menu-questions-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.menu-question-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.menu-question-btn:hover {\n  background: #f0f0f0;\n}\n\n.menu-question-icon {\n  width: 20px;\n  height: 20px;\n}\n/* Common row */\n.message-row {\n  display: flex;\n  align-items: flex-start;\n  margin: 8px 0;\n  direction: ltr;\n}\n\n/* Bubbles */\n.message-bubble {\n  max-width: 70%;\n  padding: 10px 14px;\n  border-radius: 10px;\n  word-break: break-word;\n  unicode-bidi: plaintext;\n}\n\n.message-bubble ul,\n.message-bubble ol,\n.message-bubble li {\n  color: currentColor;\n}\n\n.message-bubble ul,\n.message-bubble ol {\n  margin: 0.5rem 0;\n  padding-left: 1.25rem;\n}\n\n.message-bubble li {\n  margin: 0.25rem 0;\n  padding-left: 0;\n}\n\n.message-bubble p {\n  margin: 0.5rem 0;\n}\n\n.message-bubble > *:first-child {\n  margin-top: 0;\n}\n\n.message-bubble > *:last-child {\n  margin-bottom: 0;\n}\n\n/* Bot bubble (blue background) */\n.bot-bubble {\n  background: #2C68AD29;\n  color: #000000;\n    font-family: 'opensans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n      margin-left: 5px\n}\n\n/* User bubble (keep your existing style) */\n.user-bubble {\n  background: #2C68AD;\n  color: #fff;\n  margin-left: auto; /* push to right */\n  border-radius: 10px 10px 0 10px;\n  font-family: 'opensans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n}\n.show-more-button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    gap: 4px;\n    margin-bottom: 20px;\n    font-family: \"opensans\", sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    align-items: center !important;\n    justify-content: center;\n      display: block;\n  margin: 0 auto;\n  padding: 10px;\n}\n.typing-message {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 10px 0;\n}\n\n.typing-wrapper {\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n.message.bot {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.typing-bubble {\n  background: #2C68AD29;\n  color: #000000;\n  padding: 10px 14px;\n  border-radius: 10px;\n  max-width: 70%;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: -6px;\n}\n.typing-container {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: inherit;\n      margin-top: 7px;\n      \n}\n\n.typing-text {\n  font-size: 14px;\n  color: #555;\n  font-style: italic;\n  font-family: 'opensans', sans-serif;\n  animation: blinkText 1.6s infinite;\n}\n\n@keyframes blinkText {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n.typing-indicator {\n  display: flex;\n  gap: 3px;\n}\n\n.typing-indicator span {\n  width: 6px;\n  height: 6px;\n  background-color: #777;\n  border-radius: 50%;\n  display: inline-block;\n  animation: typingBlink 1.4s infinite both;\n}\n\n.typing-indicator span:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typingBlink {\n  0% {\n    opacity: 0.3;\n    transform: translateY(0);\n  }\n  20% {\n    opacity: 1;\n    transform: translateY(-3px);\n  }\n  40% {\n    opacity: 0.3;\n    transform: translateY(0);\n  }\n}\n.template-action-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n.template-btn {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  border: none;\n  transition: background 0.2s ease;\n}\n\n.template-btn.primary {\n  background-color: #2c68ad;\n  color: #fff;\n}\n\n.template-btn.primary:hover {\n  background-color: #1e4c7d;\n}\n\n.template-btn.secondary {\n  background-color: #f2f2f2;\n  color: #333;\n}\n\n.template-btn.secondary:hover {\n  background-color: #e0e0e0;\n}\n.ant-picker-dropdown {\n  z-index: 9999 !important;\n}\n\n.audience-selection-container {\n  margin-bottom: 24px;\n}\n\n.audience-list-heading,\n.custom-list-heading {\n      font-size: 14px;\n    font-weight: 600;\n    color: #222;\n    margin-bottom: 12px;\n    margin-top: 24px;\n    font-family: \"opensans\", sans-serif;\n    margin-left: 35px;\n    \n}\n\n.audience-list-heading {\n  margin-top: 0;\n}\n\n/* Search cell sits in first grid slot; matches .campaign-option-button frame */\n.campaign-screen-grid .audience-list-search-cell,\n.campaign-options-grid .audience-list-search-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  box-sizing: border-box;\n  background-color: #ffffff;\n  border: 2px solid #9e9b9b;\n  border-radius: 8px;\n  padding: 5px 8px;\n  align-self: start;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n  grid-column: 1 / -1;\n}\n\n.campaign-screen-grid .audience-list-search-cell:hover,\n.campaign-options-grid .audience-list-search-cell:hover {\n  border-color: #2c68ad;\n  box-shadow: 0 1px 4px rgba(44, 104, 173, 0.1);\n}\n\n.campaign-screen-grid .audience-list-search-cell:focus-within,\n.campaign-options-grid .audience-list-search-cell:focus-within {\n  border-color: #2c68ad;\n  box-shadow: 0 1px 4px rgba(44, 104, 173, 0.18);\n}\n\n.campaign-screen-grid .audience-list-search-icon,\n.campaign-options-grid .audience-list-search-icon {\n  flex-shrink: 0;\n  color: #5b6570;\n  width: 12px;\n  height: 12px;\n}\n\n.campaign-screen-grid .audience-list-search-input,\n.campaign-options-grid .audience-list-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: #000000;\n  font-size: 10px;\n  font-weight: 500;\n  font-family: inherit;\n  line-height: 1.35;\n  padding: 0;\n}\n\n.campaign-screen-grid .audience-list-search-input::placeholder,\n.campaign-options-grid .audience-list-search-input::placeholder {\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.audience-list-empty-filter {\n  margin: 0 12px 8px 35px;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n[dir=\"rtl\"] .audience-list-search-cell {\n  flex-direction: row-reverse;\n}\n\n.campaign-options-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px 16px;\n  margin-bottom: 8px;\n  margin-left: 35px;\n}\n\n//clear chat \n.chatbot-menu-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.chatbot-menu-dots {\n  font-size: 26px;\n  color: #fff;\n  padding: 0 8px;\n  user-select: none;\n      margin-bottom: 2px;\n}\n.chatbox-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color:#fff;\n\n  .expand-icon {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    transition: transform 0.2s ease, opacity 0.2s ease;\n    opacity: 0.8;\n    \n    &:hover {\n      transform: scale(1.1);\n      opacity: 1;\n    }\n  }\n}\n.chatbot-menu-dropdown {\n  position: absolute;\n  top: 32px;\n  right: 0;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.12);\n  z-index: 10;\n  min-width: 120px;\n  padding: 4px 0;\n}\n\n.chatbot-menu-dropdown button {\n  background: none;\n  border: none;\n  width: 100%;\n  text-align: left;\n  padding: 10px 18px;\n  font-size: 13px;\n  font-family: 'opensans', sans-serif;\n  color: #d32f2f;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.15s;\n  font-weight: 600;\n}\n\n.chatbot-menu-dropdown button:hover {\n  background: #f5f5f5;\n}\n\n.confirm-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 10px;\n      margin-left: 40px;\n}\n.schedule-picker-box {\n  margin-top: 1rem;\n  padding: 1.5rem;\n  background-color: rgba(44, 104, 173, 0.1607843137);\n  border-radius: 1rem;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n  width: 100%;\n  margin-left: 35px;\n    max-width: 270px;\n  animation: fadeIn 0.3s ease-in-out;\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n}\n\n.schedule-picker-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #222;\n  font-family: 'opensans', sans-serif;\n}\n.schedule-picker-paragraph{\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #222;\n  font-family: 'opensans', sans-serif;\n}\n.schedule-picker-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n    color: #222;\n  font-family: 'opensans', sans-serif;\n}\n.schedule-picker-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #444;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: 'opensans', sans-serif;\n}\n\n.schedule-picker-input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 0.5rem;\n  font-size: 0.9rem;\n  color: #333;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\nfont-family: 'opensans', sans-serif;\n  &:focus {\n    border-color: #2563eb;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n    outline: none;\n  }\n}\n.schedule-label{\n  display: block;\n    margin-bottom: 5px;\n    color: #000;\n    font-size: 14px;\n    font-weight: 600;\n    margin-top: 5px;\n    font-family: \"opensans\", sans-serif;\n}\n.schedule-picker-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.preset-button {\n  background-color: $white;\n  border: 1px solid $text-dark;\n  border-radius: 0.5rem;\n  padding: 0.4rem 0.75rem;\n  font-size: 0.85rem;\n  color: #374151;\n  cursor: pointer;\n  width: 100%;\n    text-align: left;\n  transition: all 0.2s ease;\n\n  &:hover {\n     background: $background-light;\n  }\n\n  &:active {\n   background-color: rgba(44, 104, 173, 0.18);\n    border-color: #2c68ad;\n  }\n}\n.schedule-actions{\n  margin-top: 10px;\n}\n.confirmation-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 8px;\n  margin-left: 35px;\n    margin-right: 35px;\n}\n.yes-button {\n  background-color: #2C68AD;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.no-button {\n  background-color: #e4e4e4;\n  color: #333;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.required-star {\n  color: red;\n  margin-left: 4px;\n}\n.compact-input-area {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 60px;\n  margin: 0 5px 7px;\n  padding: 8px 12px;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  width: calc(100% - 10px);\n  min-width: 0;\n}\n\n/* ✅ Inner row for input and buttons */\n.input-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* ✅ Make input take available width */\n.input-row input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  background: transparent;\n}\n\n.compact-input-area {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: calc(100% - 10px);\n  margin-left: 5px;\n  margin-right: 5px;\n  box-sizing: border-box;\n  padding: 4px 12px;\n  border-radius: 34px;\n  min-width: 0;\n}\n\n/* Host wraps ChatComposerPanel (unified border + notice); strip inner pill chrome */\n.compact-input-area--composer-panel-host {\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  padding: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  width: 100% !important;\n  gap: 10px;\n}\n\n.file-preview-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  margin: 0 0 4px;\n  box-sizing: border-box;\n}\n\n.file-thumbnail {\n  position: relative;\n  box-sizing: border-box;\n}\n\n/* Image preview: fixed tile, remove control inside corner (no overlap with outer pill) */\n.file-thumbnail--image {\n  width: 102px;\n  height: 72px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f1f5f9;\n}\n\n.file-thumbnail--image .remove-file-btn {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  z-index: 2;\n}\n\n/* Documents / CSV / PDF: full-width row, chip truncates long names */\n.file-thumbnail--document {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  height: auto;\n  padding: 2px 0 4px;\n}\n\n.file-thumbnail--document .file-chip {\n  flex: 1;\n  min-width: 0;\n}\n\n.file-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 8px 10px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.file-icon {\n  flex-shrink: 0;\n  display: inline-flex;\n  color: #2c68ad;\n}\n\n.file-name {\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #334155;\n  text-align: start;\n}\n\n.thumbnail-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n  border: 4px solid #6b7280;\n}\n\n.remove-file-btn {\n  background: #2c68ad;\n  color: #ffffff;\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  min-height: 22px;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n  flex-shrink: 0;\n}\n\n.remove-file-btn--inline {\n  position: static;\n}\n\n.remove-file-btn:hover {\n  background: #1f63ad;\n}\n\n.remove-file-btn:focus-visible {\n  outline: 2px solid rgba(44, 104, 173, 0.45);\n  outline-offset: 2px;\n}\n\n.input-row {\n  display: flex;\n  align-items: center;\n  border-radius: 20px;\n  padding: 0 2px;\n\n}\n\n.input-row input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  padding: 0 8px;\n  min-height: 28px;\n}\n\n.chatbot-send-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n}\n\n.clip-icon, .send-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.chat-input-attach-trigger {\n  display: inline-flex;\n}\n\n.input-row .chat-input-icon {\n  transform: none !important;\n  margin: 0 !important;\n}\n\n.chat-input-icon-button.disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.chat-input-icon-button.disabled .chat-input-icon {\n  color: #8ca3c0;\n}\n\n/* ✅ Ensure buttons stay centered */\n.chatbot-send-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  /* Earlier .chatbot-send-button rule locks width/height to 10px, clipping\n     the 18px icon down to an invisible sliver — reclaim real size here. */\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  margin-left: 0;\n  overflow: visible;\n}\n.chat-file {\n  margin-top: 6px;\n  display: flex;\n}\n\n.chat-file.user {\n  justify-content: flex-end;\n}\n\n.chat-file.bot {\n  justify-content: flex-start;\n}\n\n.chat-image-preview {\n  max-width: 220px;\n  max-height: 160px;\n  border-radius: 8px;\n  margin-top: 4px;\n  cursor: pointer;\n  margin-left: 0;\n}\n\n.chat-file-link {\n  display: inline-block;\n  padding: 6px 10px;\n  background: #f5f5f5;\n  border-radius: 6px;\n  text-decoration: none;\n  color: #333;\n  font-size: 14px;\n  margin-left: 0;\n}\n.schedule-picker-box.disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n.template-btn[disabled] {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.clear-chat-btn{\n  margin-top: -5px;\n}\n\n@media (max-width: 480px) {\n  .chatbot-container.open {\n    inset: 0;\n    right: 0;\n    bottom: 0;\n    margin: 0;\n    border-radius: 0;\n    width: 100%;\n    height: 100dvh;\n  }\n\n  .chatbot-container.open .chatbox {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n\n  .chatbot-container.open .conversation-area {\n    min-height: 0;\n  }\n\n  .chatbot-container.open .campaign-options-grid,\n  .chatbot-container.open .category-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .message-bubble {\n    max-width: calc(100% - 44px);\n  }\n}\n","html,\r\nbody,\r\n#root {\r\n  height: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.sidebar + .ant-layout {\r\n  height: 100vh;\r\n  max-height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.ant-layout-has-sider {\r\n  min-height: 100vh;\r\n  height: 100vh;\r\n  display: flex;\r\n  overflow: hidden; \r\n}\r\n\r\n.sidebar + .ant-layout .ant-layout-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow-y: auto;\r\n}\r\n.ant-layout {\r\n  min-height: 86vh;\r\n  min-height: 0;\r\n}\r\n.ant-layout-content {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar-thumb {\r\n  background: rgba(0, 0, 0, 0.18);\r\n  border-radius: 10px;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.sidebar.ant-layout-sider {\r\n  height: 100vh;\r\n  max-height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.sidebar .ant-layout-sider-children {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n.sidebar + .ant-layout {\r\n  margin-inline-start: 0 !important;\r\n  padding-inline-start: 0 !important;\r\n}\r\n\r\n.sidebar {\r\n  background-color: #2c68ad;\r\n  transition: width 0.25s ease;\r\n  overflow-x: hidden;\r\n  padding: 0;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n  height: 100vh;\r\n  max-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sidebar-hamburger {\r\n  position: fixed;\r\n  top: 12px;\r\n  inset-inline-start: 12px;\r\n  z-index: 1100;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background: #2c68ad;\r\n  color: #ffffff;\r\n  font-size: 20px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.sidebar-hamburger svg {\r\n  display: block;\r\n}\r\n\r\n.sidebar--drawer {\r\n  height: 100%;\r\n}\r\n\r\n.sidebar-inner {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.45) rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.sidebar-sections {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar-track {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  border-radius: 10px;\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.45);\r\n  border-radius: 10px;\r\n  border: 2px solid rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.sidebar-inner.collapsed {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.sidebar-logo {\r\n  height: 64px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  margin-top: 25px !important;\r\n}\r\n\r\n.section-header .collapsed {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 18px !important;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  margin: 4px 8px;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.section-header.open {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 6px 8px !important;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  margin: 4px 8px;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.section-header.open:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.section-header.open .icon {\r\n  width: 15px;\r\n  height: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 10px;\r\n}\r\n\r\n.section-header.open .label {\r\n  flex: 1;\r\n}\r\n\r\n.sidebar-icon-img {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.sub-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 8px 8px 10px;\r\n  padding-inline-start: 35px;\r\n  margin: 2px 8px;\r\n  font-size: 12px;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.sub-item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.item-label {\r\n  font-weight: 500;\r\n}\r\n.item-icon {\r\n  min-width: 20px;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n.sub-active {\r\n  background: #2a5f99;\r\n}\r\n\r\n.sub-sub-item {\r\n  padding: 6px 16px;\r\n  padding-inline-start: 68px;\r\n  margin: 2px 8px;\r\n  border-radius: 6px;\r\n  font-size: 12.5px;\r\n  color: #eaf1fb;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.sub-sub-item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.sub-sub-active {\r\n  background: #3a78b8;\r\n  color: #ffffff;\r\n}\r\n\r\n.sidebar.collapsed .section-header {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 16px;\r\n}\r\n\r\n.sidebar.collapsed .label,\r\n.sidebar.collapsed .sub-item,\r\n.sidebar.collapsed .sub-sub-item {\r\n  display: none;\r\n}\r\n\r\n.section-arrow {\r\n  margin-inline-end: 15px;\r\n  font-size: 12px;\r\n  color: #ffffff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.section-header.section-active {\r\n  background: #23538a;\r\n  color: white;\r\n}\r\n\r\n.sub-item.sub-active,\r\n.sub-sub-item.sub-sub-active {\r\n  background-color: #23538a;\r\n  color: white;\r\n}\r\n\r\n.sub-item.sub-active .item-label,\r\n.sub-sub-item.sub-sub-active .label {\r\n  color: white;\r\n}\r\n\r\n.sidebar-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-shrink: 0;\r\n  padding: 16px 18px;\r\n  margin-top: auto;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.18);\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.sidebar-footer:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.sidebar-footer.collapsed {\r\n  justify-content: center;\r\n  padding: 16px;\r\n}\r\n\r\n.sidebar-footer__icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.home-layout-shell .home-layout-main.responsive-margin,\r\n.home-layout-shell .home-layout-main.header-style {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .home-layout-shell .home-layout-main,\r\n  .home-layout-shell .home-layout-main.responsive-margin,\r\n  .home-layout-shell .home-layout-main.header-style {\r\n    margin-left: 0 !important;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .home-layout-shell .ant-layout-content {\r\n    margin-inline-start: 0 !important;\r\n    padding-inline-start: 0 !important;\r\n  }\r\n}\r\n","@import \"./variables\";\n/*********Loading Screen**********/\n\n.loading-screen-container {\n  margin: 0;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: Arial, sans-serif;\n  box-sizing: border-box;\n}\n\n.loading-screen-heading {\n  margin-top: -20px;\n  font-size: 3vw;\n  font-weight: bolder;\n  color: $white;\n}\n\n.loading-screen {\n  background-image: url(\"D:\\Datatram\\datatram-fe\\public\\images\\Loading-Background.jpg\") !important;\n  background-size: cover;\n  height: 100%;\n\n  background-repeat: no-repeat;\n\n  background-position: center;\n\n  overflow-x: hidden;\n\n  overflow-y: hidden;\n}\n\n.loading-content {\n  text-align: center;\n}\n\n.loading-gif {\n  margin-top: 20px;\n  width: 30%;\n}\n\n.dt-logo-loading-scr {\n  position: absolute;\n  top: 4%;\n  left: 2%;\n  z-index: 10;\n}\n\n.dt-logo-loading-scr img {\n  height: auto;\n  width: 100%;\n}\n\n.page-enter {\n  opacity: 0;\n}\n\n.page-enter-active {\n  opacity: 1;\n  transition: opacity 800ms ease-in-out;\n}\n\n.page-exit {\n  opacity: 1;\n}\n\n.page-exit-active {\n  opacity: 0;\n  transition: opacity 3000ms ease-in-out;\n}\n\n.custom-progress .ant-progress-text {\n  color: $white !important;\n}\n\n.ant-progress-text {\n  font-size: 1.5vw;\n}\n\n.custom-progress .ant-progress-status-success .ant-progress-text-success {\n  color: $white !important;\n  font-size: 1.5vw;\n}\n\n.custom-progress .ant-progress-text-success {\n  color: $white !important;\n}\n\n.fade-out {\n  opacity: 0;\n  transition: opacity 1.5s ease-out;\n}\n\n.loading-screen-heading.now-see-the-magic {\n  opacity: 1;\n  animation: fadeIn 2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.connected {\n  border: 2px solid $success;\n  background-color: rgba(40, 167, 69, 0.2);\n  border-radius: 55px;\n  width: 55px;\n  height: 55px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.tableau-container {\n  border: 1px solid $border-dark;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n// Generic horizontal scroll wrapper for Tableau dashboards\n.tableau-scroll-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.tableau-scroll-inner {\n  display: inline-block;\n  width:100%;\n}\n\n\n.over-flow-y {\n  overflow-y: hidden;\n  max-height: 100vh;\n}\n\n.payment-card {\n  width: 95px;\n  height: 90px;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n.card {\n  width: 320px;\n  height: 190px;\n  padding: 10px;\n  border: none;\n}\n\n\n.zoomable-div:hover {\n  transform: scale(1.02);\n  border-color: $color-1890ff;\n  border-radius: 5px;\n}\n\n.zoomable-div-two {\n  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;\n  border: 1px solid;\n  border-color: transparent;\n  padding: 10px;\n  border-radius: 2px;\n  width: 300px;\n  margin-top: 5%;\n}\n\n.zoomable-div-two:hover {\n  transform: scale(1.02);\n  border-color: $color-1890ff;\n  border-radius: 5px;\n}\n.zoomable-div {\n  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;\n  border: 1px solid;\n  border-color: transparent;\n  padding: 10px;\n  border-radius: 2px;\n  width: 300px;\n  max-width: 300px;\n  margin-top: 15%;\n}\n\n","/**************************************PAYMENT CONTAINER AND PAYMENTCONFIRMATION******************************/\n\n@media (max-width: 480px) {\n  .payment-image {\n    margin-bottom: 20px;\n    width: 200px;\n    height: 155px;\n    padding-top: 40px;\n  }\n}\n\n//payment page not icon\n@media (max-width: 480px) {\n  //payment cofirmation\n  .group-image {\n    margin-bottom: 10px;\n    width: 200px;\n    height: 150px;\n    padding-top: 40px;\n  }\n\n  //payment confirmation\n  @media (max-width: 480px) {\n    .pc {\n      color: var(--text, #718096);\n      font-family: Open Sans;\n      font-size: 8px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n      padding-top: 15px;\n    }\n  }\n\n  //payment container\n  .group-image-container {\n    display: flex;\n    padding-left: 40px;\n  }\n\n  //payment container\n  .group-image {\n    margin-bottom: 10px;\n    width: 400px;\n    height: 255px;\n    padding-top: 40px;\n  }\n\n  //payment container\n  .plan-payment-header {\n    display: flex;\n    padding-left: 40px;\n    margin-top: 40px;\n  }\n\n  /**********************************************Payment Confirmation****************************************/\n\n  //testing payment confirmation page content\n\n  @media (max-width: 480px) {\n    .payment-confirm-2 {\n      margin-bottom: 10px;\n      width: 200px;\n      height: 150px;\n      padding-top: 20px;\n      margin-left: 35px;\n    }\n  }\n\n  .payment-container-3 {\n    display: flex;\n    padding-left: 40px;\n    margin-top: 40px;\n  }\n\n  .money-check-2 {\n    width: 30px;\n    height: 25px;\n  }\n\n  .plan-pay-2 {\n    color: #150054;\n    font-size: 13px;\n    font-weight: bold;\n    padding-top: 4px;\n  }\n\n  .paragraph-2 {\n    display: grid;\n    padding-left: 40px;\n  }\n\n  //payment confirmation\n\n\n  .plan-payment-title {\n    color: #150054;\n    font-size: 13px;\n    font-weight: bold;\n    padding-top: 4px;\n    margin-left: 10px;\n  }\n\n  //payment confirmation\n  .payment-details {\n    display: flex;\n  }\n\n  //payment confirmation\n  .payment-labels,\n  .payment-values {\n    display: grid;\n    padding-left: 40px;\n  }\n\n  //payment confirmation\n  .subscription-info {\n    margin-top: 21px;\n  }\n\n  //payment confirmation\n  .upgrade-container {\n    display: flex;\n  }\n\n  //payment confirmarion\n\n\n  //payment confirmation\n  .upgrade-text {\n    color: #38abd2;\n    text-align: left;\n    padding-left: 4px;\n  }\n\n  //payment confirmation\n  .payment-method {\n    margin-top: 20px;\n  }\n\n  //payment confirmation\n\n\n  //payment confirmationi\n  .billing-info {\n    margin-top: 25px;\n  }\n\n  //payment confriamtion\n  .plan-payment-title {\n    color: #150054;\n    font-size: 10px;\n    font-weight: bold;\n    padding-top: 4px;\n    margin-left: 65px;\n  }\n\n  //payment confirmation\n  .subscription-info {\n    margin-top: 21px;\n    font-size: 8px;\n  }\n\n  //payment confirmation\n  .pcr {\n    color: var(--placeholder, #a0aec0);\n    font-family: Open Sans;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 400;\n    margin-top: 21px;\n  }\n}\n.payment-confirmation {\n  display: grid;\n  padding-left: 50px;\n}\n\n.payment-confirm-2 {\n  margin-bottom: 40px;\n  width: 450px;\n  height: 300px;\n  padding-top: 30px;\n}\n\n.payment-confirmation-heading {\n  padding-top: 20px;\n  padding-left: 20px;\n  text-align: left;\n  margin-left: 20px;\n}\n\n\n/*********** PaymentConfrimation**********/\n\n.payment_method {\n  display: flex;\n  flex-direction: row;\n}\n\n//PAYMENT POP UP\n\n  @media (max-width: 480px) {\n    .card {\n      width: 150px;\n      height: 100px;\n      padding: 10px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    @media (max-width: 480px) {\n      .paynow {\n        max-width: 100px;\n        color: var(--white, #fff);\n        text-align: center;\n        font-family: \"Open Sans\";\n        font-size: 10px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 8px;\n        padding: 5px;\n      }\n    }\n\n  }\n\n  .paynow {\n  width: 250px;\n  color: var(--white, #fff);\n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  /* 150% */\n}\n\n/*.invoice-page-wrapper {\n  width: 794px;\n  height: 1123px; // A4 height at 96 DPI\n  box-sizing: border-box;\n  padding: 24px;\n  background-color: white;\n  font-family: 'Arial', sans-serif;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto; // center horizontally\n}*/\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.invoice-page-wrapper {\n  width: 210mm;\n  height: 297mm;\n  margin: 0;\n  padding: 0;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  border: 6px solid \\$brand-primary;\n  box-sizing: border-box;\n}\n\n.invoice-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.invoice-bold {\n  font-weight: 700;\n  padding-right: 15px;\n}\n\n.invoice-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 30px 0 30px; // Top padding reduced\n  align-items: flex-start;\n}\n\n.invoice-logo-section {\n  display: flex;\n  align-items: flex-start;\n  padding: 0%;\n  margin-top: 10%;\n  padding-left: 10px;\n}\n\n.invoice-title-wrap {\n  margin-left: 5px;\n}\n\n.invoice-title {\n  text-transform: uppercase;\n  font-size: 18px;\n  color: \\$brand-primary;\n}\n\n.invoice-sub-title {\n  font-size: 12px;\n}\n\n.invoice-info-section {\n  text-align: right;\n  margin-top: 120px;\n  padding: 0 0px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.invoice-heading {\n  font-size: 28px;\n  color: \\$brand-primary;\n}\n\n.invoice-detail-row {\n  display: flex;\n  width: 100%;\n}\n\n.invoice-detail-row span:first-child {\n  width: 90px;\n  text-align: left;\n}\n\n.invoice-detail-row span:last-child {\n  width: calc(100% - 90px);\n}\n\n.invoice-bill-wrap {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 30px;\n  align-items: flex-start;\n  margin-top: -60px;\n}\n\n.invoice-bill-to {\n  font-size: 20px;\n  padding-left: 20px;\n}\n.invoice-name,\n.invoice-final .invoice-price {\n  color: \\$brand-primary;\n  font-size: 20px;\n}\n\n.invoice-main-table {\n  width: 100%;\n  padding-left: 20px;\n  padding-right: 20px;\n  box-sizing: border-box;\n  margin-top: 10%;\n}\n\n.invoice-table-header {\n  background: \\$brand-primary;\n  color: white;\n  font-size: 12px;\n  display: flex;\n  padding: 10px;\n  text-align: center;\n  align-items: center;\n  justify-content:center;\n}\n\n.invoice-table-row {\n  display: flex;\n  border-bottom: 1px solid $blue-400;\n}\n\n.invoice-table-col {\n  padding: 10px;\n}\n\n.invoice-col-description {\n  width: 45%;\n}\n\n.invoice-col-qty {\n  width: 10%;\n  text-align: center;\n}\n\n.invoice-col-unit-price {\n  width: 20%;\n  text-align: center;\n}\n\n.invoice-col-amount {\n  width: 25%;\n  text-align: right;\n}\n\n.invoice-summary-section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  padding: 5px 20px 20px 20px;\n  margin-top: 20px;\n}\n\n.invoice-payment-method {\n  padding-left: 30px;\n}\n\n.invoice-totals {\n  width: 30%;\n  font-size: 14px;\n  margin-bottom: 130px;\n  padding-left: -20px;\n}\n\n.invoice-totals p {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 8px 0;\n  margin: 0;\n}\n\n.invoice-totals p span {\n  padding: 0 10px;\n}\n\n.invoice-totals p span:first-child {\n  width: 60%;\n  text-align: left;\n}\n\n.invoice-totals p span:last-child {\n  width: 40%;\n  text-align: right;\n}\n\n.invoice-totals p:last-child {\n  font-weight: bold;\n\n  span {\n    padding: 12px 15px;\n  }\n\n  span:first-child {\n    background: \\$brand-primary;\n    color: white;\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n  }\n\n  span:last-child {\n    background: \\$brand-primary;\n    color: white;\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n}\n\n.invoice-notes-section {\n  font-weight: 700;\n  margin-top: -90px;\n  padding-left: 20px;\n  align-items: center;\n  justify-content: center;\n}\n\n.invoice-notes-heading {\n  font-size: 16px;\n  text-decoration: underline;\n}\n\n.invoice-notes {\n  font-size: 14px;\n  color: \\$brand-primary;\n  margin-top: -10px;\n}\n\n.invoice-logo {\n  max-width: 200px;\n  height: auto;\n}\n\n.bill-to-heading {\n  font-size: 16px;\n  text-decoration: underline;\n}\n\n.address-description {\n  font-weight: 700;\n}\n\n// responsiveness pdf\n/* Tablets */\n@media (max-width: 1024px) {\n  .invoice-page-wrapper {\n    width: 100%;\n    height: auto;\n    padding: 15px;\n    border-width: 4px;\n  }\n\n  .invoice-heading {\n    font-size: 24px;\n  }\n\n  .invoice-title {\n    font-size: 16px;\n  }\n\n  .invoice-totals {\n    width: 100%;\n  }\n}\n\n/* Mobile phones */\n@media (max-width: 768px) {\n  .invoice-page-wrapper {\n    width: 100%;\n    padding: 10px;\n    border-width: 3px;\n  }\n\n  .invoice-heading {\n    font-size: 20px;\n  }\n\n  .invoice-title {\n    font-size: 14px;\n  }\n\n  .invoice-bill-to,\n  .invoice-name,\n  .invoice-final .invoice-price {\n    font-size: 16px;\n  }\n\n  .invoice-main-table {\n    padding: 0 10px;\n    margin-top: 20px;\n  }\n\n  .invoice-table-header,\n  .invoice-table-row {\n    flex-direction: column;\n    font-size: 12px;\n  }\n\n  .invoice-summary-section {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 10px;\n  }\n\n  .invoice-totals {\n    font-size: 12px;\n    width: 100%;\n    margin-bottom: 40px;\n  }\n\n  .invoice-notes-section {\n    margin-top: 0;\n  }\n}\n/**********************************************PLAN OVERVIEW PAGE**********************************************/\n\n  //for heading\n  @media screen and (max-width: 768px) {\n    .mainheading {\n      margin-top: 40px;\n      margin-left: 15px;\n      font-size: 25px;\n      /* Smaller font size for smaller screens */\n    }\n  }\n\n  @media (max-width: 480px) and (max-width: 480px) {\n    .mainheading {\n      margin-top: 40px;\n      margin-left: 5px;\n      font-size: 15px;\n    }\n  }\n\n  //for link to plan overview page\n  @media (max-width: 480px) {\n    .planpage_switch_link {\n      margin-bottom: 5vw;\n      color: #38abd2;\n      cursor: pointer;\n      text-decoration: underline;\n      margin-left: 3.5%;\n      font-size: 10px;\n    }\n  }\n\n\n  //for containers with the plan details\n  @media (max-width: 480px) {\n    .zoomable-div {\n      /* transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s; */\n      border: 1px solid;\n      border-color: transparent;\n      /* padding: 10px; */\n      border-radius: 2px;\n      max-width: 10px;\n      margin-top: 5%;\n    }\n\n   \n    .h3,\n    h3 {\n      font-size: 10px;\n    }\n\n    .prices {\n      font-weight: 900;\n      color: #130054;\n      font-size: 10px;\n    }\n\n    li {\n      padding: 5px;\n      /* text-align: left; */\n      font-size: 8px;\n    }\n\n    .subscribecmp {\n      max-width: 100px;\n      padding: 5px 5px;\n      flex-direction: column;\n      align-items: center;\n      gap: 10px;\n      background-color: none;\n      border-radius: 3px;\n      border: 1px solid #38abd2;\n      background: #fff;\n      color: #38abd2;\n      text-align: center;\n      font-family: \"Open Sans\";\n      font-size: 5px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 10px;\n      height: 20px;\n    }\n\n    .custom-divider {\n      margin: 1px;\n    }\n  }\n\n// differnt plans\n\n.chooseplan {\n  padding: 50px 0;\n  color: var(--dark-purple, #140054);\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  /* 100% */\n}\n\n\n.comparePlan-cell {\n  display: block !important;\n  align-items: center !important;\n  text-align: center !important;\n  border-color: #333 !important;\n  border: 2px !important;\n}\n\n.subscribedplan {\n  color: var(--dark-purple, #140054);\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  justify-content: center;\n  text-align: left;\n}\n.planpage_switch_link {\n  color: #38abd2;\n  cursor: pointer;\n  text-decoration: underline;\n  margin-left: 3.5%;\n}\n\n.plan-name {\n  color: #130054;\n  font-family: \"Open Sans\";\n  font-weight: lighter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n/************************ Compare Plan ***********************/\n.colHeadings {\n  background-color: white !important;\n  position: sticky;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.heading-price-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n}\n\n\n.rowHeadings {\n  text-align: left !important;\n  font-weight: bolder;\n  color: #000;\n}\n\n.container {\n  margin-left: 3%;\n}\n\n.prices {\n  font-weight: 900;\n  color: #130054;\n  font-size: 28px;\n  margin-top: -5%;\n  margin-left: -2%;\n}\n\n\n\n\n","html,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.invoice-page-wrapper {\n  width: 210mm;\n  height: 297mm;\n  margin: 0;\n  padding: 0;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  border: 6px solid $brand-primary;\n  box-sizing: border-box;\n}\n\n.invoice-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.invoice-bold {\n  font-weight: 700;\n}\n\n.invoice-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 30px 0 30px; // Top padding reduced\n  align-items: flex-start;\n}\n\n.invoice-logo-section {\n  display: flex;\n  align-items: flex-start;\n  padding: 0%;\n  margin-top: 10%;\n  padding-left: 10px;\n}\n\n.invoice-title-wrap {\n  margin-left: 5px;\n}\n\n.invoice-title {\n  text-transform: uppercase;\n  font-size: 18px;\n  color: \\$brand-primary;\n}\n\n.invoice-sub-title {\n  font-size: 12px;\n}\n\n.invoice-info-section {\n  text-align: right;\n  margin-top: 120px;\n  padding: 0 0px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.invoice-heading {\n  font-size: 28px;\n  color: \\$brand-primary;\n}\n\n.invoice-detail-row {\n  display: flex;\n  width: 100%;\n}\n\n.invoice-detail-row span:first-child {\n  width: 90px;\n  text-align: left;\n}\n\n.invoice-detail-row span:last-child {\n  width: calc(100% - 90px);\n}\n.invoice-bill-wrap {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n}\n\n/* Left side: allow to shrink but not overflow the container */\n.invoice-bill-to {\n  flex: 1 1 auto;   \n  min-width: 0;     \n  overflow-wrap: break-word;\n  padding-left: 0;\n}\n\n.total-due-section {\n  flex: 0 0 180px;   \n  text-align: right;\n  white-space: nowrap;\n  text-align: right !important;\n}\n.invoice-name,\n.invoice-final .invoice-price {\n  color: \\$brand-primary;\n  font-size: 20px;\n  padding-left: -30px;\n}\n.invoice-main-table {\n  width: 100%;\n  padding-left: 40px;\n  padding-right: 40px;\n  box-sizing: border-box;\n  margin-top: 10%;\n}\n\n.invoice-table-header {\n  background: \\$brand-primary;\n  color: white;\n  font-size: 12px;\n  display: flex;\n  padding: 10px;\n}\n\n.invoice-table-row {\n  display: flex;\n  border-bottom: 1px solid $blue-400;\n}\n\n.invoice-table-col {\n  padding: 10px;\n}\n\n.invoice-col-description {\n  width: 45%;\n}\n\n.invoice-col-qty {\n  width: 10%;\n  text-align: center;\n}\n\n.invoice-col-unit-price {\n  width: 20%;\n  text-align: center;\n}\n\n.invoice-col-amount {\n  width: 25%;\n  text-align: right;\n}\n\n.invoice-summary-section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  padding: 5px 30px 30px 30px;\n  margin-top: 20px;\n}\n\n.invoice-payment-method {\n  padding-left: 30px;\n}\n\n.invoice-totals {\n  width: 30%;\n  font-size: 14px;\n  margin-bottom: 130px;\n  padding-left: -20px;\n}\n\n.invoice-totals p {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 8px 0;\n  margin: 0;\n}\n\n.invoice-totals p span {\n  padding: 0 10px;\n}\n\n.invoice-totals p span:first-child {\n  width: 60%;\n  text-align: left;\n}\n\n.invoice-totals p span:last-child {\n  width: 40%;\n  text-align: right;\n}\n\n.invoice-totals p:last-child {\n  font-weight: bold;\n\n  span {\n    padding: 12px 15px;\n  }\n\n  span:first-child {\n    background: \\$brand-primary;\n    color: white;\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n  }\n\n  span:last-child {\n    background: \\$brand-primary;\n    color: white;\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n}\n\n.invoice-notes-section {\n  font-weight: 700;\n  margin-top: -90px;\n  margin-left: 40px;\n}\n\n.invoice-notes-heading {\n  font-size: 16px;\n  text-decoration: underline;\n}\n\n.invoice-notes {\n  font-size: 14px;\n  color: \\$brand-primary;\n  margin-top: -10px;\n}\n\n.finance-email {\n  font-size: 14px;\n  color: white;\n  font-weight: 700 !important;\n  width: fit-content;\n  margin: 0 auto;\n  font-weight: lighter;\n}\n\n.invoice-logo {\n  max-width: 200px;\n  height: auto;\n}\n\n.bill-to-heading {\n  font-size: 16px;\n  text-decoration: underline;\n}\n\n.address-description {\n  font-weight: 700;\n}\n\n.invoice-amount-due {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 30px 10px 30px; // margin from table\n  font-weight: 700;\n  font-size: 18px;\n  color: \\$brand-primary;\n\n  .label {\n    margin-right: 10px;\n  }\n\n  .amount {\n    color: \\$brand-primary;\n  }\n}\n\n// responsiveness pdf\n/* Tablets */\n@media (max-width: 1024px) {\n  .invoice-page-wrapper {\n    width: 100%;\n    height: auto;\n    padding: 15px;\n    border-width: 4px;\n  }\n\n  .invoice-heading {\n    font-size: 24px;\n  }\n\n  .invoice-title {\n    font-size: 16px;\n  }\n\n  .invoice-totals {\n    width: 100%;\n  }\n}\n\n/* Mobile phones */\n@media (max-width: 768px) {\n  .invoice-page-wrapper {\n    width: 100%;\n    padding: 10px;\n    border-width: 3px;\n  }\n\n  .invoice-heading {\n    font-size: 20px;\n  }\n\n  .invoice-title {\n    font-size: 14px;\n  }\n\n  .invoice-bill-to,\n  .invoice-name,\n  .invoice-final .invoice-price {\n    font-size: 16px;\n  }\n\n  .invoice-main-table {\n    padding: 0 10px;\n    margin-top: 20px;\n  }\n\n  .invoice-table-header,\n  .invoice-table-row {\n    flex-direction: column;\n    font-size: 12px;\n  }\n\n  .invoice-summary-section {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 10px;\n  }\n\n  .invoice-totals {\n    font-size: 12px;\n    width: 100%;\n    margin-bottom: 40px;\n  }\n\n  .invoice-notes-section {\n    margin-top: 0;\n  }\n}\n\n.Create-invoice-box{\n  padding-left: 5;\n  padding-top:  0;\n}\n.invoice-back-button{\n  margin-bottom: 10px;\n\n}\n.customer-row {\n  margin-top: 10px;\n  display: flex;\n  align-items: stretch;\n}\n\n.customer-card {\n  border: 1px solid #00b4d8;\n}\n\n.customer-space {\n  width: 100%;\n}\n\n.customer-paragraph {\n  margin-top: 10px;\n}\n.invoice-datepicker{\n  width: 100%;\n}","@import \"./variables\";\n.custom-multiselect-dashboards-list {\n  width: 100%;\n  background-color: $white;\n  border-radius: 5px;\n  height: 2rem;\n}\ndiv#dashboardAccess_selectall.p-checkbox.p-component {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: auto;\n}\n\ndiv#dashboardAccess_selectall.p-checkbox.p-component::after {\n  content: \"All\" !important;\n  font-size: 12px;\n  margin-left: 10px;\n  color: $border-dark;\n  display: inline-block;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\ndiv#dashboardAccess_selectall.p-checkbox.p-component input[type=\"checkbox\"] {\n  margin-right: 8px;\n  pointer-events: auto;\n}\n.campaign-dashboard {\n  font-family: \"Segoe UI\", sans-serif;\n  color: $text-primary;\n\n  .dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    //align-items: center;\n    margin-top: 0px;\n\n    h2 {\n      font-size: 1.8rem;\n      color: $color-114b8a;\n    }\n\n  }\n}\n\n.compare-container {\n  padding: 2rem;\n  background-color: $gray;\n  font-family: \"Segoe UI\", sans-serif;\n  color: $text-color;\n}\n\n.page-title {\n  font-size: 1.75rem;\n  font-weight: 600;\n  margin-bottom: 2rem;\n}\n\n.dropdown-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.compare-label {\n  font-weight: 500;\n}\n\n.add-more {\n  background-color: transparent;\n  color: $secondary-blue;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.chart-section {\n  background-color: $white;\n  padding: 1.5rem;\n  margin-top: 0.5rem;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n}\n\n.chart-bar-group {\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-end;\n  height: 300px;\n  margin-bottom: 1rem;\n}\n\n.bar-set {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.bar {\n  width: 20px;\n  margin: 0.15rem 0;\n  border-radius: 3px;\n}\n\n.bar.delivered {\n  height: 150px;\n  background-color: $color-0d47a1;\n}\n\n.bar.open-rate {\n  height: 100px;\n  background-color: $color-1565c0;\n}\n\n.bar.ctr {\n  height: 80px;\n  background-color: $color-1e88e5;\n}\n\n.bar.bounce-rate {\n  height: 20px;\n  background-color: $color-64b5f6;\n}\n\n.bar.conversion-rate {\n  height: 50px;\n  background-color: $color-90caf9;\n}\n\n.bar.unsubscribe-rate {\n  height: 40px;\n  background-color: $color-bbdefb;\n}\n\n.bar.share-rate {\n  height: 30px;\n  background-color: $color-e3f2fd;\n}\n\n.bar-label {\n  margin-top: 0.5rem;\n  font-weight: 500;\n}\n\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  font-size: 0.9rem;\n  color: $text-color;\n}\n\n.legend-item {\n  padding: 0.3rem 0.6rem;\n  border-radius: 3px;\n}\n.chart-card {\n  background: $white;\n  border-radius: 1rem;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n}\n.form-title-list{\n  font-size: 14px;\n  font-weight: 600;\n  font-family: 'opensans', sans-serif;\n  color:$text-dark;\n  margin-bottom: 0px;\n}\n.form-title-segment{\n  font-size: 14px;\n  font-weight: 600;\n  font-family: 'opensans', sans-serif;\n  color:$text-dark;\n  margin-bottom: 5px;\n}\n.chart-title {\n  color: $color-0d3b66;\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n\n.condition-btn:active {\n  background: $color-3b5998; /* darker blue */\n  border-color: $color-2d4373;\n}\n\n.definition-section:not(:last-child) {\n  border-bottom: 2px dashed $color-3b5998; /* dashed blue line */\n  margin-bottom: 20px; /* space after the line */\n  padding-bottom: 20px; /* space before the line */\n}\n.metric-selection {\n  min-width: 350px;\n}\n\n.chart-container {\n  margin: 20px 0;\n}\n.dashboard-prefix {\n  margin: 0;\n  margin-bottom: 8px; \n  margin-top: 8px;\n}\n\n@media (max-width: 1024px) {\n  .header-dashboard .dashboard-prefix,\n  .header-dashboard .dashboard-image {\n    display: none;\n  }\n}\n\n",".create-campaign-container {\n  padding: 2rem;\n  background: white;\n  color: #2c3e50;\n  min-height: 70vh;\n\n  h2 {\n    font-size: 1.6rem;\n    margin: 1rem 0;\n  }\n\n  .back-button {\n    background: none;\n    border: none;\n    color: #4a90e2;\n    font-size: 0.95rem;\n    cursor: pointer;\n    margin-bottom: 0.5rem;\n  }\n\n  .input-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  h3 {\n    font-size: 1.2rem;\n    color: #2a4d77;\n    margin-bottom: 1rem;\n  }\n\n  .recipient-box {\n    background: #ffffff;\n    border: 1px solid #e0ecf9;\n    border-radius: 0.75rem;\n    padding: 1.5rem;\n    width: 100%;\n\n    .recipient-selects {\n      display: flex;\n      gap: 2rem;\n      margin-bottom: 2rem;\n\n      label {\n        display: block;\n        margin-bottom: 0.5rem;\n        font-weight: 600;\n      }\n\n      .select-list {\n        // padding: 0.6rem;\n        border: 1px solid #bdd6f4;\n        border-radius: 0.5rem;\n        min-width: 350px;\n        max-width: 350px;\n      }\n    }\n.campaign-search-input {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 6px 10px;\n  transition: border-color 0.2s ease;\n}\n\n.campaign-search-input:hover {\n  border-color: #1E63A6; /* blue on hover */\n}\n.draggable {\n  transition: none; /* ensures no lag while dragging */\n}\n    .action-buttons {\n      display: flex;\n      justify-content: flex-end;\n      gap: 1rem;\n\n      .reset-button {\n        padding: 0.6rem 1.2rem;\n        border-radius: 0.5rem;\n        border: none;\n        cursor: pointer;\n        font-weight: 600;\n      }\n\n      .reset-button {\n       background: #f0f4f9;\n        color: #2c3e50;\n      }\n    }\n  }\n}\n\n.campaign-performance {\n  padding: 0.5rem;\n  color: #1e3a8a;\n\n  &__back-btn {\n    margin-bottom: 20px;\n  }\n\n  &__page-title {\n    margin-left: -1px;\n  }\n\n  &__modal-heading {\n    margin-bottom: 16px;\n  }\n\n  &__modal-title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1.3;\n  }\n\n  &__modal-subtitle {\n    margin: 4px 0 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: #667085;\n  }\n\n  .card-section-heading {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 12px;\n  }\n\n  .card-section-title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    text-align: left;\n  }\n\n  &__donut {\n    flex: 1 1 auto;\n    width: 100%;\n    min-height: 180px;\n    height: 180px;\n    max-width: none;\n  }\n\n  &__bar-chart {\n    width: 100%;\n    height: 180px;\n  }\n\n  .performance-cards {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 2rem;\n    margin-top: 1rem;\n\n    .card {\n      background: white;\n      border-radius: 16px;\n      padding: 2rem;\n      box-shadow: 0 8px 20px rgba(30, 58, 138, 0.1);\n      transition: transform 0.2s ease;\n      min-width: 360px;\n      height: 500px;\n\n      &:hover {\n        transform: translateY(-4px);\n      }\n    }\n\n    .bar-card {\n      .bar-chart {\n        display: flex;\n        align-items: center;\n        justify-content: space-around;\n        height: 500px;\n      }\n    }\n  }\n\n  /* Image 3 popup layout: donut + users on top, rates full-width below. */\n  .performance-cards--popup {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 0;\n    width: 100%;\n\n    .performance-cards__top-row {\n      display: grid;\n      grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);\n      gap: 16px;\n      width: 100%;\n    }\n\n    .card {\n      display: flex;\n      flex-direction: column;\n      min-width: 0;\n      width: 100%;\n      height: auto;\n      padding: 18px 20px;\n      box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);\n      border: 1px solid #e5e7eb;\n\n      &:hover {\n        transform: none;\n      }\n    }\n\n    .donut-card {\n      text-align: left;\n      justify-content: flex-start;\n\n      .engagement-overview-donut__legend {\n        margin-top: 10px;\n        padding: 0;\n      }\n\n      .engagement-overview-donut__legend--centered {\n        align-items: stretch;\n        gap: 8px;\n      }\n\n      .engagement-overview-donut__legend--centered .engagement-overview-donut__legend-item {\n        max-width: none;\n      }\n    }\n\n    .bar-card .bar-chart,\n    .bar-card .campaign-performance__bar-chart {\n      height: 180px;\n      width: 100%;\n      flex: 1 1 auto;\n    }\n\n    .bar-card,\n    .donut-card {\n      min-height: 0;\n    }\n\n    .metrics-card--grid {\n      width: 100%;\n\n      .metrics-card__grid {\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        column-gap: 40px;\n        row-gap: 0;\n      }\n\n      .metrics-card__column {\n        display: grid;\n        grid-template-columns: max-content minmax(0, 1fr);\n        column-gap: 12px;\n        row-gap: 12px;\n        align-items: center;\n        min-width: 0;\n      }\n\n      .metric-row {\n        display: contents;\n        margin-bottom: 0;\n      }\n\n      .metric-label {\n        margin-bottom: 0;\n        font-size: 13px;\n        font-weight: 500;\n        color: #667085;\n        line-height: 1.3;\n        white-space: nowrap;\n      }\n\n      .metric-row__body {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        min-width: 0;\n      }\n\n      .metric-value {\n        flex: 0 0 auto;\n        min-width: 40px;\n        font-size: 14px;\n        font-weight: 700;\n        color: #101828;\n        text-align: right;\n        line-height: 1;\n      }\n    }\n  }\n\n  .metric-progress {\n    display: block;\n    flex: 1 1 auto;\n    width: 100%;\n    height: 8px;\n    border: 0;\n    border-radius: 999px;\n    overflow: hidden;\n    background: #e8edf4;\n    appearance: none;\n\n    &::-webkit-progress-bar {\n      background: #e8edf4;\n      border-radius: 999px;\n    }\n\n    &::-webkit-progress-value {\n      border-radius: 999px;\n      background: #2b74e4;\n    }\n\n    &::-moz-progress-bar {\n      border-radius: 999px;\n      background: #2b74e4;\n    }\n  }\n\n  .metric-progress--open {\n    &::-webkit-progress-value {\n      background: #2b74e4;\n    }\n\n    &::-moz-progress-bar {\n      background: #2b74e4;\n    }\n  }\n\n  .metric-progress--click {\n    &::-webkit-progress-value {\n      background: #36cdb0;\n    }\n\n    &::-moz-progress-bar {\n      background: #36cdb0;\n    }\n  }\n\n  .metric-progress--conversion {\n    &::-webkit-progress-value {\n      background: #8d4fd3;\n    }\n\n    &::-moz-progress-bar {\n      background: #8d4fd3;\n    }\n  }\n\n  .metric-progress--unsubscribe {\n    &::-webkit-progress-value {\n      background: #8eb8f0;\n    }\n\n    &::-moz-progress-bar {\n      background: #8eb8f0;\n    }\n  }\n\n  .metric-progress--share {\n    &::-webkit-progress-value {\n      background: #3d8b6e;\n    }\n\n    &::-moz-progress-bar {\n      background: #3d8b6e;\n    }\n  }\n\n  &--modal {\n    padding: 0;\n    color: #17325c;\n\n    .action-buttons {\n      margin-top: 16px;\n      justify-content: flex-end;\n    }\n  }\n}\n\n.campaign-performance-modal {\n  max-width: calc(100vw - 48px);\n\n  .ant-modal-content {\n    border-radius: 16px;\n    padding: 20px 24px 16px;\n    max-height: calc(110vh - 100px);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    overflow-y: auto;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n}\n\n.engagement-overview-donut__swatch--delivered {\n  background-color: #2b74e4;\n}\n\n.engagement-overview-donut__swatch--bounced {\n  background-color: #94d0b5;\n}\n\n.campaign-performance .engagement-overview-donut__center-label {\n  text-transform: uppercase;\n}\n\n@media (max-width: 768px) {\n  .campaign-performance .performance-cards--popup {\n    .performance-cards__top-row {\n      grid-template-columns: 1fr;\n    }\n\n    .metrics-card--grid .metrics-card__grid {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.campaign-name {\n  color: $brand-primary;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  font-weight: 700;\n  font-size: 12px;\n  font-family: 'opensans', sans-serif;\n  letter-spacing: 0 !important;\n  text-transform: none;\n}\n\n.list-name {\n  color: #0088cc;\n  cursor: pointer;\n\n  transition: color 0.2s ease; /* Smooth transition for hover effect */\n}\n\n.campaign-name:hover {\n  color: #1b4d99;\n  text-decoration: underline;\n}\n.campaign-row:hover {\n  background-color: #f5f8fc;\n  transition: background-color 0.2s ease;\n}\n\n.campaign-headers {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  margin-bottom: 10px;\n}\n\n.campaign-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.remove-campaign-btn {\n  background: none;\n  border: none;\n  color: #ff4d4f;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  padding: 0;\n}\n\n.remove-campaign-btn:hover {\n  color: #d9363e;\n}\n\n.campaign-row:hover {\n  background-color: #f5f8fc;\n  transition: background-color 0.2s ease;\n}\ncampaign-selector {\n  margin-bottom: -15px;\n}\n\n.compare-container .col-3 {\n  border-color: #dee2e6 !important;\n  border-width: 2px !important;\n  padding: 12px !important;\n\n  height: 100% !important;\n}\n.compare-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin-left: 50px;\n}\n.compare-btn {\n  background-color: #145da0;\n  color: white;\n}\n\n.compare-with-text {\n  font-weight: 500;\n  color: #145da0;\n}\n\n.comparison-container {\n  padding: 2rem;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.comparison-title {\n  color: #0d3b66;\n  font-size: 1.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.comparison-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.campaign-comparison {\n  padding: 20px;\n}\n.comparison-controls {\n  display: flex;\n  gap: 20px;\n  margin: 20px 0;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n.campaign-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.campaign-selector select {\n  padding: 8px;\n  min-width: 200px;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n}\n.campaign-selector select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n.button-group {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.add-more-btn {\n  padding: 8px 16px;\n  background-color: white;\n  color: #1890ff;\n  border: 1px solid #1890ff;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 35px;\n}\n.add-more-btn:disabled {\n  border-color: #d9d9d9;\n  color: #d9d9d9;\n  cursor: not-allowed;\n}\n.compare-btn {\n  padding: 8px 16px;\n  background-color: #1890ff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 35px;\n}\n.compare-btn:disabled {\n  background-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.chart-container {\n  margin-top: 30px;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n.chart-container h3 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n.campaign-headers {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n.campaign-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.remove-campaign-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #ff4d4f;\n}\n\n/************Mobile screen responsiveness**************/ ///////\n@media (max-width: 768px) {\n  .comparison-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .button-group {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .button-group button {\n    width: 100%;\n  }\n  .headline {\n    font-size: 13px;\n    margin-bottom: 10px;\n  }\n}\n@media (max-width: 480px) {\n  .comparison-controls {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 20px;\n  }\n\n  .comparison-controls h4,\n  .comparison-controls h5 {\n    font-size: 18px;\n    margin-bottom: 6px; /* space between heading and dropdown */\n    line-height: 1.3;\n  }\n\n  .campaign-selector {\n    display: flex;\n    flex-direction: column;\n    margin-top: 120px;\n    margin-bottom: -100px;\n  }\n\n  .go-back-button {\n    width: 100%;\n    margin-bottom: 16px;\n  }\n\n  .button-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .button-group button,\n  .compare-button {\n    width: 100%;\n  }\n  .headline {\n    font-size: 13px;\n    margin-bottom: 10px;\n  }\n}\n\n.custom-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 20px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  background-color: #fff;\n  margin-bottom: 16px;\n}\n.custom-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap; \n}\n\n.header-actions-buttons {\n  display: flex;\n  align-items: center;\n  gap: 20px;      \n  flex-wrap: nowrap; \n  margin-bottom: 0px;\n}\n.audience-btn{\n  margin-bottom: 0;\n}\n.bulk-actions {\n  display: flex;\n  gap: 10px; \n  margin-bottom: -12px;\n}\n\n.list-header-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin-left: 0;\n}\n/* Fix for double scrollbar */\n.custom-select-dropdown .rc-virtual-list-holder {\n  max-height: 250px !important;\n  overflow-y: auto !important;\n}\n\n.custom-select-dropdown .rc-virtual-list-holder::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-select-dropdown .rc-virtual-list-holder::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 3px;\n}\n\n.custom-select-dropdown .rc-virtual-list-holder::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Remove the outer scroll container */\n.custom-select-dropdown {\n  overflow: hidden !important;\n  padding-right: 0 !important;\n}\n\n/* Adjust the dropdown menu padding if needed */\n.custom-select-dropdown .ant-select-item {\n  padding: 8px 12px;\n}\n\n/*******revamped css******/\n.ant-layout-content{\n  padding:10px !important;\n}\n.dashboard-header {\n  display: flex;\n  flex-direction: column; /* stacks title & subtext */\n  align-items: flex-start;\n}\n\n.Campaign-dashboard-header {\n font-size: 32px;\n  font-weight: 600;\n   font-family: 'opensans',sans-serif;\n    color: #2A2929;\n  margin: 0;\n  margin-top:10px;\n}\n\n.audience-summary {\n color:#6E6A6A; \n font-weight: 400; \n font-size: 16px; \n font-family: 'opensans',sans-serif;\n  margin-top: 2px;\n  padding-left: 2px;\n}\n.overview-summary {\n color:#6E6A6A; \n font-weight: 400; \n font-size: 16px; \n font-family: 'opensans',sans-serif;\n  margin-top: 2px;\n  padding-left: 2px;\n  margin-bottom: 20px;\n}\n.audience-summary span {\n  display: block;\n  line-height: 1.4;\nmargin-bottom: 10px;\n}\n\n.campaign-header-actions {\n  display: flex;\n  gap: 10px; /* buttons spaced like first screenshot */\n   justify-content: flex-end;\n   margin-top: -65px;\n  // margin-right: 45px;\n}\n.overview-header-actions {\n  display: flex;\n  gap: 10px; /* buttons spaced like first screenshot */\n   justify-content: flex-end;\n   margin-top: -65px;\n  // margin-right: 45px;\n}\n.header-actions {\n  display: flex;\n  gap: 10px; /* buttons spaced like first screenshot */\n   justify-content: flex-end;\n   margin-top: -30px;\n\n}\n.chart-dropdown:hover {\n  border-color: #aaa;\n}\n\n/* Remove AntD default borders */\n.chart-dropdown .ant-select-selector {\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  min-height: 36px !important;\n  padding: 0 !important;\n}\n\n.campaign-dropdown {\n  width: 100%;\n  padding: 6px 14px;\n  padding-right: 36px;\n  border-radius: 20px;\n  border: 1px solid #ddd;\n  background-color: #fff;\n  color: #000000 !important;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  appearance: none;\n  cursor: pointer;\n   box-shadow: \n    0.3px 0.3px 1px rgba(182, 178, 178, 0.6),\n    1px 1px 4px rgba(182, 178, 178, 0.8);\n  transition: all 0.2s ease;\n  justify-content: right !important;\n}\n\n.campaign-dropdown-arrow {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  pointer-events: none;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 6px solid #666;\n}\n.filters-container {\n  display: flex;\n  justify-content: space-between; /* Left vs Right */\n  align-items: center;\n  margin-bottom: 32px !important;\n  margin-top: 35px !important;\n  flex-wrap: wrap; \n  border: 1px solid #d9d9d9;\n    padding: 15px 20px;\n    border-radius: 10px;\n  padding-top: 10px;\n}\n\n.filters-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filters-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 1;  \n  max-width: 100%; \n}\n.filters-right .button {\n  padding: 6px 14px;     \n      height: 44px;       \n  line-height: 1.5;      \n  white-space: nowrap;   \n  flex: 0 0 auto;       \n  margin-bottom: -3px;\n     box-shadow: \n    0.3px 0.3px 1px rgba(182, 178, 178, 0.6),\n    1px 1px 4px rgba(182, 178, 178, 0.8);\n}\n\n.filters-right .campaign-dropdown {\n  flex: 0 1 auto;   \n  min-width: 250px; \n}\n\n.metric-dropdown {\n  width: 100%;\n  border-radius: 20px; /* pill-like style */\n}\n\n/* Remove border/line inside multiple select dropdown */\n.ant-select-multiple .ant-select-selection-item {\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important; /* optional */\n  padding: 0 4px !important;\n  margin-bottom: 15px !important;\n}\n\n.campaign-dropdown.ant-select-multiple .ant-select-selector {\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.info-banner-campaign{\nflex: 1 1;\n    background: #f9f9f9;\n    border-radius: 6px;\n    padding: 3px 40px 3px 16px;\n    font-size: 14px;\n    font-family: \"opensans\", sans-serif;\n    color: $text-dark;\n    font-weight: 400;\n    line-height: 1.4;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\n        width: 100%;\n        text-align: center;\n        position: relative;\n}\n.info-banner-campaign .info-banner-close {\n  border:none;\n  background: #f9f9f9;\n  color: $gray-700;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.info-banner-campaign .info-banner-close:hover {\n  background-color: $border-default;\n  color: $text-dark;\n}\n\n.info-banner-campaign strong {\n  font-weight: 600;\n}\n.Banner-highlight{\n  font-weight: 600;\n  color: $text-dark;\n  font-size: 14px;\n}\n//dropdown styles\n.campaign-dropdown {\n  width: 100%;\n  border-radius: 30px !important;\n  height: 42px;\n  background-color: #fff;   \n  border: none !important;\n     box-shadow: \n    0.5px 0.5px 2px rgba(182, 178, 178, 0.6),\n    2px 2px 6px rgba(182, 178, 178, 0.8);\n\n  .ant-select-selector {\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    border-radius: 30px !important;\n    height: 42px !important;\n    display: flex;\n    align-items: center;     \n    padding: 0 8px !important; \n    gap: 6px;               \n    color: #000 !important;\n  }\n\n  .ant-select-selection-placeholder {\n    color: #777 !important;\n    font-weight: 500;\n  }\n\n  /* Remove icon inside tag */\n  .ant-select-selection-item-remove {\n    color: #555 !important;          \n    margin-left: 4px;\n  }\n}\n\n/* Open state */\n.campaign-dropdown.ant-select-open {\n  background-color: #e0e0e0 !important;  \n  color: #000 !important;\n}\n\n/* Dropdown menu */\n.custom-dropdown-menu {\n  border-radius: 12px !important;\n  background-color: #fff !important; \n  padding: 6px 0;\n  color: #000 !important;  \n\n  .ant-select-item {\n    padding: 10px 16px;\n    border-radius: 8px;\n    transition: background 0.2s ease;\n  }\n\n  .ant-select-item-option-active {\n    background-color: #f2f2f2 !important; \n  }\n\n  .ant-select-item-option-selected {\n    background-color: #1c60c6 !important; \n    color: #fff !important;\n  }\n}\n/* Selected tags */\n.campaign-dropdown .ant-select-selection-item {\n  background: #e0e0e0 !important;\n  color: #000 !important;\n  border-radius: 10px !important;\n  padding: 0 10px !important;     \n  font-size: 13px !important;\n  height: 26px !important;        \n  display: flex !important;\n  align-items: center !important;  /* vertical centering */\n  justify-content: center !important;\n  line-height: normal !important;  /* reset */\n  margin-bottom: 10px;\n}\n\n\n.campaign-dropdown .ant-select-selection-item-content {\n  display: flex !important;\n  align-items: center !important;\n}\n\n// Campaign dashboard (new UI)\n.campaign-performance-card {\n  background: $white;\n  border: 1px solid $color-e5e7eb;\n  border-radius: 12px;\n  padding: 0;\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n\n.campaign-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 22px;\n}\n\n.campaign-card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: $text-dark;\n  font-family: $font-family;\n}\n\n.campaign-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.campaign-card-actions .button--primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n}\n\n/* ── Campaign Performance page revamp ──────────────────────────────────────\n   Scoped under `.campaign-dashboard` because `Campaign.scss` is global and\n   shared with the Audience / Overview pages. */\n.campaign-dashboard {\n  .dashboard-header {\n    width: 100%;\n    align-self: stretch;\n    overflow: visible;\n  }\n\n  .campaign-dashboard__title-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-areas:\n      \"title create\"\n      \"select dates\";\n    column-gap: 16px;\n    row-gap: 24px;\n    align-items: start;\n    width: 100%;\n    margin-bottom: 20px;\n    overflow: visible;\n  }\n\n  .campaign-dashboard__title-copy {\n    grid-area: title;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    min-width: 0;\n  }\n\n  .campaign-dashboard__title-copy .audience-summary span {\n    margin-bottom: 0;\n  }\n\n  .campaign-dashboard__achievements {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .campaign-dashboard__create-btn {\n    grid-area: create;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n    padding: 0 16px;\n    margin-top: 45px;\n    flex-shrink: 0;\n    justify-self: end;\n    align-self: start;\n  }\n\n  .campaign-dashboard__filter-select {\n    grid-area: select;\n    width: 34%;\n    min-width: 220px;\n    max-width: 420px;\n    align-self: center;\n    overflow: visible;\n    position: relative;\n    z-index: 6;\n  }\n\n  .campaign-dashboard__select {\n    width: 100%;\n    position: relative;\n\n    .sales-product-analytics-dashboard__select-trigger {\n      width: 100%;\n      height: 44px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 12px;\n      padding: 0 16px 0 18px;\n      border: 1px solid #ccd6e3;\n      border-radius: 8px;\n      background: #ffffff;\n      color: #17325c;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      text-align: left;\n    }\n\n    .sales-product-analytics-dashboard__select-trigger span {\n      flex: 1 1 auto;\n      min-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .sales-product-analytics-dashboard__select-trigger--open {\n      border-color: #cfd8e3;\n      box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);\n    }\n\n    .sales-product-analytics-dashboard__select-trigger-icon {\n      width: 16px;\n      height: 16px;\n      color: #6b7280;\n      flex-shrink: 0;\n    }\n  }\n\n  .campaign-dashboard__select--toolbar {\n    min-width: 160px;\n    width: 180px;\n  }\n\n  .campaign-dashboard__select--compare {\n    min-width: 260px;\n    width: 280px;\n  }\n\n  .campaign-dashboard__filters {\n    grid-area: dates;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    margin: 0;\n    width: auto;\n    justify-self: end;\n    align-self: center;\n  }\n\n  @media (max-width: 768px) {\n    .campaign-dashboard__title-row {\n      grid-template-columns: minmax(0, 1fr) auto;\n      grid-template-areas:\n        \"title create\"\n        \"select dates\";\n      column-gap: 12px;\n      row-gap: 16px;\n    }\n\n    .campaign-dashboard__create-btn {\n      justify-self: end;\n      width: auto;\n      max-width: none;\n      min-width: 0;\n    }\n\n    .campaign-dashboard__filter-select {\n      justify-self: start;\n      width: 100%;\n      min-width: 0;\n      max-width: min(280px, calc(100% - 8px));\n    }\n\n    .campaign-dashboard__filters {\n      justify-self: end;\n      width: auto;\n      min-width: 0;\n      max-width: 100%;\n    }\n\n    .campaign-dashboard__filters .date-range-picker-container {\n      flex-wrap: nowrap;\n      gap: 8px;\n    }\n\n    .campaign-dashboard__filters .dashboard-date-picker {\n      width: min(160px, 28vw) !important;\n      min-width: 0;\n    }\n  }\n\n  /* Labelled bulk actions (replaces the icon-only toolbar buttons). */\n  .campaign-action-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    height: 36px;\n    padding: 0 14px;\n    border: 1px solid $color-e5e7eb;\n    border-radius: 8px;\n    background: $white;\n    color: $text-dark;\n    font-family: $font-family;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease;\n\n    &:hover {\n      background: $color-f2f2f2;\n      border-color: #d9d9d9;\n    }\n  }\n\n  .campaign-action-btn--danger {\n    background: #dc3545;\n    border-color: #dc3545;\n    color: $white;\n\n    &:hover {\n      background: #c22a39;\n      border-color: #c22a39;\n    }\n  }\n\n  /* Active / Archive segmented tabs (replaces the square toggle pill). */\n  .campaign-scope-tabs {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px;\n    gap: 2px;\n    border: 1px solid $color-e5e7eb;\n    border-radius: 8px;\n    background: $color-f2f2f2;\n  }\n\n  .campaign-scope-tab {\n    border: none;\n    background: transparent;\n    border-radius: 6px;\n    padding: 6px 16px;\n    font-family: $font-family;\n    font-size: 13px;\n    font-weight: 500;\n    color: #6a6a6a;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease;\n\n    &.is-active {\n      background: $white;\n      color: $text-dark;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n    }\n  }\n\n  /* The toolbar now carries search + filters, so let it wrap rather than\n     overflow on narrower viewports. */\n  .campaign-card-toolbar {\n    flex-wrap: wrap;\n  }\n\n  .campaign-toolbar-right {\n    gap: 8px;\n    //flex-wrap: wrap;\n    align-items: center;\n    justify-content: end;\n  }\n\n  .campaign-toolbar-right .campaign-dashboard__select--toolbar {\n    width: 150px;\n    min-width: 150px;\n  }\n\n  .campaign-table .ant-table-footer {\n    background: #faf9f6;\n    padding: 0;\n    border-top: 1px solid $color-e5e7eb;\n  }\n\n  .campaign-table .ant-table-container,\n  .campaign-table .ant-table-content,\n  .campaign-table .ant-table-body {\n    overflow-x: hidden !important;\n  }\n\n  .campaign-dashboard__pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 10px 16px;\n    background: #ffffff;\n  }\n\n  .campaign-dashboard__pagination-label {\n    color: #9aa0a6;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .campaign-dashboard__pagination-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .campaign-dashboard__pagination-btn {\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: $white;\n    color: #6b7280;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n\n  .campaign-dashboard__pagination-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n\n  /* The chart is now a sibling card, not nested inside the table card. */\n  .campaign-chart-card {\n    margin-bottom: 16px;\n    border-radius: 12px;\n    border: 1px solid #eaeaea;\n  }\n\n  /* Channel badge in the table's Source column. */\n  .campaign-source-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 10px;\n    border-radius: 6px;\n    font-family: $font-family;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.5;\n    white-space: nowrap;\n  }\n\n  .campaign-source-badge--whatsapp {\n    background: #e7f7ee;\n    color: #1c8a52;\n  }\n\n  .campaign-source-badge--email {\n    background: #fdf1e3;\n    color: #b96a10;\n  }\n\n  .campaign-source-badge--neutral {\n    background: $color-f2f2f2;\n    color: #4a4a4a;\n  }\n\n  /* Campaign Comparison header controls. */\n  .campaign-chart-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  .campaign-chart-title {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 0;\n  }\n\n  .campaign-chart-header-side {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  .campaign-chart-controls {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  .campaign-compare-select {\n    width: 280px;\n    min-width: 220px;\n    max-width: 360px;\n\n    .ant-select-selector {\n      width: 100% !important;\n      min-width: 0 !important;\n    }\n  }\n\n  .campaign-compare-source,\n  .campaign-compare-status {\n    min-width: 180px;\n    max-width: 240px;\n\n    .ant-select-selector {\n      width: 100% !important;\n      min-width: 0 !important;\n    }\n  }\n\n  .campaign-chart-card .chart-legend {\n    justify-content: flex-end;\n  }\n\n  @media (max-width: 996px) {\n    .campaign-chart-header {\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) auto;\n      grid-template-areas:\n        \"title controls\"\n        \"legend legend\";\n      align-items: center;\n      column-gap: 12px;\n      row-gap: 12px;\n    }\n\n    .campaign-chart-title {\n      grid-area: title;\n      flex: 0 1 auto;\n      flex-wrap: nowrap;\n      align-items: center;\n      min-width: 0;\n      white-space: nowrap;\n\n      > span {\n        white-space: nowrap;\n      }\n    }\n\n    .campaign-chart-header-side {\n      display: contents;\n    }\n\n    .campaign-chart-controls {\n      grid-area: controls;\n      flex-wrap: nowrap;\n      align-items: center;\n      justify-content: flex-end;\n      justify-self: end;\n      min-width: 0;\n    }\n\n    .campaign-chart-card .chart-legend {\n      grid-area: legend;\n      width: 100%;\n      justify-content: flex-end;\n      align-items: center;\n    }\n\n    .campaign-compare-select {\n      width: min(200px, 46vw);\n      min-width: 160px;\n      max-width: 280px;\n    }\n  }\n}\n\n/* SelectMenu popup is portalled to document.body, so option styles cannot\n   live under `.campaign-dashboard`. */\n.campaign-dashboard__select-dropdown {\n  min-width: 160px;\n  max-height: 240px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 6px;\n  border: 1px solid #e6edf7;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n\n  .sales-product-analytics-dashboard__select-dropdown-scroll {\n    min-height: 0;\n    flex: 1 1 auto;\n    overflow-y: auto;\n    scrollbar-color: #cbd5e1 transparent;\n    scrollbar-width: thin;\n  }\n\n  .sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  .sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .sales-product-analytics-dashboard__select-dropdown-scroll::-webkit-scrollbar-thumb {\n    border-radius: 999px;\n    background: #cbd5e1;\n  }\n\n  .sales-product-analytics-dashboard__select-option {\n    display: grid;\n    grid-template-columns: 20px minmax(0, 1fr);\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    min-height: 40px;\n    padding: 10px 12px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: #0f172a;\n    font-size: 13px;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  .sales-product-analytics-dashboard__select-option span {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .sales-product-analytics-dashboard__select-option:hover {\n    background: #f2f2f2;\n  }\n\n  .sales-product-analytics-dashboard__select-option--active {\n    background: #e4e4e4;\n    color: #1f1f1f;\n    font-weight: 600;\n  }\n\n  .sales-product-analytics-dashboard__select-option-check {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    color: #111827;\n  }\n}\n\n.campaign-dashboard__compare-menu {\n  z-index: 1300;\n  max-height: 280px;\n  overflow: hidden;\n\n  .rc-virtual-list-holder {\n    max-height: 256px !important;\n    overflow-y: auto !important;\n  }\n\n  .ant-select-item {\n    display: flex;\n    align-items: center;\n    min-height: 36px;\n    padding: 8px 12px;\n  }\n}\n\n.campaign-card-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 12px;\n    border-bottom: 1px solid $color-e5e7eb;\n  margin-bottom: 0;\n  flex-wrap: nowrap;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.campaign-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n.campaign-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: nowrap;\n}\n\n.icon-button {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: none;\n  background: transparent;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: $brand-primary;\n}\n\n.campaign-toolbar-left .date-range-picker-container {\n  gap: 8px;\n}\n\n.campaign-toolbar-left .date-range-picker-container,\n.campaign-toolbar-left .custom-date-picker {\n  flex-shrink: 0;\n}\n\n.campaign-search-input {\n  max-width: 260px;\n}\n\n.campaign-card-toolbar .custom-date-picker {\n  width: 150px !important;\n}\n\n.icon-button:hover {\n  background: $color-f2f2f2;\n}\n\n.icon-button--primary {\n  background: $brand-primary;\n  color: $white;\n}\n\n.icon-button--primary:hover {\n  background: $brand-primary-hover;\n}\n\n.toggle-pill {\nwidth: 72px;\n    height: 38px;\n    border-radius: 8px;\n    border: 1px solid #d9d9d9;\n    background: #e9effa;\n    padding: 2px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 10px;\n}\n\n.toggle-pill__icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: $brand-primary;\n  color: $white;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n  margin-left: -2px;\n}\n\n.toggle-pill__img {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n.toggle-pill.is-on {\n  justify-content: flex-end;\n  background: $color-e3f2fd;\n}\n\n.campaign-search-input {\n  width: 180px;\n}\n\n.campaign-card-toolbar .custom-date-picker {\n  width: 150px !important;\n  height: 44px;\n  border-radius: 8px;\n  border-color: $color-d9d9d9;\n}\n\n.campaign-card-toolbar .custom-date-picker .ant-picker-input > input {\n  font-size: 12px;\n}\n\n.campaign-toolbar-right .campaign-dashboard__select {\n  min-width: 160px;\n}\n\n.modify-file-container {\n  padding: 12px 2px;\n}\n\n.modify-file-back-button {\n  min-width: 72px;\n  height: 34px;\n  padding: 0 14px;\n  margin-bottom: 14px;\n}\n\n.modify-file-title {\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0;\n  color: #000000;\n  text-align: left;\n}\n\n.modify-file-subtitle {\n  margin: 2px 0 14px;\n  color: #6b7280;\n  font-size: 16px;\n}\n\n.modify-file-card {\n  background: #fff;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.modify-file-card-header {\n  padding: 14px 18px;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 18px;\n  font-weight: 600;\n  color: #000000;\n}\n\n.modify-file-table {\n  margin-top: 0;\n}\n\n.modify-file-table .ant-table-thead > tr > th {\n  background: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modify-file-table .ant-table-tbody > tr > td {\n  font-size: 16px;\n  color: #111827;\n  height: 58px;\n}\n\n.modify-file-cell-text {\n  color: #111827;\n}\n\n.modify-file-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.campaign-table-wrapper {\n  background: transparent;\n  border-radius: 0;\n  padding: 0;\n  margin-top: 0;\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n}\n\n.campaign-table .ant-table {\n  background: transparent;\n}\n/* Without this the inner <table> sizes to its columns' content rather than\n   the card, leaving a blank strip (no cell, so no border) to the right of\n   narrower rows — this is what made each row's border-bottom look like it\n   stopped short of the card's edge instead of spanning the full width. */\n.campaign-table .ant-table table {\n  width: 100% !important;\n  table-layout: auto;\n}\n.campaign-table .ant-table-container,\n.campaign-table .ant-table-content {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.campaign-table .ant-table-container::before,\n.campaign-table .ant-table-container::after {\n  display: none !important;\n  content: none !important;\n}\n.campaign-table{\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.campaign-table .ant-table-thead > tr > th {\n  background: $white;\n  color: $color-1a1a1a;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: $font-family;\n  padding: 10px 12px;\n  border-bottom: 1px solid $color-e5e7eb;\n}\n.campaign-table .ant-table-thead > tr > th::before {\n  display: none !important;\n  content: none !important;\n}\n\n.campaign-table .ant-table-thead > tr > th:last-child {\n  border-right: 0;\n}\n\n.campaign-table .ant-table-tbody > tr > td {\n  padding: 10px 12px;\n  font-size: 12px;\n  font-weight: 400;\n  color: $color-1a1a1a;\n  border-bottom: 1px solid $color-e5e7eb;\n  background: $white !important;\n}\n\n.campaign-table .ant-table-tbody > tr {\n  background: $white !important;\n}\n\n.campaign-table .ant-table-tbody > tr > td:last-child {\n  border-right: 0;\n}\n\n.campaign-table .ant-table-tbody > tr:hover > td {\n  background: $white;\n}\n\n.campaign-table .ant-table-tbody > tr.ant-table-row-selected > td {\n  background: $white;\n}\n\n.campaign-table .ant-table-tbody > tr.ant-table-row-selected:hover > td {\n  background: $white;\n}\n\n.campaign-table .ant-table-tbody > tr:last-child > td {\n  border-bottom: none;\n}\n\n.campaign-table .ant-table-row-expand-icon-cell {\n  width: 24px;\n  padding: 10px 0 10px 8px !important;\n}\n\n.campaign-table .ant-table-row-expand-icon-cell + td {\n  padding-left: 4px !important;\n}\n\n.campaign-table__expand-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  transition: transform 0.15s ease;\n\n  svg {\n    transition: transform 0.15s ease;\n  }\n}\n\n.campaign-table__expand-icon--open svg {\n  transform: rotate(90deg);\n}\n\n.campaign-table .ant-table-expanded-row > td {\n  padding: 0 !important;\n  background: #f7f8fa !important;\n}\n\n.campaign-table .ant-table-expanded-row:hover > td {\n  background: #f7f8fa !important;\n}\n\n.campaign-metrics-panel {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 16px 20px;\n  padding: 16px 20px;\n  background-color: #f3f4f6 !important;\n}\n\n.campaign-metrics-panel__cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.campaign-metrics-panel__cell--empty {\n  visibility: hidden;\n}\n\n.campaign-metrics-panel__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #8a8f98;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.campaign-metrics-panel__value {\n  color: $color-1a1a1a;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n@media (max-width: 1100px) {\n  .campaign-metrics-panel {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .campaign-metrics-panel {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.campaign-chart-card {\n  background: $white;\n  border-radius: 12px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.campaign-chart-card .chart-section-overview {\n  background: transparent;\n  box-shadow: none;\n  padding: 0 !important;\n  margin: 0 !important;\n  min-height: 0;\n}\n\n.campaign-chart-card .chart-header {\n  padding: 0;\n  margin-bottom: 8px;\n}\n\n.campaign-chart-card .chart-legend {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  color: $color-475569;\n}\n\n.campaign-chart-card .chart-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.campaign-chart-card .chart-legend-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.campaign-chart-card .chart-legend-dot--delivered {\n  background: #8d4fd3;\n}\n\n.campaign-chart-card .chart-legend-dot--openRate {\n  background: #94d0b5;\n}\n\n.campaign-chart-card .chart-legend-dot--clickRate {\n  background: #d946ef;\n}\n\n.campaign-chart-card .chart-legend-dot--bounceRate {\n  background: #8eb8f0;\n}\n\n.campaign-chart-card .chart-legend-dot--conversionRate {\n  background: #5abf8b;\n}\n\n.campaign-chart-card .chart-legend-dot--unsubscribeRate {\n  background: #f0a84a;\n}\n\n.campaign-chart-card .chart-legend-dot--shareRate {\n  background: #2b4a9e;\n}\n\n.campaign-chart-card .chart-pagination-wrapper {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.campaign-chart-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: $color-555;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.campaign-chart-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  padding: 16px;\n}\n\n.campaign-chart-header .campaign-chart-title {\n  margin-bottom: 0;\n}\n.pagination-controls .pagination-btn{\n  background-color: $gray-200;\n}\n@media (max-width: 768px) {\n  .header-actions {\n    justify-content: center;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n    margin-bottom: 1rem;\n  }\n\n  .header-actions .button {\n    width: 100%; /* full width buttons */\n    text-align: center;\n  }\n}\n@media (max-width: 768px) {\n  .filters-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filters-left,\n  .filters-right {\n    width: 100%;\n    min-width: unset;\n  }\n\n  .campaign-dropdown {\n    width: 100% !important;\n    margin-bottom: 20px;\n        height: 5%;\n        margin-top: 20px;\n  }\n}\n\n.audience-search-input {\n  border-radius: 6px;\n  height: 38px;\n  width: 250px !important;\n}\n\n.list-section {\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.audience-list-header {\n  border: 0;\n  border-bottom: 1px solid #e5e7eb;\n  border-radius: 0;\n  margin-bottom: 0;\n  padding: 12px 16px;\n}\n\n.audience-toolbar-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2px;\n  padding: 10px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.audience-archive-toggle {\n  min-width: 150px;\n}\n\n.audience-list-header .toggle-pill {\n  margin-bottom: 0;\n}\n\n.audience-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.audience-sort-dropdown {\n  min-width: 210px;\n  margin-bottom: 0 !important;\n}\n\n.audience-actionbuttons.is-disabled {\n  opacity: 0.4;\n  cursor: not-allowed !important;\n  pointer-events: none;\n}\n\n.table-row-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.table-row-actions .audience-actionbuttons {\n  margin-right: 0;\n}\n\n.audience-list-table .ant-table-footer {\n  border-top: 0;\n  padding-right: 16px;\n}\n\n/* --- Campaign Dashboard Responsive --- */\n@media (max-width: 1024px) {\n  .campaign-card-header {\n    //flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .campaign-card-actions {\n    //width: 100%;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n  }\n\n  .campaign-card-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .campaign-toolbar-left,\n  .campaign-toolbar-right {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .campaign-toolbar-left .custom-date-picker,\n  .campaign-toolbar-left .date-range-picker-container,\n  .campaign-search-input {\n    width: auto !important;\n    max-width: 100% !important;\n  }\n\n  .campaign-toolbar-right .campaign-dashboard__select {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .campaign-card-header {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .campaign-card-toolbar {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .campaign-toolbar-right {\n    gap: 8px;\n  }\n\n  .campaign-toolbar-right .icon-button {\n    width: 32px;\n    height: 32px;\n  }\n\n  .campaign-dashboard .campaign-table .ant-table-container,\n  .campaign-dashboard .campaign-table .ant-table-content,\n  .campaign-dashboard .campaign-table .ant-table-body {\n    overflow-x: hidden !important;\n  }\n\n  .campaign-chart-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .campaign-chart-header-side,\n  .campaign-chart-controls,\n  .campaign-chart-card .chart-legend {\n    align-items: stretch;\n    justify-content: flex-start;\n  }\n\n  .audience-toolbar-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .audience-actions {\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\n  .audience-sort-dropdown,\n  .audience-search-input {\n    width: 100%;\n  }\n}\n\n@media (max-width: 968px) {\n  .audience-toolbar-row > .custom-input-audience {\n    width: 100% !important;\n    border-radius: 6px;\n    height: 38px;\n  }\n}\n\n@media (max-width: 480px) {\n  .Campaign-dashboard-header {\n    font-size: 24px;\n  }\n\n  .audience-summary,\n  .overview-summary {\n    font-size: 14px;\n  }\n\n  .campaign-card-actions .button--primary {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .campaign-toolbar-right {\n    justify-content: flex-start;\n  }\n}\n\n/* Audience + Modify File responsive safeguards */\n@media (max-width: 1024px) {\n  .audience-list-table .ant-table-content {\n    overflow-x: auto !important;\n  }\n\n  .audience-list-table .ant-table-content table {\n    min-width: 900px;\n  }\n\n  .modify-file-table .ant-table-content {\n    overflow-x: auto !important;\n  }\n\n  .modify-file-table .ant-table-content table {\n    min-width: 760px;\n  }\n}\n\n@media (max-width: 768px) {\n  .campaign-dashboard {\n    overflow-x: hidden;\n  }\n\n  .audience-list-header {\n    gap: 10px;\n  }\n\n  .campaign-dashboard .header-actions-buttons {\n    width: 100%;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: end;\n    gap: 10px;\n  }\n\n  .campaign-dashboard .header-actions-buttons .audience-btn,\n  .campaign-dashboard .header-actions-buttons .audience-archive-toggle,\n  .campaign-dashboard .header-actions-buttons .toggle-pill,\n  .campaign-dashboard .header-actions-buttons .button {\n    width: auto !important;\n    flex: 0 0 auto;\n    margin-top: 0 !important;\n  }\n\n  .campaign-dashboard .audience-toolbar-row {\n    gap: 10px;\n  }\n\n  .campaign-dashboard .audience-actions {\n    width: 100%;\n    justify-content: flex-start;\n    gap: 21px;\n    flex-direction: row !important;\n    align-items: center;\n  }\n\n  .campaign-dashboard .audience-sort-dropdown {\n    min-width: 0;\n    flex: 1 1 220px;\n  }\n\n  .modify-file-container {\n    padding: 10px 0 20px;\n  }\n\n  .modify-file-title {\n    font-size: 28px;\n  }\n\n  .modify-file-card-header {\n    font-size: 24px;\n    padding: 12px;\n  }\n\n  .modify-file-actions {\n    gap: 6px;\n  }\n}\n\n@media (max-width: 480px) {\n  .campaign-dashboard .list-section {\n    overflow: hidden;\n  }\n\n  .campaign-dashboard .audience-list-header .list-header-title {\n    font-size: 16px;\n  }\n\n  .campaign-dashboard .header-actions-buttons {\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n\n  .campaign-dashboard .header-actions-buttons .audience-btn {\n    width: calc(100% - 88px) !important;\n    min-width: 0;\n    margin-top: 0 !important;\n  }\n\n  .campaign-dashboard .header-actions-buttons .toggle-pill {\n    flex: 0 0 auto;\n    margin-top: 0 !important;\n  }\n\n  .campaign-dashboard .audience-toolbar-row {\n    padding: 10px 12px;\n  }\n\n  .campaign-dashboard .audience-actions {\n    flex-wrap: wrap;\n  }\n\n  .campaign-dashboard .audience-actions .audience-actionbuttons {\n    margin-right: 0;\n  }\n\n  .campaign-dashboard .audience-sort-dropdown {\n    width: 100% !important;\n    flex: 1 1 100%;\n  }\n\n  .modify-file-title {\n    font-size: 24px;\n  }\n\n  .modify-file-subtitle {\n    font-size: 14px;\n  }\n\n  .modify-file-back-button {\n    margin-bottom: 10px;\n  }\n\n  .modify-file-card-header {\n    font-size: 20px;\n  }\n}\n","/***************** UserIntro ****************/\n\n.user-intro-container {\n  display: flex;\n  gap: 1rem;\n  align-items: start;\n  height: 100%;\n  padding: 1rem;\n}\n\n.image-section {\n  display: flex;\n  justify-content: center;\n  margin-top: auto;\n}\n\n.girl {\n  max-width: 75%;\n  height: auto;\n}\n\n.noScroll {\n  overflow: hidden;\n}\n\n/********************************UserIntro Media Queries*********************************/\n//USER INTRO MEDIA QUERIES\n\n//Text Boxes\n@media (max-width: 480px) {\n  .input-style {\n    max-width: 150px;\n    height: 30px;\n    padding: 5px 5px;\n    font-size: 10px;\n  }\n\n  .input-style-2 {\n    width: 200px;\n    height: 30px;\n    padding: 5px 5px;\n    font-size: 10px;\n  }\n}\n\n.container-wrap {\n  margin-left: 30px;\n  overflow-y: auto;\n  padding:0;\n}\n\n@media (max-width: 480px) {\n  //user intro\n  .container-wrap {\n    margin-left: 3px;\n      overflow-y: auto !important;\n  }\n}\n\n.user-management-description-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-management-title {\n  font-size: 24px;\n}\n\n.user-management-description {\n color:#6E6A6A; \n font-weight: 400; \n font-size: 16px; \n font-family: 'opensans',sans-serif;\n  margin-top: 2px;\n  padding-left: 2px;\n}\n\n.user-manage-divider {\n  margin-top: 5px !important;\n}\n\n.user-management-actions .ant-input,\n.user-management-actions .ant-select {\n  margin-right: 16px;\n  width: auto;\n}\n\n.user-input {\n  width: 250px !important;\n}\n\n\n@media (max-width: 768px) {\n  .user-management-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .user-management-search-bar,\n  .user-management-actions select {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n}\n\n.actions-user {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.actions-user .ant-input,\n.actions-user .ant-select,\n.actions-user  {\n  margin-right: 0;\n  margin-bottom: 10px;\n}\n.user-management-product-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px; \n  align-items: left !important;\n}\n\n.User-dashboard-header {\n font-size: 32px;\n  font-weight: 600;\n   font-family: 'opensans',sans-serif;\n    color: #2A2929;\n  margin: 0;\n\n}\n\n@media (max-width: 768px) {\n  .actions-user {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .actions-user .ant-input,\n  .actions-user .ant-select,\n  .actions-user  {\n    width: 100%;\n  }\n}\n@media (max-width: 1024px) {\n  /* Adjust font size and table cell width for laptops */\n  .user-management-title {\n    font-size: 20px; /* Decrease title font size */\n  }\n\n  .user-management-description {\n    font-size: 14px; /* Decrease description font size */\n  }\n  .ant-select-selector {\n    width: fit-content;\n  }\n\n  .user-management-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n\n  .user-management-search-bar,\n  .user-management-actions select {\n    width: fit-content;\n    margin-bottom: 10px;\n  }\n}\n.add-user-modal {\n  .ant-modal-content {\n    border-radius: 8px;\n  }\n}\n.add-user-modal .ant-modal-title {\n  color: black;\n  text-align: center;\n}\n\n.user-initials {\n  background-color: #f58512 !important;\n  width: 150px;\n  height: 150px;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  font-size: 4rem;\n}\n\n@media (max-width: 768px) {\n  .user-initials {\n    width: 120px;\n    height: 120px;\n    font-size: 3rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .user-initials {\n    width: 100px;\n    height: 100px;\n    font-size: 2.5rem;\n  }\n}\n\n\n///  update profile\n/*********** Update Profile **********/\n.update-Profile-btn {\n  width: 125px;\n  height: 44px;\n  border-radius: 3px;\n  padding: 14px 12px;\n  font-size: 16px;\n  background-color: #2596be;\n  margin-top: 10px;\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n\n.update-Profile-btn:disabled,\n.update-Profile-btn[disabled] {\n  background-color: #cccccc !important; /* Gray it out */\n  color: #666 !important;\n  cursor: not-allowed !important;\n}\n\n.update-Profile-btn label {\n  color: white;\n  cursor: pointer;\n}\n\n.update-Profile-btn:hover label {\n  color: #2596be !important;\n}\n\n.update-Profile-btn:hover {\n  border-color: #2596be !important;\n  cursor: pointer;\n  border-width: 2px !important;\n}\n/* For Account settings */\n@media (max-width: 768px) {\n  .row.mt-4.ml-3 {\n    flex-direction: column;\n    margin-left: 0;\n    margin-top: 1rem;\n  }\n\n  .col-2,\n  .col-5,\n  .col-10 {\n    width: 100% !important;\n    padding: 0 1rem;\n  }\n\n  .user-initials {\n    margin-bottom: 1rem;\n    margin-left: auto;\n    margin-right: auto;\n        display: flex !important;        \n    justify-content: center;        \n    align-items: center;            \n    width: 100px !important;       \n    height: 100px !important;     \n    border-radius: 50% !important;  \n    background: #2B68AD;            \n    color: white;                  \n    font-weight: bold;  \n  }\n}\n\n/* Small devices (phones) */\n@media (max-width: 480px) {\n  .input-fields-acc-setting {\n    font-size: 0.95rem;\n    padding: 8px;\n  }\n\n  .icon-heading {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 1rem 0;\n  }\n\n  .icon-heading img {\n    width: 24px;\n    height: 24px;\n  }\n\n  .icon-heading label {\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  .button--primary {\n    width: 100%;\n    margin-top: 1rem;\n  }\n}\n\n// user management (user side)\n.access-level-select {\n  width: 150px;\n  justify-content: center;\n}\n\n.access-level-select .ant-select-selector {\n  min-height: 30px !important;\n}\n\n.access-level-select--disabled {\n  opacity: 0.8;\n}\n\n.status-cell {\n  display: flex;\n  align-items: center;\n}\n\n.status-text {\n  margin-left: 8px;\n}\n\n.user-management-icon.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.user-management-icons {\n  display: flex;\n  align-items: center;\n  justify-content: left;\n}\n\n.user-management-switch.ant-switch-checked,\n.user-management-switch.ant-switch-checked:hover {\n  background: $blue-400 !important;\n}\n\n.delete-icon {\n  margin-left: 4px;\n  margin-top: 2px;\n}\n\n////**********user management***************//////////\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  \n  .user-management-actions {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .actions-user {\n    flex-direction: column;\n    align-items: center;\n    width: 50%;\n    margin-top: 10px;\n  }\n\n  .actions-user .ant-input,\n  .actions-user .ant-select,\n  .actions-user .button {\n    width: 100% !important;\n    max-width: 100%;\n  }\n\n  .user-management-description-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .user-management-description {\n    font-size: 0.95rem;\n    margin-top: 0.5rem;\n  }\n\n  .user-management-header {\n    padding: 0.5rem;\n  }\n\n  .user-management-table {\n    max-width:100%;\n  }\n  .custom-dropdown{\n    max-width: 70%;\n  }\n}\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .user-management-actions {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .actions-user {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .actions-user .ant-input,\n  .actions-user .ant-select,\n  .actions-user .button {\n    max-width: 100%;\n    align-items: center;\n    \n  }\n\n  .user-management-description-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .user-management-description {\n    font-size: 0.95rem;\n    margin-top: 0.5rem;\n  }\n\n  .user-management-header {\n    padding: 0.5rem;\n  }\n\n  .user-management-table {\n    overflow-x: auto;\n  }\n}\n.user-management-box {\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  padding: 15px 20px;\n  border-radius: 10px;\n  margin-bottom: 24px;\n  overflow: visible;\n  position: relative;\n}\n\n/* Toolbar container */\n.user-management-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0; \n}\n\n\n.user-toolbar-left {\n  display: flex;\n  align-items: center;\n}\n\n.user-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px; \n  flex-wrap: wrap;\n}\n\n.user-input {\n  width: 250px;\n  height: 40px;\n  flex-shrink: 0;\n}\n\n.usermanagement-dropdown {\n  width: 160px;\n  height: 40px;\n  flex-shrink: 0;\n}\n\n.usermanagement-dropdown[mode=\"multiple\"] {\n  width: 200px;\n}\n.user-management-button{\n  margin-top: 8px;\n}\n\n/* ===== User Management Revamp ===== */\n.user-management-container {\n  padding: 8px 14px 20px;\n  min-height: 100%;\n}\n\n.user-management-container .user-management-product-header {\n  margin-bottom: 14px;\n}\n\n.user-management-container .User-dashboard-header {\n  font-size: 32px;\n  line-height: 1.1;\n  font-weight: 700;\n  margin: 0;\n}\n\n.user-management-container .user-management-description {\n  font-size: 13px;\n  color: #000000;\n  margin: 3px 0 0;\n  padding-left: 0;\n}\n\n.user-management-container .user-management-box {\n  background: #fff;\n  border: 1px solid #d9e2ee;\n  border-radius: 12px;\n  padding: 0;\n  overflow: hidden;\n}\n\n.user-management-container .user-management-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e6edf7;\n}\n\n.user-management-container .user-management-card-title {\n  font-size: 26px;\n  font-weight: 600;\n  color: #1f1f1f;\n}\n\n.user-management-container .user-management-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-management-container .user-management-delete-icon-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 8px;\n  background: #fff;\n  color: #2c68ad;\n}\n\n.user-management-container .user-management-delete-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user-management-container .user-management-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 14px;\n  padding: 6px 16px 10px;\n}\n\n.user-management-container .user-management-filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-management-container .user-input {\n  width: 280px !important;\n  margin: 0;\n}\n\n.user-management-container .usermanagement-dropdown {\n  width: 170px;\n  margin: 0;\n}\n\n.user-management-container\n  .usermanagement-dropdown.ant-select-multiple:not(.ant-select-show-search)\n  .ant-select-selection-search {\n  display: none;\n}\n\n.user-management-container .user-management-button {\n  margin-top: 0;\n  margin-bottom: 0;\n  min-width: 102px;\n}\n\n.user-management-container .campaign-table-wrapper {\n  border-top: 1px solid #edf2fb;\n}\n\n.user-management-container .user-management-table .ant-table {\n  border-radius: 0;\n}\n\n.user-management-container .user-management-table .ant-table-thead > tr > th {\n  color: #161616;\n  font-size: 13px;\n  font-weight: 600;\n  border-bottom: 1px solid #e6edf7 !important;\n}\n\n.user-management-container .user-management-table .ant-table-tbody > tr > td {\n  border-bottom: 1px solid #edf2fb !important;\n  color: #2a2a2a;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr:last-child\n  > td {\n  border-bottom: none !important;\n}\n\n.user-management-container .user-management-table .ant-table-tbody > tr:hover > td {\n  background: #eeeeee !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  > td {\n  background: #eeeeee !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled:hover\n  > td {\n  background: #eeeeee !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  > td,\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  > td\n  .campaign-name,\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  > td\n  a {\n  color: #666666 !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  .user-management-icons {\n  color: #666666 !important;\n  opacity: 0.7;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  .user-management-icons\n  svg {\n  stroke: #666666 !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  .access-level-select.ant-select-disabled\n  .ant-select-selection-item,\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  .access-level-select.ant-select-disabled\n  .ant-select-selection-placeholder {\n  color: #666666 !important;\n  opacity: 1 !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  .access-level-select.ant-select-disabled\n  .styled-dropdown-caret {\n  border-top-color: #666666 !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  > tr.user-row-disabled\n  .user-management-switch.ant-switch-disabled.ant-switch-checked {\n  background: #8f8f8f !important;\n}\n\n\n.user-management-container .user-management-table .ant-table-container {\n  overflow: visible;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  .access-level-select\n  .ant-select-selector {\n  height: 32px !important;\n  min-height: 32px !important;\n  /* The wide end-side pad reserves room for the arrow, so it tracks direction\n     and no separate RTL rule is needed. */\n  padding-block: 0 !important;\n  padding-inline-start: 12px !important;\n  padding-inline-end: 34px !important;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  .access-level-select\n  .ant-select-selection-item,\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  .access-level-select\n  .ant-select-selection-placeholder {\n  font-size: 12px !important;\n  line-height: 1 !important;\n  display: flex;\n  align-items: center;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  .access-level-select\n  .ant-select-arrow {\n  top: 68% !important;\n  transform: translateY(-50%) !important;\n  height: 20px;\n  width: 20px;\n  /* Logical inset, so the arrow follows the writing direction on its own.\n     The shared `.custom-dropdown .ant-select-arrow` rule (DropDownStyle.scss)\n     is logical too, so the filter dropdowns and the portalled Add/Edit User\n     modals no longer need per-direction overrides here. */\n  inset-inline-end: 10px;\n}\n\n.user-management-container\n  .user-management-table\n  .ant-table-tbody\n  .access-level-cell-inner {\n  display: flex;\n  align-items: center;\n  min-height: 100%;\n}\n\n@media (max-width: 1024px) {\n  .user-management-container .user-management-filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .user-management-container .user-management-filter-group {\n    width: 100%;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .user-management-container .user-input {\n    width: 100% !important;\n  }\n\n  .ant-select-selector {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .user-management-container .User-dashboard-header {\n    font-size: 30px;\n  }\n\n  .user-management-container .user-management-card-header {\n    //flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  .ant-select-selector {\n    width: 100% !important;\n  }\n}\n","@import \"./variables\";\n// buttons\n.filter-buttons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n  font-weight: bold;\n  align-self: center;\n\n  div {\n    color: $brand-primary;\n    background-color: $white;\n    border: 2px solid $brand-primary; // Added border width and style\n    padding: 10px 15px;\n    border-radius: 3px;\n    font-size: 14px;\n    cursor: pointer;\n    width: fit-content;\n\n    &:hover {\n      background: $brand-primary;\n      color: $white;\n    }\n  }\n}\n\n.filter-btn {\n  border: 2px solid $color-38abd2;\n}\n.button-container {\n  margin-top: 20px;\n  display: flex;\n  flex-wrap: wrap;\n    padding-top: 30px;\n  margin-left: 25px;\n}\n//annual and monthyl button\n@media (max-width: 480px) {\n  .annualbtn {\n    max-width: 50px;\n    font-size: 7px;\n    font-weight: 700;\n    font-size: 8px;\n    line-height: 5px;\n    border-radius: 5px;\n    height: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .monthlybtn {\n    max-width: 50px;\n    font-size: 7px;\n    font-weight: 700;\n    font-size: 8px;\n    line-height: 5px;\n    border-radius: 5px;\n    height: 20px;\n  }\n}\n//facebook modal blue button on right\n\n@media (max-width: 480px) {\n  .facebook-signin-btn {\n    display: flex;\n    background-color: $color-1977f3;\n    color: $white;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 9px;\n    width: 200px;\n    height: 30px;\n    border: $white;\n    margin-left: 10px;\n    margin-top: 14px;\n    text-align: center;\n    padding-left: 10px;\n  }\n}\n\n//for selecting frequency\n@media screen and (max-width: 768px) {\n  .button-container {\n    padding-left: 50px;\n  }\n\n  .frequency-heading {\n    padding-left: 50px;\n  }\n}\n\n.error-ok-button {\n  background-color: $color-3ec3f0;\n  color: $white;\n  font-weight: bold;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n  width: 100px;\n}\n\n.error-ok-button:hover {\n  background-color: $color-2a99b4;\n}\n\n.error-ok-button:focus {\n  outline: none;\n}\n\nbutton.p-multiselect-close.p-link {\n  width: fit-content !important;\n  height: fit-content !important;\n}\n\n.action-btn {\n  padding: 4px 8px;\n  margin: 0 4px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background-color 0.2s ease;\n}\n\n.archive-btn {\n  background-color: $border-dark;\n  color: $color-666;\n}\n\n.archive-btn:hover {\n  background-color: $border-dark;\n}\n\n.delete-btn {\n  background-color: $color-ffebee;\n  color: $color-d32f2f;\n}\n\n.delete-btn:hover {\n  background-color: $color-ffcdd2;\n}\n\n.unarchive-btn {\n  background-color: $color-e8f5e9;\n  color: $color-2e7d32;\n}\n\n.unarchive-btn:hover {\n  background-color: $color-c8e6c9;\n}\n\n.red-btn {\n  background-color: $color-ff4d4f;\n  color: $white;\n  border: none;\n}\n\n.red-btn:hover {\n  background-color: $color-ff7875 !important;\n  color: $white !important;\n}\n\n.grey-btn {\n  background-color: $border-dark;\n  border: 2px solid $text-dark;\n}\n\n.grey-btn:hover {\n  background-color: $color-d9d9d9;\n}\n\n.cancel-btn {\n  background: $danger;\n  color: $white;\n  padding: 5px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  border: 1px solid $white;\n}\n\n.confirm-btn {\n  background: $brand-primary;\n  border: 1px solid $white;\n  padding: 5px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  color: $white;\n  gap: 10px;\n \n}\n\n.compare-button,\n.send-again-button {\n  margin-right: 1rem;\n  padding: 0.5rem 1.2rem;\n  background-color: $brand-primary;\n  color: $white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n \n}\n.back-button {\n  background: none;\n  border: none;\n  color: $color-2c5bbd;\n  font-size: 14px;\n  cursor: pointer;\n  margin-bottom: 16px;\n \n}\n\n.action-buttons {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: right;\n  gap: 1.25rem;\n// \n\n  .compare-btn {\n    padding: 0.6rem 1.8rem;\n    font-weight: 500;\n    font-size: 1rem;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  .compare-btn {\n background-color: $white;\n    border: 1px solid $color-cbd5e1;\n    color: $brand-primary;\n\n    &:hover {\n      background-color: $color-f1f5f9;\n    }\n  }\n}\n\n.center-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n \n}\n\n.compact-send-button:hover {\n  background-color: $color-0088cc;\n}\n\n.compact-send-button img {\n  width: 18px;\n  height: 18px;\n}\n\n/* More compact send button */\n.compact-send-button {\n  background-color: $color-00a2cc;\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 0;\n \n}\n.compact-pill-button:hover {\n  background-color: $color-bae7ff;\n}\n\n/* More compact pill buttons */\n.compact-pill-button {\n  flex: 0 0 auto;\n  background-color: rgba(44, 104, 173, 0.1607843137);\n  border: 1px solid $color-91d5ff;\n  border-radius: 20px;\n  padding: 6px 12px;\n  margin-right: 8px;\n  white-space: nowrap;\n  cursor: pointer;\n  color: $text-dark;\n  font-size: 10px;\n  transition: background-color 0.2s ease;\n  box-shadow: none;\n  height: 30px;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 400px;\n font-weight: 600;\n font-family: 'open sans', sans-serif;\n}\n.resend-button {\n  background: none;\n  border: none;\n  color: $color-38abd2;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: inherit;\n \n}\n\n.hamburger-btn {\n  position: fixed;\n  top: 20px; /* adjust as needed */\n  left: 0;\n  z-index: 1100;\n  background-color: $color-2b68ad;\n  color: $white;\n  border: none;\n  padding: 12px;\n  cursor: pointer;\n  font-size: 25px;\n  border-radius: 0 6px 6px 0;\n  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);\n\n}\n.resend-button:hover {\n  text-decoration: none;\n  background: none;\n  border: none;\n}\n.annualbtn {\n  background-color: $white !important;\n  max-width: 166px;\n  border-color: $text-dark;\n  color: var(--dark-purple, $color-140054);\n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  /* 142.857% */\n  border-radius: 5px;\n  border: 2px solid var(--blue-normal, $color-0172cb);\n \n}\n\n.monthlybtn {\n  background-color: $white !important;\n  width: 166px;\n  border-color: $text-dark;\n  color: var(--dark-purple, $color-140054);\n \n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  /* 142.857% */\n  border-radius: 5px;\n  border: 2px solid var(--blue-normal, $color-0172cb);\n}\n\n.annualbtn:hover {\n  background-color: $white !important;\n  border-color: $text-dark;\n  color: var(--dark-purple, $color-140054);\n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  /* 142.857% */\n  border-radius: 5px;\n  border: 2px solid var(--blue-normal, $color-0172cb);\n}\n\n.monthlybtn:hover {\n  background-color: $white !important;\n  border-color: $text-dark;\n  color: var(--dark-purple, $color-140054);\n  text-align: center;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  /* 142.857% */\n  border-radius: 5px;\n  border: 2px solid var(--blue-normal, $color-0172cb);\n}\n.annualbtn:hover {\n  background-color: none;\n  color: var(--dark-purple, $color-140054);\n}\n.subscribebtn {\n  width: 200px;\n  background-color: none !important;\n  border-radius: 0px;\n  border-color: $color-38abd2;\n  font-family: Open Sans;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n \n}\n.close-btn {\n  margin-left: auto;\n}\n.facebook-signin-btn {\n  display: flex;\n  background-color: $color-1977f3;\n  color: $white;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  width: 300px;\n  height: 40px;\n  border: $white;\n  margin-left: 70px;\n  margin-top: 28px;\n  text-align: center;\n  padding-left: 10px;\n \n}\n\n.facebook-signin-btn:hover {\n  background-color: $color-165ec9;\n}\n.add-more-btn,\n.compare-btn {\n  padding: 0.5rem 1.25rem;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n \n}\n\n.add-more-btn {\n  background-color: $color-dbeeff;\n  color: $color-145da0;\n \n}\n\n.red-btn {\n  background-color: $danger;\n  // font-weight: bold;\n  color: $white;\n  border-color: $danger;\n \n}\n\n.grey-btn {\n  background-color: $white;\n  // font-weight: bold;\n  color: $border-dark;\n  border-color: $border-dark;\n \n}\n\n.grey-btn,\n.red-btn {\n  border-radius: 3px;\n  width: 146px;\n  height: 45px;\n  font-size: 16px;\n \n}\n\n.cancel-btnMagicScreen {\n  position: fixed;\n  bottom: 100px;\n  /* Adjust the distance from the bottom */\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n \n}\n\n.cancel-btnMagicScreen:hover {\n  background: transparent !important;\n  text-decoration: underline;\n}\n\n.send-email-btn {\n  background-color: \\\\$brand-primary;\n  font-size: 10px;\n  width: 100px;\n  height: 40px;\n  color: $white;\n  border-color: \\\\$brand-primary;\n  border: 1px;\n  border-radius: 5px;\n  font-size: 12px;\n  margin-bottom: 20px;\n \n}\n\n.page-btn {\n  padding: 6px 12px;\n  border: 1px solid $color-c1d6f5;\n  background-color: $white;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  /* Remove browser focus ring */\n  outline: none !important;\n\n  /* Prevent tap highlight on mobile */\n  -webkit-tap-highlight-color: transparent !important;\n\n  /* Remove inner border in Firefox */\n  -moz-focus-inner {\n    border: 0;\n  }\n}\n\n.page-btn:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.page-btn.active,\n.page-btn:hover {\n  background-color: $color-2979ff;\n  color: $white;\n  border-color: $color-2979ff;\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  color: $color-0050b3;\n  font-size: 16px;\n  padding: 0;\n  margin-bottom: 20px;\n  cursor: pointer;\n}\n\n.next-btn {\n  display: block; // Ensure it's treated like a block element\n  margin: 30px auto 0 auto; // Top margin + horizontal auto-centering\n  background-color: $color-1890ff;\n  border-color: $color-1890ff;\n  font-weight: 500;\n  height: 40px;\n  padding: 0 24px;\n  border-radius: 6px;\n  text-align: center;\n \n}\n\n.btn-outline {\n  border: 1px solid $color-cbd5e1;\n  background: transparent;\n  padding: 0.35rem 0.75rem;\n  font-size: 0.85rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n \n\n  &:hover {\n    background-color: $color-f1f5f9;\n  }\n\n  &.danger:hover {\n    background-color: $color-fee2e2;\n  }\n}\n\n.btn-refresh {\n  background: transparent;\n  color: $blue-base;\n  font-size: 0.9rem;\n  border: none;\n  cursor: pointer;\n  padding: 0.35rem 0.75rem;\n  border-radius: 8px;\n\n  &:hover {\n    background-color: $color-eff6ff;\n  }\n}\n\n.right-aligned-btns {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.filter-btn.selected {\n  background-color: \\\\$brand-primary; // Or any primary color from your palette\n  color: $white;\n  font-weight: 600;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n// *************************************SelectingFrequency************************************//\n.button-container {\n  display: flex;\n  padding-top: 30px;\n  margin-left: 25px;\n}\n\n@media screen and (max-width: 768px) {\n  .button-container {\n    padding-left: 50px;\n  }\n\n  .frequency-heading {\n    padding-left: 50px;\n  }\n}\n\n.frequency-heading {\n  padding-top: 20px;\n  padding-left: 20px;\n  text-align: left;\n  margin-left: 25px;\n}\n\n.buttonstyle {\n  height: 45px;\n  width: 140px;\n}\n\n.selectable-button {\n  border-radius: 3px;\n  border: 1px solid $color-38abd2;\n  background-color: $white;\n\n  margin: 10px;\n  color: $color-38abd2;\n  /* Text color */\n  cursor: pointer;\n  transition: background-color 0.3s;\n  /* Smooth transition */\n\n  text-align: center;\n  font-family: Open, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  /* 150% */\n  text-transform: uppercase;\n}\n\n.selectable-button:hover {\n  background-color: $color-38abd2;\n  color: $white;\n}\n\n.selectable-button.selected {\n  background-color: $color-38abd2;\n  color: $white;\n}\n\n.button-style {\n  width: 330px;\n  height: 45px;\n  border: none;\n  background-color: $color-2596be;\n  color: $white;\n  font-weight: bold;\n  max-width: 350px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  margin-top: 30px;\n  display: flex;\n  padding: 14px 5px;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  font-size: 16px;\n  justify-content: center;\n \n}\n.button-otp {\n  padding: 10px;\n  border: none;\n  background-color: $color-2596be;\n  color: $white;\n  border-radius: 5px;\n  font-weight: bold;\n  font-size: 15px;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n \n}\n\n\n","@import \"./variables\";\n\n/* *************************************Steps.css************************************ */\n\n.steps-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.step-item {\n  display: flex;\n  align-items: center;\n  margin: 30px 0;\n}\n\n\n.button-group {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 180px;\n}\n\n.nextbutton {\n  flex: 1;\n  max-width: 200px;\n  height: 40px;\n  font-weight: 300;\n  color: rgb(15, 15, 15) !important;\n  background-color: $color-75ceeb;\n  border-radius: 1px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 25px;\n}\n.prebutton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border-radius: 1px;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  margin-left: 5px;\n}\n.prebutton.sidebar-back {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;    \n}\n\n.prebutton .button-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: $white;\n  width:40px;\n}\n.button-icon:hover{\n  color:$text-dark;\n}\n.input-style {\n  border: 1px solid $color-bac7d5;\n  //width: 389px;\n  max-width: 350px;\n  height: 35px;\n  border-radius: 3px;\n  display: flex;\n  padding: 14px 12px;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n//needed to modify the signup page container to improve mobile responsiveness\n.input-style-2 {\n  border: 1px solid $color-bac7d5;\n  //width: 389px;\n  max-width: 350px;\n  height: 45px;\n  border-radius: 3px;\n  display: flex;\n  padding: 14px 12px;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.h2design {\n  color: $text-dark;\n  font-family: 'opensans',sans-serif;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  padding-top: 30px;\n}\n\n.submit {\n  height: 38px;\n  width: 78px;\n  color: $white !important;\n  background-color: $color-38abd2;\n  border: none;\n  text-align: center;\n  /* font-family: 'sans-serif'; */\n  font-weight: normal;\n}\n\n///lists\n/* Notification List */\n.notifications-list {\n  overflow-y: auto;\n}\n.create-list-segment-container {\n  padding: 18px 10px 30px;\n  color: $text-primary;\n\n  .list-segment-back-button {\n    min-width: 70px;\n    height: 34px;\n    padding: 0 14px;\n    margin-bottom: 14px;\n    font-size: 14px;\n  }\n\n  .list-segment-page-title {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    color: $text-dark;\n    justify-content: left;\n    text-align: left;\n  }\n\n  .list-segment-page-subtitle {\n    margin: 4px 0 24px;\n    color: $text-secondary;\n    font-size: 16px;\n  }\n\n  .selection-box {\n    background: transparent;\n    border: 0;\n    border-radius: 0;\n    padding: 0;\n    min-height: 240px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .selection-options {\n      display: flex;\n      justify-content: center;\n      align-items: stretch;\n      gap: 24px;\n      margin-top: 80px;\n\n      .selection-card {\n        width: 266px;\n        min-height: 210px;\n        padding: 20px 18px 16px;\n        background: $white;\n        border: 1px solid rgba(117, 117, 117, 1);\n        border-radius: 8px;\n        text-align: center;\n        cursor: pointer;\n        transition: border-color 0.2s ease, box-shadow 0.2s ease;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        font-family: \"Open Sans\", sans-serif;\n        color: $text-primary;\n        gap: 6px;\n\n        &:hover {\n          background-color: rgba(217, 228, 240, 1);\n          border-color: $brand-primary;\n          box-shadow: 0 3px 10px rgba(44, 104, 173, 0.12);\n        }\n\n        .audience_icon {\n          margin-bottom: 8px;\n          color: $text-dark;\n        }\n\n        .card-title {\n          font-size: 20px;\n          font-weight: 600;\n          margin: 0 0 8px;\n          color: $text-dark;\n        }\n\n        .card-description {\n          margin: 0;\n          font-size: 12px;\n          line-height: 1.35;\n          color: rgba(117, 117, 117, 1);\n          max-width: 190px;\n        }\n      }\n    }\n  }\n}\n\n.create-list-container {\n  padding: 16px 10px 24px;\n  color: $text-primary;\n\n  .create-list-back-button {\n    min-width: 70px;\n    height: 34px;\n    padding: 0 14px;\n    margin-bottom: 14px;\n    font-size: 14px;\n    margin-left: 30px;\n  }\n\n  .create-list-title {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    color: $text-dark;\n    text-align: left;\n    padding-left: 30px;\n  }\n\n  .create-list-subtitle {\n    margin: 4px 0 14px;\n    color: $text-secondary;\n    font-size: 13px;\n    line-height: 1.4;\n    padding-left: 30px;\n  }\n\n  .create-list-form {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .form-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: $text-primary;\n    margin-top: 2px;\n  }\n\n  .create-list-input {\n    width: 100%;\n    height: 38px;\n    border-radius: 6px;\n  }\n\n  .create-list-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 2px 8px;\n    border: 1px solid $brand-primary;\n    color: #1f3b65;\n    background: #edf4ff;\n    border-radius: 8px;\n    font-size: 11px;\n  }\n\n  .tag-remove-btn {\n    border: 0;\n    background: transparent;\n    color: inherit;\n    cursor: pointer;\n    padding: 0;\n    line-height: 1;\n    font-size: 12px;\n  }\n\n  .create-list-upload-area {\n    margin-top: 8px;\n    border: 1px dashed #d1d5db;\n    border-radius: 8px;\n    background: $white;\n    padding: 62px 12px;\n  }\n\n  .create-list-upload-box {\n    gap: 4px;\n  }\n\n  .create-list-upload-box .upload-icon {\n    color: $brand-primary;\n    margin-bottom: 6px;\n  }\n\n  .create-list-upload-box .upload-text {\n    color: $text-dark;\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .create-list-upload-box .upload-subtext {\n    color: rgba(117, 117, 117, 1);\n    font-size: 13px;\n    font-weight: 400;\n  }\n\n  .create-list-upload-note {\n    margin: 2px 0 4px;\n    font-size: 11px;\n    color: #8b8b8b;\n  }\n\n  .uploaded-file-row {\n    margin-top: 8px;\n    width: 260px;\n    max-width: 100%;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n    padding: 6px 10px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    background: $white;\n  }\n\n  .uploaded-file-name {\n    font-size: 12px;\n    color: $text-dark;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .uploaded-file-paperclip {\n    color: $text-dark;\n    transform: rotate(320deg);\n    flex-shrink: 0;\n  }\n\n  .uploaded-file-remove {\n    border: 0;\n    background: transparent;\n    color: $brand-primary;\n    cursor: pointer;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  .create-list-actions {\n    margin-top: 0px;\n    justify-content: flex-end;\n    gap: 10px;\n  }\n}\n\n.create-segment-page {\n  padding: 18px 10px 30px;\n  color: $text-primary;\n\n  .create-segment-back-button {\n    min-width: 70px;\n    height: 34px;\n    padding: 0 14px;\n    margin-bottom: 14px;\n    font-size: 14px;\n  }\n\n  .create-segment-title {\n    margin: 0;\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 1.1;\n    color: $text-dark;\n    text-align: left;\n  }\n\n  .create-segment-subtitle {\n    margin: 4px 0 16px;\n    color: rgba(117, 117, 117, 1);\n    font-size: 13px;\n    line-height: 1.4;\n  }\n\n  .create-segment-form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .create-segment-label {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: $text-primary;\n  }\n\n  .create-segment-conditions-title {\n    margin-top: 2px;\n  }\n\n  .create-segment-input {\n    height: 38px;\n    border-radius: 6px;\n  }\n\n  .create-segment-condition-wrap {\n    position: relative;\n  }\n\n  .create-segment-condition-card {\n    border: 1px solid #d9d9d9;\n    border-radius: 8px;\n    background: $white;\n    padding: 14px 16px 16px;\n    overflow: visible;\n  }\n\n  .create-segment-condition-dropdown {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .create-segment-list-title {\n    margin: 20px 0 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: $text-primary;\n  }\n\n  .create-segment-chip-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 12px;\n  }\n\n  .condition-btn {\n    height: 38px;\n    min-width: 130px;\n    padding: 0 14px;\n    border: 1px solid #9ea8b3;\n    border-radius: 8px;\n    background: $white;\n    color: #1f2937;\n    font-size: 14px;\n    line-height: 1;\n    cursor: pointer;\n    transition: background-color 0.2s ease, border-color 0.2s ease;\n  }\n .condition-btn:hover {\n  border-color: $brand-primary !important;\n }\n  .condition-btn.active {\n    background: rgba(44, 104, 173, 0.18) !important;\n    border-color:$brand-primary !important;\n    color: $text-dark !important;\n  }\n\n  .condition-btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n\n  .create-segment-card-bottom {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    border-top: 1px solid #edf0f4;\n    padding-top: 12px;\n  }\n\n  .create-segment-logic-buttons {\n    display: inline-flex;\n    gap: 8px;\n    margin-top: 20px;\n  }\n\n  .create-segment-logic-btn {\n    min-width: 44px;\n    height: 32px;\n    border-radius: 6px;\n    padding: 0 12px;\n    font-size: 12px;\n    font-weight: 600;\n    border-color: $brand-primary;\n    color: $brand-primary;\n  }\n\n  .create-segment-logic-btn.is-active,\n  .create-segment-logic-btn:hover {\n    background: $brand-primary !important;\n    color: $white !important;\n    border-color: $brand-primary !important;\n  }\n\n  .create-segment-delete-btn {\n    border: 0;\n    background: transparent;\n    color: $brand-primary;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n    margin-right: 8px;\n    line-height: 1;\n  }\n\n  .create-segment-delete-row {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 2px;\n    margin-bottom: 8px;\n    padding-right: 2px;\n    position: relative;\n    z-index: 2;\n  }\n\n  .create-segment-connector {\n    position: relative;\n    margin: 0 0 0 34px;\n    min-height: 54px;\n    display: flex;\n    align-items: center;\n  }\n\n  .create-segment-connector-pill {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 46px;\n    height: 20px;\n    padding: 0 10px;\n    border-radius: 6px;\n    background: $brand-primary;\n    color: $white;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    transform: translateY(0);\n  }\n\n  .create-segment-actions {\n    margin-top: 8px;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 768px) {\n  .create-segment-page {\n    .create-segment-title {\n      font-size: 32px;\n    }\n\n    .create-segment-condition-card {\n      padding: 12px;\n    }\n\n    .condition-btn {\n      min-width: 120px;\n      flex: 1 1 calc(50% - 8px);\n    }\n\n    .create-segment-actions .button--primary {\n      width: 100%;\n      max-width: 220px;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .create-segment-page {\n    .create-segment-title {\n      font-size: 28px;\n    }\n\n    .create-segment-back-button {\n      margin-left: 0;\n    }\n\n    .create-segment-chip-row {\n      gap: 8px;\n    }\n\n    .condition-btn {\n      min-width: 100%;\n      flex: 1 1 100%;\n    }\n\n    .create-segment-connector::before {\n      left: -16px;\n      width: 16px;\n    }\n  }\n}\n\n.import-columns-page {\n  padding: 16px 10px 24px;\n  color: $text-primary;\n\n  .import-columns-back-button {\n    min-width: 70px;\n    height: 34px;\n    padding: 0 14px;\n    margin-bottom: 14px;\n    font-size: 14px;\n  }\n\n  .import-columns-title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: $text-primary;\n    text-align: left;\n  }\n\n  .import-columns-subtitle {\n    margin: 4px 0 16px;\n    color: $text-secondary;\n    font-size: 14px;\n    line-height: 1.4;\n  }\n\n  .import-columns-subtitle strong {\n    font-weight: 700;\n  }\n\n  .import-columns-card {\n    border: 1px solid #d9d9d9;\n    border-radius: 8px;\n    overflow: hidden;\n    background: $white;\n    max-width: 1240px;\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  .import-columns-table {\n    margin-top: 0;\n  }\n\n  .import-columns-table .ant-table-thead > tr > th {\n    font-size: 18px;\n    font-weight: 600;\n    color: $text-primary;\n  }\n\n  .import-columns-table .ant-table-tbody > tr > td {\n    font-size: 16px;\n    color: $text-primary;\n    height: 56px;\n  }\n\n  .mapping-text {\n    color: $text-primary;\n  }\n\n  .import-mapping-dropdown {\n    min-width: 240px;\n  }\n\n  .import-columns-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 14px;\n    max-width: 1240px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.import-columns-page .import-mapping-dropdown .ant-select-selector {\n  height: 40px !important;\n  min-height: 40px !important;\n}\n\n.import-columns-page .import-mapping-dropdown .ant-select-selection-item,\n.import-columns-page .import-mapping-dropdown .ant-select-selection-placeholder {\n  font-size: 14px !important;\n}\n.tags-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n@media (max-width:480px){\n  .create-list-segment-container .selection-box {\n    min-height: 0;\n  }\n\n  .create-list-segment-container .selection-box .selection-options {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .create-list-segment-container .selection-box .selection-options .selection-card {\n    width: 220px;\n    min-height: 210px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .create-list-segment-container .selection-box .selection-options {\n    margin-top: 30px;\n  }\n\n  .create-list-segment-container .list-segment-back-button,\n  .create-list-container .create-list-back-button,\n  .import-columns-page .import-columns-back-button {\n    width: auto !important;\n  }\n\n  .import-columns-page .import-columns-table .ant-table-content {\n    overflow-x: auto !important;\n  }\n\n  .import-columns-page .import-columns-table .ant-table-content table {\n    min-width: 820px;\n  }\n}\n\n@media (max-width: 768px) {\n  .create-list-segment-container {\n    padding: 12px 6px 20px;\n  }\n\n  .create-list-segment-container .list-segment-page-subtitle {\n    font-size: 14px;\n    margin-bottom: 14px;\n  }\n\n  .create-list-segment-container .selection-box .selection-options {\n    margin-top: 0;\n    gap: 14px;\n  }\n\n  .create-list-container {\n    padding: 12px 6px 18px;\n  }\n\n  .create-list-container .create-list-back-button,\n  .create-list-container .create-list-title,\n  .create-list-container .create-list-subtitle {\n    margin-left: 0;\n    padding-left: 0;\n  }\n\n  .create-list-container .create-list-upload-area {\n    padding: 36px 10px;\n  }\n\n  .create-list-container .uploaded-file-row {\n    width: 100%;\n  }\n\n  .create-list-container .create-list-actions {\n    margin-top: 10px;\n    justify-content: flex-end;\n    width: 100%;\n  }\n\n  .create-list-container .create-list-actions .button {\n    width: auto !important;\n    min-width: 110px;\n    margin-top: 0 !important;\n  }\n\n  .create-list-container .create-list-back-button,\n  .import-columns-page .import-columns-back-button,\n  .create-list-segment-container .list-segment-back-button {\n    width: auto !important;\n    min-width: 70px;\n  }\n\n  .import-columns-page {\n    padding: 12px 6px 18px;\n  }\n\n  .import-columns-page .import-columns-title {\n    font-size: 28px;\n  }\n\n  .import-columns-page .import-columns-subtitle {\n    font-size: 14px;\n  }\n\n  .import-columns-page .import-columns-card {\n    border-radius: 8px;\n  }\n\n  .import-columns-page .import-columns-actions {\n    margin-top: 10px;\n  }\n\n  .import-columns-page .import-columns-actions .button {\n    width: auto !important;\n    min-width: 110px;\n  }\n}\n\n@media (max-width: 480px) {\n  .create-list-segment-container .list-segment-page-title {\n    font-size: 28px;\n  }\n\n  .create-list-segment-container .selection-box .selection-options .selection-card {\n    width: 100%;\n    max-width: 260px;\n  }\n\n  .create-list-container .create-list-title {\n    font-size: 28px;\n  }\n\n  .create-list-container .create-list-subtitle {\n    font-size: 13px;\n  }\n\n  .create-list-container .create-list-actions {\n    flex-direction: row;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n  }\n\n  .create-list-container .create-list-actions .button {\n    min-width: 104px;\n  }\n\n  .import-columns-page .import-columns-title {\n    font-size: 24px;\n  }\n\n  .import-columns-page .import-columns-back-button {\n    margin-bottom: 10px;\n  }\n\n  .import-columns-page .import-columns-table .ant-table-content table {\n    min-width: 760px;\n  }\n}\n\r\n",".notification-preferences-container {\n  padding: 20px;\n  margin-bottom: 10px;\n  max-width: 100%;\n  /* `height: 84vh` reserved a full-viewport-tall box no matter how little was\n     expanded, so a single open section left dead space below its rows and the\n     card scrolled internally. `max-height` keeps the same scroll ceiling but\n     lets the card shrink to its content. */\n  max-height: 84vh;\n  overflow-y: auto;\n}\n\ndiv.p-multiselect-label.p-placeholder,\ndiv.p-multiselect-label {\n  color: black;\n}\n\n/* legacy class kept for any non-preference notification UI */\n.notification-category {\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n/* Notifications Modal */\n.notifications-modal {\n  position: fixed;\n  top: 9%;\n  right: 50px;\n  width: 480px;\n  height: 580px;\n  background: white;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  padding: 8px;\n  border: 1px solid #e5e7eb; /* Gray-200 */\n  z-index: 100000;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.notifications-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 5px;\n  padding-left: 5px;\n  max-height: 28px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.notifications-modal-title {\n  font-size: 14px; /* text-lg */\n  color: #1d1d4f;\n  font-weight: bold;\n  line-height: 1.4;\n}\n\n.notifications-mark-all-read {\n  border: none;\n  background: transparent;\n  color: $brand-primary;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.4;\n  text-decoration: underline;\n  cursor: pointer;\n  font-family: 'Open Sans', sans-serif;\n  padding: 0;\n\n  &:disabled {\n    color: $color-999;\n    cursor: not-allowed;\n    text-decoration: none;\n  }\n}\n\n.notifications-modal-content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.notifications-popup-group {\n  &:not(:last-child) {\n    margin-bottom: 4px;\n  }\n}\n\n.notifications-popup-group__label {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: $text-secondary;\n  font-family: 'Open Sans', sans-serif;\n  padding: 10px 4px 4px;\n}\n\n.notifications-popup-row__toggle {\n  color: #0077b6;\n  font-weight: 500;\n  cursor: pointer;\n  margin-left: 4px;\n  // Reset native <button> chrome — visually this is still an inline text toggle.\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: inherit;\n  font-family: inherit;\n  display: inline;\n\n  &:focus-visible {\n    outline: 2px solid $brand-primary;\n    outline-offset: 2px;\n  }\n}\n\n.notifications-view-more-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  border: none;\n  border-top: 1px solid $color-e5e7eb;\n  background: transparent;\n  color: $brand-primary;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.4;\n  font-family: 'Open Sans', sans-serif;\n  cursor: pointer;\n  padding: 10px 4px 4px;\n\n  &:hover {\n    color: $brand-primary-hover;\n  }\n}\n\n/* No notifications UI */\n.notifications-no-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  height: 100%;\n}\n\n.notifications-no-data-image {\n  width: 70%; /* w-48 */\n}\n\n/* ========== Notification empty / error state (page + bell popup) ========== */\n\n.notification-state-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 12px;\n  padding: 64px 24px;\n}\n\n.notification-state-display__icon {\n  width: 160px;\n  height: 160px;\n  margin-bottom: 8px;\n}\n\n.notification-state-display__title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #2c68ad;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.notification-state-display__message {\n  max-width: 420px;\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n  line-height: 1.5;\n}\n\n.notification-state-display--compact {\n  padding: 32px 16px;\n  gap: 8px;\n}\n\n.notification-state-display--compact .notification-state-display__icon {\n  width: 90px;\n  height: 90px;\n  margin-bottom: 4px;\n}\n\n.notification-state-display--compact .notification-state-display__title {\n  font-size: 16px;\n}\n\n.notification-state-display--compact .notification-state-display__message {\n  max-width: 300px;\n  font-size: 12px;\n}\n\ndiv.ant-picker-body {\n  padding: 0px;\n}\n\n.filter-section {\n  position: relative;\n  display: inline-block; // Prevents dropdown from covering full width\n}\n\n.date-range-dropdown {\n  position: absolute;\n  top: 100%; /* directly below the buttons */\n  left: 0;\n  margin-top: 8px;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 12px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  min-width: 280px;\n}\n\n/* ========== All notiifcation page  ========== */\n\n.all-notifications-page {\n  margin-top: 15px;\n  margin-left: 15px;\n}\n\n@media (max-width: 768px) {\n  .notifications-container {\n    padding: 10px;\n  }\n\n  .filter-btn {\n    width: 100%;\n    text-align: center;\n    .filter-btn {\n      padding: 12px 16px;\n      font-size: 14px;\n    }\n  }\n\n  .notifications-list {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .all-notification-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .notification-category-icon {\n    margin-bottom: 10px;\n  }\n\n  .all-notification-row__body {\n    width: 100%;\n  }\n\n  .date-picker-container {\n    justify-content: center;\n    margin-top: 10px;\n  }\n\n  .date-picker-container .ant-picker {\n    width: 100%;\n    max-width: 100%;\n  }\n  .no-data-image {\n    margin-top: 30px;\n    max-width: 70%;\n  }\n}\n\n@media (max-width: 480px) {\n  .filter-btn {\n    font-size: 10px;\n    padding: 5px 8px;\n  }\n  .date-picker-container {\n    justify-content: center;\n    margin-top: 20px;\n    max-width: 70%;\n    margin-right: 10px;\n  }\n  .ant-picker {\n    font-size: 13px;\n    max-width: 70%;\n    margin-top: 40px;\n  }\n\n  .ant-picker-range .ant-picker-input > input {\n    width: 100% !important;\n  }\n\n  .no-data-image {\n    margin-top: 10px;\n    min-width: 100%;\n  }\n  .ant-picker-panels {\n    flex-direction: column !important;\n    width: 100% !important;\n  }\n.no-data-message {\n    margin-top: 0px !important;\n}\n  .ant-picker-panel {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  .ant-picker-dropdown {\n    width: 100vw !important;\n    left: 0 !important;\n    padding: 0 8px;\n  }\n\n  .ant-picker-range {\n    width: 100% !important;\n  }\n}\n\n.notifications-page-title {\n  font-size: 28px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 2px;\n  text-align: start;\n  line-height: 1.4;\n  margin-top: 0;\n}\n\n.notifications-page-description {\n  font-size: 14px;\n  font-family: 'Open Sans', sans-serif;\n  color: #374151;\n  font-weight: 400;\n  margin-bottom: 4px;\n  text-align: start;\n  line-height: 1.5;\n  display: block;\n}\n\n.notifications-page-hint {\n  font-size: 13px;\n  font-family: 'Open Sans', sans-serif;\n  color: #374151;\n  font-weight: 400;\n  margin-bottom: 20px;\n  text-align: start;\n  line-height: 1.5;\n  display: block;\n}\n\n/* ========== Category Card ========== */\n\n.notification-category-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fafafa;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.notification-category-header {\n  width: 100%;\n  padding: 12px 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: flex-start;\n  transition: background 0.15s;\n  // Reset native <button> chrome so it matches the surrounding card.\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: start;\n\n  &:hover {\n    background: #f3f4f6;\n  }\n}\n\n.category-icon {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  object-fit: contain;\n  border-radius: 10px;\n}\n\n.category-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.category-title {\n  font-family: 'Inter', sans-serif;\n  font-weight: 700;\n  font-size: 16px !important;\n  line-height: 24px;\n  color: #334155 !important;\n}\n\n.category-description {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 12px !important;\n  line-height: 16px;\n  color: #94a3b8 !important;\n}\n\n.toggle-icon {\n  color: #6b7280;\n  font-size: 13px;\n  flex-shrink: 0;\n  margin-inline-start: auto;\n}\n\n/* ========== Notification Table ========== */\n\n.notification-table-wrapper {\n  border-top: 1px solid #e5e7eb;\n  margin-top: 0;\n  overflow: visible;\n}\n\n.notification-table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n\n  thead tr {\n    background: #f9fafb;\n  }\n\n  th {\n    padding: 10px 16px;\n    background-color: #fafafa !important;\n    font-size: 12px;\n    font-weight: 600;\n    color: #6b7280;\n    font-family: 'Open Sans', sans-serif;\n    text-align: start;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  tbody tr {\n    &.activity-row-active {\n      background: #fff;\n    }\n  }\n\n  td {\n    padding: 12px 16px;\n    background-color: #fafafa !important;\n    vertical-align: middle;\n    border: none !important;\n    border-bottom: 1px solid #e5e7eb !important;\n  }\n\n  tbody tr:last-child td {\n    border-bottom: none !important;\n  }\n}\n\n.notification-table th.activity-col {\n  width: 58%;\n  text-align: start;\n}\n\n.notification-table th.toggle-col {\n  width: 8%;\n  text-align: center;\n}\n\n.notification-table td.toggle-cell {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.notification-table th.threshold-col {\n  width: 18%;\n  color: #6b7280 !important;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.notification-table td.threshold-cell {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.activity-details {\n  vertical-align: middle;\n  padding-top: 18px !important;\n  padding-bottom: 18px !important;\n}\n\n/* Keeps the metric name and its (?) definition trigger on one centred line.\n   No z-index handling needed: the popover is `position: fixed` and these headers\n   aren't sticky, so it isn't clipped by the row. */\n.activity-name-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* The trigger's 1px nudge is tuned for KPI card headings, not table rows. */\n.activity-name-row .definition-tooltip__trigger {\n  transform: none;\n}\n\n.activity-name {\n  color: #6b7280 !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.activity-description {\n  font-size: 12px;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n}\n\n/* ========== Toggle Switch ========== */\n\n.notif-toggle {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n\n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n    position: absolute;\n\n    &:checked + .notif-toggle-slider {\n      background-color: #2c68ad;\n    }\n\n    &:checked + .notif-toggle-slider::before {\n      transform: translateX(20px);\n    }\n  }\n\n  .notif-toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    margin-top: 0;\n    background-color: #d1d5db;\n    border-radius: 24px;\n    transition: 0.3s;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      height: 18px;\n      width: 18px;\n      left: 3px;\n      top: 3px;\n      background-color: white;\n      border-radius: 50%;\n      transition: 0.3s;\n    }\n  }\n}\n\n/* ========== Configure Button & Badge ========== */\n\n.configure-btn {\n  padding: 5px 14px;\n  min-height: 28px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: none;\n  background: $brand-primary;\n  color: white;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: 'Open Sans', sans-serif;\n\n  &:hover {\n    background: $brand-primary-hover;\n  }\n\n  &--active {\n    background: $brand-primary-hover;\n  }\n}\n\n.threshold-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #1a56db;\n  cursor: pointer;\n  font-family: 'Open Sans', sans-serif;\n  flex: 1 1 auto;\n  min-width: 0;\n\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n    unicode-bidi: plaintext;\n  }\n\n  .threshold-edit-icon {\n    flex-shrink: 0;\n  }\n\n  &:hover {\n    border-color: #1a56db;\n    background: #dbeafe;\n  }\n\n  &--muted {\n    border-color: #e5e7eb;\n    background: #f9fafb;\n    color: #6b7280;\n\n    &:hover {\n      border-color: #d1d5db;\n      background: #f3f4f6;\n    }\n  }\n}\n\n.threshold-actions-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: flex-end;\n  width: 100%;\n  min-width: 0;\n}\n\n.threshold-delete-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid #fca5a5;\n  background: #fef2f2;\n  color: #b91c1c;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.15s;\n  flex-shrink: 0;\n\n  &:hover {\n    background: #fee2e2;\n    border-color: #dc2626;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &--muted {\n    border-color: #e5e7eb;\n    background: #f9fafb;\n    color: #6b7280;\n\n    &:hover {\n      background: #f3f4f6;\n      border-color: #d1d5db;\n    }\n  }\n}\n\n.threshold-edit-icon {\n  font-size: 12px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n/* ========== Configure Threshold Panel ========== */\n\n.configure-panel-row td {\n  padding: 0 !important;\n  background: #f8faff;\n  border: none !important;\n}\n\n.configure-threshold-panel {\n  padding: 20px 24px;\n  background: #fff;\n}\n\n.configure-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.configure-panel-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #20262c;\n  font-family: 'Open Sans', sans-serif;\n  margin-bottom: 0;\n}\n\n.configure-panel-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  color: #6b7280;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.15s;\n  flex-shrink: 0;\n\n  &:hover {\n    border-color: #9ca3af;\n    color: #374151;\n    background: #f3f4f6;\n  }\n}\n\n.threshold-form-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.threshold-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n// Fields without a required-asterisk sort after every required field,\n// regardless of which combination of fields a given section renders.\n.threshold-field--optional {\n  order: 1;\n}\n\n.threshold-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n  text-transform: capitalize;\n}\n\n.required-asterisk {\n  color: #dc2626;\n  margin-inline-start: 2px;\n}\n\n.threshold-label .definition-tooltip__trigger {\n  transform: none;\n  margin-inline-start: 4px;\n}\n\n.threshold-field-empty-note {\n  padding: 10px 12px;\n  border: 1px dashed #d7e1ee;\n  border-radius: 7px;\n  background: #f8fafc;\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.4;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.threshold-form-grid .filter-dropdown {\n  width: 100% !important;\n  min-width: 0 !important;\n}\n\n.threshold-value-input {\n  height: 38px;\n  border-radius: 6px !important;\n  border: 1px solid #d1d5db !important;\n  font-size: 14px;\n\n  &:hover, &:focus {\n    border-color: #1a56db !important;\n  }\n}\n\n.threshold-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.threshold-cancel-btn {\n  padding: 8px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background: #fafafa !important;\n  color: #374151;\n  cursor: pointer;\n  font-family: 'Open Sans', sans-serif;\n  transition: all 0.15s;\n\n  &:hover {\n    border-color: #9ca3af;\n    background: #f9fafb;\n  }\n}\n\n.threshold-save-btn {\n  padding: 8px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #2c68ad;\n  color: white;\n  cursor: pointer;\n  font-family: 'Open Sans', sans-serif;\n  transition: all 0.15s;\n\n  &:hover {\n    background: #1648c0;\n  }\n}\n\n.category-title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.notification-date-range-wrapper {\n  margin: 0;\n}\n\n/* ========== All Notifications — toolbar & list (redesign) ========== */\n\n.all-notifications-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 20px;\n  margin-bottom: 28px;\n}\n\n.all-notifications-filter-select {\n  min-width: 160px;\n}\n\n// Selector is `.filter-dropdown.all-notifications-filter-select` (both classes,\n// not just the latter) so this wins on specificity over the competing\n// `.filter-dropdown .ant-select-selection-item` rule in DropDownStyle.scss —\n// that file is `@import`-ed after this one, so equal specificity would let its\n// `!important` win by source order instead. That rule renders the selected\n// value as a grey tag chip, appropriate for the shared class's usual\n// multi-select filters — but this page's Today/This Week/Last Week/Custom\n// Range picker is single-value, and the design shows it as plain text with a\n// caret, no chip background.\n.filter-dropdown.all-notifications-filter-select .ant-select-selection-item {\n  background-color: transparent !important;\n  padding: 0 !important;\n}\n\n.all-notifications-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.all-notification-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid $color-e5e7eb;\n  background: transparent;\n  font: inherit;\n  text-align: start;\n  cursor: pointer;\n  padding: 20px 4px;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: $color-f9fafb;\n  }\n\n  // Used both as a real <button> (All Notifications page) and as a\n  // role=\"button\" <div> (header bell popup, which nests its own \"View\n  // More\" button and so can't be a <button> itself) — both need a visible\n  // keyboard-focus indicator.\n  &:focus-visible {\n    outline: 2px solid $brand-primary;\n    outline-offset: -2px;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n// Shared category icon+color badge — used by both the All Notifications rows\n// and the header bell popup rows via the `NotificationCategoryIcon` component.\n.notification-category-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  flex-shrink: 0;\n\n  &--sales {\n    background: $color-dbeafe;\n    color: $color-2563eb;\n  }\n\n  &--web {\n    background: #f3e8ff;\n    color: #9333ea;\n  }\n\n  &--insights {\n    background: $color-e8f5e9;\n    color: $color-2e7d32;\n  }\n\n  &--social {\n    background: #fef3c7;\n    color: #d97706;\n  }\n\n  &--default {\n    background: $color-f3f4f6;\n    color: $color-64748b;\n  }\n}\n\n.all-notification-row__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.all-notification-row__title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  font-family: 'Open Sans', sans-serif;\n  // Explicit, not inherited: this row renders inside the app header (bell\n  // popup) as well as the page body, and antd's `.ant-layout-header` sets a\n  // default `line-height: 64px` that would otherwise cascade in and inflate\n  // every line of text here to a 64px-tall box.\n  line-height: 1.4;\n}\n\n.all-notification-row__description {\n  font-size: 14px;\n  color: #4b5563;\n  font-family: 'Open Sans', sans-serif;\n  line-height: 1.5;\n}\n\n.all-notification-row__meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: $color-999;\n  font-family: 'Open Sans', sans-serif;\n  line-height: 1.4;\n}\n\n.all-notification-row__unread-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: $brand-primary;\n  flex-shrink: 0;\n}\n\n// Briefly flashes the row a bell-popup \"View\" deep-link landed on, so it's\n// clear which one among a page of ten was clicked.\n@keyframes all-notification-row-flash {\n  0%, 100% { background: transparent; }\n  25%, 75% { background: $color-eff6ff; }\n}\n\n.all-notification-row--highlighted {\n  animation: all-notification-row-flash 1.5s ease-in-out 2;\n}\n\n.all-notifications-pagination {\n  margin-top: 12px;\n}\n\n// Narrower context (header bell popup) — same row anatomy, tighter spacing.\n.notifications-modal-content {\n  .all-notification-row {\n    padding: 14px 4px;\n    gap: 12px;\n    cursor: pointer;\n  }\n\n  .notification-category-icon {\n    width: 36px;\n    height: 36px;\n  }\n\n  .all-notification-row__title {\n    font-size: 14px;\n  }\n\n  .all-notification-row__description {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n  .all-notifications-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n/* ========== Page loading state ========== */\n\n@keyframes donut-spin {\n  0%   { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.preferences-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n}\n\n.preferences-loading__spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(0, 0, 0, 0.1);\n  border-left-color: $brand-primary;\n  border-radius: 50%;\n  animation: donut-spin 1.2s linear infinite;\n}\n\n/* ========== Digest Frequency Card ========== */\n\n.digest-frequency-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 0 16px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 16px;\n  margin-top: 0;\n}\n\n.digest-frequency-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.digest-clock-icon {\n  font-size: 20px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.digest-frequency-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.digest-frequency-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2A2929;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.digest-frequency-subtitle {\n  font-size: 13px;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.digest-frequency-note {\n  font-size: 12px;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n  margin-top: 2px;\n}\n\n.digest-frequency-select {\n  min-width: 220px !important;\n  width: auto !important;\n  flex-shrink: 0;\n  align-self: center;\n  margin: 0 !important;\n\n  .ant-select-selector {\n    height: 38px !important;\n    display: flex !important;\n    align-items: center !important;\n    padding: 0 12px !important;\n    white-space: nowrap !important;\n  }\n\n  .ant-select-selection-item {\n    line-height: 38px !important;\n    white-space: nowrap !important;\n    overflow: visible !important;\n    text-overflow: unset !important;\n  }\n}\n\n/* ========== Enable Notification (channel master toggles) ========== */\n\n.channel-masters-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n  padding: 0 0 16px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 16px;\n}\n\n.channel-masters-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-width: 620px;\n}\n\n.channel-masters-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2A2929;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.channel-masters-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.channel-masters-toggles {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  flex-shrink: 0;\n}\n\n.channel-master-toggle {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.channel-master-toggle__label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.channel-masters-disabled-tooltip {\n  position: absolute;\n  top: calc(100% + 10px);\n  inset-inline-end: 0;\n  z-index: 5;\n  display: none;\n  width: 240px;\n  padding: 10px 12px;\n  border-radius: 7px;\n  background: #ffffff;\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.16);\n}\n\n.channel-masters-toggles--disabled:hover .channel-masters-disabled-tooltip {\n  display: block;\n}\n\n@media (max-width: 640px) {\n  .channel-masters-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .channel-masters-toggles {\n    justify-content: flex-start;\n  }\n}\n\n/* ========== Preferred Language (notification delivery language) ========== */\n\n.preferred-language-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n  padding: 0 0 16px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 16px;\n}\n\n.preferred-language-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-width: 620px;\n}\n\n.preferred-language-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2A2929;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.preferred-language-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.preferred-language-segmented {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.preferred-language-segmented-button {\n  min-width: 88px;\n  height: 38px;\n  padding: 0 16px;\n  border: 0;\n  background: #ffffff;\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: 'Open Sans', sans-serif;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.preferred-language-segmented-button + .preferred-language-segmented-button {\n  border-inline-start: 1px solid #e5e7eb;\n}\n\n.preferred-language-segmented-button--active {\n  background: #2c68ad;\n  color: #ffffff;\n}\n\n.preferred-language-segmented-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 640px) {\n  .preferred-language-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n/* ========== Toggle disabled state ========== */\n\n.notif-toggle--disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n\n  input,\n  .notif-toggle-slider {\n    cursor: not-allowed;\n  }\n}\n\n/* ========== Picker UI (campaigns, cities, pages) ========== */\n\n.checkbox-group {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin-top: 4px;\n}\n\n.checkbox-group--vertical {\n  flex-direction: column;\n  gap: 6px;\n}\n\n.checkbox-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #374151;\n  font-family: 'Open Sans', sans-serif;\n  cursor: pointer;\n\n  input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    accent-color: #1a56db;\n    cursor: pointer;\n    flex-shrink: 0;\n  }\n}\n\n.picker-platform-label {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.selected-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.selected-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-family: 'Open Sans', sans-serif;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 12px;\n  color: #1a56db;\n}\n\n.selected-tag-remove {\n  border: none;\n  background: none;\n  color: #6b7280;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1;\n  padding: 0;\n  display: flex;\n  align-items: center;\n\n  &:hover {\n    color: #dc2626;\n  }\n}\n\n.unavailable-note {\n  font-size: 13px;\n  color: #6b7280;\n  font-style: italic;\n  font-family: 'Open Sans', sans-serif;\n}\n\n/* Full-width fields inside the configure grid */\n.threshold-field--full {\n  grid-column: 1 / -1;\n}\n\n.threshold-field--toggle {\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n\n  .threshold-label {\n    margin: 0;\n  }\n}",".admin-portal-page {\n\n  .search-bar {\n    margin-bottom: 1.5rem;\n\n    input {\n      max-width: 300px;\n    }\n  }\n\n  .announcement-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n  }\n\n  .announcement-card {\n    background: #ffffff;\n    border: 1px solid $brand-primary-strong;\n    padding: 1.2rem 1.5rem;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 115, 230, 0.08);\n\n    .action-link {\n      display: inline-block;\n      font-size: 0.85rem;\n      color: $blue-400;\n      word-break: break-all;\n      text-decoration: underline;\n\n      &:hover {\n        color: \\$brand-primary;\n      }\n    }\n\n    .announcement-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 0.75rem;\n\n      h2 {\n        margin: 0;\n        font-size: 1.2rem;\n        color: $blue-300;\n      }\n\n      .meta {\n        font-size: 0.85rem;\n        color: gray;\n        display: block;\n        margin-top: 0.25rem;\n      }\n\n      .ant-tag {\n        font-size: 0.75rem;\n        padding: 0.2rem 0.6rem;\n        border-radius: 999px;\n      }\n    }\n\n    .body-text {\n      font-size: 0.95rem;\n      margin-bottom: 0.75rem;\n      color: #333;\n    }\n\n    .tags {\n      margin-bottom: 0.75rem;\n\n      .ant-tag {\n        background-color: $brand-primary;\n        color: white;\n        border: none;\n        font-size: 0.75rem;\n      }\n    }\n\n    .actions {\n      display: flex;\n      gap: 1rem;\n\n      button {\n        padding: 0;\n        font-size: 0.85rem;\n      }\n    }\n  }\n}\n\n.truncate-notification {\n  display: -webkit-box;\n  -webkit-line-clamp: 2; // 1.5 lines visually\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n/* AnnouncementPopup.css */\n.announcement-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(6px); \n  -webkit-backdrop-filter: blur(6px); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  box-shadow: #222;\n}\n\n.popup-content {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 18px;\n  width: 90%;\n  max-width: 500px;\n  position: relative;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-height: 400px;\n}\n\n.close-button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #666;\n}\n\n.announcement-title {\n  font-size: 1.3rem;\n  color: #474747;\n  margin: 0.5rem 0;\n  line-height: 1.2;\n     text-align: left;\n  margin-left: 20px;\n  margin-top: 80px;\n  font-weight: bolder;\n}\n\n.feature-item {\n  margin: 0.8rem 0;\n  display: flex;\n  align-items: flex-start;\n}\n\n.announcement-action-button {\n  background-color: #ff6d00;\n  color: white;\n  border: none;\n  padding: 0.8rem 1.5rem;\n  font-size: 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  width: 50%;\n  font-weight: bold;\n  text-transform: uppercase;\n  transition: background-color 0.3s;\n  margin-top: 80px;\n  justify-content: center;\n  margin-left: 100px;\n    box-shadow: \n    0.5px 0.5px 2px rgba(182, 178, 178, 0.6),\n    2px 2px 6px rgba(182, 178, 178, 0.8);\n}\n\n.action-button:hover {\n  background-color: #ff9100;\n}\n\n.logo-container {\n  display: flex;\n  justify-content: left;\n  margin-bottom: 12px;\n  margin-left: 20px;\n  margin-top: 15px;\n}\n\n.logo-margin {\n  margin-left: 12px; \n}\n.announcement-icon {\n  margin-right: 8px;\n  font-size: 1.2em; /* Adjust size if needed */\n  vertical-align: middle;\n}\n.logo-title {\n  margin-right: 10px; \n\n}","@import \"./variables\";\n.user-dropdown {\n  position: absolute;\n  top: 62px;\n  inset-inline-end: 15px;\n  background-color: $white;\n  border: 1px solid $border-dropdown;\n  border-radius: 6px;\n  min-width: 150px;\n  z-index: 999;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  padding: 0;\n  font-family: \"Segoe UI\", sans-serif;\n\n  &__username {\n    padding: 8px 12px;\n    font-weight: 600;\n    font-size: 13.5px;\n    border-bottom: 1px solid $border-dark;\n    background-color: $border-light;\n    color: $color-222;\n    line-height: 1.2;\n  }\n\n  &__item {\n    padding: 7px 12px;\n    display: flex;\n    align-items: center;\n    font-size: 13.5px;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    line-height: 1.2;\n\n    &:hover {\n      background-color: $white;\n    }\n\n    &--logout {\n      color: $color-d93025;\n    }\n  }\n}\n.dropdown {\n  .ant-select-selector {\n    border-radius: 6px;\n    border: 1px solid $color-91d5ff;\n    box-shadow: none;\n    transition: 0.3s;\n\n    &:hover {\n      border-color: $color-40a9ff;\n    }\n  }\n}\n.custom-dropdown {\n  position: relative;\n  select {\n    padding: 6px 10px;\n    border-radius: 2px;\n    border: 1px solid $color-ccc;\n    font-size: 12px;\n    background-color: $white;\n    appearance: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-inline-end: 20px;\n  }\n\n  select:hover {\n    border-color: $color-888;\n    border-radius: 0px;\n  }\n}\n\n.custom-submenu[aria-expanded=\"false\"] > .ant-menu-submenu-title::after {\n  display: none !important;\n}\n\n.custom-divider {\n  width: 100px;\n}\n\n/// custom dropdown Product side\n\n\n.custom-dropdown {\n  min-width: 200px;\n\n  .ant-select-selector {\n    border-radius: 6px !important;\n    padding: 4px 12px !important;\n    border: 1px solid $color-ccd9f0 !important;\n    font-size: 14px;\n    background-color: $white;\n    transition: all 0.3s;\n\n    &:hover {\n      border-color: $color-999 !important;\n    }\n  }\n\n  .ant-select-selection-item,\n  .ant-select-selection-placeholder {\n    color: $text-dark;\n  }\n\n  .ant-select-dropdown {\n    border-radius: 6px;\n  }\n\n  .ant-select-item-option-selected {\n    background-color: $color-e6f4ff !important;\n    font-weight: 600;\n  }\n\n  .ant-select-item-option-active {\n    background-color: $white !important;\n  }\n}\n\n.ant-select-arrow {\n  display: none; // hides dropdown arrow\n}\n\n.custom-dropdown .condition-btn {\n  background-color: $white !important;\n  border: 1px solid $color-d9d9d9 !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n  margin-inline-start: 5px;\n}\n\n\n.custom-dropdown .ant-select-selector {\n  background-color: transparent !important; /* Removes $white bg */\n  border-color: $border-dropdown;\n  border-radius: 6px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  transition: all 0.3s;\n}\n\n///////////////filter///////////\n.filters-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  margin-top: 10px;\n\n  .filters-inner {\n    display: flex;\n    gap: 12px; \n    flex-wrap: wrap; \n  }\n\n  .right-aligned-btns {\n    display: flex;\n    gap: 10px;\n  }\n}\n\n.filters-left {\n  display: flex;\n  align-items: center;\n}\n\n.view-filter {\n  margin-inline-start: 16px;\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 4px;\n  border: 1px solid $border-dropdown;\n}\n.styled-dropdown-container {\n  position: relative;\n  display: inline-block;\n  min-width: 180px;\n}\n\n.styled-dropdown-select {\n  width: 100%;\n  padding: 10px 15px;\n  padding-inline-end: 30px;\n  border-radius: 20px; /* Changed to circular corners */\n  border: 1px solid $border-dropdown;\n  background-color: $white;\n  font-size: 14px;\n  font-weight: 500;\n  color: $text-primary;\n  appearance: none;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.styled-dropdown-select:hover {\n  border-color: $color-1890ff;\n  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);\n}\n\n.styled-dropdown-select:focus {\n  border-color: $color-1890ff;\n  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);\n}\n\n.styled-dropdown-arrow {\n  position: absolute;\n  top: 50%;\n  inset-inline-end: 12px;\n  transform: translateY(-50%);\n  pointer-events: none;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid $color-666;\n}\n\n//audience overview screen\n\n.audience-actions {\n  display: flex;\n  align-items: center;\n}\n\n/* Pill dropdown */\n.audience-dropdown {\n  width: 40%;\n  border-radius: 30px !important;\n  height: 42px;\n  background-color: $white;   \n  border: none !important;\n  box-shadow: \n    0.5px 0.5px 2px rgba(182, 178, 178, 0.6),\n    2px 2px 6px rgba(182, 178, 178, 0.8);\n}\n\n/* Selector (visible box before opening) */\n.audience-dropdown .ant-select-selector {\n  background-color: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 30px !important;\n  height: 42px !important;\n  display: flex;\n  align-items: center; \n  padding: 0 16px !important;\n  color: $text-dark !important;\n  font-weight: 500;\n}\n\n/* Dropdown text */\n.audience-dropdown .ant-select-selection-item {\n  color: $text-dark !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  display: flex;\n  align-items: center; \n}\n\n/* Export button small adjustment */\n.export-btn {\n  height: 42px; \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px; \n  white-space: nowrap;\n      margin-bottom: -3px;\n}\n\n// Updated shared dropdown styling (single + multi)\n.custom-dropdown {\n  min-width: 220px;\n\n    .ant-select-selector {\n      background-color: $white !important;\n      border: 1px solid $color-d9d9d9 !important;\n      border-radius: 8px !important;\n      height: 44px !important;\n      min-height: 44px !important;\n      padding-block: 6px !important;\n      padding-inline: 10px 40px !important;\n      display: flex !important;\n      align-items: center !important;\n      box-shadow: none !important;\n      transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  }\n\n    &.ant-select-focused .ant-select-selector,\n    &:hover .ant-select-selector {\n      border-color: $text-dark !important;\n      box-shadow: none !important;\n    }\n\n  .ant-select-selection-overflow {\n    gap: 6px;\n  }\n\n  .ant-select-selection-item {\n    background-color: transparent !important;\n    border-radius: 0 !important;\n    padding: 0 !important;\n    font-size: 16px !important;\n    color: $text-dark !important;\n    margin-inline-end: 0 !important;\n  }\n\n    &.ant-select-single .ant-select-selection-item {\n      height: auto !important;\n      line-height: normal !important;\n    }\n\n  .ant-select-selection-item-remove {\n    margin-inline-start: 6px;\n  }\n\n  .ant-select-selection-placeholder {\n    color: $color-777 !important;\n    font-size: 14px;\n  }\n\n  .ant-select-selection-placeholder,\n  .ant-select-selection-search-input,\n  .ant-select-selection-item {\n    text-align: start;\n  }\n\n    .ant-select-arrow {\n      display: flex !important;\n      align-items: center;\n      justify-content: center !important;\n      width: 28px;\n      height: 28px;\n      inset-inline-end: 8px;\n      top: 28px;\n      transform: translateY(-50%);\n      color: $color-333;\n    }\n  }\n\n  .custom-dropdown--has-value .ant-select-selector {\n    background-color: $color-e4e4e4 !important;\n    border-color: $color-bac7d5 !important;\n  }\n\n  .custom-dropdown.ant-select-disabled .ant-select-selector {\n    background-color: $color-e8e8e8 !important;\n    border-color: $color-cbd5e1 !important;\n  }\n\n  .custom-dropdown.ant-select-disabled .ant-select-selection-item,\n  .custom-dropdown.ant-select-disabled .ant-select-selection-placeholder {\n    color: $color-bac7d5 !important;\n  }\n\n.custom-dropdown.ant-select-disabled .styled-dropdown-caret {\n  border-top-color: $color-bac7d5;\n}\n\n.condition-dropdown {\n  background-color: $white !important;\n  border: 1px solid $color-d9d9d9 !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n}\n\n.condition-dropdown .ant-select-selector {\n  background-color: $white !important;\n  border-color: $color-d9d9d9 !important;\n}\n\n.condition-static {\n  height: 42px;\n  border-radius: 12px;\n  border: 1px solid $color-d9d9d9 !important;\n  background-color: $white !important;\n  padding: 0 16px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 14px;\n  color: $text-dark;\n}\n\n/* Match dropdown container background with static button */\n.condition-dropdown .ant-select-selector {\n  background-color: $white !important;\n}\n\n.styled-dropdown-caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 6px solid $color-333;\n}\n\n.custom-dropdown-menu {\n  border-radius: 12px !important;\n  background-color: $white !important;\n  padding: 6px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n}\n\n.custom-dropdown-menu .ant-select-item {\n  padding: 10px 12px;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.custom-dropdown-menu .ant-select-item-option-active {\n  background-color: $color-f2f2f2 !important;\n}\n\n.custom-dropdown-menu .ant-select-item-option-selected {\n  background-color: $color-e4e4e4 !important;\n  color: $text-dark !important;\n  font-weight: 600;\n}\n\n// Filter dropdown styling (SingleMetricBarChart + MultiMetric filters)\n.filter-dropdown {\n  min-width: 220px;\n\n  // The arrow icon is centered via `top: 50%` against THIS element (the\n  // .ant-select root, its positioning parent) — not the .ant-select-selector\n  // below. Without pinning this root's height too, it keeps antd's default\n  // sizing (which differs between single- and multi-select), so `top: 50%`\n  // centers against a different reference box per field and the arrows\n  // drift out of alignment with each other.\n  &.custom-dropdown {\n    height: 42px !important;\n  }\n\n  &.custom-dropdown .ant-select-selector {\n    background-color: $white !important;\n    border: 1px solid $border-dropdown !important;\n    border-radius: 8px !important;\n    height: 42px !important;\n    min-height: 42px !important;\n    max-height: 42px !important;\n    overflow: hidden !important;\n    padding-block: 6px !important;\n    padding-inline: 10px 40px !important;\n    display: flex !important;\n    align-items: center !important;\n    box-shadow: none !important;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  }\n\n  &.ant-select-focused .ant-select-selector,\n  .ant-select-selector:hover {\n    border-color: $text-dark !important;\n    box-shadow: none !important;\n  }\n\n  .ant-select-selection-overflow {\n    gap: 6px;\n    flex-wrap: nowrap !important;\n    overflow: hidden;\n  }\n\n  .ant-select-selection-item {\n    background-color: $color-e4e4e4 !important;\n    border-radius: 12px !important;\n    padding: 0 10px !important;\n    font-size: 14px !important;\n    color: $text-dark !important;\n    margin-inline-end: 0 !important;\n    flex: 0 0 auto !important;\n    width: auto !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    line-height: 22px !important;\n    height: 26px !important;\n  }\n\n  &.ant-select-single .ant-select-selection-item {\n    height: 26px !important;\n    line-height: 22px !important;\n  }\n\n  &.ant-select-single .ant-select-selection-overflow,\n  &.ant-select-single .ant-select-selection-overflow-item {\n    flex: 0 0 auto !important;\n  }\n\n  &.ant-select-multiple .ant-select-selection-overflow-item {\n    flex: 0 0 auto !important;\n  }\n\n  .ant-select-selection-item-remove {\n    margin-inline-start: 6px;\n  }\n\n  .ant-select-selection-search {\n    height: 26px !important;\n    line-height: 26px !important;\n    margin-inline-start: 0 !important;\n  }\n\n  .ant-select-selection-search-input,\n  .ant-select-selection-search-mirror {\n    height: 26px !important;\n    line-height: 26px !important;\n  }\n\n  .ant-select-selection-placeholder {\n    color: $color-777 !important;\n    font-size: 14px;\n  }\n\n  .ant-select-selection-placeholder,\n  .ant-select-selection-search-input,\n  .ant-select-selection-item {\n    text-align: start;\n  }\n\n  &.custom-dropdown .ant-select-arrow {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    inset-inline-end: 8px;\n    top: 50% !important;\n    margin-top: -14px !important;\n    transform: none !important;\n    color: $color-333;\n  }\n}\n\n.filter-dropdown-menu {\n  border-radius: 12px !important;\n  background-color: $white !important;\n  padding: 6px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n}\n\n.filter-dropdown-menu .ant-select-item {\n  padding: 10px 12px;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.filter-dropdown-menu .ant-select-item-option-active {\n  background-color: $color-f2f2f2 !important;\n}\n\n.filter-dropdown-menu .ant-select-item-option-selected {\n  background-color: $color-e4e4e4 !important;\n  color: $text-dark !important;\n  font-weight: 600;\n}\n\n.audience-sort-dropdown{\n  margin-bottom: 9px !important;\n}\n","@import \"./variables\";\n\n.styled-input.ant-input-affix-wrapper {\n  width: 100%;\n  height: 44px;\n  border-radius: 8px;\n  top: 2px;\n  border: 1px solid $color-d9d9d9;\n  background-color: $white;\n  padding: 0 12px;\n  box-shadow: none;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.styled-input.ant-input-affix-wrapper:hover {\n  border-color: $text-dark;\n}\n\n.styled-input.ant-input-affix-wrapper-focused {\n  border-color: $text-dark;\n  box-shadow: none;\n}\n\n.styled-input--has-value {\n  background-color: $color-e4e4e4 !important;\n  border-color: $color-bac7d5 !important;\n}\n\n.styled-input--has-value:hover,\n.styled-input--has-value.ant-input-affix-wrapper-focused {\n  border-color: $color-bac7d5 !important;\n}\n\n.styled-input.ant-input-affix-wrapper .ant-input {\n  font-size: 16px;\n  color: $text-dark;\n}\n\n.styled-input.ant-input-affix-wrapper .ant-input::placeholder {\n  color: $color-777;\n}\n\n.styled-input.ant-input-affix-wrapper .ant-input-prefix {\n  color: $text-dark;\n  font-size: 18px;\n  margin-right: 10px;\n}\n\n.styled-input.ant-input-affix-wrapper-disabled {\n  background-color: $color-e8e8e8;\n  border-color: $color-cbd5e1;\n}\n\n.styled-input.ant-input-affix-wrapper-disabled .ant-input,\n.styled-input.ant-input-affix-wrapper-disabled .ant-input::placeholder,\n.styled-input.ant-input-affix-wrapper-disabled .ant-input-prefix {\n  color: $color-bac7d5;\n}\n\n.styled-text-input.ant-input {\n  width: 100%;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid $color-d9d9d9;\n  background-color: $white;\n  padding: 0 12px;\n  box-shadow: none;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  font-size: 16px;\n  color: $text-dark;\n}\n\n.styled-text-input.ant-input:hover {\n  border-color: $text-dark;\n}\n\n.styled-text-input.ant-input:focus,\n.styled-text-input.ant-input-focused {\n  border-color: $text-dark;\n  box-shadow: none;\n}\n\n.styled-text-input.ant-input-affix-wrapper {\n  height: 44px;\n  border-radius: 12px;\n  border: 1px solid $color-d9d9d9;\n  background-color: $white;\n  padding: 0 12px;\n  box-shadow: none;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.styled-text-input.ant-input-affix-wrapper .ant-input {\n  background-color: transparent !important;\n  height: 100%;\n}\n\n.styled-text-input.ant-input-affix-wrapper:hover {\n  border-color: $text-dark;\n}\n\n.styled-text-input.ant-input-affix-wrapper-focused {\n  border-color: $text-dark;\n  box-shadow: none;\n}\n\n.styled-text-input--has-value {\n  background-color: $color-e4e4e4 !important;\n  border-color: $color-bac7d5 !important;\n}\n\n.styled-text-input--has-value:hover,\n.styled-text-input--has-value.ant-input-focused {\n  border-color: $color-bac7d5 !important;\n}\n\n.styled-text-input.ant-input::placeholder {\n  color: $color-777;\n}\n\n.styled-text-input.ant-input[disabled],\n.styled-text-input.ant-input[disabled]::placeholder {\n  background-color: $color-e8e8e8;\n  border-color: $color-cbd5e1;\n  color: $color-bac7d5;\n}\n","@import \"./variables\";\r\n\r\n.ant-menu-title-content{\r\n    color: $white !important;\r\n  }\r\n\r\n@media (max-width: 480px) {\r\n     .stats-grid {\r\n    gap: 5px;\r\n   // grid-template-rows: repeat(4, 1fr);\r\n   grid-template-columns: 1fr !important;\r\n  }\r\n\r\n  .chart-section {\r\n    min-height: 250px;\r\n  }\r\n  .ant-card{\r\n    padding:-15px;\r\n  }\r\n .controls-row {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 12px;\r\n  }\r\n.date-range-picker-container {\r\n    gap: 14px !important;\r\n}\r\n  .controls-row .ant-picker-range,\r\n  .controls-row .ant-select {\r\n    width: 100% !important;\r\n  }\r\n.notification-date-range-wrapper {\r\n    margin-top: 0px !important;\r\n    margin-inline-end: 0px !important;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n  /* Summary banner font scaling */\r\n  .info-banner {\r\n    font-size: 14px !important;\r\n    line-height: 1.4;\r\n    text-align: center;\r\n  }\r\n\r\n  /* Chart section adjustment */\r\n  .chart-section {\r\n    min-height: 270px !important;\r\n    padding: 10px;\r\n  }\r\n\r\n  /* Headline inside chart */\r\n  .chart-section .headline {\r\n    font-size: 16px;\r\n    text-align: center;\r\n  }\r\n\r\n  /* Table responsiveness */\r\n  .pipeline-table {\r\n    overflow-x: auto;\r\n  }\r\n\r\n  .pipeline-table .ant-table-content {\r\n    min-width: 600px;\r\n  }\r\n\r\n  .pipeline-table .ant-table-thead > tr > th,\r\n  .pipeline-table .ant-table-tbody > tr > td {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  /* Dropdown full width */\r\n  .metric-selection {\r\n    width: 100% !important;\r\n    display: table-row;\r\n  }\r\n\r\n  /* Range picker full width */\r\n  .ant-picker-range {\r\n    width: 100% !important;\r\n  }\r\n  .campaign-dashboard .dashboard-header {\r\n    display: table-row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: 0px;\r\n}\r\n.filters-container {\r\n    display: table-row;\r\n    justify-content: space-between;\r\n\r\n}\r\n    .create-campaign-container {\r\n    padding: 16px;\r\n  }\r\n.campaign-header-actions,\r\n  .filters-container,\r\n  .filters-left,\r\n  .filters-right {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    width: 100%;\r\n  }\r\n\r\n  .campaign-header-actions button,\r\n  .campaign-search-input,\r\n  .campaign-dropdown,\r\n  .button--primary,\r\n  .button--outline {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .custom-dropdown-menu {\r\n    width: 100% !important;\r\n  }\r\n  .input-row {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .input-row input,\r\n  .input-row .ant-picker {\r\n    width: 100%;\r\n  }\r\n\r\n  .recipient-selects {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n\r\n  .custom-ribbon {\r\n    font-size: 10px;\r\n    line-height: 1;\r\n    margin-bottom: 10px;\r\n    margin-top: 0;\r\n  }\r\n\r\n  .heading-primary {\r\n    font-size: 20px;\r\n    text-align: center;\r\n    margin-top: 30px;\r\n  \r\n  }\r\n\r\n  .heading-secondary {\r\n    font-size: 16px;\r\n    margin-top: 20px;\r\n    display: block;\r\n    text-align: center;\r\n  }\r\n\r\n  .action-buttons {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .action-buttons button {\r\n    width: 100%;\r\n  }\r\n  .button--primary{\r\n    width:40%;\r\n  }\r\n  .ant-select-selector{\r\n    width: 100%;\r\n  }\r\n    .container {\r\n    padding: 10px;\r\n    overflow-x: auto;\r\n  }\r\n\r\n  .header-cell {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .data-cell,\r\n  .sample-cell,\r\n  .select-cell {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .select-cell .ant-select {\r\n    width: 100% !important;\r\n  }\r\n    .create-segment-container {\r\n    padding: 16px;\r\n  }\r\n\r\n  .button {\r\n   width: 100%;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .segment-name-input {\r\n    width: 100%;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .definition-section {\r\n    padding: 10px;\r\n    border: 1px solid $color-ddd;\r\n    margin-bottom: 16px;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .custom-dropdown {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .condition-btn {\r\n    width: 100% !important;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .condition-row {\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n  }\r\n\r\n  .section-title {\r\n    font-size: 16px;\r\n    margin: 12px 0 6px;\r\n  }\r\n\r\n  .logic-buttons {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .action-buttons {\r\n    margin-top: 24px;\r\n  }\r\n    .search-container {\r\n    max-width: 150px;\r\n    padding-inline-end: 10px;\r\n    gap:0px;\r\n  }\r\n  .custom-header-right {\r\n    gap: 0px !important;  /* tighter spacing on mobile */\r\n  }\r\n  .dashboards-heading {\r\n    font-size: 10px !important;\r\n    padding-inline-end: 10px;\r\n    gap:10px;\r\n    padding-inline-start: 0;\r\n  }\r\n\r\n  .profile-container {\r\n    gap: 6px;\r\n  }\r\n    .bell-icon-dashboard {\r\n    margin-top: 10px;\r\n    height: 30px !important;\r\n    width: 20px !important;\r\n  }\r\n.img{\r\n  width: 10px;\r\n}\r\n    .header-actions{\r\n    gap:30px;\r\n  }\r\n  .ant-layout{\r\n    font-size: 12px;\r\n    padding-inline-start: 0;\r\n    background-color: $white;\r\n  }\r\n  .connected-sources-container {\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n    padding-top: 20px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .connect-header {\r\n    font-size: 24px;\r\n    text-align: center;\r\n  }\r\n\r\n  .sub-heading {\r\n    font-size: 14px;\r\n    line-height: 1.6;\r\n    text-align: center;\r\n  }\r\n  .dashboard-prefix {\r\n    display: none !important;\r\n  }\r\n\r\n  .smart-search-container {\r\n    display: none !important;\r\n  }\r\n  .dashboard-image{\r\ndisplay: none !important;\r\n  }\r\n  .app-sidebar {\r\n    position: fixed;\r\n    top: 0;\r\n    inset-inline-start: 0;\r\n    height: 100vh;\r\n    width: 0;\r\n    overflow: hidden;\r\n    transition: width 0.3s ease;\r\n    z-index: 1000;\r\n    background-color: $brand-primary;\r\n  }\r\n\r\n  .app-sidebar.open {\r\n    width: 200px;\r\n    overflow-y: auto;\r\n    padding: 10px 8px;\r\n  }\r\n.ant-menu{\r\n  width:70%;\r\n}\r\n  .ant-menu-inline {\r\n    width: 100%;\r\n  }\r\n  .ant-layout-sider-children{\r\n    width: 100%;\r\n  }\r\n  .ant-layout-sider{\r\n    width:100%;\r\n  }\r\n  .ant-menu-submenu{\r\n    width:100%;\r\n  }\r\n  .ant-menu-item{\r\n    width:100%;\r\n  }\r\n    .admin-portal-page .filters {\r\n    display: table-row;\r\n    gap: 16px;\r\n    margin-bottom: -40px;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    padding-top: 10px;\r\n}\r\n.ant-select-selector{\r\n  margin-top: 10px;\r\n}\r\n.ant-col-8{\r\n  display: table-row;\r\n  height: 50%;\r\n}\r\n   .avatar-icon-dashboard {\r\n        margin-top: 22px;\r\n        height: 50px !important;\r\n        width: 40px !important;\r\n    }\r\n  .field-labels {\r\n    display: flex;\r\n    flex-direction: column;           /* or 'column' to stack */\r\n    gap: 8px;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .field-labels > div {\r\n    flex: 1;                       /* Equal width for all cards */\r\n    min-width: 0;                 /* Prevents overflow */\r\n    max-width: 100%;\r\n  }\r\n.right-aligned-btns {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n}\r\n.send-email-btn {\r\n    background-color: $brand-primary;\r\n    font-size: 10px;\r\n    width: fit-content;\r\n    height: 40px;\r\n    color: $white;\r\n    border-color: $brand-primary;\r\n    border: 1px;\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n    margin-bottom: 20px;\r\n}\r\n.admin-portal-page .filters .filters-inner {\r\n  padding-top: 10px; \r\n  gap: 10px;\r\n  width:100%;\r\n}\r\n    .admin-portal-page .filters-settings {\r\n    display: flex;\r\n    gap: 16px;\r\n    margin-bottom: -40px;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    padding-top: 10px;\r\n    \r\n}\r\n  .cards-grid {\r\n    grid-template-columns: 1fr; /* Stack cards vertically */\r\n    grid-template-rows: none;\r\n    gap: 24px;\r\n    margin-top: 30px;\r\n    justify-items: center;\r\n  }\r\n\r\n  .connected-card {\r\n    width: 90%;\r\n    height: 90%;\r\n    padding: 16px;\r\n  }\r\n .connector-img-shopify{\r\n  width:60%;\r\n  height: 180px;\r\n  object-fit: contain;\r\n }\r\n \r\n  .connector-img-google-ads,\r\n  .connector-img-google-analytics,\r\n  .connector-img-facebook {\r\n    width: 100%;\r\n    height: auto;\r\n    object-fit: contain;\r\n  }\r\n.connector-img-instagram {\r\n    width: 200px;\r\n    height: 180px;\r\n}\r\n.overview-header-actions {\r\n    margin-top: 5px;\r\n}\r\n.button--outline{\r\n  margin-top: 16px;\r\n}\r\n.audience-dropdown {\r\n    width: 100% !important;\r\n   \r\n}\r\n.custom-list-header{\r\ndisplay: flex;\r\n        flex-direction: column;\r\n        flex-wrap: nowrap;\r\n}\r\n  .header-actions-buttons {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    width: 100%;\r\n  }\r\n\r\n  .bulk-actions,\r\n  .audience-actions {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    width: 100%;\r\n  }\r\n\r\n  .audience-search-input,\r\n  .audience-dropdown,\r\n  .export-btn,\r\n  .bulk-actions button {\r\n    width: 100% !important;\r\n  }\r\n.campaign-header-actions {\r\n    margin-top: 5px;\r\n}\r\n  .filters-container {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .filters-left {\r\n    order: 1;\r\n    width: 100%;\r\n  }\r\n\r\n  .filters-left .ant-space {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n  }\r\n\r\n  .campaign-search-input {\r\n    order: 1;\r\n    width: 100% !important;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .filters-right {\r\n    order: 2;\r\n    width: 100%;\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .campaign-search-input,\r\n  .campaign-dropdown,\r\n  .button--primary,\r\n  .button--outline {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .custom-dropdown-menu {\r\n    width: 100% !important;\r\n  }\r\n.stats-row {\r\n    display: flex;\r\n        flex-direction: column;\r\n  }\r\n\r\n  .info-banner {\r\n    font-size: 13px;\r\n    padding: 8px 10px;\r\n  }\r\n\r\n  .heading-row {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .heading-row h3 {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .ant-picker {\r\n    width: 100%; \r\n  }\r\n  .connected-footer {\r\n    position: static;\r\n    margin-top: 24px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .button-footer {\r\n    width: 100%;\r\n    max-width: 300px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .disconnected-message {\r\n    font-size: 13px;\r\n    text-align: center;\r\n    padding: 8px;\r\n  }\r\n  .logo-design {\r\n    width: 120px;\r\n    height: auto;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  .signup-internal-container {\r\n    width: 100%;\r\n    max-width: 360px;\r\n    padding: 1.5rem;\r\n    background-color: $white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  }\r\n\r\n  .formdesign {\r\n    width: 100%;\r\n  }\r\n\r\n  .signup-heading {\r\n    font-size: 1.25rem;\r\n    text-align: center;\r\n  }\r\n\r\n  .custom-google-button {\r\n    width: 80%;\r\n    padding: 0.6rem;\r\n    font-size: 0.9rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .input-container {\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  .input-style-2 {\r\n    width: 100%;\r\n    padding: 0.6rem;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .button-style {\r\n    width: 80%;\r\n    padding: 0.7rem;\r\n    font-size: 1rem;\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  .forgot-password-txt,\r\n  .signup-page-text {\r\n    text-align: center;\r\n    font-size: 0.85rem;\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  .or {\r\n    text-align: center;\r\n    margin: 1rem 0;\r\n  }\r\n}\r\n\r\n/* Tablet (≤768px) */\r\n@media (max-width: 768px) {\r\n  .app-sidebar {\r\n    position: absolute;\r\n    width: 0;\r\n    overflow: hidden;\r\n    transition: width 0.3s ease;\r\n    z-index: 1000;\r\n    background-color: $brand-primary;\r\n  }\r\n    .header-dashboard {\r\n    flex-direction: row !important;\r\n    flex-wrap: nowrap;\r\n    align-items: center !important;\r\n    padding: 10px;\r\n    font-size: 12px;\r\n  }\r\nimg , svg{\r\n  padding-inline-end: 5px;\r\n  width:30px;\r\n}\r\n\r\n  .header-right {\r\n    flex: 1;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n.headline{\r\n  font-size: 14px;\r\n  //padding-right: 10px;\r\n  margin-inline-start: 10px;\r\n\r\n}\r\n  .input-row input,\r\n  .input-row .ant-picker {\r\n    flex: 1 1 100%;\r\n  }\r\n\r\n  .recipient-selects {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n\r\n  .select-list {\r\n    min-width: 100%;\r\n  }\r\n  .controls-row {\r\n    flex-direction: column !important;\r\n    column-gap: 20px;\r\n  }\r\n\r\n  .controls-row .ant-picker,\r\n  .controls-row .ant-select {\r\n    width: 40% !important;\r\n  }\r\n\r\n  .stats-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .chart-section {\r\n    padding: 0 8px;\r\n  }\r\n\r\n  .headline {\r\n font-size: 14px;\r\n        margin-bottom: 10px;\r\n        margin-inline-end: 10px;\r\n  }\r\n  .action-buttons {\r\n    justify-content: center;\r\n  }\r\n  .search-container {\r\n    flex: 1 1 auto;\r\n    max-width: 250px; /* Shrink it */\r\n  }\r\n\r\n  .profile-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n  }\r\n  .p-0{\r\n    font-size: 10px;\r\n  }\r\n .bell-icon-dashboard {\r\n    margin-top: 10px;\r\n    height: 20px !important;\r\n    width: 20px !important;\r\n  }\r\n  .breadcrumb-text {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) {\r\n  .hamburger-btn {\r\n    display: none;\r\n  }\r\n  .ant-menu-title-content{\r\n    color: $white !important;\r\n  }\r\n  .ant-menu-inline.ant-menu-root .ant-menu-item{\r\n    color:$white !important;\r\n  }\r\n    .app-sidebar {\r\n    position: absolute;\r\n    width: 0;\r\n    overflow: hidden;\r\n    transition: width 0.3s ease;\r\n    z-index: 1000;\r\n    background-color: $brand-primary;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n  .formdesign {\r\n    padding: 30px 4%;\r\n    max-height: 65vh;\r\n  }\r\n}\r\n\r\n\r\n",".account-settings-container {\n  display: flex;\n  justify-content: center; \n  align-items: flex-start; \n  gap: 100px; \n  flex-wrap: nowrap; \n  margin: 0 auto; \n  max-width: 1200px; \n  padding: 20px; \n  margin-top: -30px;\n}\n\n.account-card .ant-card-head,\n.password-card .ant-card-head {\n  background-color: #2c68ad; \n  color: white; \n}\n.photo-btns {\n  color: #2c68ad !important;\n  background-color: aliceblue !important;\n  text-decoration: underline !important;\n  padding: 5px !important;\n}\n\n/* Left card */\n.account-card {\n  width: 500px;\n  min-height: 680px;\n  border-radius: 8px !important;\n  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25) !important;\n\n  div.ant-card-body {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n}\n\n.account-avatar-section {\n  text-align: center;\n\n  font-weight: 700;\n  text-decoration: solid;\n}\n\n.account-avatar {\n  font-size: 40px !important;\n  width: 90px !important;\n  height: 90px !important;\n  border-radius: 50%;\n\n  background: #fff;\n  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.15),\n    /* main soft shadow */ 0 3px 6px rgba(0, 0, 0, 0.1); /* secondary subtle shadow */\n\n    &.no-photo {\n    background-color: #2c68ad; \n  }\n\n  &.has-photo {\n    background-color: transparent;\n  }\n}\n\n.profile-upload-input {\n  display: none;\n}\n.photo-label {\n  cursor: pointer;\n}\n\n.divider {\n  margin: 0 8px;\n  color: #ccc;\n  font-weight: 300;\n}\n\n.photo-btns {\n  color: #2c68ad;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.2s ease;\n\n  &:hover {\n    color: #174c85;\n    text-decoration: underline;\n  }\n}\n.account-upload {\n  color: $blue-300;\n  font-size: 24px;\n  font-weight: 500;\n}\n\n.account-form .edit-icon,\n.account-industry-dropdown .industry-edit-icon {\n  cursor: pointer;\n  color: #1890ff;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.update-btn {\n  margin-top: 16px;\n  width: 100%;\n}\n\n/* Right card */\n.password-card {\n  width: 500px;\n  height: 450px;\n  border-radius: 12px !important;\n  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25) !important;\n  div.ant-card-body {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n}\n\n.password-strength {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.strength-text {\n  font-size: 12px;\n}\n\n.strength-text.success {\n  color: #52c41a;\n}\n.strength-text.active {\n  color: #faad14;\n}\n.strength-text.exception {\n  color: #ff4d4f;\n}\n\n.account-photo-actions {\n  display: flex;\n  justify-content: center; /* centers under avatar */\n  align-items: center;\n  gap: 8px; /* space between items */\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n// .account-photo-actions .divider {\n//   color: #ccc;\n//   margin: 0 4px;\n// }\n\n.setting-btn {\n  width: 150px;\n  height: 50px;\n  border-radius: 8px;\n  padding: 10px;\n  background-color: #2c68ad;\n  display: block;\n  margin: 0 auto;\n}\n\ndiv.ant-col.ant-form-item-label.css-dev-only-do-not-override-vryruh {\n  padding: 0px 0px 0px !important;\n}\n\nspan.strength-text.active {\n  background-image: none !important;\n}\n\n.account-industry-dropdown.custom-dropdown .ant-select-selector {\n  height: 44px !important;\n  min-height: 44px !important;\n  border-radius: 8px !important;\n  padding-left: 12px !important;\n  padding-right: 68px !important;\n}\n\n.account-form .account-industry-dropdown {\n  width: 100% !important;\n  min-width: 0 !important;\n}\n\n.account-industry-dropdown .ant-select-arrow {\n  width: auto !important;\n  pointer-events: auto;\n}\n\n.account-industry-dropdown .industry-suffix-icons {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n@media (max-width: 1024px) {\n  .account-settings-container {\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-start;\n    gap: 24px;\n    max-width: 100%;\n  }\n\n  .account-card,\n  .password-card {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .password-card {\n    height: auto;\n  }\n}\n","/* Table container */\r\n.Reusable-table .ant-table {\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  border: 1px solid #e5e5e5;\r\n      box-shadow: \r\n    0.5px 0.5px 2px rgba(182, 178, 178, 0.6),\r\n    2px 2px 6px rgba(182, 178, 178, 0.8) !important;\r\n}\r\n\r\n/* Header */\r\n.Reusable-table .ant-table-thead > tr > th {\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: #fff;\r\n  background: #2C68AD;\r\n  padding: 10px 14px;\r\n  border-bottom: 1px solid #e5e5e5;\r\n  font-family: 'opensans', sans-serif;\r\n  text-align: start;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* Body cells */\r\n.Reusable-table .ant-table-tbody > tr > td {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  padding: 12px 16px;\r\n  color: #474747;\r\n  border-bottom: 1px solid #EEEEEE;\r\n  font-family: 'opensans', sans-serif;\r\n  //letter-spacing: 0.15em;\r\n  background: #fff;\r\n  text-align: start;\r\n}\r\n\r\n/* Row hover */\r\n.Reusable-table .ant-table-tbody > tr:hover > td {\r\n  background: #f9fbff;\r\n}\r\n\r\n/* Actions */\r\n.table-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: center;\r\n}\r\n\r\n/* Reset AntD default table spacing */\r\n.Reusable-table .ant-table table {\r\n  border-collapse: collapse !important;  /* remove gaps */\r\n  border-spacing: 0 !important;          /* kills the white padding */\r\n  border-radius: 0 !important;           /* removes extra rounding */\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n/* Ensure header aligns flush with container */\r\n.Reusable-table .ant-table-thead > tr > th:first-child {\r\n  padding-inline-start: 12px !important; /* adjust as you want */\r\n}\r\n\r\n.action-icon {\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.action-icon.edit {\r\n  color: #1890ff;\r\n}\r\n\r\n.action-icon.edit:hover {\r\n  color: #40a9ff;\r\n}\r\n\r\n.action-icon.delete {\r\n  color: #ff4d4f;\r\n}\r\n\r\n.action-icon.delete:hover {\r\n  color: #ff7875;\r\n}\r\n\r\n/* Pagination */\r\n.Reusable-table .ant-pagination {\r\n  margin: 16px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Total text (left side) */\r\n.pagination-total {\r\n  font-size: 13px;\r\n  color: #111827;\r\n  font-family: 'opensans', sans-serif;\r\n  font-weight: 500;\r\n    margin-inline-start: 50px;\r\n}\r\n.custom-pagination--compact {\r\n  justify-content: space-between !important;\r\n  width: 100%;\r\n}\r\n.custom-pagination--no-total {\r\n  justify-content: flex-end !important;\r\n}\r\n.custom-pagination--rtl {\r\n  direction: rtl;\r\n  flex-direction: row-reverse;\r\n}\r\n.custom-pagination--rtl.custom-pagination--no-total {\r\n  justify-content: flex-start !important;\r\n}\r\n.custom-pagination--ltr {\r\n  direction: ltr;\r\n}\r\n.custom-pagination {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 13px;\r\n}\r\n.pagination-number{\r\n  font-size: 13px;\r\n  color: #000000;\r\n  font-family: 'opensans', sans-serif;\r\n  font-weight: 500;\r\n}\r\n.pagination-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n.custom-pagination--rtl .pagination-controls {\r\n  direction: ltr;\r\n}\r\n\r\n.pagination-icon-btn {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fff;\r\n  color: #6b7280;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.pagination-icon-btn:hover:not(:disabled) {\r\n  background: #f9fafb;\r\n  color: #374151;\r\n}\r\n\r\n.pagination-icon-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n.pagination-btn {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fff;\r\n  color: #6b7280;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.pagination-btn svg {\r\n  width: 18px !important;\r\n  height: 18px !important;\r\n  padding-right: 0 !important;\r\n  flex-shrink: 0;\r\n  display: block;\r\n}\r\n\r\n.pagination-btn:hover:not(:disabled) {\r\n  background: #f9fafb;\r\n  color: #374151;\r\n}\r\n\r\n.pagination-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n.pagination-page {\r\n  font-weight: 600;\r\n  color: #111827;\r\n  font-size: 13px;\r\n  font-family: 'opensans', sans-serif;\r\n}\r\n.Reusable-table .ant-table-footer,\r\n.campaign-table .ant-table-footer {\r\n  padding: 12px 12px;\r\n  padding: 16px;\r\n  background: #fff;\r\n  margin-top: 0;\r\n  margin-right: 0;\r\n  padding-bottom: 0;\r\n  //border-top: 1px solid #f0f0f0;\r\n}\r\n\r\n.campaign-table .ant-table-container {\r\n  background: #fff;\r\n}\r\n\r\n.custom-pagination {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n/* On mobile: reduce font size and padding */\r\n@media (max-width: 768px) {\r\n  .reusable-table-wrapper .ant-table-thead > tr > th,\r\n  .reusable-table-wrapper .ant-table-tbody > tr > td {\r\n    padding: 8px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .table-actions .action-icon {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .Reusable-table {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .Reusable-table .ant-table-thead > tr > th,\r\n  .Reusable-table .ant-table-tbody > tr > td {\r\n    padding: 6px;\r\n    font-size: 12px;\r\n    white-space: nowrap; \r\n  }\r\n\r\n  .table-actions .action-icon {\r\n    font-size: 14px;\r\n  }\r\n  .pagination-controls {\r\n    margin-inline-start: 100px;\r\n    gap:5px;\r\n}\r\n}\r\n",".tenant-usage-monitor {\n  padding: 20px;\n  background-color: #f5f8fc;\n\n  .tum-stat-row {\n    margin-bottom: 20px;\n  }\n\n  .tum-stat-card {\n    border-radius: 12px;\n    background: linear-gradient(145deg, #e6f0ff, #f0f5ff);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n\n    .ant-statistic-title {\n      color: #003a8c;\n    }\n\n    .ant-statistic-content-value {\n      color: #1677ff;\n      font-weight: 600;\n    }\n  }\n\n  .tum-search-input {\n    margin-bottom: 16px;\n    border-radius: 8px;\n  }\n\n  .tum-table-card {\n    border-radius: 12px;\n    padding: 12px;\n    overflow: hidden;\n  }\n  .tum-table-card .ant-table-container,\n  .tum-table-card .ant-table-content {\n    overflow: visible;\n  }\n  .tum-table-card .ant-table {\n    width: 100%;\n  }\n\n  .tum-table {\n    .ant-progress-bg {\n      border-radius: 6px;\n    }\n  }\n\n  .tum-tenant-cell {\n    display: flex;\n    flex-direction: column;\n\n    .tum-tenant-id {\n      font-size: 12px;\n      color: #8c8c8c;\n    }\n  }\n\n  .tum-metric-cell {\n    font-size: 13px;\n  }\n\n  .tum-progress {\n    margin-top: 4px;\n  }\n\n  .tum-progress-normal .ant-progress-bg {\n    background-color: #1677ff !important;\n  }\n\n  .tum-progress-warning .ant-progress-bg {\n    background-color: #fa8c16 !important;\n  }\n\n  .tum-progress-critical .ant-progress-bg {\n    background-color: #ff4d4f !important;\n  }\n\n  .tum-input-number {\n    width: 100%;\n  }\n\n  .tum-edit-btn {\n    color: #1677ff;\n  }\n  .usage-table .ant-table-cell,\n  .usage-table .ant-table-thead > tr > th {\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .usage-table .ant-table-cell {\n    padding: 12px 8px;\n    font-size: 12px;\n  }\n\n  .usage-table .ant-table-thead > tr > th {\n    padding: 12px 8px;\n    font-size: 12px;\n  }\n}\n.tum-metric-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.tum-tag {\n  padding: 2px 6px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.tum-tag-normal {\n  background-color: #52c41a; // green\n}\n\n.tum-tag-warning {\n  background-color: #fa8c16; // orange\n}\n\n.tum-tag-critical {\n  background-color: #ff4d4f; // red\n}\n\n.tum-metric-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tum-metric-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.tum-tag {\n  padding: 2px 6px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.tum-tag-normal {\n  background-color: #52c41a; // green\n}\n\n.tum-tag-warning {\n  background-color: #fa8c16; // orange\n}\n\n.tum-tag-critical {\n  background-color: #ff4d4f; // red\n}\n\n/* TenantUsageMonitor.css */\n.tum-progress-bar {\n  width: 100%;\n  display: inline-block;\n}\n\n@media (max-width: 1200px) {\n  .usage-table .ant-table-cell,\n  .usage-table .ant-table-thead > tr > th {\n    padding: 10px 6px;\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 992px) {\n  .usage-table .ant-table-cell,\n  .usage-table .ant-table-thead > tr > th {\n    padding: 8px 4px;\n    font-size: 10px;\n  }\n}\n\n// EditTenantLimitsModal.scss\n\n.edit-tenant-modal {\n  .ant-modal-content {\n    border-radius: 8px;\n    padding: 20px 24px;\n  }\n\n  .ant-modal-header {\n    border-bottom: none;\n    padding: 0 0 16px 0;\n\n    .ant-modal-title {\n      font-size: 16px;\n      font-weight: 600;\n      color: #1f1f1f;\n    }\n  }\n\n  .ant-modal-footer {\n    border-top: none;\n    padding-top: 16px;\n\n    .ant-btn {\n      border-radius: 6px;\n      padding: 0 20px;\n      height: 34px;\n    }\n\n    .ant-btn-primary {\n      background-color: #1677ff;\n    }\n  }\n\n  .ant-form {\n    .ant-form-item {\n      margin-bottom: 16px;\n\n      .ant-form-item-label {\n        font-weight: 500;\n        color: #444;\n      }\n\n      .ant-input-number {\n        width: 100%;\n\n        .ant-input-number-input {\n          text-align: left;\n          padding-right: 40px; // room for edit icon\n        }\n      }\n\n      // style the edit button inside addonAfter\n      .ant-input-number-group-addon {\n        background: transparent;\n        border: none;\n        padding: 0;\n\n        .ant-btn {\n          padding: 0 6px;\n          height: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          .anticon {\n            font-size: 14px;\n            color: #888 !important;\n\n            &:hover {\n              color: #1677ff;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".error-fallback {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100%;\n  padding: 32px 16px;\n  background: #ffffff;\n}\n\n.error-fallback-card {\n  text-align: center;\n  max-width: 760px;\n  width: 100%;\n}\n\n.error-fallback-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.error-fallback-brand .logo-row {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.error-fallback-brand .popup-icon {\n  width: 42px;\n  height: 42px;\n}\n\n.error-fallback-brand .popup-logo {\n  height: 32px;\n}\n\n.error-fallback-mark {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: #2c68ad;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.error-fallback-mark img {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n.error-fallback-name {\n  font-family: \"opensans\", sans-serif;\n  font-weight: 700;\n  color: #2c68ad;\n  letter-spacing: 1px;\n  font-size: 18px;\n}\n\n.Error-image{\n  height:380px;\n}\n.error-fallback-title {\n  font-family: \"opensans\", sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #2c68ad;\n  margin: 0 0 6px 0;\n}\n\n.error-fallback-message {\n  font-family: \"opensans\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #8B8A8A;\n  margin: 0 0 20px 0;\n}\n\n.error-fallback-illustration {\n  display: flex;\n  justify-content: center;\n}\n\n.error-fallback-illustration svg {\n  width: 100%;\n  max-width: 520px;\n  height: auto;\n}\n\n.error-fallback-retry {\n  margin-top: 18px;\n  padding: 8px 20px;\n  border-radius: 6px;\n  background: #2c68ad;\n  color: #ffffff;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.error-fallback-retry:hover {\n  opacity: 0.9;\n}\n\n@media (max-width: 768px) {\n  .error-fallback {\n    min-height: calc(100vh - 120px);\n  }\n\n  .error-fallback-title {\n    font-size: 20px;\n  }\n\n  .error-fallback-message {\n    font-size: 12px;\n  }\n}\n","@import \"../../../styles/variables\";\n\n.tippy-box[data-theme~=\"dt\"] {\n  background-color: #111111;\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 1.3;\n  padding: 4px 6px;\n  border-radius: 4px;\n  font-family: $font-family;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.tippy-box[data-theme~=\"dt\"] .tippy-arrow {\n  color: #111111;\n}\n\n.dt-tooltip__trigger {\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
